/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			modules[moduleId] = moreModules[moduleId];
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		20:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + ".javascripts/" + ({"159":"user-page-js/default.page","164":"user-page-js/main/login.page"}[chunkId]||chunkId) + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/ })
/************************************************************************/
/******/ ({

/***/ 8:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global window, global*/
	var util = __webpack_require__(48)
	var assert = __webpack_require__(94)
	var now = __webpack_require__(95)
	
	var slice = Array.prototype.slice
	var console
	var times = {}
	
	if (typeof global !== "undefined" && global.console) {
	    console = global.console
	} else if (typeof window !== "undefined" && window.console) {
	    console = window.console
	} else {
	    console = {}
	}
	
	var functions = [
	    [log, "log"],
	    [info, "info"],
	    [warn, "warn"],
	    [error, "error"],
	    [time, "time"],
	    [timeEnd, "timeEnd"],
	    [trace, "trace"],
	    [dir, "dir"],
	    [consoleAssert, "assert"]
	]
	
	for (var i = 0; i < functions.length; i++) {
	    var tuple = functions[i]
	    var f = tuple[0]
	    var name = tuple[1]
	
	    if (!console[name]) {
	        console[name] = f
	    }
	}
	
	module.exports = console
	
	function log() {}
	
	function info() {
	    console.log.apply(console, arguments)
	}
	
	function warn() {
	    console.log.apply(console, arguments)
	}
	
	function error() {
	    console.warn.apply(console, arguments)
	}
	
	function time(label) {
	    times[label] = now()
	}
	
	function timeEnd(label) {
	    var time = times[label]
	    if (!time) {
	        throw new Error("No such label: " + label)
	    }
	
	    var duration = now() - time
	    console.log(label + ": " + duration + "ms")
	}
	
	function trace() {
	    var err = new Error()
	    err.name = "Trace"
	    err.message = util.format.apply(null, arguments)
	    console.error(err.stack)
	}
	
	function dir(object) {
	    console.log(util.inspect(object) + "\n")
	}
	
	function consoleAssert(expression) {
	    if (!expression) {
	        var arr = slice.call(arguments, 1)
	        assert.ok(false, util.format.apply(null, arr))
	    }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 10:
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },

/***/ 46:
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },

/***/ 48:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, console) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(97);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(96);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(46), __webpack_require__(8)))

/***/ },

/***/ 94:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(48);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 95:
/***/ function(module, exports) {

	module.exports = now
	
	function now() {
	    return new Date().getTime()
	}


/***/ },

/***/ 96:
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },

/***/ 97:
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },

/***/ 437:
/***/ function(module, exports, __webpack_require__) {

	/*!
	  * Bootstrap v4.6.0 (https://getbootstrap.com/)
	  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
	  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
	  */
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(10), __webpack_require__(474)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'jquery', 'popper.js'], factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.bootstrap = {}, global.jQuery, global.Popper));
	}(this, (function (exports, $, Popper) { 'use strict';
	
	  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	  var $__default = /*#__PURE__*/_interopDefaultLegacy($);
	  var Popper__default = /*#__PURE__*/_interopDefaultLegacy(Popper);
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  function _extends() {
	    _extends = Object.assign || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends.apply(this, arguments);
	  }
	
	  function _inheritsLoose(subClass, superClass) {
	    subClass.prototype = Object.create(superClass.prototype);
	    subClass.prototype.constructor = subClass;
	    subClass.__proto__ = superClass;
	  }
	
	  /**
	   * --------------------------------------------------------------------------
	   * Bootstrap (v4.6.0): util.js
	   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
	   * --------------------------------------------------------------------------
	   */
	  /**
	   * ------------------------------------------------------------------------
	   * Private TransitionEnd Helpers
	   * ------------------------------------------------------------------------
	   */
	
	  var TRANSITION_END = 'transitionend';
	  var MAX_UID = 1000000;
	  var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)
	
	  function toType(obj) {
	    if (obj === null || typeof obj === 'undefined') {
	      return "" + obj;
	    }
	
	    return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
	  }
	
	  function getSpecialTransitionEndEvent() {
	    return {
	      bindType: TRANSITION_END,
	      delegateType: TRANSITION_END,
	      handle: function handle(event) {
	        if ($__default['default'](event.target).is(this)) {
	          return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
	        }
	
	        return undefined;
	      }
	    };
	  }
	
	  function transitionEndEmulator(duration) {
	    var _this = this;
	
	    var called = false;
	    $__default['default'](this).one(Util.TRANSITION_END, function () {
	      called = true;
	    });
	    setTimeout(function () {
	      if (!called) {
	        Util.triggerTransitionEnd(_this);
	      }
	    }, duration);
	    return this;
	  }
	
	  function setTransitionEndSupport() {
	    $__default['default'].fn.emulateTransitionEnd = transitionEndEmulator;
	    $__default['default'].event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
	  }
	  /**
	   * --------------------------------------------------------------------------
	   * Public Util Api
	   * --------------------------------------------------------------------------
	   */
	
	
	  var Util = {
	    TRANSITION_END: 'bsTransitionEnd',
	    getUID: function getUID(prefix) {
	      do {
	        prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
	      } while (document.getElementById(prefix));
	
	      return prefix;
	    },
	    getSelectorFromElement: function getSelectorFromElement(element) {
	      var selector = element.getAttribute('data-target');
	
	      if (!selector || selector === '#') {
	        var hrefAttr = element.getAttribute('href');
	        selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : '';
	      }
	
	      try {
	        return document.querySelector(selector) ? selector : null;
	      } catch (_) {
	        return null;
	      }
	    },
	    getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
	      if (!element) {
	        return 0;
	      } // Get transition-duration of the element
	
	
	      var transitionDuration = $__default['default'](element).css('transition-duration');
	      var transitionDelay = $__default['default'](element).css('transition-delay');
	      var floatTransitionDuration = parseFloat(transitionDuration);
	      var floatTransitionDelay = parseFloat(transitionDelay); // Return 0 if element or transition duration is not found
	
	      if (!floatTransitionDuration && !floatTransitionDelay) {
	        return 0;
	      } // If multiple durations are defined, take the first
	
	
	      transitionDuration = transitionDuration.split(',')[0];
	      transitionDelay = transitionDelay.split(',')[0];
	      return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
	    },
	    reflow: function reflow(element) {
	      return element.offsetHeight;
	    },
	    triggerTransitionEnd: function triggerTransitionEnd(element) {
	      $__default['default'](element).trigger(TRANSITION_END);
	    },
	    supportsTransitionEnd: function supportsTransitionEnd() {
	      return Boolean(TRANSITION_END);
	    },
	    isElement: function isElement(obj) {
	      return (obj[0] || obj).nodeType;
	    },
	    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
	      for (var property in configTypes) {
	        if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
	          var expectedTypes = configTypes[property];
	          var value = config[property];
	          var valueType = value && Util.isElement(value) ? 'element' : toType(value);
	
	          if (!new RegExp(expectedTypes).test(valueType)) {
	            throw new Error(componentName.toUpperCase() + ": " + ("Option \"" + property + "\" provided type \"" + valueType + "\" ") + ("but expected type \"" + expectedTypes + "\"."));
	          }
	        }
	      }
	    },
	    findShadowRoot: function findShadowRoot(element) {
	      if (!document.documentElement.attachShadow) {
	        return null;
	      } // Can find the shadow root otherwise it'll return the document
	
	
	      if (typeof element.getRootNode === 'function') {
	        var root = element.getRootNode();
	        return root instanceof ShadowRoot ? root : null;
	      }
	
	      if (element instanceof ShadowRoot) {
	        return element;
	      } // when we don't find a shadow root
	
	
	      if (!element.parentNode) {
	        return null;
	      }
	
	      return Util.findShadowRoot(element.parentNode);
	    },
	    jQueryDetection: function jQueryDetection() {
	      if (typeof $__default['default'] === 'undefined') {
	        throw new TypeError('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.');
	      }
	
	      var version = $__default['default'].fn.jquery.split(' ')[0].split('.');
	      var minMajor = 1;
	      var ltMajor = 2;
	      var minMinor = 9;
	      var minPatch = 1;
	      var maxMajor = 4;
	
	      if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) {
	        throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0');
	      }
	    }
	  };
	  Util.jQueryDetection();
	  setTransitionEndSupport();
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME = 'alert';
	  var VERSION = '4.6.0';
	  var DATA_KEY = 'bs.alert';
	  var EVENT_KEY = "." + DATA_KEY;
	  var DATA_API_KEY = '.data-api';
	  var JQUERY_NO_CONFLICT = $__default['default'].fn[NAME];
	  var SELECTOR_DISMISS = '[data-dismiss="alert"]';
	  var EVENT_CLOSE = "close" + EVENT_KEY;
	  var EVENT_CLOSED = "closed" + EVENT_KEY;
	  var EVENT_CLICK_DATA_API = "click" + EVENT_KEY + DATA_API_KEY;
	  var CLASS_NAME_ALERT = 'alert';
	  var CLASS_NAME_FADE = 'fade';
	  var CLASS_NAME_SHOW = 'show';
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Alert = /*#__PURE__*/function () {
	    function Alert(element) {
	      this._element = element;
	    } // Getters
	
	
	    var _proto = Alert.prototype;
	
	    // Public
	    _proto.close = function close(element) {
	      var rootElement = this._element;
	
	      if (element) {
	        rootElement = this._getRootElement(element);
	      }
	
	      var customEvent = this._triggerCloseEvent(rootElement);
	
	      if (customEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      this._removeElement(rootElement);
	    };
	
	    _proto.dispose = function dispose() {
	      $__default['default'].removeData(this._element, DATA_KEY);
	      this._element = null;
	    } // Private
	    ;
	
	    _proto._getRootElement = function _getRootElement(element) {
	      var selector = Util.getSelectorFromElement(element);
	      var parent = false;
	
	      if (selector) {
	        parent = document.querySelector(selector);
	      }
	
	      if (!parent) {
	        parent = $__default['default'](element).closest("." + CLASS_NAME_ALERT)[0];
	      }
	
	      return parent;
	    };
	
	    _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
	      var closeEvent = $__default['default'].Event(EVENT_CLOSE);
	      $__default['default'](element).trigger(closeEvent);
	      return closeEvent;
	    };
	
	    _proto._removeElement = function _removeElement(element) {
	      var _this = this;
	
	      $__default['default'](element).removeClass(CLASS_NAME_SHOW);
	
	      if (!$__default['default'](element).hasClass(CLASS_NAME_FADE)) {
	        this._destroyElement(element);
	
	        return;
	      }
	
	      var transitionDuration = Util.getTransitionDurationFromElement(element);
	      $__default['default'](element).one(Util.TRANSITION_END, function (event) {
	        return _this._destroyElement(element, event);
	      }).emulateTransitionEnd(transitionDuration);
	    };
	
	    _proto._destroyElement = function _destroyElement(element) {
	      $__default['default'](element).detach().trigger(EVENT_CLOSED).remove();
	    } // Static
	    ;
	
	    Alert._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var $element = $__default['default'](this);
	        var data = $element.data(DATA_KEY);
	
	        if (!data) {
	          data = new Alert(this);
	          $element.data(DATA_KEY, data);
	        }
	
	        if (config === 'close') {
	          data[config](this);
	        }
	      });
	    };
	
	    Alert._handleDismiss = function _handleDismiss(alertInstance) {
	      return function (event) {
	        if (event) {
	          event.preventDefault();
	        }
	
	        alertInstance.close(this);
	      };
	    };
	
	    _createClass(Alert, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION;
	      }
	    }]);
	
	    return Alert;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	   */
	
	
	  $__default['default'](document).on(EVENT_CLICK_DATA_API, SELECTOR_DISMISS, Alert._handleDismiss(new Alert()));
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	  $__default['default'].fn[NAME] = Alert._jQueryInterface;
	  $__default['default'].fn[NAME].Constructor = Alert;
	
	  $__default['default'].fn[NAME].noConflict = function () {
	    $__default['default'].fn[NAME] = JQUERY_NO_CONFLICT;
	    return Alert._jQueryInterface;
	  };
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$1 = 'button';
	  var VERSION$1 = '4.6.0';
	  var DATA_KEY$1 = 'bs.button';
	  var EVENT_KEY$1 = "." + DATA_KEY$1;
	  var DATA_API_KEY$1 = '.data-api';
	  var JQUERY_NO_CONFLICT$1 = $__default['default'].fn[NAME$1];
	  var CLASS_NAME_ACTIVE = 'active';
	  var CLASS_NAME_BUTTON = 'btn';
	  var CLASS_NAME_FOCUS = 'focus';
	  var SELECTOR_DATA_TOGGLE_CARROT = '[data-toggle^="button"]';
	  var SELECTOR_DATA_TOGGLES = '[data-toggle="buttons"]';
	  var SELECTOR_DATA_TOGGLE = '[data-toggle="button"]';
	  var SELECTOR_DATA_TOGGLES_BUTTONS = '[data-toggle="buttons"] .btn';
	  var SELECTOR_INPUT = 'input:not([type="hidden"])';
	  var SELECTOR_ACTIVE = '.active';
	  var SELECTOR_BUTTON = '.btn';
	  var EVENT_CLICK_DATA_API$1 = "click" + EVENT_KEY$1 + DATA_API_KEY$1;
	  var EVENT_FOCUS_BLUR_DATA_API = "focus" + EVENT_KEY$1 + DATA_API_KEY$1 + " " + ("blur" + EVENT_KEY$1 + DATA_API_KEY$1);
	  var EVENT_LOAD_DATA_API = "load" + EVENT_KEY$1 + DATA_API_KEY$1;
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Button = /*#__PURE__*/function () {
	    function Button(element) {
	      this._element = element;
	      this.shouldAvoidTriggerChange = false;
	    } // Getters
	
	
	    var _proto = Button.prototype;
	
	    // Public
	    _proto.toggle = function toggle() {
	      var triggerChangeEvent = true;
	      var addAriaPressed = true;
	      var rootElement = $__default['default'](this._element).closest(SELECTOR_DATA_TOGGLES)[0];
	
	      if (rootElement) {
	        var input = this._element.querySelector(SELECTOR_INPUT);
	
	        if (input) {
	          if (input.type === 'radio') {
	            if (input.checked && this._element.classList.contains(CLASS_NAME_ACTIVE)) {
	              triggerChangeEvent = false;
	            } else {
	              var activeElement = rootElement.querySelector(SELECTOR_ACTIVE);
	
	              if (activeElement) {
	                $__default['default'](activeElement).removeClass(CLASS_NAME_ACTIVE);
	              }
	            }
	          }
	
	          if (triggerChangeEvent) {
	            // if it's not a radio button or checkbox don't add a pointless/invalid checked property to the input
	            if (input.type === 'checkbox' || input.type === 'radio') {
	              input.checked = !this._element.classList.contains(CLASS_NAME_ACTIVE);
	            }
	
	            if (!this.shouldAvoidTriggerChange) {
	              $__default['default'](input).trigger('change');
	            }
	          }
	
	          input.focus();
	          addAriaPressed = false;
	        }
	      }
	
	      if (!(this._element.hasAttribute('disabled') || this._element.classList.contains('disabled'))) {
	        if (addAriaPressed) {
	          this._element.setAttribute('aria-pressed', !this._element.classList.contains(CLASS_NAME_ACTIVE));
	        }
	
	        if (triggerChangeEvent) {
	          $__default['default'](this._element).toggleClass(CLASS_NAME_ACTIVE);
	        }
	      }
	    };
	
	    _proto.dispose = function dispose() {
	      $__default['default'].removeData(this._element, DATA_KEY$1);
	      this._element = null;
	    } // Static
	    ;
	
	    Button._jQueryInterface = function _jQueryInterface(config, avoidTriggerChange) {
	      return this.each(function () {
	        var $element = $__default['default'](this);
	        var data = $element.data(DATA_KEY$1);
	
	        if (!data) {
	          data = new Button(this);
	          $element.data(DATA_KEY$1, data);
	        }
	
	        data.shouldAvoidTriggerChange = avoidTriggerChange;
	
	        if (config === 'toggle') {
	          data[config]();
	        }
	      });
	    };
	
	    _createClass(Button, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$1;
	      }
	    }]);
	
	    return Button;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	   */
	
	
	  $__default['default'](document).on(EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE_CARROT, function (event) {
	    var button = event.target;
	    var initialButton = button;
	
	    if (!$__default['default'](button).hasClass(CLASS_NAME_BUTTON)) {
	      button = $__default['default'](button).closest(SELECTOR_BUTTON)[0];
	    }
	
	    if (!button || button.hasAttribute('disabled') || button.classList.contains('disabled')) {
	      event.preventDefault(); // work around Firefox bug #1540995
	    } else {
	      var inputBtn = button.querySelector(SELECTOR_INPUT);
	
	      if (inputBtn && (inputBtn.hasAttribute('disabled') || inputBtn.classList.contains('disabled'))) {
	        event.preventDefault(); // work around Firefox bug #1540995
	
	        return;
	      }
	
	      if (initialButton.tagName === 'INPUT' || button.tagName !== 'LABEL') {
	        Button._jQueryInterface.call($__default['default'](button), 'toggle', initialButton.tagName === 'INPUT');
	      }
	    }
	  }).on(EVENT_FOCUS_BLUR_DATA_API, SELECTOR_DATA_TOGGLE_CARROT, function (event) {
	    var button = $__default['default'](event.target).closest(SELECTOR_BUTTON)[0];
	    $__default['default'](button).toggleClass(CLASS_NAME_FOCUS, /^focus(in)?$/.test(event.type));
	  });
	  $__default['default'](window).on(EVENT_LOAD_DATA_API, function () {
	    // ensure correct active class is set to match the controls' actual values/states
	    // find all checkboxes/readio buttons inside data-toggle groups
	    var buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLES_BUTTONS));
	
	    for (var i = 0, len = buttons.length; i < len; i++) {
	      var button = buttons[i];
	      var input = button.querySelector(SELECTOR_INPUT);
	
	      if (input.checked || input.hasAttribute('checked')) {
	        button.classList.add(CLASS_NAME_ACTIVE);
	      } else {
	        button.classList.remove(CLASS_NAME_ACTIVE);
	      }
	    } // find all button toggles
	
	
	    buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE));
	
	    for (var _i = 0, _len = buttons.length; _i < _len; _i++) {
	      var _button = buttons[_i];
	
	      if (_button.getAttribute('aria-pressed') === 'true') {
	        _button.classList.add(CLASS_NAME_ACTIVE);
	      } else {
	        _button.classList.remove(CLASS_NAME_ACTIVE);
	      }
	    }
	  });
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	  $__default['default'].fn[NAME$1] = Button._jQueryInterface;
	  $__default['default'].fn[NAME$1].Constructor = Button;
	
	  $__default['default'].fn[NAME$1].noConflict = function () {
	    $__default['default'].fn[NAME$1] = JQUERY_NO_CONFLICT$1;
	    return Button._jQueryInterface;
	  };
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$2 = 'carousel';
	  var VERSION$2 = '4.6.0';
	  var DATA_KEY$2 = 'bs.carousel';
	  var EVENT_KEY$2 = "." + DATA_KEY$2;
	  var DATA_API_KEY$2 = '.data-api';
	  var JQUERY_NO_CONFLICT$2 = $__default['default'].fn[NAME$2];
	  var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key
	
	  var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key
	
	  var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
	
	  var SWIPE_THRESHOLD = 40;
	  var Default = {
	    interval: 5000,
	    keyboard: true,
	    slide: false,
	    pause: 'hover',
	    wrap: true,
	    touch: true
	  };
	  var DefaultType = {
	    interval: '(number|boolean)',
	    keyboard: 'boolean',
	    slide: '(boolean|string)',
	    pause: '(string|boolean)',
	    wrap: 'boolean',
	    touch: 'boolean'
	  };
	  var DIRECTION_NEXT = 'next';
	  var DIRECTION_PREV = 'prev';
	  var DIRECTION_LEFT = 'left';
	  var DIRECTION_RIGHT = 'right';
	  var EVENT_SLIDE = "slide" + EVENT_KEY$2;
	  var EVENT_SLID = "slid" + EVENT_KEY$2;
	  var EVENT_KEYDOWN = "keydown" + EVENT_KEY$2;
	  var EVENT_MOUSEENTER = "mouseenter" + EVENT_KEY$2;
	  var EVENT_MOUSELEAVE = "mouseleave" + EVENT_KEY$2;
	  var EVENT_TOUCHSTART = "touchstart" + EVENT_KEY$2;
	  var EVENT_TOUCHMOVE = "touchmove" + EVENT_KEY$2;
	  var EVENT_TOUCHEND = "touchend" + EVENT_KEY$2;
	  var EVENT_POINTERDOWN = "pointerdown" + EVENT_KEY$2;
	  var EVENT_POINTERUP = "pointerup" + EVENT_KEY$2;
	  var EVENT_DRAG_START = "dragstart" + EVENT_KEY$2;
	  var EVENT_LOAD_DATA_API$1 = "load" + EVENT_KEY$2 + DATA_API_KEY$2;
	  var EVENT_CLICK_DATA_API$2 = "click" + EVENT_KEY$2 + DATA_API_KEY$2;
	  var CLASS_NAME_CAROUSEL = 'carousel';
	  var CLASS_NAME_ACTIVE$1 = 'active';
	  var CLASS_NAME_SLIDE = 'slide';
	  var CLASS_NAME_RIGHT = 'carousel-item-right';
	  var CLASS_NAME_LEFT = 'carousel-item-left';
	  var CLASS_NAME_NEXT = 'carousel-item-next';
	  var CLASS_NAME_PREV = 'carousel-item-prev';
	  var CLASS_NAME_POINTER_EVENT = 'pointer-event';
	  var SELECTOR_ACTIVE$1 = '.active';
	  var SELECTOR_ACTIVE_ITEM = '.active.carousel-item';
	  var SELECTOR_ITEM = '.carousel-item';
	  var SELECTOR_ITEM_IMG = '.carousel-item img';
	  var SELECTOR_NEXT_PREV = '.carousel-item-next, .carousel-item-prev';
	  var SELECTOR_INDICATORS = '.carousel-indicators';
	  var SELECTOR_DATA_SLIDE = '[data-slide], [data-slide-to]';
	  var SELECTOR_DATA_RIDE = '[data-ride="carousel"]';
	  var PointerType = {
	    TOUCH: 'touch',
	    PEN: 'pen'
	  };
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Carousel = /*#__PURE__*/function () {
	    function Carousel(element, config) {
	      this._items = null;
	      this._interval = null;
	      this._activeElement = null;
	      this._isPaused = false;
	      this._isSliding = false;
	      this.touchTimeout = null;
	      this.touchStartX = 0;
	      this.touchDeltaX = 0;
	      this._config = this._getConfig(config);
	      this._element = element;
	      this._indicatorsElement = this._element.querySelector(SELECTOR_INDICATORS);
	      this._touchSupported = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
	      this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent);
	
	      this._addEventListeners();
	    } // Getters
	
	
	    var _proto = Carousel.prototype;
	
	    // Public
	    _proto.next = function next() {
	      if (!this._isSliding) {
	        this._slide(DIRECTION_NEXT);
	      }
	    };
	
	    _proto.nextWhenVisible = function nextWhenVisible() {
	      var $element = $__default['default'](this._element); // Don't call next when the page isn't visible
	      // or the carousel or its parent isn't visible
	
	      if (!document.hidden && $element.is(':visible') && $element.css('visibility') !== 'hidden') {
	        this.next();
	      }
	    };
	
	    _proto.prev = function prev() {
	      if (!this._isSliding) {
	        this._slide(DIRECTION_PREV);
	      }
	    };
	
	    _proto.pause = function pause(event) {
	      if (!event) {
	        this._isPaused = true;
	      }
	
	      if (this._element.querySelector(SELECTOR_NEXT_PREV)) {
	        Util.triggerTransitionEnd(this._element);
	        this.cycle(true);
	      }
	
	      clearInterval(this._interval);
	      this._interval = null;
	    };
	
	    _proto.cycle = function cycle(event) {
	      if (!event) {
	        this._isPaused = false;
	      }
	
	      if (this._interval) {
	        clearInterval(this._interval);
	        this._interval = null;
	      }
	
	      if (this._config.interval && !this._isPaused) {
	        this._updateInterval();
	
	        this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
	      }
	    };
	
	    _proto.to = function to(index) {
	      var _this = this;
	
	      this._activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);
	
	      var activeIndex = this._getItemIndex(this._activeElement);
	
	      if (index > this._items.length - 1 || index < 0) {
	        return;
	      }
	
	      if (this._isSliding) {
	        $__default['default'](this._element).one(EVENT_SLID, function () {
	          return _this.to(index);
	        });
	        return;
	      }
	
	      if (activeIndex === index) {
	        this.pause();
	        this.cycle();
	        return;
	      }
	
	      var direction = index > activeIndex ? DIRECTION_NEXT : DIRECTION_PREV;
	
	      this._slide(direction, this._items[index]);
	    };
	
	    _proto.dispose = function dispose() {
	      $__default['default'](this._element).off(EVENT_KEY$2);
	      $__default['default'].removeData(this._element, DATA_KEY$2);
	      this._items = null;
	      this._config = null;
	      this._element = null;
	      this._interval = null;
	      this._isPaused = null;
	      this._isSliding = null;
	      this._activeElement = null;
	      this._indicatorsElement = null;
	    } // Private
	    ;
	
	    _proto._getConfig = function _getConfig(config) {
	      config = _extends({}, Default, config);
	      Util.typeCheckConfig(NAME$2, config, DefaultType);
	      return config;
	    };
	
	    _proto._handleSwipe = function _handleSwipe() {
	      var absDeltax = Math.abs(this.touchDeltaX);
	
	      if (absDeltax <= SWIPE_THRESHOLD) {
	        return;
	      }
	
	      var direction = absDeltax / this.touchDeltaX;
	      this.touchDeltaX = 0; // swipe left
	
	      if (direction > 0) {
	        this.prev();
	      } // swipe right
	
	
	      if (direction < 0) {
	        this.next();
	      }
	    };
	
	    _proto._addEventListeners = function _addEventListeners() {
	      var _this2 = this;
	
	      if (this._config.keyboard) {
	        $__default['default'](this._element).on(EVENT_KEYDOWN, function (event) {
	          return _this2._keydown(event);
	        });
	      }
	
	      if (this._config.pause === 'hover') {
	        $__default['default'](this._element).on(EVENT_MOUSEENTER, function (event) {
	          return _this2.pause(event);
	        }).on(EVENT_MOUSELEAVE, function (event) {
	          return _this2.cycle(event);
	        });
	      }
	
	      if (this._config.touch) {
	        this._addTouchEventListeners();
	      }
	    };
	
	    _proto._addTouchEventListeners = function _addTouchEventListeners() {
	      var _this3 = this;
	
	      if (!this._touchSupported) {
	        return;
	      }
	
	      var start = function start(event) {
	        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
	          _this3.touchStartX = event.originalEvent.clientX;
	        } else if (!_this3._pointerEvent) {
	          _this3.touchStartX = event.originalEvent.touches[0].clientX;
	        }
	      };
	
	      var move = function move(event) {
	        // ensure swiping with one touch and not pinching
	        if (event.originalEvent.touches && event.originalEvent.touches.length > 1) {
	          _this3.touchDeltaX = 0;
	        } else {
	          _this3.touchDeltaX = event.originalEvent.touches[0].clientX - _this3.touchStartX;
	        }
	      };
	
	      var end = function end(event) {
	        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
	          _this3.touchDeltaX = event.originalEvent.clientX - _this3.touchStartX;
	        }
	
	        _this3._handleSwipe();
	
	        if (_this3._config.pause === 'hover') {
	          // If it's a touch-enabled device, mouseenter/leave are fired as
	          // part of the mouse compatibility events on first tap - the carousel
	          // would stop cycling until user tapped out of it;
	          // here, we listen for touchend, explicitly pause the carousel
	          // (as if it's the second time we tap on it, mouseenter compat event
	          // is NOT fired) and after a timeout (to allow for mouse compatibility
	          // events to fire) we explicitly restart cycling
	          _this3.pause();
	
	          if (_this3.touchTimeout) {
	            clearTimeout(_this3.touchTimeout);
	          }
	
	          _this3.touchTimeout = setTimeout(function (event) {
	            return _this3.cycle(event);
	          }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
	        }
	      };
	
	      $__default['default'](this._element.querySelectorAll(SELECTOR_ITEM_IMG)).on(EVENT_DRAG_START, function (e) {
	        return e.preventDefault();
	      });
	
	      if (this._pointerEvent) {
	        $__default['default'](this._element).on(EVENT_POINTERDOWN, function (event) {
	          return start(event);
	        });
	        $__default['default'](this._element).on(EVENT_POINTERUP, function (event) {
	          return end(event);
	        });
	
	        this._element.classList.add(CLASS_NAME_POINTER_EVENT);
	      } else {
	        $__default['default'](this._element).on(EVENT_TOUCHSTART, function (event) {
	          return start(event);
	        });
	        $__default['default'](this._element).on(EVENT_TOUCHMOVE, function (event) {
	          return move(event);
	        });
	        $__default['default'](this._element).on(EVENT_TOUCHEND, function (event) {
	          return end(event);
	        });
	      }
	    };
	
	    _proto._keydown = function _keydown(event) {
	      if (/input|textarea/i.test(event.target.tagName)) {
	        return;
	      }
	
	      switch (event.which) {
	        case ARROW_LEFT_KEYCODE:
	          event.preventDefault();
	          this.prev();
	          break;
	
	        case ARROW_RIGHT_KEYCODE:
	          event.preventDefault();
	          this.next();
	          break;
	      }
	    };
	
	    _proto._getItemIndex = function _getItemIndex(element) {
	      this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(SELECTOR_ITEM)) : [];
	      return this._items.indexOf(element);
	    };
	
	    _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
	      var isNextDirection = direction === DIRECTION_NEXT;
	      var isPrevDirection = direction === DIRECTION_PREV;
	
	      var activeIndex = this._getItemIndex(activeElement);
	
	      var lastItemIndex = this._items.length - 1;
	      var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;
	
	      if (isGoingToWrap && !this._config.wrap) {
	        return activeElement;
	      }
	
	      var delta = direction === DIRECTION_PREV ? -1 : 1;
	      var itemIndex = (activeIndex + delta) % this._items.length;
	      return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
	    };
	
	    _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
	      var targetIndex = this._getItemIndex(relatedTarget);
	
	      var fromIndex = this._getItemIndex(this._element.querySelector(SELECTOR_ACTIVE_ITEM));
	
	      var slideEvent = $__default['default'].Event(EVENT_SLIDE, {
	        relatedTarget: relatedTarget,
	        direction: eventDirectionName,
	        from: fromIndex,
	        to: targetIndex
	      });
	      $__default['default'](this._element).trigger(slideEvent);
	      return slideEvent;
	    };
	
	    _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
	      if (this._indicatorsElement) {
	        var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(SELECTOR_ACTIVE$1));
	        $__default['default'](indicators).removeClass(CLASS_NAME_ACTIVE$1);
	
	        var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];
	
	        if (nextIndicator) {
	          $__default['default'](nextIndicator).addClass(CLASS_NAME_ACTIVE$1);
	        }
	      }
	    };
	
	    _proto._updateInterval = function _updateInterval() {
	      var element = this._activeElement || this._element.querySelector(SELECTOR_ACTIVE_ITEM);
	
	      if (!element) {
	        return;
	      }
	
	      var elementInterval = parseInt(element.getAttribute('data-interval'), 10);
	
	      if (elementInterval) {
	        this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
	        this._config.interval = elementInterval;
	      } else {
	        this._config.interval = this._config.defaultInterval || this._config.interval;
	      }
	    };
	
	    _proto._slide = function _slide(direction, element) {
	      var _this4 = this;
	
	      var activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);
	
	      var activeElementIndex = this._getItemIndex(activeElement);
	
	      var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);
	
	      var nextElementIndex = this._getItemIndex(nextElement);
	
	      var isCycling = Boolean(this._interval);
	      var directionalClassName;
	      var orderClassName;
	      var eventDirectionName;
	
	      if (direction === DIRECTION_NEXT) {
	        directionalClassName = CLASS_NAME_LEFT;
	        orderClassName = CLASS_NAME_NEXT;
	        eventDirectionName = DIRECTION_LEFT;
	      } else {
	        directionalClassName = CLASS_NAME_RIGHT;
	        orderClassName = CLASS_NAME_PREV;
	        eventDirectionName = DIRECTION_RIGHT;
	      }
	
	      if (nextElement && $__default['default'](nextElement).hasClass(CLASS_NAME_ACTIVE$1)) {
	        this._isSliding = false;
	        return;
	      }
	
	      var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);
	
	      if (slideEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      if (!activeElement || !nextElement) {
	        // Some weirdness is happening, so we bail
	        return;
	      }
	
	      this._isSliding = true;
	
	      if (isCycling) {
	        this.pause();
	      }
	
	      this._setActiveIndicatorElement(nextElement);
	
	      this._activeElement = nextElement;
	      var slidEvent = $__default['default'].Event(EVENT_SLID, {
	        relatedTarget: nextElement,
	        direction: eventDirectionName,
	        from: activeElementIndex,
	        to: nextElementIndex
	      });
	
	      if ($__default['default'](this._element).hasClass(CLASS_NAME_SLIDE)) {
	        $__default['default'](nextElement).addClass(orderClassName);
	        Util.reflow(nextElement);
	        $__default['default'](activeElement).addClass(directionalClassName);
	        $__default['default'](nextElement).addClass(directionalClassName);
	        var transitionDuration = Util.getTransitionDurationFromElement(activeElement);
	        $__default['default'](activeElement).one(Util.TRANSITION_END, function () {
	          $__default['default'](nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(CLASS_NAME_ACTIVE$1);
	          $__default['default'](activeElement).removeClass(CLASS_NAME_ACTIVE$1 + " " + orderClassName + " " + directionalClassName);
	          _this4._isSliding = false;
	          setTimeout(function () {
	            return $__default['default'](_this4._element).trigger(slidEvent);
	          }, 0);
	        }).emulateTransitionEnd(transitionDuration);
	      } else {
	        $__default['default'](activeElement).removeClass(CLASS_NAME_ACTIVE$1);
	        $__default['default'](nextElement).addClass(CLASS_NAME_ACTIVE$1);
	        this._isSliding = false;
	        $__default['default'](this._element).trigger(slidEvent);
	      }
	
	      if (isCycling) {
	        this.cycle();
	      }
	    } // Static
	    ;
	
	    Carousel._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = $__default['default'](this).data(DATA_KEY$2);
	
	        var _config = _extends({}, Default, $__default['default'](this).data());
	
	        if (typeof config === 'object') {
	          _config = _extends({}, _config, config);
	        }
	
	        var action = typeof config === 'string' ? config : _config.slide;
	
	        if (!data) {
	          data = new Carousel(this, _config);
	          $__default['default'](this).data(DATA_KEY$2, data);
	        }
	
	        if (typeof config === 'number') {
	          data.to(config);
	        } else if (typeof action === 'string') {
	          if (typeof data[action] === 'undefined') {
	            throw new TypeError("No method named \"" + action + "\"");
	          }
	
	          data[action]();
	        } else if (_config.interval && _config.ride) {
	          data.pause();
	          data.cycle();
	        }
	      });
	    };
	
	    Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
	      var selector = Util.getSelectorFromElement(this);
	
	      if (!selector) {
	        return;
	      }
	
	      var target = $__default['default'](selector)[0];
	
	      if (!target || !$__default['default'](target).hasClass(CLASS_NAME_CAROUSEL)) {
	        return;
	      }
	
	      var config = _extends({}, $__default['default'](target).data(), $__default['default'](this).data());
	
	      var slideIndex = this.getAttribute('data-slide-to');
	
	      if (slideIndex) {
	        config.interval = false;
	      }
	
	      Carousel._jQueryInterface.call($__default['default'](target), config);
	
	      if (slideIndex) {
	        $__default['default'](target).data(DATA_KEY$2).to(slideIndex);
	      }
	
	      event.preventDefault();
	    };
	
	    _createClass(Carousel, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$2;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default;
	      }
	    }]);
	
	    return Carousel;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	   */
	
	
	  $__default['default'](document).on(EVENT_CLICK_DATA_API$2, SELECTOR_DATA_SLIDE, Carousel._dataApiClickHandler);
	  $__default['default'](window).on(EVENT_LOAD_DATA_API$1, function () {
	    var carousels = [].slice.call(document.querySelectorAll(SELECTOR_DATA_RIDE));
	
	    for (var i = 0, len = carousels.length; i < len; i++) {
	      var $carousel = $__default['default'](carousels[i]);
	
	      Carousel._jQueryInterface.call($carousel, $carousel.data());
	    }
	  });
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	  $__default['default'].fn[NAME$2] = Carousel._jQueryInterface;
	  $__default['default'].fn[NAME$2].Constructor = Carousel;
	
	  $__default['default'].fn[NAME$2].noConflict = function () {
	    $__default['default'].fn[NAME$2] = JQUERY_NO_CONFLICT$2;
	    return Carousel._jQueryInterface;
	  };
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$3 = 'collapse';
	  var VERSION$3 = '4.6.0';
	  var DATA_KEY$3 = 'bs.collapse';
	  var EVENT_KEY$3 = "." + DATA_KEY$3;
	  var DATA_API_KEY$3 = '.data-api';
	  var JQUERY_NO_CONFLICT$3 = $__default['default'].fn[NAME$3];
	  var Default$1 = {
	    toggle: true,
	    parent: ''
	  };
	  var DefaultType$1 = {
	    toggle: 'boolean',
	    parent: '(string|element)'
	  };
	  var EVENT_SHOW = "show" + EVENT_KEY$3;
	  var EVENT_SHOWN = "shown" + EVENT_KEY$3;
	  var EVENT_HIDE = "hide" + EVENT_KEY$3;
	  var EVENT_HIDDEN = "hidden" + EVENT_KEY$3;
	  var EVENT_CLICK_DATA_API$3 = "click" + EVENT_KEY$3 + DATA_API_KEY$3;
	  var CLASS_NAME_SHOW$1 = 'show';
	  var CLASS_NAME_COLLAPSE = 'collapse';
	  var CLASS_NAME_COLLAPSING = 'collapsing';
	  var CLASS_NAME_COLLAPSED = 'collapsed';
	  var DIMENSION_WIDTH = 'width';
	  var DIMENSION_HEIGHT = 'height';
	  var SELECTOR_ACTIVES = '.show, .collapsing';
	  var SELECTOR_DATA_TOGGLE$1 = '[data-toggle="collapse"]';
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Collapse = /*#__PURE__*/function () {
	    function Collapse(element, config) {
	      this._isTransitioning = false;
	      this._element = element;
	      this._config = this._getConfig(config);
	      this._triggerArray = [].slice.call(document.querySelectorAll("[data-toggle=\"collapse\"][href=\"#" + element.id + "\"]," + ("[data-toggle=\"collapse\"][data-target=\"#" + element.id + "\"]")));
	      var toggleList = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$1));
	
	      for (var i = 0, len = toggleList.length; i < len; i++) {
	        var elem = toggleList[i];
	        var selector = Util.getSelectorFromElement(elem);
	        var filterElement = [].slice.call(document.querySelectorAll(selector)).filter(function (foundElem) {
	          return foundElem === element;
	        });
	
	        if (selector !== null && filterElement.length > 0) {
	          this._selector = selector;
	
	          this._triggerArray.push(elem);
	        }
	      }
	
	      this._parent = this._config.parent ? this._getParent() : null;
	
	      if (!this._config.parent) {
	        this._addAriaAndCollapsedClass(this._element, this._triggerArray);
	      }
	
	      if (this._config.toggle) {
	        this.toggle();
	      }
	    } // Getters
	
	
	    var _proto = Collapse.prototype;
	
	    // Public
	    _proto.toggle = function toggle() {
	      if ($__default['default'](this._element).hasClass(CLASS_NAME_SHOW$1)) {
	        this.hide();
	      } else {
	        this.show();
	      }
	    };
	
	    _proto.show = function show() {
	      var _this = this;
	
	      if (this._isTransitioning || $__default['default'](this._element).hasClass(CLASS_NAME_SHOW$1)) {
	        return;
	      }
	
	      var actives;
	      var activesData;
	
	      if (this._parent) {
	        actives = [].slice.call(this._parent.querySelectorAll(SELECTOR_ACTIVES)).filter(function (elem) {
	          if (typeof _this._config.parent === 'string') {
	            return elem.getAttribute('data-parent') === _this._config.parent;
	          }
	
	          return elem.classList.contains(CLASS_NAME_COLLAPSE);
	        });
	
	        if (actives.length === 0) {
	          actives = null;
	        }
	      }
	
	      if (actives) {
	        activesData = $__default['default'](actives).not(this._selector).data(DATA_KEY$3);
	
	        if (activesData && activesData._isTransitioning) {
	          return;
	        }
	      }
	
	      var startEvent = $__default['default'].Event(EVENT_SHOW);
	      $__default['default'](this._element).trigger(startEvent);
	
	      if (startEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      if (actives) {
	        Collapse._jQueryInterface.call($__default['default'](actives).not(this._selector), 'hide');
	
	        if (!activesData) {
	          $__default['default'](actives).data(DATA_KEY$3, null);
	        }
	      }
	
	      var dimension = this._getDimension();
	
	      $__default['default'](this._element).removeClass(CLASS_NAME_COLLAPSE).addClass(CLASS_NAME_COLLAPSING);
	      this._element.style[dimension] = 0;
	
	      if (this._triggerArray.length) {
	        $__default['default'](this._triggerArray).removeClass(CLASS_NAME_COLLAPSED).attr('aria-expanded', true);
	      }
	
	      this.setTransitioning(true);
	
	      var complete = function complete() {
	        $__default['default'](_this._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$1);
	        _this._element.style[dimension] = '';
	
	        _this.setTransitioning(false);
	
	        $__default['default'](_this._element).trigger(EVENT_SHOWN);
	      };
	
	      var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
	      var scrollSize = "scroll" + capitalizedDimension;
	      var transitionDuration = Util.getTransitionDurationFromElement(this._element);
	      $__default['default'](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	      this._element.style[dimension] = this._element[scrollSize] + "px";
	    };
	
	    _proto.hide = function hide() {
	      var _this2 = this;
	
	      if (this._isTransitioning || !$__default['default'](this._element).hasClass(CLASS_NAME_SHOW$1)) {
	        return;
	      }
	
	      var startEvent = $__default['default'].Event(EVENT_HIDE);
	      $__default['default'](this._element).trigger(startEvent);
	
	      if (startEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      var dimension = this._getDimension();
	
	      this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
	      Util.reflow(this._element);
	      $__default['default'](this._element).addClass(CLASS_NAME_COLLAPSING).removeClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$1);
	      var triggerArrayLength = this._triggerArray.length;
	
	      if (triggerArrayLength > 0) {
	        for (var i = 0; i < triggerArrayLength; i++) {
	          var trigger = this._triggerArray[i];
	          var selector = Util.getSelectorFromElement(trigger);
	
	          if (selector !== null) {
	            var $elem = $__default['default']([].slice.call(document.querySelectorAll(selector)));
	
	            if (!$elem.hasClass(CLASS_NAME_SHOW$1)) {
	              $__default['default'](trigger).addClass(CLASS_NAME_COLLAPSED).attr('aria-expanded', false);
	            }
	          }
	        }
	      }
	
	      this.setTransitioning(true);
	
	      var complete = function complete() {
	        _this2.setTransitioning(false);
	
	        $__default['default'](_this2._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE).trigger(EVENT_HIDDEN);
	      };
	
	      this._element.style[dimension] = '';
	      var transitionDuration = Util.getTransitionDurationFromElement(this._element);
	      $__default['default'](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	    };
	
	    _proto.setTransitioning = function setTransitioning(isTransitioning) {
	      this._isTransitioning = isTransitioning;
	    };
	
	    _proto.dispose = function dispose() {
	      $__default['default'].removeData(this._element, DATA_KEY$3);
	      this._config = null;
	      this._parent = null;
	      this._element = null;
	      this._triggerArray = null;
	      this._isTransitioning = null;
	    } // Private
	    ;
	
	    _proto._getConfig = function _getConfig(config) {
	      config = _extends({}, Default$1, config);
	      config.toggle = Boolean(config.toggle); // Coerce string values
	
	      Util.typeCheckConfig(NAME$3, config, DefaultType$1);
	      return config;
	    };
	
	    _proto._getDimension = function _getDimension() {
	      var hasWidth = $__default['default'](this._element).hasClass(DIMENSION_WIDTH);
	      return hasWidth ? DIMENSION_WIDTH : DIMENSION_HEIGHT;
	    };
	
	    _proto._getParent = function _getParent() {
	      var _this3 = this;
	
	      var parent;
	
	      if (Util.isElement(this._config.parent)) {
	        parent = this._config.parent; // It's a jQuery object
	
	        if (typeof this._config.parent.jquery !== 'undefined') {
	          parent = this._config.parent[0];
	        }
	      } else {
	        parent = document.querySelector(this._config.parent);
	      }
	
	      var selector = "[data-toggle=\"collapse\"][data-parent=\"" + this._config.parent + "\"]";
	      var children = [].slice.call(parent.querySelectorAll(selector));
	      $__default['default'](children).each(function (i, element) {
	        _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
	      });
	      return parent;
	    };
	
	    _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
	      var isOpen = $__default['default'](element).hasClass(CLASS_NAME_SHOW$1);
	
	      if (triggerArray.length) {
	        $__default['default'](triggerArray).toggleClass(CLASS_NAME_COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
	      }
	    } // Static
	    ;
	
	    Collapse._getTargetFromElement = function _getTargetFromElement(element) {
	      var selector = Util.getSelectorFromElement(element);
	      return selector ? document.querySelector(selector) : null;
	    };
	
	    Collapse._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var $element = $__default['default'](this);
	        var data = $element.data(DATA_KEY$3);
	
	        var _config = _extends({}, Default$1, $element.data(), typeof config === 'object' && config ? config : {});
	
	        if (!data && _config.toggle && typeof config === 'string' && /show|hide/.test(config)) {
	          _config.toggle = false;
	        }
	
	        if (!data) {
	          data = new Collapse(this, _config);
	          $element.data(DATA_KEY$3, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config]();
	        }
	      });
	    };
	
	    _createClass(Collapse, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$3;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$1;
	      }
	    }]);
	
	    return Collapse;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	   */
	
	
	  $__default['default'](document).on(EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$1, function (event) {
	    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
	    if (event.currentTarget.tagName === 'A') {
	      event.preventDefault();
	    }
	
	    var $trigger = $__default['default'](this);
	    var selector = Util.getSelectorFromElement(this);
	    var selectors = [].slice.call(document.querySelectorAll(selector));
	    $__default['default'](selectors).each(function () {
	      var $target = $__default['default'](this);
	      var data = $target.data(DATA_KEY$3);
	      var config = data ? 'toggle' : $trigger.data();
	
	      Collapse._jQueryInterface.call($target, config);
	    });
	  });
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	  $__default['default'].fn[NAME$3] = Collapse._jQueryInterface;
	  $__default['default'].fn[NAME$3].Constructor = Collapse;
	
	  $__default['default'].fn[NAME$3].noConflict = function () {
	    $__default['default'].fn[NAME$3] = JQUERY_NO_CONFLICT$3;
	    return Collapse._jQueryInterface;
	  };
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$4 = 'dropdown';
	  var VERSION$4 = '4.6.0';
	  var DATA_KEY$4 = 'bs.dropdown';
	  var EVENT_KEY$4 = "." + DATA_KEY$4;
	  var DATA_API_KEY$4 = '.data-api';
	  var JQUERY_NO_CONFLICT$4 = $__default['default'].fn[NAME$4];
	  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
	
	  var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key
	
	  var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key
	
	  var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
	
	  var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
	
	  var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)
	
	  var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE);
	  var EVENT_HIDE$1 = "hide" + EVENT_KEY$4;
	  var EVENT_HIDDEN$1 = "hidden" + EVENT_KEY$4;
	  var EVENT_SHOW$1 = "show" + EVENT_KEY$4;
	  var EVENT_SHOWN$1 = "shown" + EVENT_KEY$4;
	  var EVENT_CLICK = "click" + EVENT_KEY$4;
	  var EVENT_CLICK_DATA_API$4 = "click" + EVENT_KEY$4 + DATA_API_KEY$4;
	  var EVENT_KEYDOWN_DATA_API = "keydown" + EVENT_KEY$4 + DATA_API_KEY$4;
	  var EVENT_KEYUP_DATA_API = "keyup" + EVENT_KEY$4 + DATA_API_KEY$4;
	  var CLASS_NAME_DISABLED = 'disabled';
	  var CLASS_NAME_SHOW$2 = 'show';
	  var CLASS_NAME_DROPUP = 'dropup';
	  var CLASS_NAME_DROPRIGHT = 'dropright';
	  var CLASS_NAME_DROPLEFT = 'dropleft';
	  var CLASS_NAME_MENURIGHT = 'dropdown-menu-right';
	  var CLASS_NAME_POSITION_STATIC = 'position-static';
	  var SELECTOR_DATA_TOGGLE$2 = '[data-toggle="dropdown"]';
	  var SELECTOR_FORM_CHILD = '.dropdown form';
	  var SELECTOR_MENU = '.dropdown-menu';
	  var SELECTOR_NAVBAR_NAV = '.navbar-nav';
	  var SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
	  var PLACEMENT_TOP = 'top-start';
	  var PLACEMENT_TOPEND = 'top-end';
	  var PLACEMENT_BOTTOM = 'bottom-start';
	  var PLACEMENT_BOTTOMEND = 'bottom-end';
	  var PLACEMENT_RIGHT = 'right-start';
	  var PLACEMENT_LEFT = 'left-start';
	  var Default$2 = {
	    offset: 0,
	    flip: true,
	    boundary: 'scrollParent',
	    reference: 'toggle',
	    display: 'dynamic',
	    popperConfig: null
	  };
	  var DefaultType$2 = {
	    offset: '(number|string|function)',
	    flip: 'boolean',
	    boundary: '(string|element)',
	    reference: '(string|element)',
	    display: 'string',
	    popperConfig: '(null|object)'
	  };
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Dropdown = /*#__PURE__*/function () {
	    function Dropdown(element, config) {
	      this._element = element;
	      this._popper = null;
	      this._config = this._getConfig(config);
	      this._menu = this._getMenuElement();
	      this._inNavbar = this._detectNavbar();
	
	      this._addEventListeners();
	    } // Getters
	
	
	    var _proto = Dropdown.prototype;
	
	    // Public
	    _proto.toggle = function toggle() {
	      if (this._element.disabled || $__default['default'](this._element).hasClass(CLASS_NAME_DISABLED)) {
	        return;
	      }
	
	      var isActive = $__default['default'](this._menu).hasClass(CLASS_NAME_SHOW$2);
	
	      Dropdown._clearMenus();
	
	      if (isActive) {
	        return;
	      }
	
	      this.show(true);
	    };
	
	    _proto.show = function show(usePopper) {
	      if (usePopper === void 0) {
	        usePopper = false;
	      }
	
	      if (this._element.disabled || $__default['default'](this._element).hasClass(CLASS_NAME_DISABLED) || $__default['default'](this._menu).hasClass(CLASS_NAME_SHOW$2)) {
	        return;
	      }
	
	      var relatedTarget = {
	        relatedTarget: this._element
	      };
	      var showEvent = $__default['default'].Event(EVENT_SHOW$1, relatedTarget);
	
	      var parent = Dropdown._getParentFromElement(this._element);
	
	      $__default['default'](parent).trigger(showEvent);
	
	      if (showEvent.isDefaultPrevented()) {
	        return;
	      } // Totally disable Popper for Dropdowns in Navbar
	
	
	      if (!this._inNavbar && usePopper) {
	        /**
	         * Check for Popper dependency
	         * Popper - https://popper.js.org
	         */
	        if (typeof Popper__default['default'] === 'undefined') {
	          throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
	        }
	
	        var referenceElement = this._element;
	
	        if (this._config.reference === 'parent') {
	          referenceElement = parent;
	        } else if (Util.isElement(this._config.reference)) {
	          referenceElement = this._config.reference; // Check if it's jQuery element
	
	          if (typeof this._config.reference.jquery !== 'undefined') {
	            referenceElement = this._config.reference[0];
	          }
	        } // If boundary is not `scrollParent`, then set position to `static`
	        // to allow the menu to "escape" the scroll parent's boundaries
	        // https://github.com/twbs/bootstrap/issues/24251
	
	
	        if (this._config.boundary !== 'scrollParent') {
	          $__default['default'](parent).addClass(CLASS_NAME_POSITION_STATIC);
	        }
	
	        this._popper = new Popper__default['default'](referenceElement, this._menu, this._getPopperConfig());
	      } // If this is a touch-enabled device we add extra
	      // empty mouseover listeners to the body's immediate children;
	      // only needed because of broken event delegation on iOS
	      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	
	
	      if ('ontouchstart' in document.documentElement && $__default['default'](parent).closest(SELECTOR_NAVBAR_NAV).length === 0) {
	        $__default['default'](document.body).children().on('mouseover', null, $__default['default'].noop);
	      }
	
	      this._element.focus();
	
	      this._element.setAttribute('aria-expanded', true);
	
	      $__default['default'](this._menu).toggleClass(CLASS_NAME_SHOW$2);
	      $__default['default'](parent).toggleClass(CLASS_NAME_SHOW$2).trigger($__default['default'].Event(EVENT_SHOWN$1, relatedTarget));
	    };
	
	    _proto.hide = function hide() {
	      if (this._element.disabled || $__default['default'](this._element).hasClass(CLASS_NAME_DISABLED) || !$__default['default'](this._menu).hasClass(CLASS_NAME_SHOW$2)) {
	        return;
	      }
	
	      var relatedTarget = {
	        relatedTarget: this._element
	      };
	      var hideEvent = $__default['default'].Event(EVENT_HIDE$1, relatedTarget);
	
	      var parent = Dropdown._getParentFromElement(this._element);
	
	      $__default['default'](parent).trigger(hideEvent);
	
	      if (hideEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      if (this._popper) {
	        this._popper.destroy();
	      }
	
	      $__default['default'](this._menu).toggleClass(CLASS_NAME_SHOW$2);
	      $__default['default'](parent).toggleClass(CLASS_NAME_SHOW$2).trigger($__default['default'].Event(EVENT_HIDDEN$1, relatedTarget));
	    };
	
	    _proto.dispose = function dispose() {
	      $__default['default'].removeData(this._element, DATA_KEY$4);
	      $__default['default'](this._element).off(EVENT_KEY$4);
	      this._element = null;
	      this._menu = null;
	
	      if (this._popper !== null) {
	        this._popper.destroy();
	
	        this._popper = null;
	      }
	    };
	
	    _proto.update = function update() {
	      this._inNavbar = this._detectNavbar();
	
	      if (this._popper !== null) {
	        this._popper.scheduleUpdate();
	      }
	    } // Private
	    ;
	
	    _proto._addEventListeners = function _addEventListeners() {
	      var _this = this;
	
	      $__default['default'](this._element).on(EVENT_CLICK, function (event) {
	        event.preventDefault();
	        event.stopPropagation();
	
	        _this.toggle();
	      });
	    };
	
	    _proto._getConfig = function _getConfig(config) {
	      config = _extends({}, this.constructor.Default, $__default['default'](this._element).data(), config);
	      Util.typeCheckConfig(NAME$4, config, this.constructor.DefaultType);
	      return config;
	    };
	
	    _proto._getMenuElement = function _getMenuElement() {
	      if (!this._menu) {
	        var parent = Dropdown._getParentFromElement(this._element);
	
	        if (parent) {
	          this._menu = parent.querySelector(SELECTOR_MENU);
	        }
	      }
	
	      return this._menu;
	    };
	
	    _proto._getPlacement = function _getPlacement() {
	      var $parentDropdown = $__default['default'](this._element.parentNode);
	      var placement = PLACEMENT_BOTTOM; // Handle dropup
	
	      if ($parentDropdown.hasClass(CLASS_NAME_DROPUP)) {
	        placement = $__default['default'](this._menu).hasClass(CLASS_NAME_MENURIGHT) ? PLACEMENT_TOPEND : PLACEMENT_TOP;
	      } else if ($parentDropdown.hasClass(CLASS_NAME_DROPRIGHT)) {
	        placement = PLACEMENT_RIGHT;
	      } else if ($parentDropdown.hasClass(CLASS_NAME_DROPLEFT)) {
	        placement = PLACEMENT_LEFT;
	      } else if ($__default['default'](this._menu).hasClass(CLASS_NAME_MENURIGHT)) {
	        placement = PLACEMENT_BOTTOMEND;
	      }
	
	      return placement;
	    };
	
	    _proto._detectNavbar = function _detectNavbar() {
	      return $__default['default'](this._element).closest('.navbar').length > 0;
	    };
	
	    _proto._getOffset = function _getOffset() {
	      var _this2 = this;
	
	      var offset = {};
	
	      if (typeof this._config.offset === 'function') {
	        offset.fn = function (data) {
	          data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets, _this2._element) || {});
	          return data;
	        };
	      } else {
	        offset.offset = this._config.offset;
	      }
	
	      return offset;
	    };
	
	    _proto._getPopperConfig = function _getPopperConfig() {
	      var popperConfig = {
	        placement: this._getPlacement(),
	        modifiers: {
	          offset: this._getOffset(),
	          flip: {
	            enabled: this._config.flip
	          },
	          preventOverflow: {
	            boundariesElement: this._config.boundary
	          }
	        }
	      }; // Disable Popper if we have a static display
	
	      if (this._config.display === 'static') {
	        popperConfig.modifiers.applyStyle = {
	          enabled: false
	        };
	      }
	
	      return _extends({}, popperConfig, this._config.popperConfig);
	    } // Static
	    ;
	
	    Dropdown._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = $__default['default'](this).data(DATA_KEY$4);
	
	        var _config = typeof config === 'object' ? config : null;
	
	        if (!data) {
	          data = new Dropdown(this, _config);
	          $__default['default'](this).data(DATA_KEY$4, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config]();
	        }
	      });
	    };
	
	    Dropdown._clearMenus = function _clearMenus(event) {
	      if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
	        return;
	      }
	
	      var toggles = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$2));
	
	      for (var i = 0, len = toggles.length; i < len; i++) {
	        var parent = Dropdown._getParentFromElement(toggles[i]);
	
	        var context = $__default['default'](toggles[i]).data(DATA_KEY$4);
	        var relatedTarget = {
	          relatedTarget: toggles[i]
	        };
	
	        if (event && event.type === 'click') {
	          relatedTarget.clickEvent = event;
	        }
	
	        if (!context) {
	          continue;
	        }
	
	        var dropdownMenu = context._menu;
	
	        if (!$__default['default'](parent).hasClass(CLASS_NAME_SHOW$2)) {
	          continue;
	        }
	
	        if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && $__default['default'].contains(parent, event.target)) {
	          continue;
	        }
	
	        var hideEvent = $__default['default'].Event(EVENT_HIDE$1, relatedTarget);
	        $__default['default'](parent).trigger(hideEvent);
	
	        if (hideEvent.isDefaultPrevented()) {
	          continue;
	        } // If this is a touch-enabled device we remove the extra
	        // empty mouseover listeners we added for iOS support
	
	
	        if ('ontouchstart' in document.documentElement) {
	          $__default['default'](document.body).children().off('mouseover', null, $__default['default'].noop);
	        }
	
	        toggles[i].setAttribute('aria-expanded', 'false');
	
	        if (context._popper) {
	          context._popper.destroy();
	        }
	
	        $__default['default'](dropdownMenu).removeClass(CLASS_NAME_SHOW$2);
	        $__default['default'](parent).removeClass(CLASS_NAME_SHOW$2).trigger($__default['default'].Event(EVENT_HIDDEN$1, relatedTarget));
	      }
	    };
	
	    Dropdown._getParentFromElement = function _getParentFromElement(element) {
	      var parent;
	      var selector = Util.getSelectorFromElement(element);
	
	      if (selector) {
	        parent = document.querySelector(selector);
	      }
	
	      return parent || element.parentNode;
	    } // eslint-disable-next-line complexity
	    ;
	
	    Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
	      // If not input/textarea:
	      //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
	      // If input/textarea:
	      //  - If space key => not a dropdown command
	      //  - If key is other than escape
	      //    - If key is not up or down => not a dropdown command
	      //    - If trigger inside the menu => not a dropdown command
	      if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $__default['default'](event.target).closest(SELECTOR_MENU).length) : !REGEXP_KEYDOWN.test(event.which)) {
	        return;
	      }
	
	      if (this.disabled || $__default['default'](this).hasClass(CLASS_NAME_DISABLED)) {
	        return;
	      }
	
	      var parent = Dropdown._getParentFromElement(this);
	
	      var isActive = $__default['default'](parent).hasClass(CLASS_NAME_SHOW$2);
	
	      if (!isActive && event.which === ESCAPE_KEYCODE) {
	        return;
	      }
	
	      event.preventDefault();
	      event.stopPropagation();
	
	      if (!isActive || event.which === ESCAPE_KEYCODE || event.which === SPACE_KEYCODE) {
	        if (event.which === ESCAPE_KEYCODE) {
	          $__default['default'](parent.querySelector(SELECTOR_DATA_TOGGLE$2)).trigger('focus');
	        }
	
	        $__default['default'](this).trigger('click');
	        return;
	      }
	
	      var items = [].slice.call(parent.querySelectorAll(SELECTOR_VISIBLE_ITEMS)).filter(function (item) {
	        return $__default['default'](item).is(':visible');
	      });
	
	      if (items.length === 0) {
	        return;
	      }
	
	      var index = items.indexOf(event.target);
	
	      if (event.which === ARROW_UP_KEYCODE && index > 0) {
	        // Up
	        index--;
	      }
	
	      if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
	        // Down
	        index++;
	      }
	
	      if (index < 0) {
	        index = 0;
	      }
	
	      items[index].focus();
	    };
	
	    _createClass(Dropdown, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$4;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$2;
	      }
	    }, {
	      key: "DefaultType",
	      get: function get() {
	        return DefaultType$2;
	      }
	    }]);
	
	    return Dropdown;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	   */
	
	
	  $__default['default'](document).on(EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$2, Dropdown._dataApiKeydownHandler).on(EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown._dataApiKeydownHandler).on(EVENT_CLICK_DATA_API$4 + " " + EVENT_KEYUP_DATA_API, Dropdown._clearMenus).on(EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$2, function (event) {
	    event.preventDefault();
	    event.stopPropagation();
	
	    Dropdown._jQueryInterface.call($__default['default'](this), 'toggle');
	  }).on(EVENT_CLICK_DATA_API$4, SELECTOR_FORM_CHILD, function (e) {
	    e.stopPropagation();
	  });
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	  $__default['default'].fn[NAME$4] = Dropdown._jQueryInterface;
	  $__default['default'].fn[NAME$4].Constructor = Dropdown;
	
	  $__default['default'].fn[NAME$4].noConflict = function () {
	    $__default['default'].fn[NAME$4] = JQUERY_NO_CONFLICT$4;
	    return Dropdown._jQueryInterface;
	  };
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$5 = 'modal';
	  var VERSION$5 = '4.6.0';
	  var DATA_KEY$5 = 'bs.modal';
	  var EVENT_KEY$5 = "." + DATA_KEY$5;
	  var DATA_API_KEY$5 = '.data-api';
	  var JQUERY_NO_CONFLICT$5 = $__default['default'].fn[NAME$5];
	  var ESCAPE_KEYCODE$1 = 27; // KeyboardEvent.which value for Escape (Esc) key
	
	  var Default$3 = {
	    backdrop: true,
	    keyboard: true,
	    focus: true,
	    show: true
	  };
	  var DefaultType$3 = {
	    backdrop: '(boolean|string)',
	    keyboard: 'boolean',
	    focus: 'boolean',
	    show: 'boolean'
	  };
	  var EVENT_HIDE$2 = "hide" + EVENT_KEY$5;
	  var EVENT_HIDE_PREVENTED = "hidePrevented" + EVENT_KEY$5;
	  var EVENT_HIDDEN$2 = "hidden" + EVENT_KEY$5;
	  var EVENT_SHOW$2 = "show" + EVENT_KEY$5;
	  var EVENT_SHOWN$2 = "shown" + EVENT_KEY$5;
	  var EVENT_FOCUSIN = "focusin" + EVENT_KEY$5;
	  var EVENT_RESIZE = "resize" + EVENT_KEY$5;
	  var EVENT_CLICK_DISMISS = "click.dismiss" + EVENT_KEY$5;
	  var EVENT_KEYDOWN_DISMISS = "keydown.dismiss" + EVENT_KEY$5;
	  var EVENT_MOUSEUP_DISMISS = "mouseup.dismiss" + EVENT_KEY$5;
	  var EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss" + EVENT_KEY$5;
	  var EVENT_CLICK_DATA_API$5 = "click" + EVENT_KEY$5 + DATA_API_KEY$5;
	  var CLASS_NAME_SCROLLABLE = 'modal-dialog-scrollable';
	  var CLASS_NAME_SCROLLBAR_MEASURER = 'modal-scrollbar-measure';
	  var CLASS_NAME_BACKDROP = 'modal-backdrop';
	  var CLASS_NAME_OPEN = 'modal-open';
	  var CLASS_NAME_FADE$1 = 'fade';
	  var CLASS_NAME_SHOW$3 = 'show';
	  var CLASS_NAME_STATIC = 'modal-static';
	  var SELECTOR_DIALOG = '.modal-dialog';
	  var SELECTOR_MODAL_BODY = '.modal-body';
	  var SELECTOR_DATA_TOGGLE$3 = '[data-toggle="modal"]';
	  var SELECTOR_DATA_DISMISS = '[data-dismiss="modal"]';
	  var SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
	  var SELECTOR_STICKY_CONTENT = '.sticky-top';
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Modal = /*#__PURE__*/function () {
	    function Modal(element, config) {
	      this._config = this._getConfig(config);
	      this._element = element;
	      this._dialog = element.querySelector(SELECTOR_DIALOG);
	      this._backdrop = null;
	      this._isShown = false;
	      this._isBodyOverflowing = false;
	      this._ignoreBackdropClick = false;
	      this._isTransitioning = false;
	      this._scrollbarWidth = 0;
	    } // Getters
	
	
	    var _proto = Modal.prototype;
	
	    // Public
	    _proto.toggle = function toggle(relatedTarget) {
	      return this._isShown ? this.hide() : this.show(relatedTarget);
	    };
	
	    _proto.show = function show(relatedTarget) {
	      var _this = this;
	
	      if (this._isShown || this._isTransitioning) {
	        return;
	      }
	
	      if ($__default['default'](this._element).hasClass(CLASS_NAME_FADE$1)) {
	        this._isTransitioning = true;
	      }
	
	      var showEvent = $__default['default'].Event(EVENT_SHOW$2, {
	        relatedTarget: relatedTarget
	      });
	      $__default['default'](this._element).trigger(showEvent);
	
	      if (this._isShown || showEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      this._isShown = true;
	
	      this._checkScrollbar();
	
	      this._setScrollbar();
	
	      this._adjustDialog();
	
	      this._setEscapeEvent();
	
	      this._setResizeEvent();
	
	      $__default['default'](this._element).on(EVENT_CLICK_DISMISS, SELECTOR_DATA_DISMISS, function (event) {
	        return _this.hide(event);
	      });
	      $__default['default'](this._dialog).on(EVENT_MOUSEDOWN_DISMISS, function () {
	        $__default['default'](_this._element).one(EVENT_MOUSEUP_DISMISS, function (event) {
	          if ($__default['default'](event.target).is(_this._element)) {
	            _this._ignoreBackdropClick = true;
	          }
	        });
	      });
	
	      this._showBackdrop(function () {
	        return _this._showElement(relatedTarget);
	      });
	    };
	
	    _proto.hide = function hide(event) {
	      var _this2 = this;
	
	      if (event) {
	        event.preventDefault();
	      }
	
	      if (!this._isShown || this._isTransitioning) {
	        return;
	      }
	
	      var hideEvent = $__default['default'].Event(EVENT_HIDE$2);
	      $__default['default'](this._element).trigger(hideEvent);
	
	      if (!this._isShown || hideEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      this._isShown = false;
	      var transition = $__default['default'](this._element).hasClass(CLASS_NAME_FADE$1);
	
	      if (transition) {
	        this._isTransitioning = true;
	      }
	
	      this._setEscapeEvent();
	
	      this._setResizeEvent();
	
	      $__default['default'](document).off(EVENT_FOCUSIN);
	      $__default['default'](this._element).removeClass(CLASS_NAME_SHOW$3);
	      $__default['default'](this._element).off(EVENT_CLICK_DISMISS);
	      $__default['default'](this._dialog).off(EVENT_MOUSEDOWN_DISMISS);
	
	      if (transition) {
	        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
	        $__default['default'](this._element).one(Util.TRANSITION_END, function (event) {
	          return _this2._hideModal(event);
	        }).emulateTransitionEnd(transitionDuration);
	      } else {
	        this._hideModal();
	      }
	    };
	
	    _proto.dispose = function dispose() {
	      [window, this._element, this._dialog].forEach(function (htmlElement) {
	        return $__default['default'](htmlElement).off(EVENT_KEY$5);
	      });
	      /**
	       * `document` has 2 events `EVENT_FOCUSIN` and `EVENT_CLICK_DATA_API`
	       * Do not move `document` in `htmlElements` array
	       * It will remove `EVENT_CLICK_DATA_API` event that should remain
	       */
	
	      $__default['default'](document).off(EVENT_FOCUSIN);
	      $__default['default'].removeData(this._element, DATA_KEY$5);
	      this._config = null;
	      this._element = null;
	      this._dialog = null;
	      this._backdrop = null;
	      this._isShown = null;
	      this._isBodyOverflowing = null;
	      this._ignoreBackdropClick = null;
	      this._isTransitioning = null;
	      this._scrollbarWidth = null;
	    };
	
	    _proto.handleUpdate = function handleUpdate() {
	      this._adjustDialog();
	    } // Private
	    ;
	
	    _proto._getConfig = function _getConfig(config) {
	      config = _extends({}, Default$3, config);
	      Util.typeCheckConfig(NAME$5, config, DefaultType$3);
	      return config;
	    };
	
	    _proto._triggerBackdropTransition = function _triggerBackdropTransition() {
	      var _this3 = this;
	
	      var hideEventPrevented = $__default['default'].Event(EVENT_HIDE_PREVENTED);
	      $__default['default'](this._element).trigger(hideEventPrevented);
	
	      if (hideEventPrevented.isDefaultPrevented()) {
	        return;
	      }
	
	      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
	
	      if (!isModalOverflowing) {
	        this._element.style.overflowY = 'hidden';
	      }
	
	      this._element.classList.add(CLASS_NAME_STATIC);
	
	      var modalTransitionDuration = Util.getTransitionDurationFromElement(this._dialog);
	      $__default['default'](this._element).off(Util.TRANSITION_END);
	      $__default['default'](this._element).one(Util.TRANSITION_END, function () {
	        _this3._element.classList.remove(CLASS_NAME_STATIC);
	
	        if (!isModalOverflowing) {
	          $__default['default'](_this3._element).one(Util.TRANSITION_END, function () {
	            _this3._element.style.overflowY = '';
	          }).emulateTransitionEnd(_this3._element, modalTransitionDuration);
	        }
	      }).emulateTransitionEnd(modalTransitionDuration);
	
	      this._element.focus();
	    };
	
	    _proto._showElement = function _showElement(relatedTarget) {
	      var _this4 = this;
	
	      var transition = $__default['default'](this._element).hasClass(CLASS_NAME_FADE$1);
	      var modalBody = this._dialog ? this._dialog.querySelector(SELECTOR_MODAL_BODY) : null;
	
	      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
	        // Don't move modal's DOM position
	        document.body.appendChild(this._element);
	      }
	
	      this._element.style.display = 'block';
	
	      this._element.removeAttribute('aria-hidden');
	
	      this._element.setAttribute('aria-modal', true);
	
	      this._element.setAttribute('role', 'dialog');
	
	      if ($__default['default'](this._dialog).hasClass(CLASS_NAME_SCROLLABLE) && modalBody) {
	        modalBody.scrollTop = 0;
	      } else {
	        this._element.scrollTop = 0;
	      }
	
	      if (transition) {
	        Util.reflow(this._element);
	      }
	
	      $__default['default'](this._element).addClass(CLASS_NAME_SHOW$3);
	
	      if (this._config.focus) {
	        this._enforceFocus();
	      }
	
	      var shownEvent = $__default['default'].Event(EVENT_SHOWN$2, {
	        relatedTarget: relatedTarget
	      });
	
	      var transitionComplete = function transitionComplete() {
	        if (_this4._config.focus) {
	          _this4._element.focus();
	        }
	
	        _this4._isTransitioning = false;
	        $__default['default'](_this4._element).trigger(shownEvent);
	      };
	
	      if (transition) {
	        var transitionDuration = Util.getTransitionDurationFromElement(this._dialog);
	        $__default['default'](this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
	      } else {
	        transitionComplete();
	      }
	    };
	
	    _proto._enforceFocus = function _enforceFocus() {
	      var _this5 = this;
	
	      $__default['default'](document).off(EVENT_FOCUSIN) // Guard against infinite focus loop
	      .on(EVENT_FOCUSIN, function (event) {
	        if (document !== event.target && _this5._element !== event.target && $__default['default'](_this5._element).has(event.target).length === 0) {
	          _this5._element.focus();
	        }
	      });
	    };
	
	    _proto._setEscapeEvent = function _setEscapeEvent() {
	      var _this6 = this;
	
	      if (this._isShown) {
	        $__default['default'](this._element).on(EVENT_KEYDOWN_DISMISS, function (event) {
	          if (_this6._config.keyboard && event.which === ESCAPE_KEYCODE$1) {
	            event.preventDefault();
	
	            _this6.hide();
	          } else if (!_this6._config.keyboard && event.which === ESCAPE_KEYCODE$1) {
	            _this6._triggerBackdropTransition();
	          }
	        });
	      } else if (!this._isShown) {
	        $__default['default'](this._element).off(EVENT_KEYDOWN_DISMISS);
	      }
	    };
	
	    _proto._setResizeEvent = function _setResizeEvent() {
	      var _this7 = this;
	
	      if (this._isShown) {
	        $__default['default'](window).on(EVENT_RESIZE, function (event) {
	          return _this7.handleUpdate(event);
	        });
	      } else {
	        $__default['default'](window).off(EVENT_RESIZE);
	      }
	    };
	
	    _proto._hideModal = function _hideModal() {
	      var _this8 = this;
	
	      this._element.style.display = 'none';
	
	      this._element.setAttribute('aria-hidden', true);
	
	      this._element.removeAttribute('aria-modal');
	
	      this._element.removeAttribute('role');
	
	      this._isTransitioning = false;
	
	      this._showBackdrop(function () {
	        $__default['default'](document.body).removeClass(CLASS_NAME_OPEN);
	
	        _this8._resetAdjustments();
	
	        _this8._resetScrollbar();
	
	        $__default['default'](_this8._element).trigger(EVENT_HIDDEN$2);
	      });
	    };
	
	    _proto._removeBackdrop = function _removeBackdrop() {
	      if (this._backdrop) {
	        $__default['default'](this._backdrop).remove();
	        this._backdrop = null;
	      }
	    };
	
	    _proto._showBackdrop = function _showBackdrop(callback) {
	      var _this9 = this;
	
	      var animate = $__default['default'](this._element).hasClass(CLASS_NAME_FADE$1) ? CLASS_NAME_FADE$1 : '';
	
	      if (this._isShown && this._config.backdrop) {
	        this._backdrop = document.createElement('div');
	        this._backdrop.className = CLASS_NAME_BACKDROP;
	
	        if (animate) {
	          this._backdrop.classList.add(animate);
	        }
	
	        $__default['default'](this._backdrop).appendTo(document.body);
	        $__default['default'](this._element).on(EVENT_CLICK_DISMISS, function (event) {
	          if (_this9._ignoreBackdropClick) {
	            _this9._ignoreBackdropClick = false;
	            return;
	          }
	
	          if (event.target !== event.currentTarget) {
	            return;
	          }
	
	          if (_this9._config.backdrop === 'static') {
	            _this9._triggerBackdropTransition();
	          } else {
	            _this9.hide();
	          }
	        });
	
	        if (animate) {
	          Util.reflow(this._backdrop);
	        }
	
	        $__default['default'](this._backdrop).addClass(CLASS_NAME_SHOW$3);
	
	        if (!callback) {
	          return;
	        }
	
	        if (!animate) {
	          callback();
	          return;
	        }
	
	        var backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
	        $__default['default'](this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
	      } else if (!this._isShown && this._backdrop) {
	        $__default['default'](this._backdrop).removeClass(CLASS_NAME_SHOW$3);
	
	        var callbackRemove = function callbackRemove() {
	          _this9._removeBackdrop();
	
	          if (callback) {
	            callback();
	          }
	        };
	
	        if ($__default['default'](this._element).hasClass(CLASS_NAME_FADE$1)) {
	          var _backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
	
	          $__default['default'](this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
	        } else {
	          callbackRemove();
	        }
	      } else if (callback) {
	        callback();
	      }
	    } // ----------------------------------------------------------------------
	    // the following methods are used to handle overflowing modals
	    // todo (fat): these should probably be refactored out of modal.js
	    // ----------------------------------------------------------------------
	    ;
	
	    _proto._adjustDialog = function _adjustDialog() {
	      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
	
	      if (!this._isBodyOverflowing && isModalOverflowing) {
	        this._element.style.paddingLeft = this._scrollbarWidth + "px";
	      }
	
	      if (this._isBodyOverflowing && !isModalOverflowing) {
	        this._element.style.paddingRight = this._scrollbarWidth + "px";
	      }
	    };
	
	    _proto._resetAdjustments = function _resetAdjustments() {
	      this._element.style.paddingLeft = '';
	      this._element.style.paddingRight = '';
	    };
	
	    _proto._checkScrollbar = function _checkScrollbar() {
	      var rect = document.body.getBoundingClientRect();
	      this._isBodyOverflowing = Math.round(rect.left + rect.right) < window.innerWidth;
	      this._scrollbarWidth = this._getScrollbarWidth();
	    };
	
	    _proto._setScrollbar = function _setScrollbar() {
	      var _this10 = this;
	
	      if (this._isBodyOverflowing) {
	        // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
	        //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
	        var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
	        var stickyContent = [].slice.call(document.querySelectorAll(SELECTOR_STICKY_CONTENT)); // Adjust fixed content padding
	
	        $__default['default'](fixedContent).each(function (index, element) {
	          var actualPadding = element.style.paddingRight;
	          var calculatedPadding = $__default['default'](element).css('padding-right');
	          $__default['default'](element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this10._scrollbarWidth + "px");
	        }); // Adjust sticky content margin
	
	        $__default['default'](stickyContent).each(function (index, element) {
	          var actualMargin = element.style.marginRight;
	          var calculatedMargin = $__default['default'](element).css('margin-right');
	          $__default['default'](element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this10._scrollbarWidth + "px");
	        }); // Adjust body padding
	
	        var actualPadding = document.body.style.paddingRight;
	        var calculatedPadding = $__default['default'](document.body).css('padding-right');
	        $__default['default'](document.body).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
	      }
	
	      $__default['default'](document.body).addClass(CLASS_NAME_OPEN);
	    };
	
	    _proto._resetScrollbar = function _resetScrollbar() {
	      // Restore fixed content padding
	      var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
	      $__default['default'](fixedContent).each(function (index, element) {
	        var padding = $__default['default'](element).data('padding-right');
	        $__default['default'](element).removeData('padding-right');
	        element.style.paddingRight = padding ? padding : '';
	      }); // Restore sticky content
	
	      var elements = [].slice.call(document.querySelectorAll("" + SELECTOR_STICKY_CONTENT));
	      $__default['default'](elements).each(function (index, element) {
	        var margin = $__default['default'](element).data('margin-right');
	
	        if (typeof margin !== 'undefined') {
	          $__default['default'](element).css('margin-right', margin).removeData('margin-right');
	        }
	      }); // Restore body padding
	
	      var padding = $__default['default'](document.body).data('padding-right');
	      $__default['default'](document.body).removeData('padding-right');
	      document.body.style.paddingRight = padding ? padding : '';
	    };
	
	    _proto._getScrollbarWidth = function _getScrollbarWidth() {
	      // thx d.walsh
	      var scrollDiv = document.createElement('div');
	      scrollDiv.className = CLASS_NAME_SCROLLBAR_MEASURER;
	      document.body.appendChild(scrollDiv);
	      var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	      return scrollbarWidth;
	    } // Static
	    ;
	
	    Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
	      return this.each(function () {
	        var data = $__default['default'](this).data(DATA_KEY$5);
	
	        var _config = _extends({}, Default$3, $__default['default'](this).data(), typeof config === 'object' && config ? config : {});
	
	        if (!data) {
	          data = new Modal(this, _config);
	          $__default['default'](this).data(DATA_KEY$5, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config](relatedTarget);
	        } else if (_config.show) {
	          data.show(relatedTarget);
	        }
	      });
	    };
	
	    _createClass(Modal, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$5;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$3;
	      }
	    }]);
	
	    return Modal;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	   */
	
	
	  $__default['default'](document).on(EVENT_CLICK_DATA_API$5, SELECTOR_DATA_TOGGLE$3, function (event) {
	    var _this11 = this;
	
	    var target;
	    var selector = Util.getSelectorFromElement(this);
	
	    if (selector) {
	      target = document.querySelector(selector);
	    }
	
	    var config = $__default['default'](target).data(DATA_KEY$5) ? 'toggle' : _extends({}, $__default['default'](target).data(), $__default['default'](this).data());
	
	    if (this.tagName === 'A' || this.tagName === 'AREA') {
	      event.preventDefault();
	    }
	
	    var $target = $__default['default'](target).one(EVENT_SHOW$2, function (showEvent) {
	      if (showEvent.isDefaultPrevented()) {
	        // Only register focus restorer if modal will actually get shown
	        return;
	      }
	
	      $target.one(EVENT_HIDDEN$2, function () {
	        if ($__default['default'](_this11).is(':visible')) {
	          _this11.focus();
	        }
	      });
	    });
	
	    Modal._jQueryInterface.call($__default['default'](target), config, this);
	  });
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	  $__default['default'].fn[NAME$5] = Modal._jQueryInterface;
	  $__default['default'].fn[NAME$5].Constructor = Modal;
	
	  $__default['default'].fn[NAME$5].noConflict = function () {
	    $__default['default'].fn[NAME$5] = JQUERY_NO_CONFLICT$5;
	    return Modal._jQueryInterface;
	  };
	
	  /**
	   * --------------------------------------------------------------------------
	   * Bootstrap (v4.6.0): tools/sanitizer.js
	   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
	   * --------------------------------------------------------------------------
	   */
	  var uriAttrs = ['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href'];
	  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
	  var DefaultWhitelist = {
	    // Global attributes allowed on any supplied element below.
	    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
	    a: ['target', 'href', 'title', 'rel'],
	    area: [],
	    b: [],
	    br: [],
	    col: [],
	    code: [],
	    div: [],
	    em: [],
	    hr: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    i: [],
	    img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
	    li: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    small: [],
	    span: [],
	    sub: [],
	    sup: [],
	    strong: [],
	    u: [],
	    ul: []
	  };
	  /**
	   * A pattern that recognizes a commonly useful subset of URLs that are safe.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	
	  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^#&/:?]*(?:[#/?]|$))/gi;
	  /**
	   * A pattern that matches safe data URLs. Only matches image, video and audio types.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	
	  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;
	
	  function allowedAttribute(attr, allowedAttributeList) {
	    var attrName = attr.nodeName.toLowerCase();
	
	    if (allowedAttributeList.indexOf(attrName) !== -1) {
	      if (uriAttrs.indexOf(attrName) !== -1) {
	        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
	      }
	
	      return true;
	    }
	
	    var regExp = allowedAttributeList.filter(function (attrRegex) {
	      return attrRegex instanceof RegExp;
	    }); // Check if a regular expression validates the attribute.
	
	    for (var i = 0, len = regExp.length; i < len; i++) {
	      if (attrName.match(regExp[i])) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
	    if (unsafeHtml.length === 0) {
	      return unsafeHtml;
	    }
	
	    if (sanitizeFn && typeof sanitizeFn === 'function') {
	      return sanitizeFn(unsafeHtml);
	    }
	
	    var domParser = new window.DOMParser();
	    var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
	    var whitelistKeys = Object.keys(whiteList);
	    var elements = [].slice.call(createdDocument.body.querySelectorAll('*'));
	
	    var _loop = function _loop(i, len) {
	      var el = elements[i];
	      var elName = el.nodeName.toLowerCase();
	
	      if (whitelistKeys.indexOf(el.nodeName.toLowerCase()) === -1) {
	        el.parentNode.removeChild(el);
	        return "continue";
	      }
	
	      var attributeList = [].slice.call(el.attributes);
	      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);
	      attributeList.forEach(function (attr) {
	        if (!allowedAttribute(attr, whitelistedAttributes)) {
	          el.removeAttribute(attr.nodeName);
	        }
	      });
	    };
	
	    for (var i = 0, len = elements.length; i < len; i++) {
	      var _ret = _loop(i);
	
	      if (_ret === "continue") continue;
	    }
	
	    return createdDocument.body.innerHTML;
	  }
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$6 = 'tooltip';
	  var VERSION$6 = '4.6.0';
	  var DATA_KEY$6 = 'bs.tooltip';
	  var EVENT_KEY$6 = "." + DATA_KEY$6;
	  var JQUERY_NO_CONFLICT$6 = $__default['default'].fn[NAME$6];
	  var CLASS_PREFIX = 'bs-tooltip';
	  var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
	  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];
	  var DefaultType$4 = {
	    animation: 'boolean',
	    template: 'string',
	    title: '(string|element|function)',
	    trigger: 'string',
	    delay: '(number|object)',
	    html: 'boolean',
	    selector: '(string|boolean)',
	    placement: '(string|function)',
	    offset: '(number|string|function)',
	    container: '(string|element|boolean)',
	    fallbackPlacement: '(string|array)',
	    boundary: '(string|element)',
	    customClass: '(string|function)',
	    sanitize: 'boolean',
	    sanitizeFn: '(null|function)',
	    whiteList: 'object',
	    popperConfig: '(null|object)'
	  };
	  var AttachmentMap = {
	    AUTO: 'auto',
	    TOP: 'top',
	    RIGHT: 'right',
	    BOTTOM: 'bottom',
	    LEFT: 'left'
	  };
	  var Default$4 = {
	    animation: true,
	    template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    selector: false,
	    placement: 'top',
	    offset: 0,
	    container: false,
	    fallbackPlacement: 'flip',
	    boundary: 'scrollParent',
	    customClass: '',
	    sanitize: true,
	    sanitizeFn: null,
	    whiteList: DefaultWhitelist,
	    popperConfig: null
	  };
	  var HOVER_STATE_SHOW = 'show';
	  var HOVER_STATE_OUT = 'out';
	  var Event = {
	    HIDE: "hide" + EVENT_KEY$6,
	    HIDDEN: "hidden" + EVENT_KEY$6,
	    SHOW: "show" + EVENT_KEY$6,
	    SHOWN: "shown" + EVENT_KEY$6,
	    INSERTED: "inserted" + EVENT_KEY$6,
	    CLICK: "click" + EVENT_KEY$6,
	    FOCUSIN: "focusin" + EVENT_KEY$6,
	    FOCUSOUT: "focusout" + EVENT_KEY$6,
	    MOUSEENTER: "mouseenter" + EVENT_KEY$6,
	    MOUSELEAVE: "mouseleave" + EVENT_KEY$6
	  };
	  var CLASS_NAME_FADE$2 = 'fade';
	  var CLASS_NAME_SHOW$4 = 'show';
	  var SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
	  var SELECTOR_ARROW = '.arrow';
	  var TRIGGER_HOVER = 'hover';
	  var TRIGGER_FOCUS = 'focus';
	  var TRIGGER_CLICK = 'click';
	  var TRIGGER_MANUAL = 'manual';
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Tooltip = /*#__PURE__*/function () {
	    function Tooltip(element, config) {
	      if (typeof Popper__default['default'] === 'undefined') {
	        throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
	      } // private
	
	
	      this._isEnabled = true;
	      this._timeout = 0;
	      this._hoverState = '';
	      this._activeTrigger = {};
	      this._popper = null; // Protected
	
	      this.element = element;
	      this.config = this._getConfig(config);
	      this.tip = null;
	
	      this._setListeners();
	    } // Getters
	
	
	    var _proto = Tooltip.prototype;
	
	    // Public
	    _proto.enable = function enable() {
	      this._isEnabled = true;
	    };
	
	    _proto.disable = function disable() {
	      this._isEnabled = false;
	    };
	
	    _proto.toggleEnabled = function toggleEnabled() {
	      this._isEnabled = !this._isEnabled;
	    };
	
	    _proto.toggle = function toggle(event) {
	      if (!this._isEnabled) {
	        return;
	      }
	
	      if (event) {
	        var dataKey = this.constructor.DATA_KEY;
	        var context = $__default['default'](event.currentTarget).data(dataKey);
	
	        if (!context) {
	          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
	          $__default['default'](event.currentTarget).data(dataKey, context);
	        }
	
	        context._activeTrigger.click = !context._activeTrigger.click;
	
	        if (context._isWithActiveTrigger()) {
	          context._enter(null, context);
	        } else {
	          context._leave(null, context);
	        }
	      } else {
	        if ($__default['default'](this.getTipElement()).hasClass(CLASS_NAME_SHOW$4)) {
	          this._leave(null, this);
	
	          return;
	        }
	
	        this._enter(null, this);
	      }
	    };
	
	    _proto.dispose = function dispose() {
	      clearTimeout(this._timeout);
	      $__default['default'].removeData(this.element, this.constructor.DATA_KEY);
	      $__default['default'](this.element).off(this.constructor.EVENT_KEY);
	      $__default['default'](this.element).closest('.modal').off('hide.bs.modal', this._hideModalHandler);
	
	      if (this.tip) {
	        $__default['default'](this.tip).remove();
	      }
	
	      this._isEnabled = null;
	      this._timeout = null;
	      this._hoverState = null;
	      this._activeTrigger = null;
	
	      if (this._popper) {
	        this._popper.destroy();
	      }
	
	      this._popper = null;
	      this.element = null;
	      this.config = null;
	      this.tip = null;
	    };
	
	    _proto.show = function show() {
	      var _this = this;
	
	      if ($__default['default'](this.element).css('display') === 'none') {
	        throw new Error('Please use show on visible elements');
	      }
	
	      var showEvent = $__default['default'].Event(this.constructor.Event.SHOW);
	
	      if (this.isWithContent() && this._isEnabled) {
	        $__default['default'](this.element).trigger(showEvent);
	        var shadowRoot = Util.findShadowRoot(this.element);
	        var isInTheDom = $__default['default'].contains(shadowRoot !== null ? shadowRoot : this.element.ownerDocument.documentElement, this.element);
	
	        if (showEvent.isDefaultPrevented() || !isInTheDom) {
	          return;
	        }
	
	        var tip = this.getTipElement();
	        var tipId = Util.getUID(this.constructor.NAME);
	        tip.setAttribute('id', tipId);
	        this.element.setAttribute('aria-describedby', tipId);
	        this.setContent();
	
	        if (this.config.animation) {
	          $__default['default'](tip).addClass(CLASS_NAME_FADE$2);
	        }
	
	        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;
	
	        var attachment = this._getAttachment(placement);
	
	        this.addAttachmentClass(attachment);
	
	        var container = this._getContainer();
	
	        $__default['default'](tip).data(this.constructor.DATA_KEY, this);
	
	        if (!$__default['default'].contains(this.element.ownerDocument.documentElement, this.tip)) {
	          $__default['default'](tip).appendTo(container);
	        }
	
	        $__default['default'](this.element).trigger(this.constructor.Event.INSERTED);
	        this._popper = new Popper__default['default'](this.element, tip, this._getPopperConfig(attachment));
	        $__default['default'](tip).addClass(CLASS_NAME_SHOW$4);
	        $__default['default'](tip).addClass(this.config.customClass); // If this is a touch-enabled device we add extra
	        // empty mouseover listeners to the body's immediate children;
	        // only needed because of broken event delegation on iOS
	        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	
	        if ('ontouchstart' in document.documentElement) {
	          $__default['default'](document.body).children().on('mouseover', null, $__default['default'].noop);
	        }
	
	        var complete = function complete() {
	          if (_this.config.animation) {
	            _this._fixTransition();
	          }
	
	          var prevHoverState = _this._hoverState;
	          _this._hoverState = null;
	          $__default['default'](_this.element).trigger(_this.constructor.Event.SHOWN);
	
	          if (prevHoverState === HOVER_STATE_OUT) {
	            _this._leave(null, _this);
	          }
	        };
	
	        if ($__default['default'](this.tip).hasClass(CLASS_NAME_FADE$2)) {
	          var transitionDuration = Util.getTransitionDurationFromElement(this.tip);
	          $__default['default'](this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	        } else {
	          complete();
	        }
	      }
	    };
	
	    _proto.hide = function hide(callback) {
	      var _this2 = this;
	
	      var tip = this.getTipElement();
	      var hideEvent = $__default['default'].Event(this.constructor.Event.HIDE);
	
	      var complete = function complete() {
	        if (_this2._hoverState !== HOVER_STATE_SHOW && tip.parentNode) {
	          tip.parentNode.removeChild(tip);
	        }
	
	        _this2._cleanTipClass();
	
	        _this2.element.removeAttribute('aria-describedby');
	
	        $__default['default'](_this2.element).trigger(_this2.constructor.Event.HIDDEN);
	
	        if (_this2._popper !== null) {
	          _this2._popper.destroy();
	        }
	
	        if (callback) {
	          callback();
	        }
	      };
	
	      $__default['default'](this.element).trigger(hideEvent);
	
	      if (hideEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      $__default['default'](tip).removeClass(CLASS_NAME_SHOW$4); // If this is a touch-enabled device we remove the extra
	      // empty mouseover listeners we added for iOS support
	
	      if ('ontouchstart' in document.documentElement) {
	        $__default['default'](document.body).children().off('mouseover', null, $__default['default'].noop);
	      }
	
	      this._activeTrigger[TRIGGER_CLICK] = false;
	      this._activeTrigger[TRIGGER_FOCUS] = false;
	      this._activeTrigger[TRIGGER_HOVER] = false;
	
	      if ($__default['default'](this.tip).hasClass(CLASS_NAME_FADE$2)) {
	        var transitionDuration = Util.getTransitionDurationFromElement(tip);
	        $__default['default'](tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	      } else {
	        complete();
	      }
	
	      this._hoverState = '';
	    };
	
	    _proto.update = function update() {
	      if (this._popper !== null) {
	        this._popper.scheduleUpdate();
	      }
	    } // Protected
	    ;
	
	    _proto.isWithContent = function isWithContent() {
	      return Boolean(this.getTitle());
	    };
	
	    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
	      $__default['default'](this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
	    };
	
	    _proto.getTipElement = function getTipElement() {
	      this.tip = this.tip || $__default['default'](this.config.template)[0];
	      return this.tip;
	    };
	
	    _proto.setContent = function setContent() {
	      var tip = this.getTipElement();
	      this.setElementContent($__default['default'](tip.querySelectorAll(SELECTOR_TOOLTIP_INNER)), this.getTitle());
	      $__default['default'](tip).removeClass(CLASS_NAME_FADE$2 + " " + CLASS_NAME_SHOW$4);
	    };
	
	    _proto.setElementContent = function setElementContent($element, content) {
	      if (typeof content === 'object' && (content.nodeType || content.jquery)) {
	        // Content is a DOM node or a jQuery
	        if (this.config.html) {
	          if (!$__default['default'](content).parent().is($element)) {
	            $element.empty().append(content);
	          }
	        } else {
	          $element.text($__default['default'](content).text());
	        }
	
	        return;
	      }
	
	      if (this.config.html) {
	        if (this.config.sanitize) {
	          content = sanitizeHtml(content, this.config.whiteList, this.config.sanitizeFn);
	        }
	
	        $element.html(content);
	      } else {
	        $element.text(content);
	      }
	    };
	
	    _proto.getTitle = function getTitle() {
	      var title = this.element.getAttribute('data-original-title');
	
	      if (!title) {
	        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
	      }
	
	      return title;
	    } // Private
	    ;
	
	    _proto._getPopperConfig = function _getPopperConfig(attachment) {
	      var _this3 = this;
	
	      var defaultBsConfig = {
	        placement: attachment,
	        modifiers: {
	          offset: this._getOffset(),
	          flip: {
	            behavior: this.config.fallbackPlacement
	          },
	          arrow: {
	            element: SELECTOR_ARROW
	          },
	          preventOverflow: {
	            boundariesElement: this.config.boundary
	          }
	        },
	        onCreate: function onCreate(data) {
	          if (data.originalPlacement !== data.placement) {
	            _this3._handlePopperPlacementChange(data);
	          }
	        },
	        onUpdate: function onUpdate(data) {
	          return _this3._handlePopperPlacementChange(data);
	        }
	      };
	      return _extends({}, defaultBsConfig, this.config.popperConfig);
	    };
	
	    _proto._getOffset = function _getOffset() {
	      var _this4 = this;
	
	      var offset = {};
	
	      if (typeof this.config.offset === 'function') {
	        offset.fn = function (data) {
	          data.offsets = _extends({}, data.offsets, _this4.config.offset(data.offsets, _this4.element) || {});
	          return data;
	        };
	      } else {
	        offset.offset = this.config.offset;
	      }
	
	      return offset;
	    };
	
	    _proto._getContainer = function _getContainer() {
	      if (this.config.container === false) {
	        return document.body;
	      }
	
	      if (Util.isElement(this.config.container)) {
	        return $__default['default'](this.config.container);
	      }
	
	      return $__default['default'](document).find(this.config.container);
	    };
	
	    _proto._getAttachment = function _getAttachment(placement) {
	      return AttachmentMap[placement.toUpperCase()];
	    };
	
	    _proto._setListeners = function _setListeners() {
	      var _this5 = this;
	
	      var triggers = this.config.trigger.split(' ');
	      triggers.forEach(function (trigger) {
	        if (trigger === 'click') {
	          $__default['default'](_this5.element).on(_this5.constructor.Event.CLICK, _this5.config.selector, function (event) {
	            return _this5.toggle(event);
	          });
	        } else if (trigger !== TRIGGER_MANUAL) {
	          var eventIn = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSEENTER : _this5.constructor.Event.FOCUSIN;
	          var eventOut = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSELEAVE : _this5.constructor.Event.FOCUSOUT;
	          $__default['default'](_this5.element).on(eventIn, _this5.config.selector, function (event) {
	            return _this5._enter(event);
	          }).on(eventOut, _this5.config.selector, function (event) {
	            return _this5._leave(event);
	          });
	        }
	      });
	
	      this._hideModalHandler = function () {
	        if (_this5.element) {
	          _this5.hide();
	        }
	      };
	
	      $__default['default'](this.element).closest('.modal').on('hide.bs.modal', this._hideModalHandler);
	
	      if (this.config.selector) {
	        this.config = _extends({}, this.config, {
	          trigger: 'manual',
	          selector: ''
	        });
	      } else {
	        this._fixTitle();
	      }
	    };
	
	    _proto._fixTitle = function _fixTitle() {
	      var titleType = typeof this.element.getAttribute('data-original-title');
	
	      if (this.element.getAttribute('title') || titleType !== 'string') {
	        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
	        this.element.setAttribute('title', '');
	      }
	    };
	
	    _proto._enter = function _enter(event, context) {
	      var dataKey = this.constructor.DATA_KEY;
	      context = context || $__default['default'](event.currentTarget).data(dataKey);
	
	      if (!context) {
	        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
	        $__default['default'](event.currentTarget).data(dataKey, context);
	      }
	
	      if (event) {
	        context._activeTrigger[event.type === 'focusin' ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
	      }
	
	      if ($__default['default'](context.getTipElement()).hasClass(CLASS_NAME_SHOW$4) || context._hoverState === HOVER_STATE_SHOW) {
	        context._hoverState = HOVER_STATE_SHOW;
	        return;
	      }
	
	      clearTimeout(context._timeout);
	      context._hoverState = HOVER_STATE_SHOW;
	
	      if (!context.config.delay || !context.config.delay.show) {
	        context.show();
	        return;
	      }
	
	      context._timeout = setTimeout(function () {
	        if (context._hoverState === HOVER_STATE_SHOW) {
	          context.show();
	        }
	      }, context.config.delay.show);
	    };
	
	    _proto._leave = function _leave(event, context) {
	      var dataKey = this.constructor.DATA_KEY;
	      context = context || $__default['default'](event.currentTarget).data(dataKey);
	
	      if (!context) {
	        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
	        $__default['default'](event.currentTarget).data(dataKey, context);
	      }
	
	      if (event) {
	        context._activeTrigger[event.type === 'focusout' ? TRIGGER_FOCUS : TRIGGER_HOVER] = false;
	      }
	
	      if (context._isWithActiveTrigger()) {
	        return;
	      }
	
	      clearTimeout(context._timeout);
	      context._hoverState = HOVER_STATE_OUT;
	
	      if (!context.config.delay || !context.config.delay.hide) {
	        context.hide();
	        return;
	      }
	
	      context._timeout = setTimeout(function () {
	        if (context._hoverState === HOVER_STATE_OUT) {
	          context.hide();
	        }
	      }, context.config.delay.hide);
	    };
	
	    _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
	      for (var trigger in this._activeTrigger) {
	        if (this._activeTrigger[trigger]) {
	          return true;
	        }
	      }
	
	      return false;
	    };
	
	    _proto._getConfig = function _getConfig(config) {
	      var dataAttributes = $__default['default'](this.element).data();
	      Object.keys(dataAttributes).forEach(function (dataAttr) {
	        if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) {
	          delete dataAttributes[dataAttr];
	        }
	      });
	      config = _extends({}, this.constructor.Default, dataAttributes, typeof config === 'object' && config ? config : {});
	
	      if (typeof config.delay === 'number') {
	        config.delay = {
	          show: config.delay,
	          hide: config.delay
	        };
	      }
	
	      if (typeof config.title === 'number') {
	        config.title = config.title.toString();
	      }
	
	      if (typeof config.content === 'number') {
	        config.content = config.content.toString();
	      }
	
	      Util.typeCheckConfig(NAME$6, config, this.constructor.DefaultType);
	
	      if (config.sanitize) {
	        config.template = sanitizeHtml(config.template, config.whiteList, config.sanitizeFn);
	      }
	
	      return config;
	    };
	
	    _proto._getDelegateConfig = function _getDelegateConfig() {
	      var config = {};
	
	      if (this.config) {
	        for (var key in this.config) {
	          if (this.constructor.Default[key] !== this.config[key]) {
	            config[key] = this.config[key];
	          }
	        }
	      }
	
	      return config;
	    };
	
	    _proto._cleanTipClass = function _cleanTipClass() {
	      var $tip = $__default['default'](this.getTipElement());
	      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);
	
	      if (tabClass !== null && tabClass.length) {
	        $tip.removeClass(tabClass.join(''));
	      }
	    };
	
	    _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(popperData) {
	      this.tip = popperData.instance.popper;
	
	      this._cleanTipClass();
	
	      this.addAttachmentClass(this._getAttachment(popperData.placement));
	    };
	
	    _proto._fixTransition = function _fixTransition() {
	      var tip = this.getTipElement();
	      var initConfigAnimation = this.config.animation;
	
	      if (tip.getAttribute('x-placement') !== null) {
	        return;
	      }
	
	      $__default['default'](tip).removeClass(CLASS_NAME_FADE$2);
	      this.config.animation = false;
	      this.hide();
	      this.show();
	      this.config.animation = initConfigAnimation;
	    } // Static
	    ;
	
	    Tooltip._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var $element = $__default['default'](this);
	        var data = $element.data(DATA_KEY$6);
	
	        var _config = typeof config === 'object' && config;
	
	        if (!data && /dispose|hide/.test(config)) {
	          return;
	        }
	
	        if (!data) {
	          data = new Tooltip(this, _config);
	          $element.data(DATA_KEY$6, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config]();
	        }
	      });
	    };
	
	    _createClass(Tooltip, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$6;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$4;
	      }
	    }, {
	      key: "NAME",
	      get: function get() {
	        return NAME$6;
	      }
	    }, {
	      key: "DATA_KEY",
	      get: function get() {
	        return DATA_KEY$6;
	      }
	    }, {
	      key: "Event",
	      get: function get() {
	        return Event;
	      }
	    }, {
	      key: "EVENT_KEY",
	      get: function get() {
	        return EVENT_KEY$6;
	      }
	    }, {
	      key: "DefaultType",
	      get: function get() {
	        return DefaultType$4;
	      }
	    }]);
	
	    return Tooltip;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	
	  $__default['default'].fn[NAME$6] = Tooltip._jQueryInterface;
	  $__default['default'].fn[NAME$6].Constructor = Tooltip;
	
	  $__default['default'].fn[NAME$6].noConflict = function () {
	    $__default['default'].fn[NAME$6] = JQUERY_NO_CONFLICT$6;
	    return Tooltip._jQueryInterface;
	  };
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$7 = 'popover';
	  var VERSION$7 = '4.6.0';
	  var DATA_KEY$7 = 'bs.popover';
	  var EVENT_KEY$7 = "." + DATA_KEY$7;
	  var JQUERY_NO_CONFLICT$7 = $__default['default'].fn[NAME$7];
	  var CLASS_PREFIX$1 = 'bs-popover';
	  var BSCLS_PREFIX_REGEX$1 = new RegExp("(^|\\s)" + CLASS_PREFIX$1 + "\\S+", 'g');
	
	  var Default$5 = _extends({}, Tooltip.Default, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip">' + '<div class="arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
	  });
	
	  var DefaultType$5 = _extends({}, Tooltip.DefaultType, {
	    content: '(string|element|function)'
	  });
	
	  var CLASS_NAME_FADE$3 = 'fade';
	  var CLASS_NAME_SHOW$5 = 'show';
	  var SELECTOR_TITLE = '.popover-header';
	  var SELECTOR_CONTENT = '.popover-body';
	  var Event$1 = {
	    HIDE: "hide" + EVENT_KEY$7,
	    HIDDEN: "hidden" + EVENT_KEY$7,
	    SHOW: "show" + EVENT_KEY$7,
	    SHOWN: "shown" + EVENT_KEY$7,
	    INSERTED: "inserted" + EVENT_KEY$7,
	    CLICK: "click" + EVENT_KEY$7,
	    FOCUSIN: "focusin" + EVENT_KEY$7,
	    FOCUSOUT: "focusout" + EVENT_KEY$7,
	    MOUSEENTER: "mouseenter" + EVENT_KEY$7,
	    MOUSELEAVE: "mouseleave" + EVENT_KEY$7
	  };
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Popover = /*#__PURE__*/function (_Tooltip) {
	    _inheritsLoose(Popover, _Tooltip);
	
	    function Popover() {
	      return _Tooltip.apply(this, arguments) || this;
	    }
	
	    var _proto = Popover.prototype;
	
	    // Overrides
	    _proto.isWithContent = function isWithContent() {
	      return this.getTitle() || this._getContent();
	    };
	
	    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
	      $__default['default'](this.getTipElement()).addClass(CLASS_PREFIX$1 + "-" + attachment);
	    };
	
	    _proto.getTipElement = function getTipElement() {
	      this.tip = this.tip || $__default['default'](this.config.template)[0];
	      return this.tip;
	    };
	
	    _proto.setContent = function setContent() {
	      var $tip = $__default['default'](this.getTipElement()); // We use append for html objects to maintain js events
	
	      this.setElementContent($tip.find(SELECTOR_TITLE), this.getTitle());
	
	      var content = this._getContent();
	
	      if (typeof content === 'function') {
	        content = content.call(this.element);
	      }
	
	      this.setElementContent($tip.find(SELECTOR_CONTENT), content);
	      $tip.removeClass(CLASS_NAME_FADE$3 + " " + CLASS_NAME_SHOW$5);
	    } // Private
	    ;
	
	    _proto._getContent = function _getContent() {
	      return this.element.getAttribute('data-content') || this.config.content;
	    };
	
	    _proto._cleanTipClass = function _cleanTipClass() {
	      var $tip = $__default['default'](this.getTipElement());
	      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX$1);
	
	      if (tabClass !== null && tabClass.length > 0) {
	        $tip.removeClass(tabClass.join(''));
	      }
	    } // Static
	    ;
	
	    Popover._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = $__default['default'](this).data(DATA_KEY$7);
	
	        var _config = typeof config === 'object' ? config : null;
	
	        if (!data && /dispose|hide/.test(config)) {
	          return;
	        }
	
	        if (!data) {
	          data = new Popover(this, _config);
	          $__default['default'](this).data(DATA_KEY$7, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config]();
	        }
	      });
	    };
	
	    _createClass(Popover, null, [{
	      key: "VERSION",
	      // Getters
	      get: function get() {
	        return VERSION$7;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$5;
	      }
	    }, {
	      key: "NAME",
	      get: function get() {
	        return NAME$7;
	      }
	    }, {
	      key: "DATA_KEY",
	      get: function get() {
	        return DATA_KEY$7;
	      }
	    }, {
	      key: "Event",
	      get: function get() {
	        return Event$1;
	      }
	    }, {
	      key: "EVENT_KEY",
	      get: function get() {
	        return EVENT_KEY$7;
	      }
	    }, {
	      key: "DefaultType",
	      get: function get() {
	        return DefaultType$5;
	      }
	    }]);
	
	    return Popover;
	  }(Tooltip);
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	
	  $__default['default'].fn[NAME$7] = Popover._jQueryInterface;
	  $__default['default'].fn[NAME$7].Constructor = Popover;
	
	  $__default['default'].fn[NAME$7].noConflict = function () {
	    $__default['default'].fn[NAME$7] = JQUERY_NO_CONFLICT$7;
	    return Popover._jQueryInterface;
	  };
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$8 = 'scrollspy';
	  var VERSION$8 = '4.6.0';
	  var DATA_KEY$8 = 'bs.scrollspy';
	  var EVENT_KEY$8 = "." + DATA_KEY$8;
	  var DATA_API_KEY$6 = '.data-api';
	  var JQUERY_NO_CONFLICT$8 = $__default['default'].fn[NAME$8];
	  var Default$6 = {
	    offset: 10,
	    method: 'auto',
	    target: ''
	  };
	  var DefaultType$6 = {
	    offset: 'number',
	    method: 'string',
	    target: '(string|element)'
	  };
	  var EVENT_ACTIVATE = "activate" + EVENT_KEY$8;
	  var EVENT_SCROLL = "scroll" + EVENT_KEY$8;
	  var EVENT_LOAD_DATA_API$2 = "load" + EVENT_KEY$8 + DATA_API_KEY$6;
	  var CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
	  var CLASS_NAME_ACTIVE$2 = 'active';
	  var SELECTOR_DATA_SPY = '[data-spy="scroll"]';
	  var SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
	  var SELECTOR_NAV_LINKS = '.nav-link';
	  var SELECTOR_NAV_ITEMS = '.nav-item';
	  var SELECTOR_LIST_ITEMS = '.list-group-item';
	  var SELECTOR_DROPDOWN = '.dropdown';
	  var SELECTOR_DROPDOWN_ITEMS = '.dropdown-item';
	  var SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
	  var METHOD_OFFSET = 'offset';
	  var METHOD_POSITION = 'position';
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var ScrollSpy = /*#__PURE__*/function () {
	    function ScrollSpy(element, config) {
	      var _this = this;
	
	      this._element = element;
	      this._scrollElement = element.tagName === 'BODY' ? window : element;
	      this._config = this._getConfig(config);
	      this._selector = this._config.target + " " + SELECTOR_NAV_LINKS + "," + (this._config.target + " " + SELECTOR_LIST_ITEMS + ",") + (this._config.target + " " + SELECTOR_DROPDOWN_ITEMS);
	      this._offsets = [];
	      this._targets = [];
	      this._activeTarget = null;
	      this._scrollHeight = 0;
	      $__default['default'](this._scrollElement).on(EVENT_SCROLL, function (event) {
	        return _this._process(event);
	      });
	      this.refresh();
	
	      this._process();
	    } // Getters
	
	
	    var _proto = ScrollSpy.prototype;
	
	    // Public
	    _proto.refresh = function refresh() {
	      var _this2 = this;
	
	      var autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
	      var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
	      var offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
	      this._offsets = [];
	      this._targets = [];
	      this._scrollHeight = this._getScrollHeight();
	      var targets = [].slice.call(document.querySelectorAll(this._selector));
	      targets.map(function (element) {
	        var target;
	        var targetSelector = Util.getSelectorFromElement(element);
	
	        if (targetSelector) {
	          target = document.querySelector(targetSelector);
	        }
	
	        if (target) {
	          var targetBCR = target.getBoundingClientRect();
	
	          if (targetBCR.width || targetBCR.height) {
	            // TODO (fat): remove sketch reliance on jQuery position/offset
	            return [$__default['default'](target)[offsetMethod]().top + offsetBase, targetSelector];
	          }
	        }
	
	        return null;
	      }).filter(function (item) {
	        return item;
	      }).sort(function (a, b) {
	        return a[0] - b[0];
	      }).forEach(function (item) {
	        _this2._offsets.push(item[0]);
	
	        _this2._targets.push(item[1]);
	      });
	    };
	
	    _proto.dispose = function dispose() {
	      $__default['default'].removeData(this._element, DATA_KEY$8);
	      $__default['default'](this._scrollElement).off(EVENT_KEY$8);
	      this._element = null;
	      this._scrollElement = null;
	      this._config = null;
	      this._selector = null;
	      this._offsets = null;
	      this._targets = null;
	      this._activeTarget = null;
	      this._scrollHeight = null;
	    } // Private
	    ;
	
	    _proto._getConfig = function _getConfig(config) {
	      config = _extends({}, Default$6, typeof config === 'object' && config ? config : {});
	
	      if (typeof config.target !== 'string' && Util.isElement(config.target)) {
	        var id = $__default['default'](config.target).attr('id');
	
	        if (!id) {
	          id = Util.getUID(NAME$8);
	          $__default['default'](config.target).attr('id', id);
	        }
	
	        config.target = "#" + id;
	      }
	
	      Util.typeCheckConfig(NAME$8, config, DefaultType$6);
	      return config;
	    };
	
	    _proto._getScrollTop = function _getScrollTop() {
	      return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
	    };
	
	    _proto._getScrollHeight = function _getScrollHeight() {
	      return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
	    };
	
	    _proto._getOffsetHeight = function _getOffsetHeight() {
	      return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
	    };
	
	    _proto._process = function _process() {
	      var scrollTop = this._getScrollTop() + this._config.offset;
	
	      var scrollHeight = this._getScrollHeight();
	
	      var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();
	
	      if (this._scrollHeight !== scrollHeight) {
	        this.refresh();
	      }
	
	      if (scrollTop >= maxScroll) {
	        var target = this._targets[this._targets.length - 1];
	
	        if (this._activeTarget !== target) {
	          this._activate(target);
	        }
	
	        return;
	      }
	
	      if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
	        this._activeTarget = null;
	
	        this._clear();
	
	        return;
	      }
	
	      for (var i = this._offsets.length; i--;) {
	        var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);
	
	        if (isActiveTarget) {
	          this._activate(this._targets[i]);
	        }
	      }
	    };
	
	    _proto._activate = function _activate(target) {
	      this._activeTarget = target;
	
	      this._clear();
	
	      var queries = this._selector.split(',').map(function (selector) {
	        return selector + "[data-target=\"" + target + "\"]," + selector + "[href=\"" + target + "\"]";
	      });
	
	      var $link = $__default['default']([].slice.call(document.querySelectorAll(queries.join(','))));
	
	      if ($link.hasClass(CLASS_NAME_DROPDOWN_ITEM)) {
	        $link.closest(SELECTOR_DROPDOWN).find(SELECTOR_DROPDOWN_TOGGLE).addClass(CLASS_NAME_ACTIVE$2);
	        $link.addClass(CLASS_NAME_ACTIVE$2);
	      } else {
	        // Set triggered link as active
	        $link.addClass(CLASS_NAME_ACTIVE$2); // Set triggered links parents as active
	        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
	
	        $link.parents(SELECTOR_NAV_LIST_GROUP).prev(SELECTOR_NAV_LINKS + ", " + SELECTOR_LIST_ITEMS).addClass(CLASS_NAME_ACTIVE$2); // Handle special case when .nav-link is inside .nav-item
	
	        $link.parents(SELECTOR_NAV_LIST_GROUP).prev(SELECTOR_NAV_ITEMS).children(SELECTOR_NAV_LINKS).addClass(CLASS_NAME_ACTIVE$2);
	      }
	
	      $__default['default'](this._scrollElement).trigger(EVENT_ACTIVATE, {
	        relatedTarget: target
	      });
	    };
	
	    _proto._clear = function _clear() {
	      [].slice.call(document.querySelectorAll(this._selector)).filter(function (node) {
	        return node.classList.contains(CLASS_NAME_ACTIVE$2);
	      }).forEach(function (node) {
	        return node.classList.remove(CLASS_NAME_ACTIVE$2);
	      });
	    } // Static
	    ;
	
	    ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = $__default['default'](this).data(DATA_KEY$8);
	
	        var _config = typeof config === 'object' && config;
	
	        if (!data) {
	          data = new ScrollSpy(this, _config);
	          $__default['default'](this).data(DATA_KEY$8, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config]();
	        }
	      });
	    };
	
	    _createClass(ScrollSpy, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$8;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$6;
	      }
	    }]);
	
	    return ScrollSpy;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	   */
	
	
	  $__default['default'](window).on(EVENT_LOAD_DATA_API$2, function () {
	    var scrollSpys = [].slice.call(document.querySelectorAll(SELECTOR_DATA_SPY));
	    var scrollSpysLength = scrollSpys.length;
	
	    for (var i = scrollSpysLength; i--;) {
	      var $spy = $__default['default'](scrollSpys[i]);
	
	      ScrollSpy._jQueryInterface.call($spy, $spy.data());
	    }
	  });
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	  $__default['default'].fn[NAME$8] = ScrollSpy._jQueryInterface;
	  $__default['default'].fn[NAME$8].Constructor = ScrollSpy;
	
	  $__default['default'].fn[NAME$8].noConflict = function () {
	    $__default['default'].fn[NAME$8] = JQUERY_NO_CONFLICT$8;
	    return ScrollSpy._jQueryInterface;
	  };
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$9 = 'tab';
	  var VERSION$9 = '4.6.0';
	  var DATA_KEY$9 = 'bs.tab';
	  var EVENT_KEY$9 = "." + DATA_KEY$9;
	  var DATA_API_KEY$7 = '.data-api';
	  var JQUERY_NO_CONFLICT$9 = $__default['default'].fn[NAME$9];
	  var EVENT_HIDE$3 = "hide" + EVENT_KEY$9;
	  var EVENT_HIDDEN$3 = "hidden" + EVENT_KEY$9;
	  var EVENT_SHOW$3 = "show" + EVENT_KEY$9;
	  var EVENT_SHOWN$3 = "shown" + EVENT_KEY$9;
	  var EVENT_CLICK_DATA_API$6 = "click" + EVENT_KEY$9 + DATA_API_KEY$7;
	  var CLASS_NAME_DROPDOWN_MENU = 'dropdown-menu';
	  var CLASS_NAME_ACTIVE$3 = 'active';
	  var CLASS_NAME_DISABLED$1 = 'disabled';
	  var CLASS_NAME_FADE$4 = 'fade';
	  var CLASS_NAME_SHOW$6 = 'show';
	  var SELECTOR_DROPDOWN$1 = '.dropdown';
	  var SELECTOR_NAV_LIST_GROUP$1 = '.nav, .list-group';
	  var SELECTOR_ACTIVE$2 = '.active';
	  var SELECTOR_ACTIVE_UL = '> li > .active';
	  var SELECTOR_DATA_TOGGLE$4 = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]';
	  var SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
	  var SELECTOR_DROPDOWN_ACTIVE_CHILD = '> .dropdown-menu .active';
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Tab = /*#__PURE__*/function () {
	    function Tab(element) {
	      this._element = element;
	    } // Getters
	
	
	    var _proto = Tab.prototype;
	
	    // Public
	    _proto.show = function show() {
	      var _this = this;
	
	      if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $__default['default'](this._element).hasClass(CLASS_NAME_ACTIVE$3) || $__default['default'](this._element).hasClass(CLASS_NAME_DISABLED$1)) {
	        return;
	      }
	
	      var target;
	      var previous;
	      var listElement = $__default['default'](this._element).closest(SELECTOR_NAV_LIST_GROUP$1)[0];
	      var selector = Util.getSelectorFromElement(this._element);
	
	      if (listElement) {
	        var itemSelector = listElement.nodeName === 'UL' || listElement.nodeName === 'OL' ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE$2;
	        previous = $__default['default'].makeArray($__default['default'](listElement).find(itemSelector));
	        previous = previous[previous.length - 1];
	      }
	
	      var hideEvent = $__default['default'].Event(EVENT_HIDE$3, {
	        relatedTarget: this._element
	      });
	      var showEvent = $__default['default'].Event(EVENT_SHOW$3, {
	        relatedTarget: previous
	      });
	
	      if (previous) {
	        $__default['default'](previous).trigger(hideEvent);
	      }
	
	      $__default['default'](this._element).trigger(showEvent);
	
	      if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      if (selector) {
	        target = document.querySelector(selector);
	      }
	
	      this._activate(this._element, listElement);
	
	      var complete = function complete() {
	        var hiddenEvent = $__default['default'].Event(EVENT_HIDDEN$3, {
	          relatedTarget: _this._element
	        });
	        var shownEvent = $__default['default'].Event(EVENT_SHOWN$3, {
	          relatedTarget: previous
	        });
	        $__default['default'](previous).trigger(hiddenEvent);
	        $__default['default'](_this._element).trigger(shownEvent);
	      };
	
	      if (target) {
	        this._activate(target, target.parentNode, complete);
	      } else {
	        complete();
	      }
	    };
	
	    _proto.dispose = function dispose() {
	      $__default['default'].removeData(this._element, DATA_KEY$9);
	      this._element = null;
	    } // Private
	    ;
	
	    _proto._activate = function _activate(element, container, callback) {
	      var _this2 = this;
	
	      var activeElements = container && (container.nodeName === 'UL' || container.nodeName === 'OL') ? $__default['default'](container).find(SELECTOR_ACTIVE_UL) : $__default['default'](container).children(SELECTOR_ACTIVE$2);
	      var active = activeElements[0];
	      var isTransitioning = callback && active && $__default['default'](active).hasClass(CLASS_NAME_FADE$4);
	
	      var complete = function complete() {
	        return _this2._transitionComplete(element, active, callback);
	      };
	
	      if (active && isTransitioning) {
	        var transitionDuration = Util.getTransitionDurationFromElement(active);
	        $__default['default'](active).removeClass(CLASS_NAME_SHOW$6).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	      } else {
	        complete();
	      }
	    };
	
	    _proto._transitionComplete = function _transitionComplete(element, active, callback) {
	      if (active) {
	        $__default['default'](active).removeClass(CLASS_NAME_ACTIVE$3);
	        var dropdownChild = $__default['default'](active.parentNode).find(SELECTOR_DROPDOWN_ACTIVE_CHILD)[0];
	
	        if (dropdownChild) {
	          $__default['default'](dropdownChild).removeClass(CLASS_NAME_ACTIVE$3);
	        }
	
	        if (active.getAttribute('role') === 'tab') {
	          active.setAttribute('aria-selected', false);
	        }
	      }
	
	      $__default['default'](element).addClass(CLASS_NAME_ACTIVE$3);
	
	      if (element.getAttribute('role') === 'tab') {
	        element.setAttribute('aria-selected', true);
	      }
	
	      Util.reflow(element);
	
	      if (element.classList.contains(CLASS_NAME_FADE$4)) {
	        element.classList.add(CLASS_NAME_SHOW$6);
	      }
	
	      if (element.parentNode && $__default['default'](element.parentNode).hasClass(CLASS_NAME_DROPDOWN_MENU)) {
	        var dropdownElement = $__default['default'](element).closest(SELECTOR_DROPDOWN$1)[0];
	
	        if (dropdownElement) {
	          var dropdownToggleList = [].slice.call(dropdownElement.querySelectorAll(SELECTOR_DROPDOWN_TOGGLE$1));
	          $__default['default'](dropdownToggleList).addClass(CLASS_NAME_ACTIVE$3);
	        }
	
	        element.setAttribute('aria-expanded', true);
	      }
	
	      if (callback) {
	        callback();
	      }
	    } // Static
	    ;
	
	    Tab._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var $this = $__default['default'](this);
	        var data = $this.data(DATA_KEY$9);
	
	        if (!data) {
	          data = new Tab(this);
	          $this.data(DATA_KEY$9, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config]();
	        }
	      });
	    };
	
	    _createClass(Tab, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$9;
	      }
	    }]);
	
	    return Tab;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	   */
	
	
	  $__default['default'](document).on(EVENT_CLICK_DATA_API$6, SELECTOR_DATA_TOGGLE$4, function (event) {
	    event.preventDefault();
	
	    Tab._jQueryInterface.call($__default['default'](this), 'show');
	  });
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	  $__default['default'].fn[NAME$9] = Tab._jQueryInterface;
	  $__default['default'].fn[NAME$9].Constructor = Tab;
	
	  $__default['default'].fn[NAME$9].noConflict = function () {
	    $__default['default'].fn[NAME$9] = JQUERY_NO_CONFLICT$9;
	    return Tab._jQueryInterface;
	  };
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$a = 'toast';
	  var VERSION$a = '4.6.0';
	  var DATA_KEY$a = 'bs.toast';
	  var EVENT_KEY$a = "." + DATA_KEY$a;
	  var JQUERY_NO_CONFLICT$a = $__default['default'].fn[NAME$a];
	  var EVENT_CLICK_DISMISS$1 = "click.dismiss" + EVENT_KEY$a;
	  var EVENT_HIDE$4 = "hide" + EVENT_KEY$a;
	  var EVENT_HIDDEN$4 = "hidden" + EVENT_KEY$a;
	  var EVENT_SHOW$4 = "show" + EVENT_KEY$a;
	  var EVENT_SHOWN$4 = "shown" + EVENT_KEY$a;
	  var CLASS_NAME_FADE$5 = 'fade';
	  var CLASS_NAME_HIDE = 'hide';
	  var CLASS_NAME_SHOW$7 = 'show';
	  var CLASS_NAME_SHOWING = 'showing';
	  var DefaultType$7 = {
	    animation: 'boolean',
	    autohide: 'boolean',
	    delay: 'number'
	  };
	  var Default$7 = {
	    animation: true,
	    autohide: true,
	    delay: 500
	  };
	  var SELECTOR_DATA_DISMISS$1 = '[data-dismiss="toast"]';
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Toast = /*#__PURE__*/function () {
	    function Toast(element, config) {
	      this._element = element;
	      this._config = this._getConfig(config);
	      this._timeout = null;
	
	      this._setListeners();
	    } // Getters
	
	
	    var _proto = Toast.prototype;
	
	    // Public
	    _proto.show = function show() {
	      var _this = this;
	
	      var showEvent = $__default['default'].Event(EVENT_SHOW$4);
	      $__default['default'](this._element).trigger(showEvent);
	
	      if (showEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      this._clearTimeout();
	
	      if (this._config.animation) {
	        this._element.classList.add(CLASS_NAME_FADE$5);
	      }
	
	      var complete = function complete() {
	        _this._element.classList.remove(CLASS_NAME_SHOWING);
	
	        _this._element.classList.add(CLASS_NAME_SHOW$7);
	
	        $__default['default'](_this._element).trigger(EVENT_SHOWN$4);
	
	        if (_this._config.autohide) {
	          _this._timeout = setTimeout(function () {
	            _this.hide();
	          }, _this._config.delay);
	        }
	      };
	
	      this._element.classList.remove(CLASS_NAME_HIDE);
	
	      Util.reflow(this._element);
	
	      this._element.classList.add(CLASS_NAME_SHOWING);
	
	      if (this._config.animation) {
	        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
	        $__default['default'](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	      } else {
	        complete();
	      }
	    };
	
	    _proto.hide = function hide() {
	      if (!this._element.classList.contains(CLASS_NAME_SHOW$7)) {
	        return;
	      }
	
	      var hideEvent = $__default['default'].Event(EVENT_HIDE$4);
	      $__default['default'](this._element).trigger(hideEvent);
	
	      if (hideEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      this._close();
	    };
	
	    _proto.dispose = function dispose() {
	      this._clearTimeout();
	
	      if (this._element.classList.contains(CLASS_NAME_SHOW$7)) {
	        this._element.classList.remove(CLASS_NAME_SHOW$7);
	      }
	
	      $__default['default'](this._element).off(EVENT_CLICK_DISMISS$1);
	      $__default['default'].removeData(this._element, DATA_KEY$a);
	      this._element = null;
	      this._config = null;
	    } // Private
	    ;
	
	    _proto._getConfig = function _getConfig(config) {
	      config = _extends({}, Default$7, $__default['default'](this._element).data(), typeof config === 'object' && config ? config : {});
	      Util.typeCheckConfig(NAME$a, config, this.constructor.DefaultType);
	      return config;
	    };
	
	    _proto._setListeners = function _setListeners() {
	      var _this2 = this;
	
	      $__default['default'](this._element).on(EVENT_CLICK_DISMISS$1, SELECTOR_DATA_DISMISS$1, function () {
	        return _this2.hide();
	      });
	    };
	
	    _proto._close = function _close() {
	      var _this3 = this;
	
	      var complete = function complete() {
	        _this3._element.classList.add(CLASS_NAME_HIDE);
	
	        $__default['default'](_this3._element).trigger(EVENT_HIDDEN$4);
	      };
	
	      this._element.classList.remove(CLASS_NAME_SHOW$7);
	
	      if (this._config.animation) {
	        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
	        $__default['default'](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	      } else {
	        complete();
	      }
	    };
	
	    _proto._clearTimeout = function _clearTimeout() {
	      clearTimeout(this._timeout);
	      this._timeout = null;
	    } // Static
	    ;
	
	    Toast._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var $element = $__default['default'](this);
	        var data = $element.data(DATA_KEY$a);
	
	        var _config = typeof config === 'object' && config;
	
	        if (!data) {
	          data = new Toast(this, _config);
	          $element.data(DATA_KEY$a, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config](this);
	        }
	      });
	    };
	
	    _createClass(Toast, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$a;
	      }
	    }, {
	      key: "DefaultType",
	      get: function get() {
	        return DefaultType$7;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$7;
	      }
	    }]);
	
	    return Toast;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	
	  $__default['default'].fn[NAME$a] = Toast._jQueryInterface;
	  $__default['default'].fn[NAME$a].Constructor = Toast;
	
	  $__default['default'].fn[NAME$a].noConflict = function () {
	    $__default['default'].fn[NAME$a] = JQUERY_NO_CONFLICT$a;
	    return Toast._jQueryInterface;
	  };
	
	  exports.Alert = Alert;
	  exports.Button = Button;
	  exports.Carousel = Carousel;
	  exports.Collapse = Collapse;
	  exports.Dropdown = Dropdown;
	  exports.Modal = Modal;
	  exports.Popover = Popover;
	  exports.Scrollspy = ScrollSpy;
	  exports.Tab = Tab;
	  exports.Toast = Toast;
	  exports.Tooltip = Tooltip;
	  exports.Util = Util;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=bootstrap.js.map


/***/ },

/***/ 474:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console, global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), (function() { return this; }())))

/***/ },

/***/ 479:
/***/ function(module, exports) {

	/**
	 * jquery.string - Prototype string functions for jQuery
	 * (c) 2008 David E. Still (http://stilldesigning.com)
	 * Original Prototype extensions (c) 2005-2008 Sam Stephenson (http://prototypejs.org)
	 */
	
	jQuery.extend({
		__stringPrototype: {
			/**
			 * ScriptFragmet, specialChar, and JSONFilter borrowed from Prototype 1.6.0.2
			 */
		 	JSONFilter: /^\/\*-secure-([\s\S]*)\*\/\s*$/,
			ScriptFragment: '<script[^>]*>([\\S\\s]*?)<\/script>',
			specialChar: {
				'\b': '\\b',
				'\t': '\\t',
				'\n': '\\n',
				'\f': '\\f',
				'\r': '\\r',
				'\\': '\\\\'
			},
	
			/**
			 * Check if the string is blank (white-space only or empty).
			 * @param {String} s string to be evaluated
			 * @return {Boolean} boolean of result
			 */
			blank: function(s) {
				return /^\s*$/.test(this.s(s) || ' ');
			},
			/**
			 * Converts a string separated by dashes into a camelCase equivalent.
			 * For instance, 'foo-bar' would be converted to 'fooBar'.
			 * @param {String} s string to be evaluated
			 * @return {Boolean} boolean of result
			 */
			camelize: function(s) {
				var a = this.s(s).split('-'), i;
				s = [a[0]];
				for (i=1; i<a.length; i++){
					s.push(a[i].charAt(0).toUpperCase() + a[i].substring(1));
				}
				s = s.join('');
				return this.r(arguments,0,s);
			},
			/**
			 * Capitalizes the first letter of a string and downcases all the others.
			 * @param {String} s string to be evaluated
			 * @return {Boolean} boolean of result
			 */
			capitalize: function(s) {
				s = this.s(s);
				s = s.charAt(0).toUpperCase() + s.substring(1).toLowerCase();
				return this.r(arguments,0,s);
			},
			/**
			 * Replaces every instance of the underscore character ("_") by a dash ("-").
			 * @param {String} s string to be evaluated
			 * @return {Boolean} boolean of result
			 */
			dasherize: function(s) {
				s = this.s(s).split('_').join('-');
				return this.r(arguments,0,s);
			},
			/**
			 * Check if the string is empty.
			 * @param {String} s string to be evaluated
			 * @return {Boolean} boolean of result
			 */
			empty: function(s) {
				return this.s(s) === '';
			},
			/**
			 * Tests whether the end of a string matches pattern.
			 * @param {Object} pattern
			 * @param {String} s string to be evaluated
			 * @return {Boolean} boolean of result
			 */
			endsWith: function(pattern, s) {
				s = this.s(s);
				var d = s.length - pattern.length;
				return d >= 0 && s.lastIndexOf(pattern) === d;
			},
			/**
			 * escapeHTML from Prototype-1.6.0.2 -- If it's good enough for Webkit and IE, it's good enough for Gecko!
			 * Converts HTML special characters to their entity equivalents.
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			escapeHTML: function(s) {
				s = this.s(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
				return this.r(arguments,0,s);
			},
			/**
			 * evalJSON from Prototype-1.6.0.2
			 * Evaluates the JSON in the string and returns the resulting object. If the optional sanitize parameter
			 * is set to true, the string is checked for possible malicious attempts and eval is not called if one
			 * is detected.
			 * @param {String} s string to be evaluated
			 * @return {Object} evaluated JSON result
			 */
			evalJSON: function(sanitize, s) {
				s = this.s(s);
				var json = this.unfilterJSON(false, s);
				try {
					if (!sanitize || this.isJSON(json)) { return eval('(' + json + ')'); }
				} catch (e) { }
				throw new SyntaxError('Badly formed JSON string: ' + s);
			},
			/**
			 * evalScripts from Prototype-1.6.0.2
			 * Evaluates the content of any script block present in the string. Returns an array containing
			 * the value returned by each script.
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			evalScripts: function(s) {
				var scriptTags = this.extractScripts(this.s(s)), results = [];
				if (scriptTags.length > 0) {
					for (var i = 0; i < scriptTags.length; i++) {
						results.push(eval(scriptTags[i]));
					}
				}
				return results;
			},
			/**
			 * extractScripts from Prototype-1.6.0.2
			 * Extracts the content of any script block present in the string and returns them as an array of strings.
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			extractScripts: function(s) {
				var matchAll = new RegExp(this.ScriptFragment, 'img'), matchOne = new RegExp(this.ScriptFragment, 'im'), scriptMatches = this.s(s).match(matchAll) || [], scriptTags = [];
				if (scriptMatches.length > 0) {
					for (var i = 0; i < scriptMatches.length; i++) {
						scriptTags.push(scriptMatches[i].match(matchOne)[1] || '');
					}
				}
				return scriptTags;
			},
			/**
			 * Returns a string with all occurances of pattern replaced by either a regular string
			 * or the returned value of a function.  Calls sub internally.
			 * @param {Object} pattern RegEx pattern or string to replace
			 * @param {Object} replacement string or function to replace matched patterns
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 * @see sub
			 */
			gsub: function(pattern, replacement, s) {
				s = this.s(s);
				if (jQuery.isFunction(replacement)) { s = this.sub(pattern, replacement, -1, s); }
				/* if replacement is not a function, do this the easy way; it's quicker */
				else { s = s.split(pattern).join(replacement); }
				return this.r(arguments,2,s);
			},
			/**
			 * Check if the string contains a substring.
			 * @param {Object} pattern RegEx pattern or string to find
			 * @param {String} s string to be evaluated
			 * @return {Boolean} boolean result
			 */
			include: function(pattern, s) {
				return this.s(s).indexOf(pattern) > -1;
			},
			/**
			 * Returns a debug-oriented version of the string (i.e. wrapped in single or double quotes,
			 * with backslashes and quotes escaped).
			 * @param {Object} useDoubleQuotes escape double-quotes instead of single-quotes
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			inspect: function(useDoubleQuotes, s) {
				s = this.s(s);
				var escapedString;
				try {
					escapedString = this.sub(/[\x00-\x1f\\]/, function(match) {
						var character = jQuery.__stringPrototype.specialChar[match[0]];
						return character ? character : '\\u00' + match[0].charCodeAt().toPaddedString(2, 16);
				    }, -1, s);
				} catch(e) { escapedString = s; }
				s = (useDoubleQuotes) ? '"' + escapedString.replace(/"/g, '\\"') + '"' : "'" + escapedString.replace(/'/g, '\\\'') + "'";
				return this.r(arguments,1,s);
			},
			/**
			 * Treats the string as a Prototype-style Template and fills it with objectﾕs properties.
			 * @param {Object} obj object of values to replace in string
			 * @param {Object} pattern RegEx pattern for template replacement (default matches Ruby-style '#{attribute}')
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			interpolate: function(obj, pattern, s) {
				s = this.s(s);
				if (!pattern) { pattern = /(\#\{\s*(\w+)\s*\})/; }
				var gpattern = new RegExp(pattern.source, "g");
				var matches = s.match(gpattern), i;
				for (i=0; i<matches.length; i++) {
					s = s.replace(matches[i], obj[matches[i].match(pattern)[2]]);
				}
				return this.r(arguments,2,s);
			},
			/**
			 * isJSON from Prototype-1.6.0.2
			 * Check if the string is valid JSON by the use of regular expressions. This security method is called internally.
			 * @param {String} s string to be evaluated
			 * @return {Boolean} boolean result
			 */
			isJSON: function(s) {
				s = this.s(s);
				if (this.blank(s)) { return false; }
				s = s.replace(/\\./g, '@').replace(/"[^"\\\n\r]*"/g, '');
				return (/^[,:{}\[\]0-9.\-+Eaeflnr-u \n\r\t]*$/).test(s);
			},
			/**
			 * Evaluates replacement for each match of pattern in string and returns the original string.
			 * Calls sub internally.
			 * @param {Object} pattern RegEx pattern or string to replace
			 * @param {Object} replacement string or function to replace matched patterns
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 * @see sub
			 */
			scan: function(pattern, replacement, s) {
				s = this.s(s);
				this.sub(pattern, replacement, -1, s);
				return this.r(arguments,2,s);
			},
			/**
			 * Tests whether the beginning of a string matches pattern.
			 * @param {Object} pattern
			 * @param {String} s string to be evaluated
			 * @return {Boolean} boolean of result
			 */
			startsWith: function(pattern, s) {
				return this.s(s).indexOf(pattern) === 0;
			},
			/**
			 * Trims white space from the beginning and end of a string.
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			strip: function(s) {
				s = jQuery.trim(this.s(s));
				return this.r(arguments,0,s);
			},
			/**
			 * Strips a string of anything that looks like an HTML script block.
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			stripScripts: function(s) {
				s = this.s(s).replace(new RegExp(this.ScriptFragment, 'img'), '');
				return this.r(arguments,0,s);
			},
			/**
			 * Strips a string of any HTML tags.
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			stripTags: function(s) {
				s = this.s(s).replace(/<\/?[^>]+>/gi, '');
				return this.r(arguments,0,s);
			},
			/**
			 * Returns a string with the first count occurances of pattern replaced by either a regular string
			 * or the returned value of a function.
			 * @param {Object} pattern RegEx pattern or string to replace
			 * @param {Object} replacement string or function to replace matched patterns
			 * @param {Integer} count number of (default = 1, -1 replaces all)
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			sub: function(pattern, replacement, count, s) {
				s = this.s(s);
				if (pattern.source && !pattern.global) {
					var patternMods = (pattern.ignoreCase)?"ig":"g";
					patternMods += (pattern.multiline)?"m":"";
					pattern = new RegExp(pattern.source, patternMods);
				}
				var sarray = s.split(pattern), matches = s.match(pattern);
				if (jQuery.browser.msie) {
					if (s.indexOf(matches[0]) == 0) sarray.unshift("");
					if (s.lastIndexOf(matches[matches.length-1]) == s.length - matches[matches.length-1].length) sarray.push("");
				}
				count = (count < 0)?(sarray.length-1):count || 1;
				s = sarray[0];
				for (var i=1; i<sarray.length; i++) {
					if (i <= count) {
						if (jQuery.isFunction(replacement)) {
							s += replacement(matches[i-1] || matches) + sarray[i];
						} else { s += replacement + sarray[i]; }
					} else { s += (matches[i-1] || matches) + sarray[i]; }
				}
				return this.r(arguments,3,s);
			},
			/**
			 *
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			succ: function(s) {
				s = this.s(s);
				s = s.slice(0, s.length - 1) + String.fromCharCode(s.charCodeAt(s.length - 1) + 1);
				return this.r(arguments,0,s);
			},
			/**
			 * Concatenate count number of copies of s together and return result.
			 * @param {Integer} count Number of times to repeat s
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			times: function(count, s) {
				s = this.s(s);
				var newS = "";
				for (var i=0; i<count; i++) {
					newS += s;
				}
				return this.r(arguments,1,newS);
			},
			/**
			 * Returns a JSON string
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			toJSON: function(s) {
				return this.r(arguments,0,this.inspect(true, this.s(s)));
			},
			/**
			 * Parses a URI-like query string and returns an object composed of parameter/value pairs.
			 * This method is mainly targeted at parsing query strings (hence the default value of '&'
			 * for the seperator argument). For this reason, it does not consider anything that is either
			 * before a question mark (which signals the beginning of a query string) or beyond the hash
			 * symbol ("#"), and runs decodeURIComponent() on each parameter/value pair.
			 * @param {Object} separator string to separate parameters (default = '&')
			 * @param {Object} s
			 * @return {Object} object
			 */
			toQueryParams: function(separator, s) {
				s = this.s(s);
				var paramsList = s.substring(s.indexOf('?')+1).split('#')[0].split(separator || '&'), params = {}, i, key, value, pair;
				for (i=0; i<paramsList.length; i++) {
					pair = paramsList[i].split('=');
					key = decodeURIComponent(pair[0]);
					value = (pair[1])?decodeURIComponent(pair[1]):undefined;
					if (params[key]) {
						if (typeof params[key] == "string") { params[key] = [params[key]]; }
						params[key].push(value);
					} else { params[key] = value; }
				}
				return params;
			},
	
			/**
			 * TOKOBETU Takeo Tamura 2010/2/4
			 */
			toQueryParamsEncodeHankakuSpace: function(separator, s) {
				s = this.s(s);
				var paramsList = s.substring(s.indexOf('?')+1).split('#')[0].split(separator || '&'), params = {}, i, key, value, pair;
				for (i=0; i<paramsList.length; i++) {
					pair = paramsList[i].split('=');
					key = decodeURIComponent(pair[0]);
					value = (pair[1])?decodeURIComponent(pair[1].replace(/\+/g, ' ')):undefined;
	
					if (params[key]) {
						if (typeof params[key] == "string") { params[key] = [params[key]]; }
						params[key].push(value);
					} else { params[key] = value; }
				}
				return params;
			},
	
			/**
			 * truncate from Prototype-1.6.0.2
			 * Truncates a string to the given length and appends a suffix to it (indicating that it is only an excerpt).
			 * @param {Object} length length of string to truncate to
			 * @param {Object} truncation string to concatenate onto truncated string (default = '...')
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			truncate: function(length, truncation, s) {
				s = this.s(s);
				length = length || 30;
				truncation = (!truncation) ? '...' : truncation;
				s = (s.length > length) ? s.slice(0, length - truncation.length) + truncation : String(s);
				return this.r(arguments,2,s);
			},
			/**
			 * Converts a camelized string into a series of words separated by an underscore ("_").
			 * e.g. $.string('borderBottomWidth').underscore().str = 'border_bottom_width'
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			underscore: function(s) {
				s = this.sub(/[A-Z]/, function(c) { return "_"+c.toLowerCase(); }, -1, this.s(s));
				if (s.charAt(0) == "_") s = s.substring(1);
				return this.r(arguments,0,s);
			},
			/**
			 * unescapeHTML from Prototype-1.6.0.2 -- If it's good enough for Webkit and IE, it's good enough for Gecko!
			 * Strips tags and converts the entity forms of special HTML characters to their normal form.
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			unescapeHTML: function(s) {
				s = this.stripTags(this.s(s)).replace(/&amp;/g,'&').replace(/&lt;/g,'<').replace(/&gt;/g,'>');
				return this.r(arguments,0,s);
			},
			/**
			 * unfilterJSON from Prototype-1.6.0.2.
			 * @param {Function} filter
			 * @param {String} s string to be evaluated
			 * @return {Object} .string object (or string if internal)
			 */
			unfilterJSON: function(filter, s) {
				s = this.s(s);
				filter = filter || this.JSONFilter;
				var filtered = s.match(filter);
				s = (filtered !== null)?filtered[1]:s;
				return this.r(arguments,1,jQuery.trim(s));
			},
	
			/**
			 * Sets .str property and returns $.string object.
			 * @param {String} s string to be evaluated
			 */
			r: function(args, size, s) {
				if (args.length > size || this.str === undefined) {
					return s;
				} else {
					this.str = ''+s;
					return this;
				};
			},
			s: function(s) {
				if (s === '' || s) { return s; }
				if (this.str === '' || this.str) { return this.str; }
				return this;
			}
		},
		string: function(str) {
			if (str === String.prototype) { jQuery.extend(String.prototype, jQuery.__stringPrototype); }
			else { return jQuery.extend({ str: str }, jQuery.__stringPrototype); }
		}
	});
	jQuery.__stringPrototype.parseQuery = jQuery.__stringPrototype.toQueryParams;
	jQuery.__stringPrototype.parseQuery = jQuery.__stringPrototype.toQueryParamsEncodeHankakuSpace;

/***/ },

/***/ 674:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(10);
	
	__webpack_require__(1013);
	
	__webpack_require__(437);
	
	__webpack_require__(479);
	
	__webpack_require__(1121);
	
	__webpack_require__(1108);
	
	__webpack_require__(1111);
	
	__webpack_require__(1109);
	
	__webpack_require__(1110);
	
	__webpack_require__(1105);
	
	__webpack_require__(1106);
	
	__webpack_require__(1107);
	
	__webpack_require__(1112);

/***/ },

/***/ 1013:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	* jquery-match-height 0.7.0 by @liabru
	* http://brm.io/jquery-match-height/
	* License: MIT
	*/
	
	;(function(factory) { // eslint-disable-line no-extra-semi
	    'use strict';
	    if (true) {
	        // AMD
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined' && module.exports) {
	        // CommonJS
	        module.exports = factory(require('jquery'));
	    } else {
	        // Global
	        factory(jQuery);
	    }
	})(function($) {
	    /*
	    *  internal
	    */
	
	    var _previousResizeWidth = -1,
	        _updateTimeout = -1;
	
	    /*
	    *  _parse
	    *  value parse utility function
	    */
	
	    var _parse = function(value) {
	        // parse value and convert NaN to 0
	        return parseFloat(value) || 0;
	    };
	
	    /*
	    *  _rows
	    *  utility function returns array of jQuery selections representing each row
	    *  (as displayed after float wrapping applied by browser)
	    */
	
	    var _rows = function(elements) {
	        var tolerance = 1,
	            $elements = $(elements),
	            lastTop = null,
	            rows = [];
	
	        // group elements by their top position
	        $elements.each(function(){
	            var $that = $(this),
	                top = $that.offset().top - _parse($that.css('margin-top')),
	                lastRow = rows.length > 0 ? rows[rows.length - 1] : null;
	
	            if (lastRow === null) {
	                // first item on the row, so just push it
	                rows.push($that);
	            } else {
	                // if the row top is the same, add to the row group
	                if (Math.floor(Math.abs(lastTop - top)) <= tolerance) {
	                    rows[rows.length - 1] = lastRow.add($that);
	                } else {
	                    // otherwise start a new row group
	                    rows.push($that);
	                }
	            }
	
	            // keep track of the last row top
	            lastTop = top;
	        });
	
	        return rows;
	    };
	
	    /*
	    *  _parseOptions
	    *  handle plugin options
	    */
	
	    var _parseOptions = function(options) {
	        var opts = {
	            byRow: true,
	            property: 'height',
	            target: null,
	            remove: false
	        };
	
	        if (typeof options === 'object') {
	            return $.extend(opts, options);
	        }
	
	        if (typeof options === 'boolean') {
	            opts.byRow = options;
	        } else if (options === 'remove') {
	            opts.remove = true;
	        }
	
	        return opts;
	    };
	
	    /*
	    *  matchHeight
	    *  plugin definition
	    */
	
	    var matchHeight = $.fn.matchHeight = function(options) {
	        var opts = _parseOptions(options);
	
	        // handle remove
	        if (opts.remove) {
	            var that = this;
	
	            // remove fixed height from all selected elements
	            this.css(opts.property, '');
	
	            // remove selected elements from all groups
	            $.each(matchHeight._groups, function(key, group) {
	                group.elements = group.elements.not(that);
	            });
	
	            // TODO: cleanup empty groups
	
	            return this;
	        }
	
	        if (this.length <= 1 && !opts.target) {
	            return this;
	        }
	
	        // keep track of this group so we can re-apply later on load and resize events
	        matchHeight._groups.push({
	            elements: this,
	            options: opts
	        });
	
	        // match each element's height to the tallest element in the selection
	        matchHeight._apply(this, opts);
	
	        return this;
	    };
	
	    /*
	    *  plugin global options
	    */
	
	    matchHeight.version = '0.7.0';
	    matchHeight._groups = [];
	    matchHeight._throttle = 80;
	    matchHeight._maintainScroll = false;
	    matchHeight._beforeUpdate = null;
	    matchHeight._afterUpdate = null;
	    matchHeight._rows = _rows;
	    matchHeight._parse = _parse;
	    matchHeight._parseOptions = _parseOptions;
	
	    /*
	    *  matchHeight._apply
	    *  apply matchHeight to given elements
	    */
	
	    matchHeight._apply = function(elements, options) {
	        var opts = _parseOptions(options),
	            $elements = $(elements),
	            rows = [$elements];
	
	        // take note of scroll position
	        var scrollTop = $(window).scrollTop(),
	            htmlHeight = $('html').outerHeight(true);
	
	        // get hidden parents
	        var $hiddenParents = $elements.parents().filter(':hidden');
	
	        // cache the original inline style
	        $hiddenParents.each(function() {
	            var $that = $(this);
	            $that.data('style-cache', $that.attr('style'));
	        });
	
	        // temporarily must force hidden parents visible
	        $hiddenParents.css('display', 'block');
	
	        // get rows if using byRow, otherwise assume one row
	        if (opts.byRow && !opts.target) {
	
	            // must first force an arbitrary equal height so floating elements break evenly
	            $elements.each(function() {
	                var $that = $(this),
	                    display = $that.css('display');
	
	                // temporarily force a usable display value
	                if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
	                    display = 'block';
	                }
	
	                // cache the original inline style
	                $that.data('style-cache', $that.attr('style'));
	
	                $that.css({
	                    'display': display,
	                    'padding-top': '0',
	                    'padding-bottom': '0',
	                    'margin-top': '0',
	                    'margin-bottom': '0',
	                    'border-top-width': '0',
	                    'border-bottom-width': '0',
	                    'height': '100px',
	                    'overflow': 'hidden'
	                });
	            });
	
	            // get the array of rows (based on element top position)
	            rows = _rows($elements);
	
	            // revert original inline styles
	            $elements.each(function() {
	                var $that = $(this);
	                $that.attr('style', $that.data('style-cache') || '');
	            });
	        }
	
	        $.each(rows, function(key, row) {
	            var $row = $(row),
	                targetHeight = 0;
	
	            if (!opts.target) {
	                // skip apply to rows with only one item
	                if (opts.byRow && $row.length <= 1) {
	                    $row.css(opts.property, '');
	                    return;
	                }
	
	                // iterate the row and find the max height
	                $row.each(function(){
	                    var $that = $(this),
	                        style = $that.attr('style'),
	                        display = $that.css('display');
	
	                    // temporarily force a usable display value
	                    if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
	                        display = 'block';
	                    }
	
	                    // ensure we get the correct actual height (and not a previously set height value)
	                    var css = { 'display': display };
	                    css[opts.property] = '';
	                    $that.css(css);
	
	                    // find the max height (including padding, but not margin)
	                    if ($that.outerHeight(false) > targetHeight) {
	                        targetHeight = $that.outerHeight(false);
	                    }
	
	                    // revert styles
	                    if (style) {
	                        $that.attr('style', style);
	                    } else {
	                        $that.css('display', '');
	                    }
	                });
	            } else {
	                // if target set, use the height of the target element
	                targetHeight = opts.target.outerHeight(false);
	            }
	
	            // iterate the row and apply the height to all elements
	            $row.each(function(){
	                var $that = $(this),
	                    verticalPadding = 0;
	
	                // don't apply to a target
	                if (opts.target && $that.is(opts.target)) {
	                    return;
	                }
	
	                // handle padding and border correctly (required when not using border-box)
	                if ($that.css('box-sizing') !== 'border-box') {
	                    verticalPadding += _parse($that.css('border-top-width')) + _parse($that.css('border-bottom-width'));
	                    verticalPadding += _parse($that.css('padding-top')) + _parse($that.css('padding-bottom'));
	                }
	
	                // set the height (accounting for padding and border)
	                $that.css(opts.property, (targetHeight - verticalPadding) + 'px');
	            });
	        });
	
	        // revert hidden parents
	        $hiddenParents.each(function() {
	            var $that = $(this);
	            $that.attr('style', $that.data('style-cache') || null);
	        });
	
	        // restore scroll position if enabled
	        if (matchHeight._maintainScroll) {
	            $(window).scrollTop((scrollTop / htmlHeight) * $('html').outerHeight(true));
	        }
	
	        return this;
	    };
	
	    /*
	    *  matchHeight._applyDataApi
	    *  applies matchHeight to all elements with a data-match-height attribute
	    */
	
	    matchHeight._applyDataApi = function() {
	        var groups = {};
	
	        // generate groups by their groupId set by elements using data-match-height
	        $('[data-match-height], [data-mh]').each(function() {
	            var $this = $(this),
	                groupId = $this.attr('data-mh') || $this.attr('data-match-height');
	
	            if (groupId in groups) {
	                groups[groupId] = groups[groupId].add($this);
	            } else {
	                groups[groupId] = $this;
	            }
	        });
	
	        // apply matchHeight to each group
	        $.each(groups, function() {
	            this.matchHeight(true);
	        });
	    };
	
	    /*
	    *  matchHeight._update
	    *  updates matchHeight on all current groups with their correct options
	    */
	
	    var _update = function(event) {
	        if (matchHeight._beforeUpdate) {
	            matchHeight._beforeUpdate(event, matchHeight._groups);
	        }
	
	        $.each(matchHeight._groups, function() {
	            matchHeight._apply(this.elements, this.options);
	        });
	
	        if (matchHeight._afterUpdate) {
	            matchHeight._afterUpdate(event, matchHeight._groups);
	        }
	    };
	
	    matchHeight._update = function(throttle, event) {
	        // prevent update if fired from a resize event
	        // where the viewport width hasn't actually changed
	        // fixes an event looping bug in IE8
	        if (event && event.type === 'resize') {
	            var windowWidth = $(window).width();
	            if (windowWidth === _previousResizeWidth) {
	                return;
	            }
	            _previousResizeWidth = windowWidth;
	        }
	
	        // throttle updates
	        if (!throttle) {
	            _update(event);
	        } else if (_updateTimeout === -1) {
	            _updateTimeout = setTimeout(function() {
	                _update(event);
	                _updateTimeout = -1;
	            }, matchHeight._throttle);
	        }
	    };
	
	    /*
	    *  bind events
	    */
	
	    // apply on DOM ready event
	    $(matchHeight._applyDataApi);
	
	    // update heights on load and resize events
	    $(window).bind('load', function(event) {
	        matchHeight._update(false, event);
	    });
	
	    // throttled update heights on resize events
	    $(window).bind('resize orientationchange', function(event) {
	        matchHeight._update(true, event);
	    });
	
	});


/***/ },

/***/ 1105:
/***/ function(module, exports) {

	/* Javascript plotting library for jQuery, version 0.8.3.
	
	Copyright (c) 2007-2014 IOLA and Ole Laursen.
	Licensed under the MIT license.
	
	*/
	
	// first an inline dependency, jquery.colorhelpers.js, we inline it here
	// for convenience
	
	/* Plugin for jQuery for working with colors.
	 *
	 * Version 1.1.
	 *
	 * Inspiration from jQuery color animation plugin by John Resig.
	 *
	 * Released under the MIT license by Ole Laursen, October 2009.
	 *
	 * Examples:
	 *
	 *   $.color.parse("#fff").scale('rgb', 0.25).add('a', -0.5).toString()
	 *   var c = $.color.extract($("#mydiv"), 'background-color');
	 *   console.log(c.r, c.g, c.b, c.a);
	 *   $.color.make(100, 50, 25, 0.4).toString() // returns "rgba(100,50,25,0.4)"
	 *
	 * Note that .scale() and .add() return the same modified object
	 * instead of making a new one.
	 *
	 * V. 1.1: Fix error handling so e.g. parsing an empty string does
	 * produce a color rather than just crashing.
	 */
	(function($){$.color={};$.color.make=function(r,g,b,a){var o={};o.r=r||0;o.g=g||0;o.b=b||0;o.a=a!=null?a:1;o.add=function(c,d){for(var i=0;i<c.length;++i)o[c.charAt(i)]+=d;return o.normalize()};o.scale=function(c,f){for(var i=0;i<c.length;++i)o[c.charAt(i)]*=f;return o.normalize()};o.toString=function(){if(o.a>=1){return"rgb("+[o.r,o.g,o.b].join(",")+")"}else{return"rgba("+[o.r,o.g,o.b,o.a].join(",")+")"}};o.normalize=function(){function clamp(min,value,max){return value<min?min:value>max?max:value}o.r=clamp(0,parseInt(o.r),255);o.g=clamp(0,parseInt(o.g),255);o.b=clamp(0,parseInt(o.b),255);o.a=clamp(0,o.a,1);return o};o.clone=function(){return $.color.make(o.r,o.b,o.g,o.a)};return o.normalize()};$.color.extract=function(elem,css){var c;do{c=elem.css(css).toLowerCase();if(c!=""&&c!="transparent")break;elem=elem.parent()}while(elem.length&&!$.nodeName(elem.get(0),"body"));if(c=="rgba(0, 0, 0, 0)")c="transparent";return $.color.parse(c)};$.color.parse=function(str){var res,m=$.color.make;if(res=/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(str))return m(parseInt(res[1],10),parseInt(res[2],10),parseInt(res[3],10));if(res=/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(str))return m(parseInt(res[1],10),parseInt(res[2],10),parseInt(res[3],10),parseFloat(res[4]));if(res=/rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(str))return m(parseFloat(res[1])*2.55,parseFloat(res[2])*2.55,parseFloat(res[3])*2.55);if(res=/rgba\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(str))return m(parseFloat(res[1])*2.55,parseFloat(res[2])*2.55,parseFloat(res[3])*2.55,parseFloat(res[4]));if(res=/#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(str))return m(parseInt(res[1],16),parseInt(res[2],16),parseInt(res[3],16));if(res=/#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(str))return m(parseInt(res[1]+res[1],16),parseInt(res[2]+res[2],16),parseInt(res[3]+res[3],16));var name=$.trim(str).toLowerCase();if(name=="transparent")return m(255,255,255,0);else{res=lookupColors[name]||[0,0,0];return m(res[0],res[1],res[2])}};var lookupColors={aqua:[0,255,255],azure:[240,255,255],beige:[245,245,220],black:[0,0,0],blue:[0,0,255],brown:[165,42,42],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgrey:[169,169,169],darkgreen:[0,100,0],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkviolet:[148,0,211],fuchsia:[255,0,255],gold:[255,215,0],green:[0,128,0],indigo:[75,0,130],khaki:[240,230,140],lightblue:[173,216,230],lightcyan:[224,255,255],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightyellow:[255,255,224],lime:[0,255,0],magenta:[255,0,255],maroon:[128,0,0],navy:[0,0,128],olive:[128,128,0],orange:[255,165,0],pink:[255,192,203],purple:[128,0,128],violet:[128,0,128],red:[255,0,0],silver:[192,192,192],white:[255,255,255],yellow:[255,255,0]}})(jQuery);
	
	// the actual Flot code
	(function($) {
	
		// Cache the prototype hasOwnProperty for faster access
	
		var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	    // A shim to provide 'detach' to jQuery versions prior to 1.4.  Using a DOM
	    // operation produces the same effect as detach, i.e. removing the element
	    // without touching its jQuery data.
	
	    // Do not merge this into Flot 0.9, since it requires jQuery 1.4.4+.
	
	    if (!$.fn.detach) {
	        $.fn.detach = function() {
	            return this.each(function() {
	                if (this.parentNode) {
	                    this.parentNode.removeChild( this );
	                }
	            });
	        };
	    }
	
		///////////////////////////////////////////////////////////////////////////
		// The Canvas object is a wrapper around an HTML5 <canvas> tag.
		//
		// @constructor
		// @param {string} cls List of classes to apply to the canvas.
		// @param {element} container Element onto which to append the canvas.
		//
		// Requiring a container is a little iffy, but unfortunately canvas
		// operations don't work unless the canvas is attached to the DOM.
	
		function Canvas(cls, container) {
	
			var element = container.children("." + cls)[0];
	
			if (element == null) {
	
				element = document.createElement("canvas");
				element.className = cls;
	
				$(element).css({ direction: "ltr", position: "absolute", left: 0, top: 0 })
					.appendTo(container);
	
				// If HTML5 Canvas isn't available, fall back to [Ex|Flash]canvas
	
				if (!element.getContext) {
					if (window.G_vmlCanvasManager) {
						element = window.G_vmlCanvasManager.initElement(element);
					} else {
						throw new Error("Canvas is not available. If you're using IE with a fall-back such as Excanvas, then there's either a mistake in your conditional include, or the page has no DOCTYPE and is rendering in Quirks Mode.");
					}
				}
			}
	
			this.element = element;
	
			var context = this.context = element.getContext("2d");
	
			// Determine the screen's ratio of physical to device-independent
			// pixels.  This is the ratio between the canvas width that the browser
			// advertises and the number of pixels actually present in that space.
	
			// The iPhone 4, for example, has a device-independent width of 320px,
			// but its screen is actually 640px wide.  It therefore has a pixel
			// ratio of 2, while most normal devices have a ratio of 1.
	
			var devicePixelRatio = window.devicePixelRatio || 1,
				backingStoreRatio =
					context.webkitBackingStorePixelRatio ||
					context.mozBackingStorePixelRatio ||
					context.msBackingStorePixelRatio ||
					context.oBackingStorePixelRatio ||
					context.backingStorePixelRatio || 1;
	
			this.pixelRatio = devicePixelRatio / backingStoreRatio;
	
			// Size the canvas to match the internal dimensions of its container
	
			this.resize(container.width(), container.height());
	
			// Collection of HTML div layers for text overlaid onto the canvas
	
			this.textContainer = null;
			this.text = {};
	
			// Cache of text fragments and metrics, so we can avoid expensively
			// re-calculating them when the plot is re-rendered in a loop.
	
			this._textCache = {};
		}
	
		// Resizes the canvas to the given dimensions.
		//
		// @param {number} width New width of the canvas, in pixels.
		// @param {number} width New height of the canvas, in pixels.
	
		Canvas.prototype.resize = function(width, height) {
	
			if (width <= 0 || height <= 0) {
				throw new Error("Invalid dimensions for plot, width = " + width + ", height = " + height);
			}
	
			var element = this.element,
				context = this.context,
				pixelRatio = this.pixelRatio;
	
			// Resize the canvas, increasing its density based on the display's
			// pixel ratio; basically giving it more pixels without increasing the
			// size of its element, to take advantage of the fact that retina
			// displays have that many more pixels in the same advertised space.
	
			// Resizing should reset the state (excanvas seems to be buggy though)
	
			if (this.width != width) {
				element.width = width * pixelRatio;
				element.style.width = width + "px";
				this.width = width;
			}
	
			if (this.height != height) {
				element.height = height * pixelRatio;
				element.style.height = height + "px";
				this.height = height;
			}
	
			// Save the context, so we can reset in case we get replotted.  The
			// restore ensure that we're really back at the initial state, and
			// should be safe even if we haven't saved the initial state yet.
	
			context.restore();
			context.save();
	
			// Scale the coordinate space to match the display density; so even though we
			// may have twice as many pixels, we still want lines and other drawing to
			// appear at the same size; the extra pixels will just make them crisper.
	
			context.scale(pixelRatio, pixelRatio);
		};
	
		// Clears the entire canvas area, not including any overlaid HTML text
	
		Canvas.prototype.clear = function() {
			this.context.clearRect(0, 0, this.width, this.height);
		};
	
		// Finishes rendering the canvas, including managing the text overlay.
	
		Canvas.prototype.render = function() {
	
			var cache = this._textCache;
	
			// For each text layer, add elements marked as active that haven't
			// already been rendered, and remove those that are no longer active.
	
			for (var layerKey in cache) {
				if (hasOwnProperty.call(cache, layerKey)) {
	
					var layer = this.getTextLayer(layerKey),
						layerCache = cache[layerKey];
	
					layer.hide();
	
					for (var styleKey in layerCache) {
						if (hasOwnProperty.call(layerCache, styleKey)) {
							var styleCache = layerCache[styleKey];
							for (var key in styleCache) {
								if (hasOwnProperty.call(styleCache, key)) {
	
									var positions = styleCache[key].positions;
	
									for (var i = 0, position; position = positions[i]; i++) {
										if (position.active) {
											if (!position.rendered) {
												layer.append(position.element);
												position.rendered = true;
											}
										} else {
											positions.splice(i--, 1);
											if (position.rendered) {
												position.element.detach();
											}
										}
									}
	
									if (positions.length == 0) {
										delete styleCache[key];
									}
								}
							}
						}
					}
	
					layer.show();
				}
			}
		};
	
		// Creates (if necessary) and returns the text overlay container.
		//
		// @param {string} classes String of space-separated CSS classes used to
		//     uniquely identify the text layer.
		// @return {object} The jQuery-wrapped text-layer div.
	
		Canvas.prototype.getTextLayer = function(classes) {
	
			var layer = this.text[classes];
	
			// Create the text layer if it doesn't exist
	
			if (layer == null) {
	
				// Create the text layer container, if it doesn't exist
	
				if (this.textContainer == null) {
					this.textContainer = $("<div class='flot-text'></div>")
						.css({
							position: "absolute",
							top: 0,
							left: 0,
							bottom: 0,
							right: 0,
							'font-size': "smaller",
							color: "#545454"
						})
						.insertAfter(this.element);
				}
	
				layer = this.text[classes] = $("<div></div>")
					.addClass(classes)
					.css({
						position: "absolute",
						top: 0,
						left: 0,
						bottom: 0,
						right: 0
					})
					.appendTo(this.textContainer);
			}
	
			return layer;
		};
	
		// Creates (if necessary) and returns a text info object.
		//
		// The object looks like this:
		//
		// {
		//     width: Width of the text's wrapper div.
		//     height: Height of the text's wrapper div.
		//     element: The jQuery-wrapped HTML div containing the text.
		//     positions: Array of positions at which this text is drawn.
		// }
		//
		// The positions array contains objects that look like this:
		//
		// {
		//     active: Flag indicating whether the text should be visible.
		//     rendered: Flag indicating whether the text is currently visible.
		//     element: The jQuery-wrapped HTML div containing the text.
		//     x: X coordinate at which to draw the text.
		//     y: Y coordinate at which to draw the text.
		// }
		//
		// Each position after the first receives a clone of the original element.
		//
		// The idea is that that the width, height, and general 'identity' of the
		// text is constant no matter where it is placed; the placements are a
		// secondary property.
		//
		// Canvas maintains a cache of recently-used text info objects; getTextInfo
		// either returns the cached element or creates a new entry.
		//
		// @param {string} layer A string of space-separated CSS classes uniquely
		//     identifying the layer containing this text.
		// @param {string} text Text string to retrieve info for.
		// @param {(string|object)=} font Either a string of space-separated CSS
		//     classes or a font-spec object, defining the text's font and style.
		// @param {number=} angle Angle at which to rotate the text, in degrees.
		//     Angle is currently unused, it will be implemented in the future.
		// @param {number=} width Maximum width of the text before it wraps.
		// @return {object} a text info object.
	
		Canvas.prototype.getTextInfo = function(layer, text, font, angle, width) {
	
			var textStyle, layerCache, styleCache, info;
	
			// Cast the value to a string, in case we were given a number or such
	
			text = "" + text;
	
			// If the font is a font-spec object, generate a CSS font definition
	
			if (typeof font === "object") {
				textStyle = font.style + " " + font.variant + " " + font.weight + " " + font.size + "px/" + font.lineHeight + "px " + font.family;
			} else {
				textStyle = font;
			}
	
			// Retrieve (or create) the cache for the text's layer and styles
	
			layerCache = this._textCache[layer];
	
			if (layerCache == null) {
				layerCache = this._textCache[layer] = {};
			}
	
			styleCache = layerCache[textStyle];
	
			if (styleCache == null) {
				styleCache = layerCache[textStyle] = {};
			}
	
			info = styleCache[text];
	
			// If we can't find a matching element in our cache, create a new one
	
			if (info == null) {
	
				var element = $("<div></div>").html(text)
					.css({
						position: "absolute",
						'max-width': width,
						top: -9999
					})
					.appendTo(this.getTextLayer(layer));
	
				if (typeof font === "object") {
					element.css({
						font: textStyle,
						color: font.color
					});
				} else if (typeof font === "string") {
					element.addClass(font);
				}
	
				info = styleCache[text] = {
					width: element.outerWidth(true),
					height: element.outerHeight(true),
					element: element,
					positions: []
				};
	
				element.detach();
			}
	
			return info;
		};
	
		// Adds a text string to the canvas text overlay.
		//
		// The text isn't drawn immediately; it is marked as rendering, which will
		// result in its addition to the canvas on the next render pass.
		//
		// @param {string} layer A string of space-separated CSS classes uniquely
		//     identifying the layer containing this text.
		// @param {number} x X coordinate at which to draw the text.
		// @param {number} y Y coordinate at which to draw the text.
		// @param {string} text Text string to draw.
		// @param {(string|object)=} font Either a string of space-separated CSS
		//     classes or a font-spec object, defining the text's font and style.
		// @param {number=} angle Angle at which to rotate the text, in degrees.
		//     Angle is currently unused, it will be implemented in the future.
		// @param {number=} width Maximum width of the text before it wraps.
		// @param {string=} halign Horizontal alignment of the text; either "left",
		//     "center" or "right".
		// @param {string=} valign Vertical alignment of the text; either "top",
		//     "middle" or "bottom".
	
		Canvas.prototype.addText = function(layer, x, y, text, font, angle, width, halign, valign) {
	
			var info = this.getTextInfo(layer, text, font, angle, width),
				positions = info.positions;
	
			// Tweak the div's position to match the text's alignment
	
			if (halign == "center") {
				x -= info.width / 2;
			} else if (halign == "right") {
				x -= info.width;
			}
	
			if (valign == "middle") {
				y -= info.height / 2;
			} else if (valign == "bottom") {
				y -= info.height;
			}
	
			// Determine whether this text already exists at this position.
			// If so, mark it for inclusion in the next render pass.
	
			for (var i = 0, position; position = positions[i]; i++) {
				if (position.x == x && position.y == y) {
					position.active = true;
					return;
				}
			}
	
			// If the text doesn't exist at this position, create a new entry
	
			// For the very first position we'll re-use the original element,
			// while for subsequent ones we'll clone it.
	
			position = {
				active: true,
				rendered: false,
				element: positions.length ? info.element.clone() : info.element,
				x: x,
				y: y
			};
	
			positions.push(position);
	
			// Move the element to its final position within the container
	
			position.element.css({
				top: Math.round(y),
				left: Math.round(x),
				'text-align': halign	// In case the text wraps
			});
		};
	
		// Removes one or more text strings from the canvas text overlay.
		//
		// If no parameters are given, all text within the layer is removed.
		//
		// Note that the text is not immediately removed; it is simply marked as
		// inactive, which will result in its removal on the next render pass.
		// This avoids the performance penalty for 'clear and redraw' behavior,
		// where we potentially get rid of all text on a layer, but will likely
		// add back most or all of it later, as when redrawing axes, for example.
		//
		// @param {string} layer A string of space-separated CSS classes uniquely
		//     identifying the layer containing this text.
		// @param {number=} x X coordinate of the text.
		// @param {number=} y Y coordinate of the text.
		// @param {string=} text Text string to remove.
		// @param {(string|object)=} font Either a string of space-separated CSS
		//     classes or a font-spec object, defining the text's font and style.
		// @param {number=} angle Angle at which the text is rotated, in degrees.
		//     Angle is currently unused, it will be implemented in the future.
	
		Canvas.prototype.removeText = function(layer, x, y, text, font, angle) {
			if (text == null) {
				var layerCache = this._textCache[layer];
				if (layerCache != null) {
					for (var styleKey in layerCache) {
						if (hasOwnProperty.call(layerCache, styleKey)) {
							var styleCache = layerCache[styleKey];
							for (var key in styleCache) {
								if (hasOwnProperty.call(styleCache, key)) {
									var positions = styleCache[key].positions;
									for (var i = 0, position; position = positions[i]; i++) {
										position.active = false;
									}
								}
							}
						}
					}
				}
			} else {
				var positions = this.getTextInfo(layer, text, font, angle).positions;
				for (var i = 0, position; position = positions[i]; i++) {
					if (position.x == x && position.y == y) {
						position.active = false;
					}
				}
			}
		};
	
		///////////////////////////////////////////////////////////////////////////
		// The top-level container for the entire plot.
	
	    function Plot(placeholder, data_, options_, plugins) {
	        // data is on the form:
	        //   [ series1, series2 ... ]
	        // where series is either just the data as [ [x1, y1], [x2, y2], ... ]
	        // or { data: [ [x1, y1], [x2, y2], ... ], label: "some label", ... }
	
	        var series = [],
	            options = {
	                // the color theme used for graphs
	                colors: ["#edc240", "#afd8f8", "#cb4b4b", "#4da74d", "#9440ed"],
	                legend: {
	                    show: true,
	                    noColumns: 1, // number of colums in legend table
	                    labelFormatter: null, // fn: string -> string
	                    labelBoxBorderColor: "#ccc", // border color for the little label boxes
	                    container: null, // container (as jQuery object) to put legend in, null means default on top of graph
	                    position: "ne", // position of default legend container within plot
	                    margin: 5, // distance from grid edge to default legend container within plot
	                    backgroundColor: null, // null means auto-detect
	                    backgroundOpacity: 0.85, // set to 0 to avoid background
	                    sorted: null    // default to no legend sorting
	                },
	                xaxis: {
	                    show: null, // null = auto-detect, true = always, false = never
	                    position: "bottom", // or "top"
	                    mode: null, // null or "time"
	                    font: null, // null (derived from CSS in placeholder) or object like { size: 11, lineHeight: 13, style: "italic", weight: "bold", family: "sans-serif", variant: "small-caps" }
	                    color: null, // base color, labels, ticks
	                    tickColor: null, // possibly different color of ticks, e.g. "rgba(0,0,0,0.15)"
	                    transform: null, // null or f: number -> number to transform axis
	                    inverseTransform: null, // if transform is set, this should be the inverse function
	                    min: null, // min. value to show, null means set automatically
	                    max: null, // max. value to show, null means set automatically
	                    autoscaleMargin: null, // margin in % to add if auto-setting min/max
	                    ticks: null, // either [1, 3] or [[1, "a"], 3] or (fn: axis info -> ticks) or app. number of ticks for auto-ticks
	                    tickFormatter: null, // fn: number -> string
	                    labelWidth: null, // size of tick labels in pixels
	                    labelHeight: null,
	                    reserveSpace: null, // whether to reserve space even if axis isn't shown
	                    tickLength: null, // size in pixels of ticks, or "full" for whole line
	                    alignTicksWithAxis: null, // axis number or null for no sync
	                    tickDecimals: null, // no. of decimals, null means auto
	                    tickSize: null, // number or [number, "unit"]
	                    minTickSize: null // number or [number, "unit"]
	                },
	                yaxis: {
	                    autoscaleMargin: 0.02,
	                    position: "left" // or "right"
	                },
	                xaxes: [],
	                yaxes: [],
	                series: {
	                    points: {
	                        show: false,
	                        radius: 3,
	                        lineWidth: 2, // in pixels
	                        fill: true,
	                        fillColor: "#ffffff",
	                        symbol: "circle" // or callback
	                    },
	                    lines: {
	                        // we don't put in show: false so we can see
	                        // whether lines were actively disabled
	                        lineWidth: 2, // in pixels
	                        fill: false,
	                        fillColor: null,
	                        steps: false
	                        // Omit 'zero', so we can later default its value to
	                        // match that of the 'fill' option.
	                    },
	                    bars: {
	                        show: false,
	                        lineWidth: 2, // in pixels
	                        barWidth: 1, // in units of the x axis
	                        fill: true,
	                        fillColor: null,
	                        align: "left", // "left", "right", or "center"
	                        horizontal: false,
	                        zero: true
	                    },
	                    shadowSize: 3,
	                    highlightColor: null
	                },
	                grid: {
	                    show: true,
	                    aboveData: false,
	                    color: "#545454", // primary color used for outline and labels
	                    backgroundColor: null, // null for transparent, else color
	                    borderColor: null, // set if different from the grid color
	                    tickColor: null, // color for the ticks, e.g. "rgba(0,0,0,0.15)"
	                    margin: 0, // distance from the canvas edge to the grid
	                    labelMargin: 5, // in pixels
	                    axisMargin: 8, // in pixels
	                    borderWidth: 2, // in pixels
	                    minBorderMargin: null, // in pixels, null means taken from points radius
	                    markings: null, // array of ranges or fn: axes -> array of ranges
	                    markingsColor: "#f4f4f4",
	                    markingsLineWidth: 2,
	                    // interactive stuff
	                    clickable: false,
	                    hoverable: false,
	                    autoHighlight: true, // highlight in case mouse is near
	                    mouseActiveRadius: 10 // how far the mouse can be away to activate an item
	                },
	                interaction: {
	                    redrawOverlayInterval: 1000/60 // time between updates, -1 means in same flow
	                },
	                hooks: {}
	            },
	        surface = null,     // the canvas for the plot itself
	        overlay = null,     // canvas for interactive stuff on top of plot
	        eventHolder = null, // jQuery object that events should be bound to
	        ctx = null, octx = null,
	        xaxes = [], yaxes = [],
	        plotOffset = { left: 0, right: 0, top: 0, bottom: 0},
	        plotWidth = 0, plotHeight = 0,
	        hooks = {
	            processOptions: [],
	            processRawData: [],
	            processDatapoints: [],
	            processOffset: [],
	            drawBackground: [],
	            drawSeries: [],
	            draw: [],
	            bindEvents: [],
	            drawOverlay: [],
	            shutdown: []
	        },
	        plot = this;
	
	        // public functions
	        plot.setData = setData;
	        plot.setupGrid = setupGrid;
	        plot.draw = draw;
	        plot.getPlaceholder = function() { return placeholder; };
	        plot.getCanvas = function() { return surface.element; };
	        plot.getPlotOffset = function() { return plotOffset; };
	        plot.width = function () { return plotWidth; };
	        plot.height = function () { return plotHeight; };
	        plot.offset = function () {
	            var o = eventHolder.offset();
	            o.left += plotOffset.left;
	            o.top += plotOffset.top;
	            return o;
	        };
	        plot.getData = function () { return series; };
	        plot.getAxes = function () {
	            var res = {}, i;
	            $.each(xaxes.concat(yaxes), function (_, axis) {
	                if (axis)
	                    res[axis.direction + (axis.n != 1 ? axis.n : "") + "axis"] = axis;
	            });
	            return res;
	        };
	        plot.getXAxes = function () { return xaxes; };
	        plot.getYAxes = function () { return yaxes; };
	        plot.c2p = canvasToAxisCoords;
	        plot.p2c = axisToCanvasCoords;
	        plot.getOptions = function () { return options; };
	        plot.highlight = highlight;
	        plot.unhighlight = unhighlight;
	        plot.triggerRedrawOverlay = triggerRedrawOverlay;
	        plot.pointOffset = function(point) {
	            return {
	                left: parseInt(xaxes[axisNumber(point, "x") - 1].p2c(+point.x) + plotOffset.left, 10),
	                top: parseInt(yaxes[axisNumber(point, "y") - 1].p2c(+point.y) + plotOffset.top, 10)
	            };
	        };
	        plot.shutdown = shutdown;
	        plot.destroy = function () {
	            shutdown();
	            placeholder.removeData("plot").empty();
	
	            series = [];
	            options = null;
	            surface = null;
	            overlay = null;
	            eventHolder = null;
	            ctx = null;
	            octx = null;
	            xaxes = [];
	            yaxes = [];
	            hooks = null;
	            highlights = [];
	            plot = null;
	        };
	        plot.resize = function () {
	        	var width = placeholder.width(),
	        		height = placeholder.height();
	            surface.resize(width, height);
	            overlay.resize(width, height);
	        };
	
	        // public attributes
	        plot.hooks = hooks;
	
	        // initialize
	        initPlugins(plot);
	        parseOptions(options_);
	        setupCanvases();
	        setData(data_);
	        setupGrid();
	        draw();
	        bindEvents();
	
	
	        function executeHooks(hook, args) {
	            args = [plot].concat(args);
	            for (var i = 0; i < hook.length; ++i)
	                hook[i].apply(this, args);
	        }
	
	        function initPlugins() {
	
	            // References to key classes, allowing plugins to modify them
	
	            var classes = {
	                Canvas: Canvas
	            };
	
	            for (var i = 0; i < plugins.length; ++i) {
	                var p = plugins[i];
	                p.init(plot, classes);
	                if (p.options)
	                    $.extend(true, options, p.options);
	            }
	        }
	
	        function parseOptions(opts) {
	
	            $.extend(true, options, opts);
	
	            // $.extend merges arrays, rather than replacing them.  When less
	            // colors are provided than the size of the default palette, we
	            // end up with those colors plus the remaining defaults, which is
	            // not expected behavior; avoid it by replacing them here.
	
	            if (opts && opts.colors) {
	            	options.colors = opts.colors;
	            }
	
	            if (options.xaxis.color == null)
	                options.xaxis.color = $.color.parse(options.grid.color).scale('a', 0.22).toString();
	            if (options.yaxis.color == null)
	                options.yaxis.color = $.color.parse(options.grid.color).scale('a', 0.22).toString();
	
	            if (options.xaxis.tickColor == null) // grid.tickColor for back-compatibility
	                options.xaxis.tickColor = options.grid.tickColor || options.xaxis.color;
	            if (options.yaxis.tickColor == null) // grid.tickColor for back-compatibility
	                options.yaxis.tickColor = options.grid.tickColor || options.yaxis.color;
	
	            if (options.grid.borderColor == null)
	                options.grid.borderColor = options.grid.color;
	            if (options.grid.tickColor == null)
	                options.grid.tickColor = $.color.parse(options.grid.color).scale('a', 0.22).toString();
	
	            // Fill in defaults for axis options, including any unspecified
	            // font-spec fields, if a font-spec was provided.
	
	            // If no x/y axis options were provided, create one of each anyway,
	            // since the rest of the code assumes that they exist.
	
	            var i, axisOptions, axisCount,
	                fontSize = placeholder.css("font-size"),
	                fontSizeDefault = fontSize ? +fontSize.replace("px", "") : 13,
	                fontDefaults = {
	                    style: placeholder.css("font-style"),
	                    size: Math.round(0.8 * fontSizeDefault),
	                    variant: placeholder.css("font-variant"),
	                    weight: placeholder.css("font-weight"),
	                    family: placeholder.css("font-family")
	                };
	
	            axisCount = options.xaxes.length || 1;
	            for (i = 0; i < axisCount; ++i) {
	
	                axisOptions = options.xaxes[i];
	                if (axisOptions && !axisOptions.tickColor) {
	                    axisOptions.tickColor = axisOptions.color;
	                }
	
	                axisOptions = $.extend(true, {}, options.xaxis, axisOptions);
	                options.xaxes[i] = axisOptions;
	
	                if (axisOptions.font) {
	                    axisOptions.font = $.extend({}, fontDefaults, axisOptions.font);
	                    if (!axisOptions.font.color) {
	                        axisOptions.font.color = axisOptions.color;
	                    }
	                    if (!axisOptions.font.lineHeight) {
	                        axisOptions.font.lineHeight = Math.round(axisOptions.font.size * 1.15);
	                    }
	                }
	            }
	
	            axisCount = options.yaxes.length || 1;
	            for (i = 0; i < axisCount; ++i) {
	
	                axisOptions = options.yaxes[i];
	                if (axisOptions && !axisOptions.tickColor) {
	                    axisOptions.tickColor = axisOptions.color;
	                }
	
	                axisOptions = $.extend(true, {}, options.yaxis, axisOptions);
	                options.yaxes[i] = axisOptions;
	
	                if (axisOptions.font) {
	                    axisOptions.font = $.extend({}, fontDefaults, axisOptions.font);
	                    if (!axisOptions.font.color) {
	                        axisOptions.font.color = axisOptions.color;
	                    }
	                    if (!axisOptions.font.lineHeight) {
	                        axisOptions.font.lineHeight = Math.round(axisOptions.font.size * 1.15);
	                    }
	                }
	            }
	
	            // backwards compatibility, to be removed in future
	            if (options.xaxis.noTicks && options.xaxis.ticks == null)
	                options.xaxis.ticks = options.xaxis.noTicks;
	            if (options.yaxis.noTicks && options.yaxis.ticks == null)
	                options.yaxis.ticks = options.yaxis.noTicks;
	            if (options.x2axis) {
	                options.xaxes[1] = $.extend(true, {}, options.xaxis, options.x2axis);
	                options.xaxes[1].position = "top";
	                // Override the inherit to allow the axis to auto-scale
	                if (options.x2axis.min == null) {
	                    options.xaxes[1].min = null;
	                }
	                if (options.x2axis.max == null) {
	                    options.xaxes[1].max = null;
	                }
	            }
	            if (options.y2axis) {
	                options.yaxes[1] = $.extend(true, {}, options.yaxis, options.y2axis);
	                options.yaxes[1].position = "right";
	                // Override the inherit to allow the axis to auto-scale
	                if (options.y2axis.min == null) {
	                    options.yaxes[1].min = null;
	                }
	                if (options.y2axis.max == null) {
	                    options.yaxes[1].max = null;
	                }
	            }
	            if (options.grid.coloredAreas)
	                options.grid.markings = options.grid.coloredAreas;
	            if (options.grid.coloredAreasColor)
	                options.grid.markingsColor = options.grid.coloredAreasColor;
	            if (options.lines)
	                $.extend(true, options.series.lines, options.lines);
	            if (options.points)
	                $.extend(true, options.series.points, options.points);
	            if (options.bars)
	                $.extend(true, options.series.bars, options.bars);
	            if (options.shadowSize != null)
	                options.series.shadowSize = options.shadowSize;
	            if (options.highlightColor != null)
	                options.series.highlightColor = options.highlightColor;
	
	            // save options on axes for future reference
	            for (i = 0; i < options.xaxes.length; ++i)
	                getOrCreateAxis(xaxes, i + 1).options = options.xaxes[i];
	            for (i = 0; i < options.yaxes.length; ++i)
	                getOrCreateAxis(yaxes, i + 1).options = options.yaxes[i];
	
	            // add hooks from options
	            for (var n in hooks)
	                if (options.hooks[n] && options.hooks[n].length)
	                    hooks[n] = hooks[n].concat(options.hooks[n]);
	
	            executeHooks(hooks.processOptions, [options]);
	        }
	
	        function setData(d) {
	            series = parseData(d);
	            fillInSeriesOptions();
	            processData();
	        }
	
	        function parseData(d) {
	            var res = [];
	            for (var i = 0; i < d.length; ++i) {
	                var s = $.extend(true, {}, options.series);
	
	                if (d[i].data != null) {
	                    s.data = d[i].data; // move the data instead of deep-copy
	                    delete d[i].data;
	
	                    $.extend(true, s, d[i]);
	
	                    d[i].data = s.data;
	                }
	                else
	                    s.data = d[i];
	                res.push(s);
	            }
	
	            return res;
	        }
	
	        function axisNumber(obj, coord) {
	            var a = obj[coord + "axis"];
	            if (typeof a == "object") // if we got a real axis, extract number
	                a = a.n;
	            if (typeof a != "number")
	                a = 1; // default to first axis
	            return a;
	        }
	
	        function allAxes() {
	            // return flat array without annoying null entries
	            return $.grep(xaxes.concat(yaxes), function (a) { return a; });
	        }
	
	        function canvasToAxisCoords(pos) {
	            // return an object with x/y corresponding to all used axes
	            var res = {}, i, axis;
	            for (i = 0; i < xaxes.length; ++i) {
	                axis = xaxes[i];
	                if (axis && axis.used)
	                    res["x" + axis.n] = axis.c2p(pos.left);
	            }
	
	            for (i = 0; i < yaxes.length; ++i) {
	                axis = yaxes[i];
	                if (axis && axis.used)
	                    res["y" + axis.n] = axis.c2p(pos.top);
	            }
	
	            if (res.x1 !== undefined)
	                res.x = res.x1;
	            if (res.y1 !== undefined)
	                res.y = res.y1;
	
	            return res;
	        }
	
	        function axisToCanvasCoords(pos) {
	            // get canvas coords from the first pair of x/y found in pos
	            var res = {}, i, axis, key;
	
	            for (i = 0; i < xaxes.length; ++i) {
	                axis = xaxes[i];
	                if (axis && axis.used) {
	                    key = "x" + axis.n;
	                    if (pos[key] == null && axis.n == 1)
	                        key = "x";
	
	                    if (pos[key] != null) {
	                        res.left = axis.p2c(pos[key]);
	                        break;
	                    }
	                }
	            }
	
	            for (i = 0; i < yaxes.length; ++i) {
	                axis = yaxes[i];
	                if (axis && axis.used) {
	                    key = "y" + axis.n;
	                    if (pos[key] == null && axis.n == 1)
	                        key = "y";
	
	                    if (pos[key] != null) {
	                        res.top = axis.p2c(pos[key]);
	                        break;
	                    }
	                }
	            }
	
	            return res;
	        }
	
	        function getOrCreateAxis(axes, number) {
	            if (!axes[number - 1])
	                axes[number - 1] = {
	                    n: number, // save the number for future reference
	                    direction: axes == xaxes ? "x" : "y",
	                    options: $.extend(true, {}, axes == xaxes ? options.xaxis : options.yaxis)
	                };
	
	            return axes[number - 1];
	        }
	
	        function fillInSeriesOptions() {
	
	            var neededColors = series.length, maxIndex = -1, i;
	
	            // Subtract the number of series that already have fixed colors or
	            // color indexes from the number that we still need to generate.
	
	            for (i = 0; i < series.length; ++i) {
	                var sc = series[i].color;
	                if (sc != null) {
	                    neededColors--;
	                    if (typeof sc == "number" && sc > maxIndex) {
	                        maxIndex = sc;
	                    }
	                }
	            }
	
	            // If any of the series have fixed color indexes, then we need to
	            // generate at least as many colors as the highest index.
	
	            if (neededColors <= maxIndex) {
	                neededColors = maxIndex + 1;
	            }
	
	            // Generate all the colors, using first the option colors and then
	            // variations on those colors once they're exhausted.
	
	            var c, colors = [], colorPool = options.colors,
	                colorPoolSize = colorPool.length, variation = 0;
	
	            for (i = 0; i < neededColors; i++) {
	
	                c = $.color.parse(colorPool[i % colorPoolSize] || "#666");
	
	                // Each time we exhaust the colors in the pool we adjust
	                // a scaling factor used to produce more variations on
	                // those colors. The factor alternates negative/positive
	                // to produce lighter/darker colors.
	
	                // Reset the variation after every few cycles, or else
	                // it will end up producing only white or black colors.
	
	                if (i % colorPoolSize == 0 && i) {
	                    if (variation >= 0) {
	                        if (variation < 0.5) {
	                            variation = -variation - 0.2;
	                        } else variation = 0;
	                    } else variation = -variation;
	                }
	
	                colors[i] = c.scale('rgb', 1 + variation);
	            }
	
	            // Finalize the series options, filling in their colors
	
	            var colori = 0, s;
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	
	                // assign colors
	                if (s.color == null) {
	                    s.color = colors[colori].toString();
	                    ++colori;
	                }
	                else if (typeof s.color == "number")
	                    s.color = colors[s.color].toString();
	
	                // turn on lines automatically in case nothing is set
	                if (s.lines.show == null) {
	                    var v, show = true;
	                    for (v in s)
	                        if (s[v] && s[v].show) {
	                            show = false;
	                            break;
	                        }
	                    if (show)
	                        s.lines.show = true;
	                }
	
	                // If nothing was provided for lines.zero, default it to match
	                // lines.fill, since areas by default should extend to zero.
	
	                if (s.lines.zero == null) {
	                    s.lines.zero = !!s.lines.fill;
	                }
	
	                // setup axes
	                s.xaxis = getOrCreateAxis(xaxes, axisNumber(s, "x"));
	                s.yaxis = getOrCreateAxis(yaxes, axisNumber(s, "y"));
	            }
	        }
	
	        function processData() {
	            var topSentry = Number.POSITIVE_INFINITY,
	                bottomSentry = Number.NEGATIVE_INFINITY,
	                fakeInfinity = Number.MAX_VALUE,
	                i, j, k, m, length,
	                s, points, ps, x, y, axis, val, f, p,
	                data, format;
	
	            function updateAxis(axis, min, max) {
	                if (min < axis.datamin && min != -fakeInfinity)
	                    axis.datamin = min;
	                if (max > axis.datamax && max != fakeInfinity)
	                    axis.datamax = max;
	            }
	
	            $.each(allAxes(), function (_, axis) {
	                // init axis
	                axis.datamin = topSentry;
	                axis.datamax = bottomSentry;
	                axis.used = false;
	            });
	
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	                s.datapoints = { points: [] };
	
	                executeHooks(hooks.processRawData, [ s, s.data, s.datapoints ]);
	            }
	
	            // first pass: clean and copy data
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	
	                data = s.data;
	                format = s.datapoints.format;
	
	                if (!format) {
	                    format = [];
	                    // find out how to copy
	                    format.push({ x: true, number: true, required: true });
	                    format.push({ y: true, number: true, required: true });
	
	                    if (s.bars.show || (s.lines.show && s.lines.fill)) {
	                        var autoscale = !!((s.bars.show && s.bars.zero) || (s.lines.show && s.lines.zero));
	                        format.push({ y: true, number: true, required: false, defaultValue: 0, autoscale: autoscale });
	                        if (s.bars.horizontal) {
	                            delete format[format.length - 1].y;
	                            format[format.length - 1].x = true;
	                        }
	                    }
	
	                    s.datapoints.format = format;
	                }
	
	                if (s.datapoints.pointsize != null)
	                    continue; // already filled in
	
	                s.datapoints.pointsize = format.length;
	
	                ps = s.datapoints.pointsize;
	                points = s.datapoints.points;
	
	                var insertSteps = s.lines.show && s.lines.steps;
	                s.xaxis.used = s.yaxis.used = true;
	
	                for (j = k = 0; j < data.length; ++j, k += ps) {
	                    p = data[j];
	
	                    var nullify = p == null;
	                    if (!nullify) {
	                        for (m = 0; m < ps; ++m) {
	                            val = p[m];
	                            f = format[m];
	
	                            if (f) {
	                                if (f.number && val != null) {
	                                    val = +val; // convert to number
	                                    if (isNaN(val))
	                                        val = null;
	                                    else if (val == Infinity)
	                                        val = fakeInfinity;
	                                    else if (val == -Infinity)
	                                        val = -fakeInfinity;
	                                }
	
	                                if (val == null) {
	                                    if (f.required)
	                                        nullify = true;
	
	                                    if (f.defaultValue != null)
	                                        val = f.defaultValue;
	                                }
	                            }
	
	                            points[k + m] = val;
	                        }
	                    }
	
	                    if (nullify) {
	                        for (m = 0; m < ps; ++m) {
	                            val = points[k + m];
	                            if (val != null) {
	                                f = format[m];
	                                // extract min/max info
	                                if (f.autoscale !== false) {
	                                    if (f.x) {
	                                        updateAxis(s.xaxis, val, val);
	                                    }
	                                    if (f.y) {
	                                        updateAxis(s.yaxis, val, val);
	                                    }
	                                }
	                            }
	                            points[k + m] = null;
	                        }
	                    }
	                    else {
	                        // a little bit of line specific stuff that
	                        // perhaps shouldn't be here, but lacking
	                        // better means...
	                        if (insertSteps && k > 0
	                            && points[k - ps] != null
	                            && points[k - ps] != points[k]
	                            && points[k - ps + 1] != points[k + 1]) {
	                            // copy the point to make room for a middle point
	                            for (m = 0; m < ps; ++m)
	                                points[k + ps + m] = points[k + m];
	
	                            // middle point has same y
	                            points[k + 1] = points[k - ps + 1];
	
	                            // we've added a point, better reflect that
	                            k += ps;
	                        }
	                    }
	                }
	            }
	
	            // give the hooks a chance to run
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	
	                executeHooks(hooks.processDatapoints, [ s, s.datapoints]);
	            }
	
	            // second pass: find datamax/datamin for auto-scaling
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	                points = s.datapoints.points;
	                ps = s.datapoints.pointsize;
	                format = s.datapoints.format;
	
	                var xmin = topSentry, ymin = topSentry,
	                    xmax = bottomSentry, ymax = bottomSentry;
	
	                for (j = 0; j < points.length; j += ps) {
	                    if (points[j] == null)
	                        continue;
	
	                    for (m = 0; m < ps; ++m) {
	                        val = points[j + m];
	                        f = format[m];
	                        if (!f || f.autoscale === false || val == fakeInfinity || val == -fakeInfinity)
	                            continue;
	
	                        if (f.x) {
	                            if (val < xmin)
	                                xmin = val;
	                            if (val > xmax)
	                                xmax = val;
	                        }
	                        if (f.y) {
	                            if (val < ymin)
	                                ymin = val;
	                            if (val > ymax)
	                                ymax = val;
	                        }
	                    }
	                }
	
	                if (s.bars.show) {
	                    // make sure we got room for the bar on the dancing floor
	                    var delta;
	
	                    switch (s.bars.align) {
	                        case "left":
	                            delta = 0;
	                            break;
	                        case "right":
	                            delta = -s.bars.barWidth;
	                            break;
	                        default:
	                            delta = -s.bars.barWidth / 2;
	                    }
	
	                    if (s.bars.horizontal) {
	                        ymin += delta;
	                        ymax += delta + s.bars.barWidth;
	                    }
	                    else {
	                        xmin += delta;
	                        xmax += delta + s.bars.barWidth;
	                    }
	                }
	
	                updateAxis(s.xaxis, xmin, xmax);
	                updateAxis(s.yaxis, ymin, ymax);
	            }
	
	            $.each(allAxes(), function (_, axis) {
	                if (axis.datamin == topSentry)
	                    axis.datamin = null;
	                if (axis.datamax == bottomSentry)
	                    axis.datamax = null;
	            });
	        }
	
	        function setupCanvases() {
	
	            // Make sure the placeholder is clear of everything except canvases
	            // from a previous plot in this container that we'll try to re-use.
	
	            placeholder.css("padding", 0) // padding messes up the positioning
	                .children().filter(function(){
	                    return !$(this).hasClass("flot-overlay") && !$(this).hasClass('flot-base');
	                }).remove();
	
	            if (placeholder.css("position") == 'static')
	                placeholder.css("position", "relative"); // for positioning labels and overlay
	
	            surface = new Canvas("flot-base", placeholder);
	            overlay = new Canvas("flot-overlay", placeholder); // overlay canvas for interactive features
	
	            ctx = surface.context;
	            octx = overlay.context;
	
	            // define which element we're listening for events on
	            eventHolder = $(overlay.element).unbind();
	
	            // If we're re-using a plot object, shut down the old one
	
	            var existing = placeholder.data("plot");
	
	            if (existing) {
	                existing.shutdown();
	                overlay.clear();
	            }
	
	            // save in case we get replotted
	            placeholder.data("plot", plot);
	        }
	
	        function bindEvents() {
	            // bind events
	            if (options.grid.hoverable) {
	                eventHolder.mousemove(onMouseMove);
	
	                // Use bind, rather than .mouseleave, because we officially
	                // still support jQuery 1.2.6, which doesn't define a shortcut
	                // for mouseenter or mouseleave.  This was a bug/oversight that
	                // was fixed somewhere around 1.3.x.  We can return to using
	                // .mouseleave when we drop support for 1.2.6.
	
	                eventHolder.bind("mouseleave", onMouseLeave);
	            }
	
	            if (options.grid.clickable)
	                eventHolder.click(onClick);
	
	            executeHooks(hooks.bindEvents, [eventHolder]);
	        }
	
	        function shutdown() {
	            if (redrawTimeout)
	                clearTimeout(redrawTimeout);
	
	            eventHolder.unbind("mousemove", onMouseMove);
	            eventHolder.unbind("mouseleave", onMouseLeave);
	            eventHolder.unbind("click", onClick);
	
	            executeHooks(hooks.shutdown, [eventHolder]);
	        }
	
	        function setTransformationHelpers(axis) {
	            // set helper functions on the axis, assumes plot area
	            // has been computed already
	
	            function identity(x) { return x; }
	
	            var s, m, t = axis.options.transform || identity,
	                it = axis.options.inverseTransform;
	
	            // precompute how much the axis is scaling a point
	            // in canvas space
	            if (axis.direction == "x") {
	                s = axis.scale = plotWidth / Math.abs(t(axis.max) - t(axis.min));
	                m = Math.min(t(axis.max), t(axis.min));
	            }
	            else {
	                s = axis.scale = plotHeight / Math.abs(t(axis.max) - t(axis.min));
	                s = -s;
	                m = Math.max(t(axis.max), t(axis.min));
	            }
	
	            // data point to canvas coordinate
	            if (t == identity) // slight optimization
	                axis.p2c = function (p) { return (p - m) * s; };
	            else
	                axis.p2c = function (p) { return (t(p) - m) * s; };
	            // canvas coordinate to data point
	            if (!it)
	                axis.c2p = function (c) { return m + c / s; };
	            else
	                axis.c2p = function (c) { return it(m + c / s); };
	        }
	
	        function measureTickLabels(axis) {
	
	            var opts = axis.options,
	                ticks = axis.ticks || [],
	                labelWidth = opts.labelWidth || 0,
	                labelHeight = opts.labelHeight || 0,
	                maxWidth = labelWidth || (axis.direction == "x" ? Math.floor(surface.width / (ticks.length || 1)) : null),
	                legacyStyles = axis.direction + "Axis " + axis.direction + axis.n + "Axis",
	                layer = "flot-" + axis.direction + "-axis flot-" + axis.direction + axis.n + "-axis " + legacyStyles,
	                font = opts.font || "flot-tick-label tickLabel";
	
	            for (var i = 0; i < ticks.length; ++i) {
	
	                var t = ticks[i];
	
	                if (!t.label)
	                    continue;
	
	                var info = surface.getTextInfo(layer, t.label, font, null, maxWidth);
	
	                labelWidth = Math.max(labelWidth, info.width);
	                labelHeight = Math.max(labelHeight, info.height);
	            }
	
	            axis.labelWidth = opts.labelWidth || labelWidth;
	            axis.labelHeight = opts.labelHeight || labelHeight;
	        }
	
	        function allocateAxisBoxFirstPhase(axis) {
	            // find the bounding box of the axis by looking at label
	            // widths/heights and ticks, make room by diminishing the
	            // plotOffset; this first phase only looks at one
	            // dimension per axis, the other dimension depends on the
	            // other axes so will have to wait
	
	            var lw = axis.labelWidth,
	                lh = axis.labelHeight,
	                pos = axis.options.position,
	                isXAxis = axis.direction === "x",
	                tickLength = axis.options.tickLength,
	                axisMargin = options.grid.axisMargin,
	                padding = options.grid.labelMargin,
	                innermost = true,
	                outermost = true,
	                first = true,
	                found = false;
	
	            // Determine the axis's position in its direction and on its side
	
	            $.each(isXAxis ? xaxes : yaxes, function(i, a) {
	                if (a && (a.show || a.reserveSpace)) {
	                    if (a === axis) {
	                        found = true;
	                    } else if (a.options.position === pos) {
	                        if (found) {
	                            outermost = false;
	                        } else {
	                            innermost = false;
	                        }
	                    }
	                    if (!found) {
	                        first = false;
	                    }
	                }
	            });
	
	            // The outermost axis on each side has no margin
	
	            if (outermost) {
	                axisMargin = 0;
	            }
	
	            // The ticks for the first axis in each direction stretch across
	
	            if (tickLength == null) {
	                tickLength = first ? "full" : 5;
	            }
	
	            if (!isNaN(+tickLength))
	                padding += +tickLength;
	
	            if (isXAxis) {
	                lh += padding;
	
	                if (pos == "bottom") {
	                    plotOffset.bottom += lh + axisMargin;
	                    axis.box = { top: surface.height - plotOffset.bottom, height: lh };
	                }
	                else {
	                    axis.box = { top: plotOffset.top + axisMargin, height: lh };
	                    plotOffset.top += lh + axisMargin;
	                }
	            }
	            else {
	                lw += padding;
	
	                if (pos == "left") {
	                    axis.box = { left: plotOffset.left + axisMargin, width: lw };
	                    plotOffset.left += lw + axisMargin;
	                }
	                else {
	                    plotOffset.right += lw + axisMargin;
	                    axis.box = { left: surface.width - plotOffset.right, width: lw };
	                }
	            }
	
	             // save for future reference
	            axis.position = pos;
	            axis.tickLength = tickLength;
	            axis.box.padding = padding;
	            axis.innermost = innermost;
	        }
	
	        function allocateAxisBoxSecondPhase(axis) {
	            // now that all axis boxes have been placed in one
	            // dimension, we can set the remaining dimension coordinates
	            if (axis.direction == "x") {
	                axis.box.left = plotOffset.left - axis.labelWidth / 2;
	                axis.box.width = surface.width - plotOffset.left - plotOffset.right + axis.labelWidth;
	            }
	            else {
	                axis.box.top = plotOffset.top - axis.labelHeight / 2;
	                axis.box.height = surface.height - plotOffset.bottom - plotOffset.top + axis.labelHeight;
	            }
	        }
	
	        function adjustLayoutForThingsStickingOut() {
	            // possibly adjust plot offset to ensure everything stays
	            // inside the canvas and isn't clipped off
	
	            var minMargin = options.grid.minBorderMargin,
	                axis, i;
	
	            // check stuff from the plot (FIXME: this should just read
	            // a value from the series, otherwise it's impossible to
	            // customize)
	            if (minMargin == null) {
	                minMargin = 0;
	                for (i = 0; i < series.length; ++i)
	                    minMargin = Math.max(minMargin, 2 * (series[i].points.radius + series[i].points.lineWidth/2));
	            }
	
	            var margins = {
	                left: minMargin,
	                right: minMargin,
	                top: minMargin,
	                bottom: minMargin
	            };
	
	            // check axis labels, note we don't check the actual
	            // labels but instead use the overall width/height to not
	            // jump as much around with replots
	            $.each(allAxes(), function (_, axis) {
	                if (axis.reserveSpace && axis.ticks && axis.ticks.length) {
	                    if (axis.direction === "x") {
	                        margins.left = Math.max(margins.left, axis.labelWidth / 2);
	                        margins.right = Math.max(margins.right, axis.labelWidth / 2);
	                    } else {
	                        margins.bottom = Math.max(margins.bottom, axis.labelHeight / 2);
	                        margins.top = Math.max(margins.top, axis.labelHeight / 2);
	                    }
	                }
	            });
	
	            plotOffset.left = Math.ceil(Math.max(margins.left, plotOffset.left));
	            plotOffset.right = Math.ceil(Math.max(margins.right, plotOffset.right));
	            plotOffset.top = Math.ceil(Math.max(margins.top, plotOffset.top));
	            plotOffset.bottom = Math.ceil(Math.max(margins.bottom, plotOffset.bottom));
	        }
	
	        function setupGrid() {
	            var i, axes = allAxes(), showGrid = options.grid.show;
	
	            // Initialize the plot's offset from the edge of the canvas
	
	            for (var a in plotOffset) {
	                var margin = options.grid.margin || 0;
	                plotOffset[a] = typeof margin == "number" ? margin : margin[a] || 0;
	            }
	
	            executeHooks(hooks.processOffset, [plotOffset]);
	
	            // If the grid is visible, add its border width to the offset
	
	            for (var a in plotOffset) {
	                if(typeof(options.grid.borderWidth) == "object") {
	                    plotOffset[a] += showGrid ? options.grid.borderWidth[a] : 0;
	                }
	                else {
	                    plotOffset[a] += showGrid ? options.grid.borderWidth : 0;
	                }
	            }
	
	            $.each(axes, function (_, axis) {
	                var axisOpts = axis.options;
	                axis.show = axisOpts.show == null ? axis.used : axisOpts.show;
	                axis.reserveSpace = axisOpts.reserveSpace == null ? axis.show : axisOpts.reserveSpace;
	                setRange(axis);
	            });
	
	            if (showGrid) {
	
	                var allocatedAxes = $.grep(axes, function (axis) {
	                    return axis.show || axis.reserveSpace;
	                });
	
	                $.each(allocatedAxes, function (_, axis) {
	                    // make the ticks
	                    setupTickGeneration(axis);
	                    setTicks(axis);
	                    snapRangeToTicks(axis, axis.ticks);
	                    // find labelWidth/Height for axis
	                    measureTickLabels(axis);
	                });
	
	                // with all dimensions calculated, we can compute the
	                // axis bounding boxes, start from the outside
	                // (reverse order)
	                for (i = allocatedAxes.length - 1; i >= 0; --i)
	                    allocateAxisBoxFirstPhase(allocatedAxes[i]);
	
	                // make sure we've got enough space for things that
	                // might stick out
	                adjustLayoutForThingsStickingOut();
	
	                $.each(allocatedAxes, function (_, axis) {
	                    allocateAxisBoxSecondPhase(axis);
	                });
	            }
	
	            plotWidth = surface.width - plotOffset.left - plotOffset.right;
	            plotHeight = surface.height - plotOffset.bottom - plotOffset.top;
	
	            // now we got the proper plot dimensions, we can compute the scaling
	            $.each(axes, function (_, axis) {
	                setTransformationHelpers(axis);
	            });
	
	            if (showGrid) {
	                drawAxisLabels();
	            }
	
	            insertLegend();
	        }
	
	        function setRange(axis) {
	            var opts = axis.options,
	                min = +(opts.min != null ? opts.min : axis.datamin),
	                max = +(opts.max != null ? opts.max : axis.datamax),
	                delta = max - min;
	
	            if (delta == 0.0) {
	                // degenerate case
	                var widen = max == 0 ? 1 : 0.01;
	
	                if (opts.min == null)
	                    min -= widen;
	                // always widen max if we couldn't widen min to ensure we
	                // don't fall into min == max which doesn't work
	                if (opts.max == null || opts.min != null)
	                    max += widen;
	            }
	            else {
	                // consider autoscaling
	                var margin = opts.autoscaleMargin;
	                if (margin != null) {
	                    if (opts.min == null) {
	                        min -= delta * margin;
	                        // make sure we don't go below zero if all values
	                        // are positive
	                        if (min < 0 && axis.datamin != null && axis.datamin >= 0)
	                            min = 0;
	                    }
	                    if (opts.max == null) {
	                        max += delta * margin;
	                        if (max > 0 && axis.datamax != null && axis.datamax <= 0)
	                            max = 0;
	                    }
	                }
	            }
	            axis.min = min;
	            axis.max = max;
	        }
	
	        function setupTickGeneration(axis) {
	            var opts = axis.options;
	
	            // estimate number of ticks
	            var noTicks;
	            if (typeof opts.ticks == "number" && opts.ticks > 0)
	                noTicks = opts.ticks;
	            else
	                // heuristic based on the model a*sqrt(x) fitted to
	                // some data points that seemed reasonable
	                noTicks = 0.3 * Math.sqrt(axis.direction == "x" ? surface.width : surface.height);
	
	            var delta = (axis.max - axis.min) / noTicks,
	                dec = -Math.floor(Math.log(delta) / Math.LN10),
	                maxDec = opts.tickDecimals;
	
	            if (maxDec != null && dec > maxDec) {
	                dec = maxDec;
	            }
	
	            var magn = Math.pow(10, -dec),
	                norm = delta / magn, // norm is between 1.0 and 10.0
	                size;
	
	            if (norm < 1.5) {
	                size = 1;
	            } else if (norm < 3) {
	                size = 2;
	                // special case for 2.5, requires an extra decimal
	                if (norm > 2.25 && (maxDec == null || dec + 1 <= maxDec)) {
	                    size = 2.5;
	                    ++dec;
	                }
	            } else if (norm < 7.5) {
	                size = 5;
	            } else {
	                size = 10;
	            }
	
	            size *= magn;
	
	            if (opts.minTickSize != null && size < opts.minTickSize) {
	                size = opts.minTickSize;
	            }
	
	            axis.delta = delta;
	            axis.tickDecimals = Math.max(0, maxDec != null ? maxDec : dec);
	            axis.tickSize = opts.tickSize || size;
	
	            // Time mode was moved to a plug-in in 0.8, and since so many people use it
	            // we'll add an especially friendly reminder to make sure they included it.
	
	            if (opts.mode == "time" && !axis.tickGenerator) {
	                throw new Error("Time mode requires the flot.time plugin.");
	            }
	
	            // Flot supports base-10 axes; any other mode else is handled by a plug-in,
	            // like flot.time.js.
	
	            if (!axis.tickGenerator) {
	
	                axis.tickGenerator = function (axis) {
	
	                    var ticks = [],
	                        start = floorInBase(axis.min, axis.tickSize),
	                        i = 0,
	                        v = Number.NaN,
	                        prev;
	
	                    do {
	                        prev = v;
	                        v = start + i * axis.tickSize;
	                        ticks.push(v);
	                        ++i;
	                    } while (v < axis.max && v != prev);
	                    return ticks;
	                };
	
					axis.tickFormatter = function (value, axis) {
	
						var factor = axis.tickDecimals ? Math.pow(10, axis.tickDecimals) : 1;
						var formatted = "" + Math.round(value * factor) / factor;
	
						// If tickDecimals was specified, ensure that we have exactly that
						// much precision; otherwise default to the value's own precision.
	
						if (axis.tickDecimals != null) {
							var decimal = formatted.indexOf(".");
							var precision = decimal == -1 ? 0 : formatted.length - decimal - 1;
							if (precision < axis.tickDecimals) {
								return (precision ? formatted : formatted + ".") + ("" + factor).substr(1, axis.tickDecimals - precision);
							}
						}
	
	                    return formatted;
	                };
	            }
	
	            if ($.isFunction(opts.tickFormatter))
	                axis.tickFormatter = function (v, axis) { return "" + opts.tickFormatter(v, axis); };
	
	            if (opts.alignTicksWithAxis != null) {
	                var otherAxis = (axis.direction == "x" ? xaxes : yaxes)[opts.alignTicksWithAxis - 1];
	                if (otherAxis && otherAxis.used && otherAxis != axis) {
	                    // consider snapping min/max to outermost nice ticks
	                    var niceTicks = axis.tickGenerator(axis);
	                    if (niceTicks.length > 0) {
	                        if (opts.min == null)
	                            axis.min = Math.min(axis.min, niceTicks[0]);
	                        if (opts.max == null && niceTicks.length > 1)
	                            axis.max = Math.max(axis.max, niceTicks[niceTicks.length - 1]);
	                    }
	
	                    axis.tickGenerator = function (axis) {
	                        // copy ticks, scaled to this axis
	                        var ticks = [], v, i;
	                        for (i = 0; i < otherAxis.ticks.length; ++i) {
	                            v = (otherAxis.ticks[i].v - otherAxis.min) / (otherAxis.max - otherAxis.min);
	                            v = axis.min + v * (axis.max - axis.min);
	                            ticks.push(v);
	                        }
	                        return ticks;
	                    };
	
	                    // we might need an extra decimal since forced
	                    // ticks don't necessarily fit naturally
	                    if (!axis.mode && opts.tickDecimals == null) {
	                        var extraDec = Math.max(0, -Math.floor(Math.log(axis.delta) / Math.LN10) + 1),
	                            ts = axis.tickGenerator(axis);
	
	                        // only proceed if the tick interval rounded
	                        // with an extra decimal doesn't give us a
	                        // zero at end
	                        if (!(ts.length > 1 && /\..*0$/.test((ts[1] - ts[0]).toFixed(extraDec))))
	                            axis.tickDecimals = extraDec;
	                    }
	                }
	            }
	        }
	
	        function setTicks(axis) {
	            var oticks = axis.options.ticks, ticks = [];
	            if (oticks == null || (typeof oticks == "number" && oticks > 0))
	                ticks = axis.tickGenerator(axis);
	            else if (oticks) {
	                if ($.isFunction(oticks))
	                    // generate the ticks
	                    ticks = oticks(axis);
	                else
	                    ticks = oticks;
	            }
	
	            // clean up/labelify the supplied ticks, copy them over
	            var i, v;
	            axis.ticks = [];
	            for (i = 0; i < ticks.length; ++i) {
	                var label = null;
	                var t = ticks[i];
	                if (typeof t == "object") {
	                    v = +t[0];
	                    if (t.length > 1)
	                        label = t[1];
	                }
	                else
	                    v = +t;
	                if (label == null)
	                    label = axis.tickFormatter(v, axis);
	                if (!isNaN(v))
	                    axis.ticks.push({ v: v, label: label });
	            }
	        }
	
	        function snapRangeToTicks(axis, ticks) {
	            if (axis.options.autoscaleMargin && ticks.length > 0) {
	                // snap to ticks
	                if (axis.options.min == null)
	                    axis.min = Math.min(axis.min, ticks[0].v);
	                if (axis.options.max == null && ticks.length > 1)
	                    axis.max = Math.max(axis.max, ticks[ticks.length - 1].v);
	            }
	        }
	
	        function draw() {
	
	            surface.clear();
	
	            executeHooks(hooks.drawBackground, [ctx]);
	
	            var grid = options.grid;
	
	            // draw background, if any
	            if (grid.show && grid.backgroundColor)
	                drawBackground();
	
	            if (grid.show && !grid.aboveData) {
	                drawGrid();
	            }
	
	            for (var i = 0; i < series.length; ++i) {
	                executeHooks(hooks.drawSeries, [ctx, series[i]]);
	                drawSeries(series[i]);
	            }
	
	            executeHooks(hooks.draw, [ctx]);
	
	            if (grid.show && grid.aboveData) {
	                drawGrid();
	            }
	
	            surface.render();
	
	            // A draw implies that either the axes or data have changed, so we
	            // should probably update the overlay highlights as well.
	
	            triggerRedrawOverlay();
	        }
	
	        function extractRange(ranges, coord) {
	            var axis, from, to, key, axes = allAxes();
	
	            for (var i = 0; i < axes.length; ++i) {
	                axis = axes[i];
	                if (axis.direction == coord) {
	                    key = coord + axis.n + "axis";
	                    if (!ranges[key] && axis.n == 1)
	                        key = coord + "axis"; // support x1axis as xaxis
	                    if (ranges[key]) {
	                        from = ranges[key].from;
	                        to = ranges[key].to;
	                        break;
	                    }
	                }
	            }
	
	            // backwards-compat stuff - to be removed in future
	            if (!ranges[key]) {
	                axis = coord == "x" ? xaxes[0] : yaxes[0];
	                from = ranges[coord + "1"];
	                to = ranges[coord + "2"];
	            }
	
	            // auto-reverse as an added bonus
	            if (from != null && to != null && from > to) {
	                var tmp = from;
	                from = to;
	                to = tmp;
	            }
	
	            return { from: from, to: to, axis: axis };
	        }
	
	        function drawBackground() {
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	
	            ctx.fillStyle = getColorOrGradient(options.grid.backgroundColor, plotHeight, 0, "rgba(255, 255, 255, 0)");
	            ctx.fillRect(0, 0, plotWidth, plotHeight);
	            ctx.restore();
	        }
	
	        function drawGrid() {
	            var i, axes, bw, bc;
	
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	
	            // draw markings
	            var markings = options.grid.markings;
	            if (markings) {
	                if ($.isFunction(markings)) {
	                    axes = plot.getAxes();
	                    // xmin etc. is backwards compatibility, to be
	                    // removed in the future
	                    axes.xmin = axes.xaxis.min;
	                    axes.xmax = axes.xaxis.max;
	                    axes.ymin = axes.yaxis.min;
	                    axes.ymax = axes.yaxis.max;
	
	                    markings = markings(axes);
	                }
	
	                for (i = 0; i < markings.length; ++i) {
	                    var m = markings[i],
	                        xrange = extractRange(m, "x"),
	                        yrange = extractRange(m, "y");
	
	                    // fill in missing
	                    if (xrange.from == null)
	                        xrange.from = xrange.axis.min;
	                    if (xrange.to == null)
	                        xrange.to = xrange.axis.max;
	                    if (yrange.from == null)
	                        yrange.from = yrange.axis.min;
	                    if (yrange.to == null)
	                        yrange.to = yrange.axis.max;
	
	                    // clip
	                    if (xrange.to < xrange.axis.min || xrange.from > xrange.axis.max ||
	                        yrange.to < yrange.axis.min || yrange.from > yrange.axis.max)
	                        continue;
	
	                    xrange.from = Math.max(xrange.from, xrange.axis.min);
	                    xrange.to = Math.min(xrange.to, xrange.axis.max);
	                    yrange.from = Math.max(yrange.from, yrange.axis.min);
	                    yrange.to = Math.min(yrange.to, yrange.axis.max);
	
	                    var xequal = xrange.from === xrange.to,
	                        yequal = yrange.from === yrange.to;
	
	                    if (xequal && yequal) {
	                        continue;
	                    }
	
	                    // then draw
	                    xrange.from = Math.floor(xrange.axis.p2c(xrange.from));
	                    xrange.to = Math.floor(xrange.axis.p2c(xrange.to));
	                    yrange.from = Math.floor(yrange.axis.p2c(yrange.from));
	                    yrange.to = Math.floor(yrange.axis.p2c(yrange.to));
	
	                    if (xequal || yequal) {
	                        var lineWidth = m.lineWidth || options.grid.markingsLineWidth,
	                            subPixel = lineWidth % 2 ? 0.5 : 0;
	                        ctx.beginPath();
	                        ctx.strokeStyle = m.color || options.grid.markingsColor;
	                        ctx.lineWidth = lineWidth;
	                        if (xequal) {
	                            ctx.moveTo(xrange.to + subPixel, yrange.from);
	                            ctx.lineTo(xrange.to + subPixel, yrange.to);
	                        } else {
	                            ctx.moveTo(xrange.from, yrange.to + subPixel);
	                            ctx.lineTo(xrange.to, yrange.to + subPixel);                            
	                        }
	                        ctx.stroke();
	                    } else {
	                        ctx.fillStyle = m.color || options.grid.markingsColor;
	                        ctx.fillRect(xrange.from, yrange.to,
	                                     xrange.to - xrange.from,
	                                     yrange.from - yrange.to);
	                    }
	                }
	            }
	
	            // draw the ticks
	            axes = allAxes();
	            bw = options.grid.borderWidth;
	
	            for (var j = 0; j < axes.length; ++j) {
	                var axis = axes[j], box = axis.box,
	                    t = axis.tickLength, x, y, xoff, yoff;
	                if (!axis.show || axis.ticks.length == 0)
	                    continue;
	
	                ctx.lineWidth = 1;
	
	                // find the edges
	                if (axis.direction == "x") {
	                    x = 0;
	                    if (t == "full")
	                        y = (axis.position == "top" ? 0 : plotHeight);
	                    else
	                        y = box.top - plotOffset.top + (axis.position == "top" ? box.height : 0);
	                }
	                else {
	                    y = 0;
	                    if (t == "full")
	                        x = (axis.position == "left" ? 0 : plotWidth);
	                    else
	                        x = box.left - plotOffset.left + (axis.position == "left" ? box.width : 0);
	                }
	
	                // draw tick bar
	                if (!axis.innermost) {
	                    ctx.strokeStyle = axis.options.color;
	                    ctx.beginPath();
	                    xoff = yoff = 0;
	                    if (axis.direction == "x")
	                        xoff = plotWidth + 1;
	                    else
	                        yoff = plotHeight + 1;
	
	                    if (ctx.lineWidth == 1) {
	                        if (axis.direction == "x") {
	                            y = Math.floor(y) + 0.5;
	                        } else {
	                            x = Math.floor(x) + 0.5;
	                        }
	                    }
	
	                    ctx.moveTo(x, y);
	                    ctx.lineTo(x + xoff, y + yoff);
	                    ctx.stroke();
	                }
	
	                // draw ticks
	
	                ctx.strokeStyle = axis.options.tickColor;
	
	                ctx.beginPath();
	                for (i = 0; i < axis.ticks.length; ++i) {
	                    var v = axis.ticks[i].v;
	
	                    xoff = yoff = 0;
	
	                    if (isNaN(v) || v < axis.min || v > axis.max
	                        // skip those lying on the axes if we got a border
	                        || (t == "full"
	                            && ((typeof bw == "object" && bw[axis.position] > 0) || bw > 0)
	                            && (v == axis.min || v == axis.max)))
	                        continue;
	
	                    if (axis.direction == "x") {
	                        x = axis.p2c(v);
	                        yoff = t == "full" ? -plotHeight : t;
	
	                        if (axis.position == "top")
	                            yoff = -yoff;
	                    }
	                    else {
	                        y = axis.p2c(v);
	                        xoff = t == "full" ? -plotWidth : t;
	
	                        if (axis.position == "left")
	                            xoff = -xoff;
	                    }
	
	                    if (ctx.lineWidth == 1) {
	                        if (axis.direction == "x")
	                            x = Math.floor(x) + 0.5;
	                        else
	                            y = Math.floor(y) + 0.5;
	                    }
	
	                    ctx.moveTo(x, y);
	                    ctx.lineTo(x + xoff, y + yoff);
	                }
	
	                ctx.stroke();
	            }
	
	
	            // draw border
	            if (bw) {
	                // If either borderWidth or borderColor is an object, then draw the border
	                // line by line instead of as one rectangle
	                bc = options.grid.borderColor;
	                if(typeof bw == "object" || typeof bc == "object") {
	                    if (typeof bw !== "object") {
	                        bw = {top: bw, right: bw, bottom: bw, left: bw};
	                    }
	                    if (typeof bc !== "object") {
	                        bc = {top: bc, right: bc, bottom: bc, left: bc};
	                    }
	
	                    if (bw.top > 0) {
	                        ctx.strokeStyle = bc.top;
	                        ctx.lineWidth = bw.top;
	                        ctx.beginPath();
	                        ctx.moveTo(0 - bw.left, 0 - bw.top/2);
	                        ctx.lineTo(plotWidth, 0 - bw.top/2);
	                        ctx.stroke();
	                    }
	
	                    if (bw.right > 0) {
	                        ctx.strokeStyle = bc.right;
	                        ctx.lineWidth = bw.right;
	                        ctx.beginPath();
	                        ctx.moveTo(plotWidth + bw.right / 2, 0 - bw.top);
	                        ctx.lineTo(plotWidth + bw.right / 2, plotHeight);
	                        ctx.stroke();
	                    }
	
	                    if (bw.bottom > 0) {
	                        ctx.strokeStyle = bc.bottom;
	                        ctx.lineWidth = bw.bottom;
	                        ctx.beginPath();
	                        ctx.moveTo(plotWidth + bw.right, plotHeight + bw.bottom / 2);
	                        ctx.lineTo(0, plotHeight + bw.bottom / 2);
	                        ctx.stroke();
	                    }
	
	                    if (bw.left > 0) {
	                        ctx.strokeStyle = bc.left;
	                        ctx.lineWidth = bw.left;
	                        ctx.beginPath();
	                        ctx.moveTo(0 - bw.left/2, plotHeight + bw.bottom);
	                        ctx.lineTo(0- bw.left/2, 0);
	                        ctx.stroke();
	                    }
	                }
	                else {
	                    ctx.lineWidth = bw;
	                    ctx.strokeStyle = options.grid.borderColor;
	                    ctx.strokeRect(-bw/2, -bw/2, plotWidth + bw, plotHeight + bw);
	                }
	            }
	
	            ctx.restore();
	        }
	
	        function drawAxisLabels() {
	
	            $.each(allAxes(), function (_, axis) {
	                var box = axis.box,
	                    legacyStyles = axis.direction + "Axis " + axis.direction + axis.n + "Axis",
	                    layer = "flot-" + axis.direction + "-axis flot-" + axis.direction + axis.n + "-axis " + legacyStyles,
	                    font = axis.options.font || "flot-tick-label tickLabel",
	                    tick, x, y, halign, valign;
	
	                // Remove text before checking for axis.show and ticks.length;
	                // otherwise plugins, like flot-tickrotor, that draw their own
	                // tick labels will end up with both theirs and the defaults.
	
	                surface.removeText(layer);
	
	                if (!axis.show || axis.ticks.length == 0)
	                    return;
	
	                for (var i = 0; i < axis.ticks.length; ++i) {
	
	                    tick = axis.ticks[i];
	                    if (!tick.label || tick.v < axis.min || tick.v > axis.max)
	                        continue;
	
	                    if (axis.direction == "x") {
	                        halign = "center";
	                        x = plotOffset.left + axis.p2c(tick.v);
	                        if (axis.position == "bottom") {
	                            y = box.top + box.padding;
	                        } else {
	                            y = box.top + box.height - box.padding;
	                            valign = "bottom";
	                        }
	                    } else {
	                        valign = "middle";
	                        y = plotOffset.top + axis.p2c(tick.v);
	                        if (axis.position == "left") {
	                            x = box.left + box.width - box.padding;
	                            halign = "right";
	                        } else {
	                            x = box.left + box.padding;
	                        }
	                    }
	
	                    surface.addText(layer, x, y, tick.label, font, null, null, halign, valign);
	                }
	            });
	        }
	
	        function drawSeries(series) {
	            if (series.lines.show)
	                drawSeriesLines(series);
	            if (series.bars.show)
	                drawSeriesBars(series);
	            if (series.points.show)
	                drawSeriesPoints(series);
	        }
	
	        function drawSeriesLines(series) {
	            function plotLine(datapoints, xoffset, yoffset, axisx, axisy) {
	                var points = datapoints.points,
	                    ps = datapoints.pointsize,
	                    prevx = null, prevy = null;
	
	                ctx.beginPath();
	                for (var i = ps; i < points.length; i += ps) {
	                    var x1 = points[i - ps], y1 = points[i - ps + 1],
	                        x2 = points[i], y2 = points[i + 1];
	
	                    if (x1 == null || x2 == null)
	                        continue;
	
	                    // clip with ymin
	                    if (y1 <= y2 && y1 < axisy.min) {
	                        if (y2 < axisy.min)
	                            continue;   // line segment is outside
	                        // compute new intersection point
	                        x1 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y1 = axisy.min;
	                    }
	                    else if (y2 <= y1 && y2 < axisy.min) {
	                        if (y1 < axisy.min)
	                            continue;
	                        x2 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y2 = axisy.min;
	                    }
	
	                    // clip with ymax
	                    if (y1 >= y2 && y1 > axisy.max) {
	                        if (y2 > axisy.max)
	                            continue;
	                        x1 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y1 = axisy.max;
	                    }
	                    else if (y2 >= y1 && y2 > axisy.max) {
	                        if (y1 > axisy.max)
	                            continue;
	                        x2 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y2 = axisy.max;
	                    }
	
	                    // clip with xmin
	                    if (x1 <= x2 && x1 < axisx.min) {
	                        if (x2 < axisx.min)
	                            continue;
	                        y1 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x1 = axisx.min;
	                    }
	                    else if (x2 <= x1 && x2 < axisx.min) {
	                        if (x1 < axisx.min)
	                            continue;
	                        y2 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x2 = axisx.min;
	                    }
	
	                    // clip with xmax
	                    if (x1 >= x2 && x1 > axisx.max) {
	                        if (x2 > axisx.max)
	                            continue;
	                        y1 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x1 = axisx.max;
	                    }
	                    else if (x2 >= x1 && x2 > axisx.max) {
	                        if (x1 > axisx.max)
	                            continue;
	                        y2 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x2 = axisx.max;
	                    }
	
	                    if (x1 != prevx || y1 != prevy)
	                        ctx.moveTo(axisx.p2c(x1) + xoffset, axisy.p2c(y1) + yoffset);
	
	                    prevx = x2;
	                    prevy = y2;
	                    ctx.lineTo(axisx.p2c(x2) + xoffset, axisy.p2c(y2) + yoffset);
	                }
	                ctx.stroke();
	            }
	
	            function plotLineArea(datapoints, axisx, axisy) {
	                var points = datapoints.points,
	                    ps = datapoints.pointsize,
	                    bottom = Math.min(Math.max(0, axisy.min), axisy.max),
	                    i = 0, top, areaOpen = false,
	                    ypos = 1, segmentStart = 0, segmentEnd = 0;
	
	                // we process each segment in two turns, first forward
	                // direction to sketch out top, then once we hit the
	                // end we go backwards to sketch the bottom
	                while (true) {
	                    if (ps > 0 && i > points.length + ps)
	                        break;
	
	                    i += ps; // ps is negative if going backwards
	
	                    var x1 = points[i - ps],
	                        y1 = points[i - ps + ypos],
	                        x2 = points[i], y2 = points[i + ypos];
	
	                    if (areaOpen) {
	                        if (ps > 0 && x1 != null && x2 == null) {
	                            // at turning point
	                            segmentEnd = i;
	                            ps = -ps;
	                            ypos = 2;
	                            continue;
	                        }
	
	                        if (ps < 0 && i == segmentStart + ps) {
	                            // done with the reverse sweep
	                            ctx.fill();
	                            areaOpen = false;
	                            ps = -ps;
	                            ypos = 1;
	                            i = segmentStart = segmentEnd + ps;
	                            continue;
	                        }
	                    }
	
	                    if (x1 == null || x2 == null)
	                        continue;
	
	                    // clip x values
	
	                    // clip with xmin
	                    if (x1 <= x2 && x1 < axisx.min) {
	                        if (x2 < axisx.min)
	                            continue;
	                        y1 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x1 = axisx.min;
	                    }
	                    else if (x2 <= x1 && x2 < axisx.min) {
	                        if (x1 < axisx.min)
	                            continue;
	                        y2 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x2 = axisx.min;
	                    }
	
	                    // clip with xmax
	                    if (x1 >= x2 && x1 > axisx.max) {
	                        if (x2 > axisx.max)
	                            continue;
	                        y1 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x1 = axisx.max;
	                    }
	                    else if (x2 >= x1 && x2 > axisx.max) {
	                        if (x1 > axisx.max)
	                            continue;
	                        y2 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x2 = axisx.max;
	                    }
	
	                    if (!areaOpen) {
	                        // open area
	                        ctx.beginPath();
	                        ctx.moveTo(axisx.p2c(x1), axisy.p2c(bottom));
	                        areaOpen = true;
	                    }
	
	                    // now first check the case where both is outside
	                    if (y1 >= axisy.max && y2 >= axisy.max) {
	                        ctx.lineTo(axisx.p2c(x1), axisy.p2c(axisy.max));
	                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(axisy.max));
	                        continue;
	                    }
	                    else if (y1 <= axisy.min && y2 <= axisy.min) {
	                        ctx.lineTo(axisx.p2c(x1), axisy.p2c(axisy.min));
	                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(axisy.min));
	                        continue;
	                    }
	
	                    // else it's a bit more complicated, there might
	                    // be a flat maxed out rectangle first, then a
	                    // triangular cutout or reverse; to find these
	                    // keep track of the current x values
	                    var x1old = x1, x2old = x2;
	
	                    // clip the y values, without shortcutting, we
	                    // go through all cases in turn
	
	                    // clip with ymin
	                    if (y1 <= y2 && y1 < axisy.min && y2 >= axisy.min) {
	                        x1 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y1 = axisy.min;
	                    }
	                    else if (y2 <= y1 && y2 < axisy.min && y1 >= axisy.min) {
	                        x2 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y2 = axisy.min;
	                    }
	
	                    // clip with ymax
	                    if (y1 >= y2 && y1 > axisy.max && y2 <= axisy.max) {
	                        x1 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y1 = axisy.max;
	                    }
	                    else if (y2 >= y1 && y2 > axisy.max && y1 <= axisy.max) {
	                        x2 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y2 = axisy.max;
	                    }
	
	                    // if the x value was changed we got a rectangle
	                    // to fill
	                    if (x1 != x1old) {
	                        ctx.lineTo(axisx.p2c(x1old), axisy.p2c(y1));
	                        // it goes to (x1, y1), but we fill that below
	                    }
	
	                    // fill triangular section, this sometimes result
	                    // in redundant points if (x1, y1) hasn't changed
	                    // from previous line to, but we just ignore that
	                    ctx.lineTo(axisx.p2c(x1), axisy.p2c(y1));
	                    ctx.lineTo(axisx.p2c(x2), axisy.p2c(y2));
	
	                    // fill the other rectangle if it's there
	                    if (x2 != x2old) {
	                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(y2));
	                        ctx.lineTo(axisx.p2c(x2old), axisy.p2c(y2));
	                    }
	                }
	            }
	
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	            ctx.lineJoin = "round";
	
	            var lw = series.lines.lineWidth,
	                sw = series.shadowSize;
	            // FIXME: consider another form of shadow when filling is turned on
	            if (lw > 0 && sw > 0) {
	                // draw shadow as a thick and thin line with transparency
	                ctx.lineWidth = sw;
	                ctx.strokeStyle = "rgba(0,0,0,0.1)";
	                // position shadow at angle from the mid of line
	                var angle = Math.PI/18;
	                plotLine(series.datapoints, Math.sin(angle) * (lw/2 + sw/2), Math.cos(angle) * (lw/2 + sw/2), series.xaxis, series.yaxis);
	                ctx.lineWidth = sw/2;
	                plotLine(series.datapoints, Math.sin(angle) * (lw/2 + sw/4), Math.cos(angle) * (lw/2 + sw/4), series.xaxis, series.yaxis);
	            }
	
	            ctx.lineWidth = lw;
	            ctx.strokeStyle = series.color;
	            var fillStyle = getFillStyle(series.lines, series.color, 0, plotHeight);
	            if (fillStyle) {
	                ctx.fillStyle = fillStyle;
	                plotLineArea(series.datapoints, series.xaxis, series.yaxis);
	            }
	
	            if (lw > 0)
	                plotLine(series.datapoints, 0, 0, series.xaxis, series.yaxis);
	            ctx.restore();
	        }
	
	        function drawSeriesPoints(series) {
	            function plotPoints(datapoints, radius, fillStyle, offset, shadow, axisx, axisy, symbol) {
	                var points = datapoints.points, ps = datapoints.pointsize;
	
	                for (var i = 0; i < points.length; i += ps) {
	                    var x = points[i], y = points[i + 1];
	                    if (x == null || x < axisx.min || x > axisx.max || y < axisy.min || y > axisy.max)
	                        continue;
	
	                    ctx.beginPath();
	                    x = axisx.p2c(x);
	                    y = axisy.p2c(y) + offset;
	                    if (symbol == "circle")
	                        ctx.arc(x, y, radius, 0, shadow ? Math.PI : Math.PI * 2, false);
	                    else
	                        symbol(ctx, x, y, radius, shadow);
	                    ctx.closePath();
	
	                    if (fillStyle) {
	                        ctx.fillStyle = fillStyle;
	                        ctx.fill();
	                    }
	                    ctx.stroke();
	                }
	            }
	
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	
	            var lw = series.points.lineWidth,
	                sw = series.shadowSize,
	                radius = series.points.radius,
	                symbol = series.points.symbol;
	
	            // If the user sets the line width to 0, we change it to a very 
	            // small value. A line width of 0 seems to force the default of 1.
	            // Doing the conditional here allows the shadow setting to still be 
	            // optional even with a lineWidth of 0.
	
	            if( lw == 0 )
	                lw = 0.0001;
	
	            if (lw > 0 && sw > 0) {
	                // draw shadow in two steps
	                var w = sw / 2;
	                ctx.lineWidth = w;
	                ctx.strokeStyle = "rgba(0,0,0,0.1)";
	                plotPoints(series.datapoints, radius, null, w + w/2, true,
	                           series.xaxis, series.yaxis, symbol);
	
	                ctx.strokeStyle = "rgba(0,0,0,0.2)";
	                plotPoints(series.datapoints, radius, null, w/2, true,
	                           series.xaxis, series.yaxis, symbol);
	            }
	
	            ctx.lineWidth = lw;
	            ctx.strokeStyle = series.color;
	            plotPoints(series.datapoints, radius,
	                       getFillStyle(series.points, series.color), 0, false,
	                       series.xaxis, series.yaxis, symbol);
	            ctx.restore();
	        }
	
	        function drawBar(x, y, b, barLeft, barRight, fillStyleCallback, axisx, axisy, c, horizontal, lineWidth) {
	            var left, right, bottom, top,
	                drawLeft, drawRight, drawTop, drawBottom,
	                tmp;
	
	            // in horizontal mode, we start the bar from the left
	            // instead of from the bottom so it appears to be
	            // horizontal rather than vertical
	            if (horizontal) {
	                drawBottom = drawRight = drawTop = true;
	                drawLeft = false;
	                left = b;
	                right = x;
	                top = y + barLeft;
	                bottom = y + barRight;
	
	                // account for negative bars
	                if (right < left) {
	                    tmp = right;
	                    right = left;
	                    left = tmp;
	                    drawLeft = true;
	                    drawRight = false;
	                }
	            }
	            else {
	                drawLeft = drawRight = drawTop = true;
	                drawBottom = false;
	                left = x + barLeft;
	                right = x + barRight;
	                bottom = b;
	                top = y;
	
	                // account for negative bars
	                if (top < bottom) {
	                    tmp = top;
	                    top = bottom;
	                    bottom = tmp;
	                    drawBottom = true;
	                    drawTop = false;
	                }
	            }
	
	            // clip
	            if (right < axisx.min || left > axisx.max ||
	                top < axisy.min || bottom > axisy.max)
	                return;
	
	            if (left < axisx.min) {
	                left = axisx.min;
	                drawLeft = false;
	            }
	
	            if (right > axisx.max) {
	                right = axisx.max;
	                drawRight = false;
	            }
	
	            if (bottom < axisy.min) {
	                bottom = axisy.min;
	                drawBottom = false;
	            }
	
	            if (top > axisy.max) {
	                top = axisy.max;
	                drawTop = false;
	            }
	
	            left = axisx.p2c(left);
	            bottom = axisy.p2c(bottom);
	            right = axisx.p2c(right);
	            top = axisy.p2c(top);
	
	            // fill the bar
	            if (fillStyleCallback) {
	                c.fillStyle = fillStyleCallback(bottom, top);
	                c.fillRect(left, top, right - left, bottom - top)
	            }
	
	            // draw outline
	            if (lineWidth > 0 && (drawLeft || drawRight || drawTop || drawBottom)) {
	                c.beginPath();
	
	                // FIXME: inline moveTo is buggy with excanvas
	                c.moveTo(left, bottom);
	                if (drawLeft)
	                    c.lineTo(left, top);
	                else
	                    c.moveTo(left, top);
	                if (drawTop)
	                    c.lineTo(right, top);
	                else
	                    c.moveTo(right, top);
	                if (drawRight)
	                    c.lineTo(right, bottom);
	                else
	                    c.moveTo(right, bottom);
	                if (drawBottom)
	                    c.lineTo(left, bottom);
	                else
	                    c.moveTo(left, bottom);
	                c.stroke();
	            }
	        }
	
	        function drawSeriesBars(series) {
	            function plotBars(datapoints, barLeft, barRight, fillStyleCallback, axisx, axisy) {
	                var points = datapoints.points, ps = datapoints.pointsize;
	
	                for (var i = 0; i < points.length; i += ps) {
	                    if (points[i] == null)
	                        continue;
	                    drawBar(points[i], points[i + 1], points[i + 2], barLeft, barRight, fillStyleCallback, axisx, axisy, ctx, series.bars.horizontal, series.bars.lineWidth);
	                }
	            }
	
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	
	            // FIXME: figure out a way to add shadows (for instance along the right edge)
	            ctx.lineWidth = series.bars.lineWidth;
	            ctx.strokeStyle = series.color;
	
	            var barLeft;
	
	            switch (series.bars.align) {
	                case "left":
	                    barLeft = 0;
	                    break;
	                case "right":
	                    barLeft = -series.bars.barWidth;
	                    break;
	                default:
	                    barLeft = -series.bars.barWidth / 2;
	            }
	
	            var fillStyleCallback = series.bars.fill ? function (bottom, top) { return getFillStyle(series.bars, series.color, bottom, top); } : null;
	            plotBars(series.datapoints, barLeft, barLeft + series.bars.barWidth, fillStyleCallback, series.xaxis, series.yaxis);
	            ctx.restore();
	        }
	
	        function getFillStyle(filloptions, seriesColor, bottom, top) {
	            var fill = filloptions.fill;
	            if (!fill)
	                return null;
	
	            if (filloptions.fillColor)
	                return getColorOrGradient(filloptions.fillColor, bottom, top, seriesColor);
	
	            var c = $.color.parse(seriesColor);
	            c.a = typeof fill == "number" ? fill : 0.4;
	            c.normalize();
	            return c.toString();
	        }
	
	        function insertLegend() {
	
	            if (options.legend.container != null) {
	                $(options.legend.container).html("");
	            } else {
	                placeholder.find(".legend").remove();
	            }
	
	            if (!options.legend.show) {
	                return;
	            }
	
	            var fragments = [], entries = [], rowStarted = false,
	                lf = options.legend.labelFormatter, s, label;
	
	            // Build a list of legend entries, with each having a label and a color
	
	            for (var i = 0; i < series.length; ++i) {
	                s = series[i];
	                if (s.label) {
	                    label = lf ? lf(s.label, s) : s.label;
	                    if (label) {
	                        entries.push({
	                            label: label,
	                            color: s.color
	                        });
	                    }
	                }
	            }
	
	            // Sort the legend using either the default or a custom comparator
	
	            if (options.legend.sorted) {
	                if ($.isFunction(options.legend.sorted)) {
	                    entries.sort(options.legend.sorted);
	                } else if (options.legend.sorted == "reverse") {
	                	entries.reverse();
	                } else {
	                    var ascending = options.legend.sorted != "descending";
	                    entries.sort(function(a, b) {
	                        return a.label == b.label ? 0 : (
	                            (a.label < b.label) != ascending ? 1 : -1   // Logical XOR
	                        );
	                    });
	                }
	            }
	
	            // Generate markup for the list of entries, in their final order
	
	            for (var i = 0; i < entries.length; ++i) {
	
	                var entry = entries[i];
	
	                if (i % options.legend.noColumns == 0) {
	                    if (rowStarted)
	                        fragments.push('</tr>');
	                    fragments.push('<tr>');
	                    rowStarted = true;
	                }
	
	                fragments.push(
	                    '<td class="legendColorBox"><div style="border:1px solid ' + options.legend.labelBoxBorderColor + ';padding:1px"><div style="width:4px;height:0;border:5px solid ' + entry.color + ';overflow:hidden"></div></div></td>' +
	                    '<td class="legendLabel">' + entry.label + '</td>'
	                );
	            }
	
	            if (rowStarted)
	                fragments.push('</tr>');
	
	            if (fragments.length == 0)
	                return;
	
	            var table = '<table style="font-size:smaller;color:' + options.grid.color + '">' + fragments.join("") + '</table>';
	            if (options.legend.container != null)
	                $(options.legend.container).html(table);
	            else {
	                var pos = "",
	                    p = options.legend.position,
	                    m = options.legend.margin;
	                if (m[0] == null)
	                    m = [m, m];
	                if (p.charAt(0) == "n")
	                    pos += 'top:' + (m[1] + plotOffset.top) + 'px;';
	                else if (p.charAt(0) == "s")
	                    pos += 'bottom:' + (m[1] + plotOffset.bottom) + 'px;';
	                if (p.charAt(1) == "e")
	                    pos += 'right:' + (m[0] + plotOffset.right) + 'px;';
	                else if (p.charAt(1) == "w")
	                    pos += 'left:' + (m[0] + plotOffset.left) + 'px;';
	                var legend = $('<div class="legend">' + table.replace('style="', 'style="position:absolute;' + pos +';') + '</div>').appendTo(placeholder);
	                if (options.legend.backgroundOpacity != 0.0) {
	                    // put in the transparent background
	                    // separately to avoid blended labels and
	                    // label boxes
	                    var c = options.legend.backgroundColor;
	                    if (c == null) {
	                        c = options.grid.backgroundColor;
	                        if (c && typeof c == "string")
	                            c = $.color.parse(c);
	                        else
	                            c = $.color.extract(legend, 'background-color');
	                        c.a = 1;
	                        c = c.toString();
	                    }
	                    var div = legend.children();
	                    $('<div style="position:absolute;width:' + div.width() + 'px;height:' + div.height() + 'px;' + pos +'background-color:' + c + ';"> </div>').prependTo(legend).css('opacity', options.legend.backgroundOpacity);
	                }
	            }
	        }
	
	
	        // interactive features
	
	        var highlights = [],
	            redrawTimeout = null;
	
	        // returns the data item the mouse is over, or null if none is found
	        function findNearbyItem(mouseX, mouseY, seriesFilter) {
	            var maxDistance = options.grid.mouseActiveRadius,
	                smallestDistance = maxDistance * maxDistance + 1,
	                item = null, foundPoint = false, i, j, ps;
	
	            for (i = series.length - 1; i >= 0; --i) {
	                if (!seriesFilter(series[i]))
	                    continue;
	
	                var s = series[i],
	                    axisx = s.xaxis,
	                    axisy = s.yaxis,
	                    points = s.datapoints.points,
	                    mx = axisx.c2p(mouseX), // precompute some stuff to make the loop faster
	                    my = axisy.c2p(mouseY),
	                    maxx = maxDistance / axisx.scale,
	                    maxy = maxDistance / axisy.scale;
	
	                ps = s.datapoints.pointsize;
	                // with inverse transforms, we can't use the maxx/maxy
	                // optimization, sadly
	                if (axisx.options.inverseTransform)
	                    maxx = Number.MAX_VALUE;
	                if (axisy.options.inverseTransform)
	                    maxy = Number.MAX_VALUE;
	
	                if (s.lines.show || s.points.show) {
	                    for (j = 0; j < points.length; j += ps) {
	                        var x = points[j], y = points[j + 1];
	                        if (x == null)
	                            continue;
	
	                        // For points and lines, the cursor must be within a
	                        // certain distance to the data point
	                        if (x - mx > maxx || x - mx < -maxx ||
	                            y - my > maxy || y - my < -maxy)
	                            continue;
	
	                        // We have to calculate distances in pixels, not in
	                        // data units, because the scales of the axes may be different
	                        var dx = Math.abs(axisx.p2c(x) - mouseX),
	                            dy = Math.abs(axisy.p2c(y) - mouseY),
	                            dist = dx * dx + dy * dy; // we save the sqrt
	
	                        // use <= to ensure last point takes precedence
	                        // (last generally means on top of)
	                        if (dist < smallestDistance) {
	                            smallestDistance = dist;
	                            item = [i, j / ps];
	                        }
	                    }
	                }
	
	                if (s.bars.show && !item) { // no other point can be nearby
	
	                    var barLeft, barRight;
	
	                    switch (s.bars.align) {
	                        case "left":
	                            barLeft = 0;
	                            break;
	                        case "right":
	                            barLeft = -s.bars.barWidth;
	                            break;
	                        default:
	                            barLeft = -s.bars.barWidth / 2;
	                    }
	
	                    barRight = barLeft + s.bars.barWidth;
	
	                    for (j = 0; j < points.length; j += ps) {
	                        var x = points[j], y = points[j + 1], b = points[j + 2];
	                        if (x == null)
	                            continue;
	
	                        // for a bar graph, the cursor must be inside the bar
	                        if (series[i].bars.horizontal ?
	                            (mx <= Math.max(b, x) && mx >= Math.min(b, x) &&
	                             my >= y + barLeft && my <= y + barRight) :
	                            (mx >= x + barLeft && mx <= x + barRight &&
	                             my >= Math.min(b, y) && my <= Math.max(b, y)))
	                                item = [i, j / ps];
	                    }
	                }
	            }
	
	            if (item) {
	                i = item[0];
	                j = item[1];
	                ps = series[i].datapoints.pointsize;
	
	                return { datapoint: series[i].datapoints.points.slice(j * ps, (j + 1) * ps),
	                         dataIndex: j,
	                         series: series[i],
	                         seriesIndex: i };
	            }
	
	            return null;
	        }
	
	        function onMouseMove(e) {
	            if (options.grid.hoverable)
	                triggerClickHoverEvent("plothover", e,
	                                       function (s) { return s["hoverable"] != false; });
	        }
	
	        function onMouseLeave(e) {
	            if (options.grid.hoverable)
	                triggerClickHoverEvent("plothover", e,
	                                       function (s) { return false; });
	        }
	
	        function onClick(e) {
	            triggerClickHoverEvent("plotclick", e,
	                                   function (s) { return s["clickable"] != false; });
	        }
	
	        // trigger click or hover event (they send the same parameters
	        // so we share their code)
	        function triggerClickHoverEvent(eventname, event, seriesFilter) {
	            var offset = eventHolder.offset(),
	                canvasX = event.pageX - offset.left - plotOffset.left,
	                canvasY = event.pageY - offset.top - plotOffset.top,
	            pos = canvasToAxisCoords({ left: canvasX, top: canvasY });
	
	            pos.pageX = event.pageX;
	            pos.pageY = event.pageY;
	
	            var item = findNearbyItem(canvasX, canvasY, seriesFilter);
	
	            if (item) {
	                // fill in mouse pos for any listeners out there
	                item.pageX = parseInt(item.series.xaxis.p2c(item.datapoint[0]) + offset.left + plotOffset.left, 10);
	                item.pageY = parseInt(item.series.yaxis.p2c(item.datapoint[1]) + offset.top + plotOffset.top, 10);
	            }
	
	            if (options.grid.autoHighlight) {
	                // clear auto-highlights
	                for (var i = 0; i < highlights.length; ++i) {
	                    var h = highlights[i];
	                    if (h.auto == eventname &&
	                        !(item && h.series == item.series &&
	                          h.point[0] == item.datapoint[0] &&
	                          h.point[1] == item.datapoint[1]))
	                        unhighlight(h.series, h.point);
	                }
	
	                if (item)
	                    highlight(item.series, item.datapoint, eventname);
	            }
	
	            placeholder.trigger(eventname, [ pos, item ]);
	        }
	
	        function triggerRedrawOverlay() {
	            var t = options.interaction.redrawOverlayInterval;
	            if (t == -1) {      // skip event queue
	                drawOverlay();
	                return;
	            }
	
	            if (!redrawTimeout)
	                redrawTimeout = setTimeout(drawOverlay, t);
	        }
	
	        function drawOverlay() {
	            redrawTimeout = null;
	
	            // draw highlights
	            octx.save();
	            overlay.clear();
	            octx.translate(plotOffset.left, plotOffset.top);
	
	            var i, hi;
	            for (i = 0; i < highlights.length; ++i) {
	                hi = highlights[i];
	
	                if (hi.series.bars.show)
	                    drawBarHighlight(hi.series, hi.point);
	                else
	                    drawPointHighlight(hi.series, hi.point);
	            }
	            octx.restore();
	
	            executeHooks(hooks.drawOverlay, [octx]);
	        }
	
	        function highlight(s, point, auto) {
	            if (typeof s == "number")
	                s = series[s];
	
	            if (typeof point == "number") {
	                var ps = s.datapoints.pointsize;
	                point = s.datapoints.points.slice(ps * point, ps * (point + 1));
	            }
	
	            var i = indexOfHighlight(s, point);
	            if (i == -1) {
	                highlights.push({ series: s, point: point, auto: auto });
	
	                triggerRedrawOverlay();
	            }
	            else if (!auto)
	                highlights[i].auto = false;
	        }
	
	        function unhighlight(s, point) {
	            if (s == null && point == null) {
	                highlights = [];
	                triggerRedrawOverlay();
	                return;
	            }
	
	            if (typeof s == "number")
	                s = series[s];
	
	            if (typeof point == "number") {
	                var ps = s.datapoints.pointsize;
	                point = s.datapoints.points.slice(ps * point, ps * (point + 1));
	            }
	
	            var i = indexOfHighlight(s, point);
	            if (i != -1) {
	                highlights.splice(i, 1);
	
	                triggerRedrawOverlay();
	            }
	        }
	
	        function indexOfHighlight(s, p) {
	            for (var i = 0; i < highlights.length; ++i) {
	                var h = highlights[i];
	                if (h.series == s && h.point[0] == p[0]
	                    && h.point[1] == p[1])
	                    return i;
	            }
	            return -1;
	        }
	
	        function drawPointHighlight(series, point) {
	            var x = point[0], y = point[1],
	                axisx = series.xaxis, axisy = series.yaxis,
	                highlightColor = (typeof series.highlightColor === "string") ? series.highlightColor : $.color.parse(series.color).scale('a', 0.5).toString();
	
	            if (x < axisx.min || x > axisx.max || y < axisy.min || y > axisy.max)
	                return;
	
	            var pointRadius = series.points.radius + series.points.lineWidth / 2;
	            octx.lineWidth = pointRadius;
	            octx.strokeStyle = highlightColor;
	            var radius = 1.5 * pointRadius;
	            x = axisx.p2c(x);
	            y = axisy.p2c(y);
	
	            octx.beginPath();
	            if (series.points.symbol == "circle")
	                octx.arc(x, y, radius, 0, 2 * Math.PI, false);
	            else
	                series.points.symbol(octx, x, y, radius, false);
	            octx.closePath();
	            octx.stroke();
	        }
	
	        function drawBarHighlight(series, point) {
	            var highlightColor = (typeof series.highlightColor === "string") ? series.highlightColor : $.color.parse(series.color).scale('a', 0.5).toString(),
	                fillStyle = highlightColor,
	                barLeft;
	
	            switch (series.bars.align) {
	                case "left":
	                    barLeft = 0;
	                    break;
	                case "right":
	                    barLeft = -series.bars.barWidth;
	                    break;
	                default:
	                    barLeft = -series.bars.barWidth / 2;
	            }
	
	            octx.lineWidth = series.bars.lineWidth;
	            octx.strokeStyle = highlightColor;
	
	            drawBar(point[0], point[1], point[2] || 0, barLeft, barLeft + series.bars.barWidth,
	                    function () { return fillStyle; }, series.xaxis, series.yaxis, octx, series.bars.horizontal, series.bars.lineWidth);
	        }
	
	        function getColorOrGradient(spec, bottom, top, defaultColor) {
	            if (typeof spec == "string")
	                return spec;
	            else {
	                // assume this is a gradient spec; IE currently only
	                // supports a simple vertical gradient properly, so that's
	                // what we support too
	                var gradient = ctx.createLinearGradient(0, top, 0, bottom);
	
	                for (var i = 0, l = spec.colors.length; i < l; ++i) {
	                    var c = spec.colors[i];
	                    if (typeof c != "string") {
	                        var co = $.color.parse(defaultColor);
	                        if (c.brightness != null)
	                            co = co.scale('rgb', c.brightness);
	                        if (c.opacity != null)
	                            co.a *= c.opacity;
	                        c = co.toString();
	                    }
	                    gradient.addColorStop(i / (l - 1), c);
	                }
	
	                return gradient;
	            }
	        }
	    }
	
	    // Add the plot function to the top level of the jQuery object
	
	    $.plot = function(placeholder, data, options) {
	        //var t0 = new Date();
	        var plot = new Plot($(placeholder), data, options, $.plot.plugins);
	        //(window.console ? console.log : alert)("time used (msecs): " + ((new Date()).getTime() - t0.getTime()));
	        return plot;
	    };
	
	    $.plot.version = "0.8.3";
	
	    $.plot.plugins = [];
	
	    // Also add the plot function as a chainable property
	
	    $.fn.plot = function(data, options) {
	        return this.each(function() {
	            $.plot(this, data, options);
	        });
	    };
	
	    // round to nearby lower multiple of base
	    function floorInBase(n, base) {
	        return base * Math.floor(n / base);
	    }
	
	})(jQuery);


/***/ },

/***/ 1106:
/***/ function(module, exports) {

	/* Flot plugin for rendering pie charts.
	
	Copyright (c) 2007-2014 IOLA and Ole Laursen.
	Licensed under the MIT license.
	
	The plugin assumes that each series has a single data value, and that each
	value is a positive integer or zero.  Negative numbers don't make sense for a
	pie chart, and have unpredictable results.  The values do NOT need to be
	passed in as percentages; the plugin will calculate the total and per-slice
	percentages internally.
	
	* Created by Brian Medendorp
	
	* Updated with contributions from btburnett3, Anthony Aragues and Xavi Ivars
	
	The plugin supports these options:
	
		series: {
			pie: {
				show: true/false
				radius: 0-1 for percentage of fullsize, or a specified pixel length, or 'auto'
				innerRadius: 0-1 for percentage of fullsize or a specified pixel length, for creating a donut effect
				startAngle: 0-2 factor of PI used for starting angle (in radians) i.e 3/2 starts at the top, 0 and 2 have the same result
				tilt: 0-1 for percentage to tilt the pie, where 1 is no tilt, and 0 is completely flat (nothing will show)
				offset: {
					top: integer value to move the pie up or down
					left: integer value to move the pie left or right, or 'auto'
				},
				stroke: {
					color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#FFF')
					width: integer pixel width of the stroke
				},
				label: {
					show: true/false, or 'auto'
					formatter:  a user-defined function that modifies the text/style of the label text
					radius: 0-1 for percentage of fullsize, or a specified pixel length
					background: {
						color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#000')
						opacity: 0-1
					},
					threshold: 0-1 for the percentage value at which to hide labels (if they're too small)
				},
				combine: {
					threshold: 0-1 for the percentage value at which to combine slices (if they're too small)
					color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#CCC'), if null, the plugin will automatically use the color of the first slice to be combined
					label: any text value of what the combined slice should be labeled
				}
				highlight: {
					opacity: 0-1
				}
			}
		}
	
	More detail and specific examples can be found in the included HTML file.
	
	*/
	
	(function($) {
	
		// Maximum redraw attempts when fitting labels within the plot
	
		var REDRAW_ATTEMPTS = 10;
	
		// Factor by which to shrink the pie when fitting labels within the plot
	
		var REDRAW_SHRINK = 0.95;
	
		function init(plot) {
	
			var canvas = null,
				target = null,
				options = null,
				maxRadius = null,
				centerLeft = null,
				centerTop = null,
				processed = false,
				ctx = null;
	
			// interactive variables
	
			var highlights = [];
	
			// add hook to determine if pie plugin in enabled, and then perform necessary operations
	
			plot.hooks.processOptions.push(function(plot, options) {
				if (options.series.pie.show) {
	
					options.grid.show = false;
	
					// set labels.show
	
					if (options.series.pie.label.show == "auto") {
						if (options.legend.show) {
							options.series.pie.label.show = false;
						} else {
							options.series.pie.label.show = true;
						}
					}
	
					// set radius
	
					if (options.series.pie.radius == "auto") {
						if (options.series.pie.label.show) {
							options.series.pie.radius = 3/4;
						} else {
							options.series.pie.radius = 1;
						}
					}
	
					// ensure sane tilt
	
					if (options.series.pie.tilt > 1) {
						options.series.pie.tilt = 1;
					} else if (options.series.pie.tilt < 0) {
						options.series.pie.tilt = 0;
					}
				}
			});
	
			plot.hooks.bindEvents.push(function(plot, eventHolder) {
				var options = plot.getOptions();
				if (options.series.pie.show) {
					if (options.grid.hoverable) {
						eventHolder.unbind("mousemove").mousemove(onMouseMove);
					}
					if (options.grid.clickable) {
						eventHolder.unbind("click").click(onClick);
					}
				}
			});
	
			plot.hooks.processDatapoints.push(function(plot, series, data, datapoints) {
				var options = plot.getOptions();
				if (options.series.pie.show) {
					processDatapoints(plot, series, data, datapoints);
				}
			});
	
			plot.hooks.drawOverlay.push(function(plot, octx) {
				var options = plot.getOptions();
				if (options.series.pie.show) {
					drawOverlay(plot, octx);
				}
			});
	
			plot.hooks.draw.push(function(plot, newCtx) {
				var options = plot.getOptions();
				if (options.series.pie.show) {
					draw(plot, newCtx);
				}
			});
	
			function processDatapoints(plot, series, datapoints) {
				if (!processed)	{
					processed = true;
					canvas = plot.getCanvas();
					target = $(canvas).parent();
					options = plot.getOptions();
					plot.setData(combine(plot.getData()));
				}
			}
	
			function combine(data) {
	
				var total = 0,
					combined = 0,
					numCombined = 0,
					color = options.series.pie.combine.color,
					newdata = [];
	
				// Fix up the raw data from Flot, ensuring the data is numeric
	
				for (var i = 0; i < data.length; ++i) {
	
					var value = data[i].data;
	
					// If the data is an array, we'll assume that it's a standard
					// Flot x-y pair, and are concerned only with the second value.
	
					// Note how we use the original array, rather than creating a
					// new one; this is more efficient and preserves any extra data
					// that the user may have stored in higher indexes.
	
					if ($.isArray(value) && value.length == 1) {
	    				value = value[0];
					}
	
					if ($.isArray(value)) {
						// Equivalent to $.isNumeric() but compatible with jQuery < 1.7
						if (!isNaN(parseFloat(value[1])) && isFinite(value[1])) {
							value[1] = +value[1];
						} else {
							value[1] = 0;
						}
					} else if (!isNaN(parseFloat(value)) && isFinite(value)) {
						value = [1, +value];
					} else {
						value = [1, 0];
					}
	
					data[i].data = [value];
				}
	
				// Sum up all the slices, so we can calculate percentages for each
	
				for (var i = 0; i < data.length; ++i) {
					total += data[i].data[0][1];
				}
	
				// Count the number of slices with percentages below the combine
				// threshold; if it turns out to be just one, we won't combine.
	
				for (var i = 0; i < data.length; ++i) {
					var value = data[i].data[0][1];
					if (value / total <= options.series.pie.combine.threshold) {
						combined += value;
						numCombined++;
						if (!color) {
							color = data[i].color;
						}
					}
				}
	
				for (var i = 0; i < data.length; ++i) {
					var value = data[i].data[0][1];
					if (numCombined < 2 || value / total > options.series.pie.combine.threshold) {
						newdata.push(
							$.extend(data[i], {     /* extend to allow keeping all other original data values
							                           and using them e.g. in labelFormatter. */
								data: [[1, value]],
								color: data[i].color,
								label: data[i].label,
								angle: value * Math.PI * 2 / total,
								percent: value / (total / 100)
							})
						);
					}
				}
	
				if (numCombined > 1) {
					newdata.push({
						data: [[1, combined]],
						color: color,
						label: options.series.pie.combine.label,
						angle: combined * Math.PI * 2 / total,
						percent: combined / (total / 100)
					});
				}
	
				return newdata;
			}
	
			function draw(plot, newCtx) {
	
				if (!target) {
					return; // if no series were passed
				}
	
				var canvasWidth = plot.getPlaceholder().width(),
					canvasHeight = plot.getPlaceholder().height(),
					legendWidth = target.children().filter(".legend").children().width() || 0;
	
				ctx = newCtx;
	
				// WARNING: HACK! REWRITE THIS CODE AS SOON AS POSSIBLE!
	
				// When combining smaller slices into an 'other' slice, we need to
				// add a new series.  Since Flot gives plugins no way to modify the
				// list of series, the pie plugin uses a hack where the first call
				// to processDatapoints results in a call to setData with the new
				// list of series, then subsequent processDatapoints do nothing.
	
				// The plugin-global 'processed' flag is used to control this hack;
				// it starts out false, and is set to true after the first call to
				// processDatapoints.
	
				// Unfortunately this turns future setData calls into no-ops; they
				// call processDatapoints, the flag is true, and nothing happens.
	
				// To fix this we'll set the flag back to false here in draw, when
				// all series have been processed, so the next sequence of calls to
				// processDatapoints once again starts out with a slice-combine.
				// This is really a hack; in 0.9 we need to give plugins a proper
				// way to modify series before any processing begins.
	
				processed = false;
	
				// calculate maximum radius and center point
	
				maxRadius =  Math.min(canvasWidth, canvasHeight / options.series.pie.tilt) / 2;
				centerTop = canvasHeight / 2 + options.series.pie.offset.top;
				centerLeft = canvasWidth / 2;
	
				if (options.series.pie.offset.left == "auto") {
					if (options.legend.position.match("w")) {
						centerLeft += legendWidth / 2;
					} else {
						centerLeft -= legendWidth / 2;
					}
					if (centerLeft < maxRadius) {
						centerLeft = maxRadius;
					} else if (centerLeft > canvasWidth - maxRadius) {
						centerLeft = canvasWidth - maxRadius;
					}
				} else {
					centerLeft += options.series.pie.offset.left;
				}
	
				var slices = plot.getData(),
					attempts = 0;
	
				// Keep shrinking the pie's radius until drawPie returns true,
				// indicating that all the labels fit, or we try too many times.
	
				do {
					if (attempts > 0) {
						maxRadius *= REDRAW_SHRINK;
					}
					attempts += 1;
					clear();
					if (options.series.pie.tilt <= 0.8) {
						drawShadow();
					}
				} while (!drawPie() && attempts < REDRAW_ATTEMPTS)
	
				if (attempts >= REDRAW_ATTEMPTS) {
					clear();
					target.prepend("<div class='error'>Could not draw pie with labels contained inside canvas</div>");
				}
	
				if (plot.setSeries && plot.insertLegend) {
					plot.setSeries(slices);
					plot.insertLegend();
				}
	
				// we're actually done at this point, just defining internal functions at this point
	
				function clear() {
					ctx.clearRect(0, 0, canvasWidth, canvasHeight);
					target.children().filter(".pieLabel, .pieLabelBackground").remove();
				}
	
				function drawShadow() {
	
					var shadowLeft = options.series.pie.shadow.left;
					var shadowTop = options.series.pie.shadow.top;
					var edge = 10;
					var alpha = options.series.pie.shadow.alpha;
					var radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius;
	
					if (radius >= canvasWidth / 2 - shadowLeft || radius * options.series.pie.tilt >= canvasHeight / 2 - shadowTop || radius <= edge) {
						return;	// shadow would be outside canvas, so don't draw it
					}
	
					ctx.save();
					ctx.translate(shadowLeft,shadowTop);
					ctx.globalAlpha = alpha;
					ctx.fillStyle = "#000";
	
					// center and rotate to starting position
	
					ctx.translate(centerLeft,centerTop);
					ctx.scale(1, options.series.pie.tilt);
	
					//radius -= edge;
	
					for (var i = 1; i <= edge; i++) {
						ctx.beginPath();
						ctx.arc(0, 0, radius, 0, Math.PI * 2, false);
						ctx.fill();
						radius -= i;
					}
	
					ctx.restore();
				}
	
				function drawPie() {
	
					var startAngle = Math.PI * options.series.pie.startAngle;
					var radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius;
	
					// center and rotate to starting position
	
					ctx.save();
					ctx.translate(centerLeft,centerTop);
					ctx.scale(1, options.series.pie.tilt);
					//ctx.rotate(startAngle); // start at top; -- This doesn't work properly in Opera
	
					// draw slices
	
					ctx.save();
					var currentAngle = startAngle;
					for (var i = 0; i < slices.length; ++i) {
						slices[i].startAngle = currentAngle;
						drawSlice(slices[i].angle, slices[i].color, true);
					}
					ctx.restore();
	
					// draw slice outlines
	
					if (options.series.pie.stroke.width > 0) {
						ctx.save();
						ctx.lineWidth = options.series.pie.stroke.width;
						currentAngle = startAngle;
						for (var i = 0; i < slices.length; ++i) {
							drawSlice(slices[i].angle, options.series.pie.stroke.color, false);
						}
						ctx.restore();
					}
	
					// draw donut hole
	
					drawDonutHole(ctx);
	
					ctx.restore();
	
					// Draw the labels, returning true if they fit within the plot
	
					if (options.series.pie.label.show) {
						return drawLabels();
					} else return true;
	
					function drawSlice(angle, color, fill) {
	
						if (angle <= 0 || isNaN(angle)) {
							return;
						}
	
						if (fill) {
							ctx.fillStyle = color;
						} else {
							ctx.strokeStyle = color;
							ctx.lineJoin = "round";
						}
	
						ctx.beginPath();
						if (Math.abs(angle - Math.PI * 2) > 0.000000001) {
							ctx.moveTo(0, 0); // Center of the pie
						}
	
						//ctx.arc(0, 0, radius, 0, angle, false); // This doesn't work properly in Opera
						ctx.arc(0, 0, radius,currentAngle, currentAngle + angle / 2, false);
						ctx.arc(0, 0, radius,currentAngle + angle / 2, currentAngle + angle, false);
						ctx.closePath();
						//ctx.rotate(angle); // This doesn't work properly in Opera
						currentAngle += angle;
	
						if (fill) {
							ctx.fill();
						} else {
							ctx.stroke();
						}
					}
	
					function drawLabels() {
	
						var currentAngle = startAngle;
						var radius = options.series.pie.label.radius > 1 ? options.series.pie.label.radius : maxRadius * options.series.pie.label.radius;
	
						for (var i = 0; i < slices.length; ++i) {
							if (slices[i].percent >= options.series.pie.label.threshold * 100) {
								if (!drawLabel(slices[i], currentAngle, i)) {
									return false;
								}
							}
							currentAngle += slices[i].angle;
						}
	
						return true;
	
						function drawLabel(slice, startAngle, index) {
	
							if (slice.data[0][1] == 0) {
								return true;
							}
	
							// format label text
	
							var lf = options.legend.labelFormatter, text, plf = options.series.pie.label.formatter;
	
							if (lf) {
								text = lf(slice.label, slice);
							} else {
								text = slice.label;
							}
	
							if (plf) {
								text = plf(text, slice);
							}
	
							var halfAngle = ((startAngle + slice.angle) + startAngle) / 2;
							var x = centerLeft + Math.round(Math.cos(halfAngle) * radius);
							var y = centerTop + Math.round(Math.sin(halfAngle) * radius) * options.series.pie.tilt;
	
							var html = "<span class='pieLabel' id='pieLabel" + index + "' style='position:absolute;top:" + y + "px;left:" + x + "px;'>" + text + "</span>";
							target.append(html);
	
							var label = target.children("#pieLabel" + index);
							var labelTop = (y - label.height() / 2);
							var labelLeft = (x - label.width() / 2);
	
							label.css("top", labelTop);
							label.css("left", labelLeft);
	
							// check to make sure that the label is not outside the canvas
	
							if (0 - labelTop > 0 || 0 - labelLeft > 0 || canvasHeight - (labelTop + label.height()) < 0 || canvasWidth - (labelLeft + label.width()) < 0) {
								return false;
							}
	
							if (options.series.pie.label.background.opacity != 0) {
	
								// put in the transparent background separately to avoid blended labels and label boxes
	
								var c = options.series.pie.label.background.color;
	
								if (c == null) {
									c = slice.color;
								}
	
								var pos = "top:" + labelTop + "px;left:" + labelLeft + "px;";
								$("<div class='pieLabelBackground' style='position:absolute;width:" + label.width() + "px;height:" + label.height() + "px;" + pos + "background-color:" + c + ";'></div>")
									.css("opacity", options.series.pie.label.background.opacity)
									.insertBefore(label);
							}
	
							return true;
						} // end individual label function
					} // end drawLabels function
				} // end drawPie function
			} // end draw function
	
			// Placed here because it needs to be accessed from multiple locations
	
			function drawDonutHole(layer) {
				if (options.series.pie.innerRadius > 0) {
	
					// subtract the center
	
					layer.save();
					var innerRadius = options.series.pie.innerRadius > 1 ? options.series.pie.innerRadius : maxRadius * options.series.pie.innerRadius;
					layer.globalCompositeOperation = "destination-out"; // this does not work with excanvas, but it will fall back to using the stroke color
					layer.beginPath();
					layer.fillStyle = options.series.pie.stroke.color;
					layer.arc(0, 0, innerRadius, 0, Math.PI * 2, false);
					layer.fill();
					layer.closePath();
					layer.restore();
	
					// add inner stroke
	
					layer.save();
					layer.beginPath();
					layer.strokeStyle = options.series.pie.stroke.color;
					layer.arc(0, 0, innerRadius, 0, Math.PI * 2, false);
					layer.stroke();
					layer.closePath();
					layer.restore();
	
					// TODO: add extra shadow inside hole (with a mask) if the pie is tilted.
				}
			}
	
			//-- Additional Interactive related functions --
	
			function isPointInPoly(poly, pt) {
				for(var c = false, i = -1, l = poly.length, j = l - 1; ++i < l; j = i)
					((poly[i][1] <= pt[1] && pt[1] < poly[j][1]) || (poly[j][1] <= pt[1] && pt[1]< poly[i][1]))
					&& (pt[0] < (poly[j][0] - poly[i][0]) * (pt[1] - poly[i][1]) / (poly[j][1] - poly[i][1]) + poly[i][0])
					&& (c = !c);
				return c;
			}
	
			function findNearbySlice(mouseX, mouseY) {
	
				var slices = plot.getData(),
					options = plot.getOptions(),
					radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius,
					x, y;
	
				for (var i = 0; i < slices.length; ++i) {
	
					var s = slices[i];
	
					if (s.pie.show) {
	
						ctx.save();
						ctx.beginPath();
						ctx.moveTo(0, 0); // Center of the pie
						//ctx.scale(1, options.series.pie.tilt);	// this actually seems to break everything when here.
						ctx.arc(0, 0, radius, s.startAngle, s.startAngle + s.angle / 2, false);
						ctx.arc(0, 0, radius, s.startAngle + s.angle / 2, s.startAngle + s.angle, false);
						ctx.closePath();
						x = mouseX - centerLeft;
						y = mouseY - centerTop;
	
						if (ctx.isPointInPath) {
							if (ctx.isPointInPath(mouseX - centerLeft, mouseY - centerTop)) {
								ctx.restore();
								return {
									datapoint: [s.percent, s.data],
									dataIndex: 0,
									series: s,
									seriesIndex: i
								};
							}
						} else {
	
							// excanvas for IE doesn;t support isPointInPath, this is a workaround.
	
							var p1X = radius * Math.cos(s.startAngle),
								p1Y = radius * Math.sin(s.startAngle),
								p2X = radius * Math.cos(s.startAngle + s.angle / 4),
								p2Y = radius * Math.sin(s.startAngle + s.angle / 4),
								p3X = radius * Math.cos(s.startAngle + s.angle / 2),
								p3Y = radius * Math.sin(s.startAngle + s.angle / 2),
								p4X = radius * Math.cos(s.startAngle + s.angle / 1.5),
								p4Y = radius * Math.sin(s.startAngle + s.angle / 1.5),
								p5X = radius * Math.cos(s.startAngle + s.angle),
								p5Y = radius * Math.sin(s.startAngle + s.angle),
								arrPoly = [[0, 0], [p1X, p1Y], [p2X, p2Y], [p3X, p3Y], [p4X, p4Y], [p5X, p5Y]],
								arrPoint = [x, y];
	
							// TODO: perhaps do some mathmatical trickery here with the Y-coordinate to compensate for pie tilt?
	
							if (isPointInPoly(arrPoly, arrPoint)) {
								ctx.restore();
								return {
									datapoint: [s.percent, s.data],
									dataIndex: 0,
									series: s,
									seriesIndex: i
								};
							}
						}
	
						ctx.restore();
					}
				}
	
				return null;
			}
	
			function onMouseMove(e) {
				triggerClickHoverEvent("plothover", e);
			}
	
			function onClick(e) {
				triggerClickHoverEvent("plotclick", e);
			}
	
			// trigger click or hover event (they send the same parameters so we share their code)
	
			function triggerClickHoverEvent(eventname, e) {
	
				var offset = plot.offset();
				var canvasX = parseInt(e.pageX - offset.left);
				var canvasY =  parseInt(e.pageY - offset.top);
				var item = findNearbySlice(canvasX, canvasY);
	
				if (options.grid.autoHighlight) {
	
					// clear auto-highlights
	
					for (var i = 0; i < highlights.length; ++i) {
						var h = highlights[i];
						if (h.auto == eventname && !(item && h.series == item.series)) {
							unhighlight(h.series);
						}
					}
				}
	
				// highlight the slice
	
				if (item) {
					highlight(item.series, eventname);
				}
	
				// trigger any hover bind events
	
				var pos = { pageX: e.pageX, pageY: e.pageY };
				target.trigger(eventname, [pos, item]);
			}
	
			function highlight(s, auto) {
				//if (typeof s == "number") {
				//	s = series[s];
				//}
	
				var i = indexOfHighlight(s);
	
				if (i == -1) {
					highlights.push({ series: s, auto: auto });
					plot.triggerRedrawOverlay();
				} else if (!auto) {
					highlights[i].auto = false;
				}
			}
	
			function unhighlight(s) {
				if (s == null) {
					highlights = [];
					plot.triggerRedrawOverlay();
				}
	
				//if (typeof s == "number") {
				//	s = series[s];
				//}
	
				var i = indexOfHighlight(s);
	
				if (i != -1) {
					highlights.splice(i, 1);
					plot.triggerRedrawOverlay();
				}
			}
	
			function indexOfHighlight(s) {
				for (var i = 0; i < highlights.length; ++i) {
					var h = highlights[i];
					if (h.series == s)
						return i;
				}
				return -1;
			}
	
			function drawOverlay(plot, octx) {
	
				var options = plot.getOptions();
	
				var radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius;
	
				octx.save();
				octx.translate(centerLeft, centerTop);
				octx.scale(1, options.series.pie.tilt);
	
				for (var i = 0; i < highlights.length; ++i) {
					drawHighlight(highlights[i].series);
				}
	
				drawDonutHole(octx);
	
				octx.restore();
	
				function drawHighlight(series) {
	
					if (series.angle <= 0 || isNaN(series.angle)) {
						return;
					}
	
					//octx.fillStyle = parseColor(options.series.pie.highlight.color).scale(null, null, null, options.series.pie.highlight.opacity).toString();
					octx.fillStyle = "rgba(255, 255, 255, " + options.series.pie.highlight.opacity + ")"; // this is temporary until we have access to parseColor
					octx.beginPath();
					if (Math.abs(series.angle - Math.PI * 2) > 0.000000001) {
						octx.moveTo(0, 0); // Center of the pie
					}
					octx.arc(0, 0, radius, series.startAngle, series.startAngle + series.angle / 2, false);
					octx.arc(0, 0, radius, series.startAngle + series.angle / 2, series.startAngle + series.angle, false);
					octx.closePath();
					octx.fill();
				}
			}
		} // end init (plugin body)
	
		// define pie specific options and their default values
	
		var options = {
			series: {
				pie: {
					show: false,
					radius: "auto",	// actual radius of the visible pie (based on full calculated radius if <=1, or hard pixel value)
					innerRadius: 0, /* for donut */
					startAngle: 3/2,
					tilt: 1,
					shadow: {
						left: 5,	// shadow left offset
						top: 15,	// shadow top offset
						alpha: 0.02	// shadow alpha
					},
					offset: {
						top: 0,
						left: "auto"
					},
					stroke: {
						color: "#fff",
						width: 1
					},
					label: {
						show: "auto",
						formatter: function(label, slice) {
							return "<div style='font-size:x-small;text-align:center;padding:2px;color:" + slice.color + ";'>" + label + "<br/>" + Math.round(slice.percent) + "%</div>";
						},	// formatter function
						radius: 1,	// radius at which to place the labels (based on full calculated radius if <=1, or hard pixel value)
						background: {
							color: null,
							opacity: 0
						},
						threshold: 0	// percentage at which to hide the label (i.e. the slice is too narrow)
					},
					combine: {
						threshold: -1,	// percentage at which to combine little slices into one larger slice
						color: null,	// color to give the new slice (auto-generated if null)
						label: "Other"	// label to give the new slice
					},
					highlight: {
						//color: "#fff",		// will add this functionality once parseColor is available
						opacity: 0.5
					}
				}
			}
		};
	
		$.plot.plugins.push({
			init: init,
			options: options,
			name: "pie",
			version: "1.1"
		});
	
	})(jQuery);


/***/ },

/***/ 1107:
/***/ function(module, exports) {

	/* Flot plugin for automatically redrawing plots as the placeholder resizes.
	
	Copyright (c) 2007-2014 IOLA and Ole Laursen.
	Licensed under the MIT license.
	
	It works by listening for changes on the placeholder div (through the jQuery
	resize event plugin) - if the size changes, it will redraw the plot.
	
	There are no options. If you need to disable the plugin for some plots, you
	can just fix the size of their placeholders.
	
	*/
	
	/* Inline dependency:
	 * jQuery resize event - v1.1 - 3/14/2010
	 * http://benalman.com/projects/jquery-resize-plugin/
	 *
	 * Copyright (c) 2010 "Cowboy" Ben Alman
	 * Dual licensed under the MIT and GPL licenses.
	 * http://benalman.com/about/license/
	 */
	(function($,e,t){"$:nomunge";var i=[],n=$.resize=$.extend($.resize,{}),a,r=false,s="setTimeout",u="resize",m=u+"-special-event",o="pendingDelay",l="activeDelay",f="throttleWindow";n[o]=200;n[l]=20;n[f]=true;$.event.special[u]={setup:function(){if(!n[f]&&this[s]){return false}var e=$(this);i.push(this);e.data(m,{w:e.width(),h:e.height()});if(i.length===1){a=t;h()}},teardown:function(){if(!n[f]&&this[s]){return false}var e=$(this);for(var t=i.length-1;t>=0;t--){if(i[t]==this){i.splice(t,1);break}}e.removeData(m);if(!i.length){if(r){cancelAnimationFrame(a)}else{clearTimeout(a)}a=null}},add:function(e){if(!n[f]&&this[s]){return false}var i;function a(e,n,a){var r=$(this),s=r.data(m)||{};s.w=n!==t?n:r.width();s.h=a!==t?a:r.height();i.apply(this,arguments)}if($.isFunction(e)){i=e;return a}else{i=e.handler;e.handler=a}}};function h(t){if(r===true){r=t||1}for(var s=i.length-1;s>=0;s--){var l=$(i[s]);if(l[0]==e||l.is(":visible")){var f=l.width(),c=l.height(),d=l.data(m);if(d&&(f!==d.w||c!==d.h)){l.trigger(u,[d.w=f,d.h=c]);r=t||true}}else{d=l.data(m);d.w=0;d.h=0}}if(a!==null){if(r&&(t==null||t-r<1e3)){a=e.requestAnimationFrame(h)}else{a=setTimeout(h,n[o]);r=false}}}if(!e.requestAnimationFrame){e.requestAnimationFrame=function(){return e.webkitRequestAnimationFrame||e.mozRequestAnimationFrame||e.oRequestAnimationFrame||e.msRequestAnimationFrame||function(t,i){return e.setTimeout(function(){t((new Date).getTime())},n[l])}}()}if(!e.cancelAnimationFrame){e.cancelAnimationFrame=function(){return e.webkitCancelRequestAnimationFrame||e.mozCancelRequestAnimationFrame||e.oCancelRequestAnimationFrame||e.msCancelRequestAnimationFrame||clearTimeout}()}})(jQuery,this);
	
	(function ($) {
	    var options = { }; // no options
	
	    function init(plot) {
	        function onResize() {
	            var placeholder = plot.getPlaceholder();
	
	            // somebody might have hidden us and we can't plot
	            // when we don't have the dimensions
	            if (placeholder.width() == 0 || placeholder.height() == 0)
	                return;
	
	            plot.resize();
	            plot.setupGrid();
	            plot.draw();
	        }
	        
	        function bindEvents(plot, eventHolder) {
	            plot.getPlaceholder().resize(onResize);
	        }
	
	        function shutdown(plot, eventHolder) {
	            plot.getPlaceholder().unbind("resize", onResize);
	        }
	        
	        plot.hooks.bindEvents.push(bindEvents);
	        plot.hooks.shutdown.push(shutdown);
	    }
	    
	    $.plot.plugins.push({
	        init: init,
	        options: options,
	        name: 'resize',
	        version: '1.0'
	    });
	})(jQuery);


/***/ },

/***/ 1108:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jQuery UI - v1.11.4 - 2015-09-20
	* http://jqueryui.com
	* Includes: core.js, widget.js, mouse.js, position.js, draggable.js, droppable.js, resizable.js, selectable.js, sortable.js, slider.js
	* Copyright 2015 jQuery Foundation and other contributors; Licensed MIT */
	
	(function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(10) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}(function( $ ) {
	/*!
	 * jQuery UI Core 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	
	// $.ui might exist from components with no dependencies, e.g., $.ui.position
	$.ui = $.ui || {};
	
	$.extend( $.ui, {
		version: "1.11.4",
	
		keyCode: {
			BACKSPACE: 8,
			COMMA: 188,
			DELETE: 46,
			DOWN: 40,
			END: 35,
			ENTER: 13,
			ESCAPE: 27,
			HOME: 36,
			LEFT: 37,
			PAGE_DOWN: 34,
			PAGE_UP: 33,
			PERIOD: 190,
			RIGHT: 39,
			SPACE: 32,
			TAB: 9,
			UP: 38
		}
	});
	
	// plugins
	$.fn.extend({
		scrollParent: function( includeHidden ) {
			var position = this.css( "position" ),
				excludeStaticParent = position === "absolute",
				overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
				scrollParent = this.parents().filter( function() {
					var parent = $( this );
					if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
						return false;
					}
					return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) + parent.css( "overflow-x" ) );
				}).eq( 0 );
	
			return position === "fixed" || !scrollParent.length ? $( this[ 0 ].ownerDocument || document ) : scrollParent;
		},
	
		uniqueId: (function() {
			var uuid = 0;
	
			return function() {
				return this.each(function() {
					if ( !this.id ) {
						this.id = "ui-id-" + ( ++uuid );
					}
				});
			};
		})(),
	
		removeUniqueId: function() {
			return this.each(function() {
				if ( /^ui-id-\d+$/.test( this.id ) ) {
					$( this ).removeAttr( "id" );
				}
			});
		}
	});
	
	// selectors
	function focusable( element, isTabIndexNotNaN ) {
		var map, mapName, img,
			nodeName = element.nodeName.toLowerCase();
		if ( "area" === nodeName ) {
			map = element.parentNode;
			mapName = map.name;
			if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
				return false;
			}
			img = $( "img[usemap='#" + mapName + "']" )[ 0 ];
			return !!img && visible( img );
		}
		return ( /^(input|select|textarea|button|object)$/.test( nodeName ) ?
			!element.disabled :
			"a" === nodeName ?
				element.href || isTabIndexNotNaN :
				isTabIndexNotNaN) &&
			// the element and all of its ancestors must be visible
			visible( element );
	}
	
	function visible( element ) {
		return $.expr.filters.visible( element ) &&
			!$( element ).parents().addBack().filter(function() {
				return $.css( this, "visibility" ) === "hidden";
			}).length;
	}
	
	$.extend( $.expr[ ":" ], {
		data: $.expr.createPseudo ?
			$.expr.createPseudo(function( dataName ) {
				return function( elem ) {
					return !!$.data( elem, dataName );
				};
			}) :
			// support: jQuery <1.8
			function( elem, i, match ) {
				return !!$.data( elem, match[ 3 ] );
			},
	
		focusable: function( element ) {
			return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
		},
	
		tabbable: function( element ) {
			var tabIndex = $.attr( element, "tabindex" ),
				isTabIndexNaN = isNaN( tabIndex );
			return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
		}
	});
	
	// support: jQuery <1.8
	if ( !$( "<a>" ).outerWidth( 1 ).jquery ) {
		$.each( [ "Width", "Height" ], function( i, name ) {
			var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
				type = name.toLowerCase(),
				orig = {
					innerWidth: $.fn.innerWidth,
					innerHeight: $.fn.innerHeight,
					outerWidth: $.fn.outerWidth,
					outerHeight: $.fn.outerHeight
				};
	
			function reduce( elem, size, border, margin ) {
				$.each( side, function() {
					size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
					if ( border ) {
						size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
					}
					if ( margin ) {
						size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
					}
				});
				return size;
			}
	
			$.fn[ "inner" + name ] = function( size ) {
				if ( size === undefined ) {
					return orig[ "inner" + name ].call( this );
				}
	
				return this.each(function() {
					$( this ).css( type, reduce( this, size ) + "px" );
				});
			};
	
			$.fn[ "outer" + name] = function( size, margin ) {
				if ( typeof size !== "number" ) {
					return orig[ "outer" + name ].call( this, size );
				}
	
				return this.each(function() {
					$( this).css( type, reduce( this, size, true, margin ) + "px" );
				});
			};
		});
	}
	
	// support: jQuery <1.8
	if ( !$.fn.addBack ) {
		$.fn.addBack = function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		};
	}
	
	// support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
	if ( $( "<a>" ).data( "a-b", "a" ).removeData( "a-b" ).data( "a-b" ) ) {
		$.fn.removeData = (function( removeData ) {
			return function( key ) {
				if ( arguments.length ) {
					return removeData.call( this, $.camelCase( key ) );
				} else {
					return removeData.call( this );
				}
			};
		})( $.fn.removeData );
	}
	
	// deprecated
	$.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );
	
	$.fn.extend({
		focus: (function( orig ) {
			return function( delay, fn ) {
				return typeof delay === "number" ?
					this.each(function() {
						var elem = this;
						setTimeout(function() {
							$( elem ).focus();
							if ( fn ) {
								fn.call( elem );
							}
						}, delay );
					}) :
					orig.apply( this, arguments );
			};
		})( $.fn.focus ),
	
		disableSelection: (function() {
			var eventType = "onselectstart" in document.createElement( "div" ) ?
				"selectstart" :
				"mousedown";
	
			return function() {
				return this.bind( eventType + ".ui-disableSelection", function( event ) {
					event.preventDefault();
				});
			};
		})(),
	
		enableSelection: function() {
			return this.unbind( ".ui-disableSelection" );
		},
	
		zIndex: function( zIndex ) {
			if ( zIndex !== undefined ) {
				return this.css( "zIndex", zIndex );
			}
	
			if ( this.length ) {
				var elem = $( this[ 0 ] ), position, value;
				while ( elem.length && elem[ 0 ] !== document ) {
					// Ignore z-index if position is set to a value where z-index is ignored by the browser
					// This makes behavior of this function consistent across browsers
					// WebKit always returns auto if the element is positioned
					position = elem.css( "position" );
					if ( position === "absolute" || position === "relative" || position === "fixed" ) {
						// IE returns 0 when zIndex is not specified
						// other browsers return a string
						// we ignore the case of nested elements with an explicit value of 0
						// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
						value = parseInt( elem.css( "zIndex" ), 10 );
						if ( !isNaN( value ) && value !== 0 ) {
							return value;
						}
					}
					elem = elem.parent();
				}
			}
	
			return 0;
		}
	});
	
	// $.ui.plugin is deprecated. Use $.widget() extensions instead.
	$.ui.plugin = {
		add: function( module, option, set ) {
			var i,
				proto = $.ui[ module ].prototype;
			for ( i in set ) {
				proto.plugins[ i ] = proto.plugins[ i ] || [];
				proto.plugins[ i ].push( [ option, set[ i ] ] );
			}
		},
		call: function( instance, name, args, allowDisconnected ) {
			var i,
				set = instance.plugins[ name ];
	
			if ( !set ) {
				return;
			}
	
			if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode || instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
				return;
			}
	
			for ( i = 0; i < set.length; i++ ) {
				if ( instance.options[ set[ i ][ 0 ] ] ) {
					set[ i ][ 1 ].apply( instance.element, args );
				}
			}
		}
	};
	
	
	/*!
	 * jQuery UI Widget 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/jQuery.widget/
	 */
	
	
	var widget_uuid = 0,
		widget_slice = Array.prototype.slice;
	
	$.cleanData = (function( orig ) {
		return function( elems ) {
			var events, elem, i;
			for ( i = 0; (elem = elems[i]) != null; i++ ) {
				try {
	
					// Only trigger remove when necessary to save time
					events = $._data( elem, "events" );
					if ( events && events.remove ) {
						$( elem ).triggerHandler( "remove" );
					}
	
				// http://bugs.jquery.com/ticket/8235
				} catch ( e ) {}
			}
			orig( elems );
		};
	})( $.cleanData );
	
	$.widget = function( name, base, prototype ) {
		var fullName, existingConstructor, constructor, basePrototype,
			// proxiedPrototype allows the provided prototype to remain unmodified
			// so that it can be used as a mixin for multiple widgets (#8876)
			proxiedPrototype = {},
			namespace = name.split( "." )[ 0 ];
	
		name = name.split( "." )[ 1 ];
		fullName = namespace + "-" + name;
	
		if ( !prototype ) {
			prototype = base;
			base = $.Widget;
		}
	
		// create selector for plugin
		$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
			return !!$.data( elem, fullName );
		};
	
		$[ namespace ] = $[ namespace ] || {};
		existingConstructor = $[ namespace ][ name ];
		constructor = $[ namespace ][ name ] = function( options, element ) {
			// allow instantiation without "new" keyword
			if ( !this._createWidget ) {
				return new constructor( options, element );
			}
	
			// allow instantiation without initializing for simple inheritance
			// must use "new" keyword (the code above always passes args)
			if ( arguments.length ) {
				this._createWidget( options, element );
			}
		};
		// extend with the existing constructor to carry over any static properties
		$.extend( constructor, existingConstructor, {
			version: prototype.version,
			// copy the object used to create the prototype in case we need to
			// redefine the widget later
			_proto: $.extend( {}, prototype ),
			// track widgets that inherit from this widget in case this widget is
			// redefined after a widget inherits from it
			_childConstructors: []
		});
	
		basePrototype = new base();
		// we need to make the options hash a property directly on the new instance
		// otherwise we'll modify the options hash on the prototype that we're
		// inheriting from
		basePrototype.options = $.widget.extend( {}, basePrototype.options );
		$.each( prototype, function( prop, value ) {
			if ( !$.isFunction( value ) ) {
				proxiedPrototype[ prop ] = value;
				return;
			}
			proxiedPrototype[ prop ] = (function() {
				var _super = function() {
						return base.prototype[ prop ].apply( this, arguments );
					},
					_superApply = function( args ) {
						return base.prototype[ prop ].apply( this, args );
					};
				return function() {
					var __super = this._super,
						__superApply = this._superApply,
						returnValue;
	
					this._super = _super;
					this._superApply = _superApply;
	
					returnValue = value.apply( this, arguments );
	
					this._super = __super;
					this._superApply = __superApply;
	
					return returnValue;
				};
			})();
		});
		constructor.prototype = $.widget.extend( basePrototype, {
			// TODO: remove support for widgetEventPrefix
			// always use the name + a colon as the prefix, e.g., draggable:start
			// don't prefix for widgets that aren't DOM-based
			widgetEventPrefix: existingConstructor ? (basePrototype.widgetEventPrefix || name) : name
		}, proxiedPrototype, {
			constructor: constructor,
			namespace: namespace,
			widgetName: name,
			widgetFullName: fullName
		});
	
		// If this widget is being redefined then we need to find all widgets that
		// are inheriting from it and redefine all of them so that they inherit from
		// the new version of this widget. We're essentially trying to replace one
		// level in the prototype chain.
		if ( existingConstructor ) {
			$.each( existingConstructor._childConstructors, function( i, child ) {
				var childPrototype = child.prototype;
	
				// redefine the child widget using the same prototype that was
				// originally used, but inherit from the new version of the base
				$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
			});
			// remove the list of existing child constructors from the old constructor
			// so the old child constructors can be garbage collected
			delete existingConstructor._childConstructors;
		} else {
			base._childConstructors.push( constructor );
		}
	
		$.widget.bridge( name, constructor );
	
		return constructor;
	};
	
	$.widget.extend = function( target ) {
		var input = widget_slice.call( arguments, 1 ),
			inputIndex = 0,
			inputLength = input.length,
			key,
			value;
		for ( ; inputIndex < inputLength; inputIndex++ ) {
			for ( key in input[ inputIndex ] ) {
				value = input[ inputIndex ][ key ];
				if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
					// Clone objects
					if ( $.isPlainObject( value ) ) {
						target[ key ] = $.isPlainObject( target[ key ] ) ?
							$.widget.extend( {}, target[ key ], value ) :
							// Don't extend strings, arrays, etc. with objects
							$.widget.extend( {}, value );
					// Copy everything else by reference
					} else {
						target[ key ] = value;
					}
				}
			}
		}
		return target;
	};
	
	$.widget.bridge = function( name, object ) {
		var fullName = object.prototype.widgetFullName || name;
		$.fn[ name ] = function( options ) {
			var isMethodCall = typeof options === "string",
				args = widget_slice.call( arguments, 1 ),
				returnValue = this;
	
			if ( isMethodCall ) {
				this.each(function() {
					var methodValue,
						instance = $.data( this, fullName );
					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}
					if ( !instance ) {
						return $.error( "cannot call methods on " + name + " prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}
					if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name + " widget instance" );
					}
					methodValue = instance[ options ].apply( instance, args );
					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				});
			} else {
	
				// Allow multiple hashes to be passed on init
				if ( args.length ) {
					options = $.widget.extend.apply( null, [ options ].concat(args) );
				}
	
				this.each(function() {
					var instance = $.data( this, fullName );
					if ( instance ) {
						instance.option( options || {} );
						if ( instance._init ) {
							instance._init();
						}
					} else {
						$.data( this, fullName, new object( options, this ) );
					}
				});
			}
	
			return returnValue;
		};
	};
	
	$.Widget = function( /* options, element */ ) {};
	$.Widget._childConstructors = [];
	
	$.Widget.prototype = {
		widgetName: "widget",
		widgetEventPrefix: "",
		defaultElement: "<div>",
		options: {
			disabled: false,
	
			// callbacks
			create: null
		},
		_createWidget: function( options, element ) {
			element = $( element || this.defaultElement || this )[ 0 ];
			this.element = $( element );
			this.uuid = widget_uuid++;
			this.eventNamespace = "." + this.widgetName + this.uuid;
	
			this.bindings = $();
			this.hoverable = $();
			this.focusable = $();
	
			if ( element !== this ) {
				$.data( element, this.widgetFullName, this );
				this._on( true, this.element, {
					remove: function( event ) {
						if ( event.target === element ) {
							this.destroy();
						}
					}
				});
				this.document = $( element.style ?
					// element within the document
					element.ownerDocument :
					// element is window or document
					element.document || element );
				this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
			}
	
			this.options = $.widget.extend( {},
				this.options,
				this._getCreateOptions(),
				options );
	
			this._create();
			this._trigger( "create", null, this._getCreateEventData() );
			this._init();
		},
		_getCreateOptions: $.noop,
		_getCreateEventData: $.noop,
		_create: $.noop,
		_init: $.noop,
	
		destroy: function() {
			this._destroy();
			// we can probably remove the unbind calls in 2.0
			// all event bindings should go through this._on()
			this.element
				.unbind( this.eventNamespace )
				.removeData( this.widgetFullName )
				// support: jquery <1.6.3
				// http://bugs.jquery.com/ticket/9413
				.removeData( $.camelCase( this.widgetFullName ) );
			this.widget()
				.unbind( this.eventNamespace )
				.removeAttr( "aria-disabled" )
				.removeClass(
					this.widgetFullName + "-disabled " +
					"ui-state-disabled" );
	
			// clean up events and states
			this.bindings.unbind( this.eventNamespace );
			this.hoverable.removeClass( "ui-state-hover" );
			this.focusable.removeClass( "ui-state-focus" );
		},
		_destroy: $.noop,
	
		widget: function() {
			return this.element;
		},
	
		option: function( key, value ) {
			var options = key,
				parts,
				curOption,
				i;
	
			if ( arguments.length === 0 ) {
				// don't return a reference to the internal hash
				return $.widget.extend( {}, this.options );
			}
	
			if ( typeof key === "string" ) {
				// handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
				options = {};
				parts = key.split( "." );
				key = parts.shift();
				if ( parts.length ) {
					curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
					for ( i = 0; i < parts.length - 1; i++ ) {
						curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
						curOption = curOption[ parts[ i ] ];
					}
					key = parts.pop();
					if ( arguments.length === 1 ) {
						return curOption[ key ] === undefined ? null : curOption[ key ];
					}
					curOption[ key ] = value;
				} else {
					if ( arguments.length === 1 ) {
						return this.options[ key ] === undefined ? null : this.options[ key ];
					}
					options[ key ] = value;
				}
			}
	
			this._setOptions( options );
	
			return this;
		},
		_setOptions: function( options ) {
			var key;
	
			for ( key in options ) {
				this._setOption( key, options[ key ] );
			}
	
			return this;
		},
		_setOption: function( key, value ) {
			this.options[ key ] = value;
	
			if ( key === "disabled" ) {
				this.widget()
					.toggleClass( this.widgetFullName + "-disabled", !!value );
	
				// If the widget is becoming disabled, then nothing is interactive
				if ( value ) {
					this.hoverable.removeClass( "ui-state-hover" );
					this.focusable.removeClass( "ui-state-focus" );
				}
			}
	
			return this;
		},
	
		enable: function() {
			return this._setOptions({ disabled: false });
		},
		disable: function() {
			return this._setOptions({ disabled: true });
		},
	
		_on: function( suppressDisabledCheck, element, handlers ) {
			var delegateElement,
				instance = this;
	
			// no suppressDisabledCheck flag, shuffle arguments
			if ( typeof suppressDisabledCheck !== "boolean" ) {
				handlers = element;
				element = suppressDisabledCheck;
				suppressDisabledCheck = false;
			}
	
			// no element argument, shuffle and use this.element
			if ( !handlers ) {
				handlers = element;
				element = this.element;
				delegateElement = this.widget();
			} else {
				element = delegateElement = $( element );
				this.bindings = this.bindings.add( element );
			}
	
			$.each( handlers, function( event, handler ) {
				function handlerProxy() {
					// allow widgets to customize the disabled handling
					// - disabled as an array instead of boolean
					// - disabled class as method for disabling individual parts
					if ( !suppressDisabledCheck &&
							( instance.options.disabled === true ||
								$( this ).hasClass( "ui-state-disabled" ) ) ) {
						return;
					}
					return ( typeof handler === "string" ? instance[ handler ] : handler )
						.apply( instance, arguments );
				}
	
				// copy the guid so direct unbinding works
				if ( typeof handler !== "string" ) {
					handlerProxy.guid = handler.guid =
						handler.guid || handlerProxy.guid || $.guid++;
				}
	
				var match = event.match( /^([\w:-]*)\s*(.*)$/ ),
					eventName = match[1] + instance.eventNamespace,
					selector = match[2];
				if ( selector ) {
					delegateElement.delegate( selector, eventName, handlerProxy );
				} else {
					element.bind( eventName, handlerProxy );
				}
			});
		},
	
		_off: function( element, eventName ) {
			eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) +
				this.eventNamespace;
			element.unbind( eventName ).undelegate( eventName );
	
			// Clear the stack to avoid memory leaks (#10056)
			this.bindings = $( this.bindings.not( element ).get() );
			this.focusable = $( this.focusable.not( element ).get() );
			this.hoverable = $( this.hoverable.not( element ).get() );
		},
	
		_delay: function( handler, delay ) {
			function handlerProxy() {
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}
			var instance = this;
			return setTimeout( handlerProxy, delay || 0 );
		},
	
		_hoverable: function( element ) {
			this.hoverable = this.hoverable.add( element );
			this._on( element, {
				mouseenter: function( event ) {
					$( event.currentTarget ).addClass( "ui-state-hover" );
				},
				mouseleave: function( event ) {
					$( event.currentTarget ).removeClass( "ui-state-hover" );
				}
			});
		},
	
		_focusable: function( element ) {
			this.focusable = this.focusable.add( element );
			this._on( element, {
				focusin: function( event ) {
					$( event.currentTarget ).addClass( "ui-state-focus" );
				},
				focusout: function( event ) {
					$( event.currentTarget ).removeClass( "ui-state-focus" );
				}
			});
		},
	
		_trigger: function( type, event, data ) {
			var prop, orig,
				callback = this.options[ type ];
	
			data = data || {};
			event = $.Event( event );
			event.type = ( type === this.widgetEventPrefix ?
				type :
				this.widgetEventPrefix + type ).toLowerCase();
			// the original event may come from any element
			// so we need to reset the target on the new event
			event.target = this.element[ 0 ];
	
			// copy original event properties over to the new event
			orig = event.originalEvent;
			if ( orig ) {
				for ( prop in orig ) {
					if ( !( prop in event ) ) {
						event[ prop ] = orig[ prop ];
					}
				}
			}
	
			this.element.trigger( event, data );
			return !( $.isFunction( callback ) &&
				callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
				event.isDefaultPrevented() );
		}
	};
	
	$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
		$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
			if ( typeof options === "string" ) {
				options = { effect: options };
			}
			var hasOptions,
				effectName = !options ?
					method :
					options === true || typeof options === "number" ?
						defaultEffect :
						options.effect || defaultEffect;
			options = options || {};
			if ( typeof options === "number" ) {
				options = { duration: options };
			}
			hasOptions = !$.isEmptyObject( options );
			options.complete = callback;
			if ( options.delay ) {
				element.delay( options.delay );
			}
			if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
				element[ method ]( options );
			} else if ( effectName !== method && element[ effectName ] ) {
				element[ effectName ]( options.duration, options.easing, callback );
			} else {
				element.queue(function( next ) {
					$( this )[ method ]();
					if ( callback ) {
						callback.call( element[ 0 ] );
					}
					next();
				});
			}
		};
	});
	
	var widget = $.widget;
	
	
	/*!
	 * jQuery UI Mouse 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/mouse/
	 */
	
	
	var mouseHandled = false;
	$( document ).mouseup( function() {
		mouseHandled = false;
	});
	
	var mouse = $.widget("ui.mouse", {
		version: "1.11.4",
		options: {
			cancel: "input,textarea,button,select,option",
			distance: 1,
			delay: 0
		},
		_mouseInit: function() {
			var that = this;
	
			this.element
				.bind("mousedown." + this.widgetName, function(event) {
					return that._mouseDown(event);
				})
				.bind("click." + this.widgetName, function(event) {
					if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
						$.removeData(event.target, that.widgetName + ".preventClickEvent");
						event.stopImmediatePropagation();
						return false;
					}
				});
	
			this.started = false;
		},
	
		// TODO: make sure destroying one instance of mouse doesn't mess with
		// other instances of mouse
		_mouseDestroy: function() {
			this.element.unbind("." + this.widgetName);
			if ( this._mouseMoveDelegate ) {
				this.document
					.unbind("mousemove." + this.widgetName, this._mouseMoveDelegate)
					.unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
			}
		},
	
		_mouseDown: function(event) {
			// don't let more than one widget handle mouseStart
			if ( mouseHandled ) {
				return;
			}
	
			this._mouseMoved = false;
	
			// we may have missed mouseup (out of window)
			(this._mouseStarted && this._mouseUp(event));
	
			this._mouseDownEvent = event;
	
			var that = this,
				btnIsLeft = (event.which === 1),
				// event.target.nodeName works around a bug in IE 8 with
				// disabled inputs (#7620)
				elIsCancel = (typeof this.options.cancel === "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false);
			if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
				return true;
			}
	
			this.mouseDelayMet = !this.options.delay;
			if (!this.mouseDelayMet) {
				this._mouseDelayTimer = setTimeout(function() {
					that.mouseDelayMet = true;
				}, this.options.delay);
			}
	
			if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
				this._mouseStarted = (this._mouseStart(event) !== false);
				if (!this._mouseStarted) {
					event.preventDefault();
					return true;
				}
			}
	
			// Click event may never have fired (Gecko & Opera)
			if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) {
				$.removeData(event.target, this.widgetName + ".preventClickEvent");
			}
	
			// these delegates are required to keep context
			this._mouseMoveDelegate = function(event) {
				return that._mouseMove(event);
			};
			this._mouseUpDelegate = function(event) {
				return that._mouseUp(event);
			};
	
			this.document
				.bind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.bind( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			event.preventDefault();
	
			mouseHandled = true;
			return true;
		},
	
		_mouseMove: function(event) {
			// Only check for mouseups outside the document if you've moved inside the document
			// at least once. This prevents the firing of mouseup in the case of IE<9, which will
			// fire a mousemove event if content is placed under the cursor. See #7778
			// Support: IE <9
			if ( this._mouseMoved ) {
				// IE mouseup check - mouseup happened when mouse was out of window
				if ($.ui.ie && ( !document.documentMode || document.documentMode < 9 ) && !event.button) {
					return this._mouseUp(event);
	
				// Iframe mouseup check - mouseup occurred in another document
				} else if ( !event.which ) {
					return this._mouseUp( event );
				}
			}
	
			if ( event.which || event.button ) {
				this._mouseMoved = true;
			}
	
			if (this._mouseStarted) {
				this._mouseDrag(event);
				return event.preventDefault();
			}
	
			if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
				this._mouseStarted =
					(this._mouseStart(this._mouseDownEvent, event) !== false);
				(this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event));
			}
	
			return !this._mouseStarted;
		},
	
		_mouseUp: function(event) {
			this.document
				.unbind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.unbind( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			if (this._mouseStarted) {
				this._mouseStarted = false;
	
				if (event.target === this._mouseDownEvent.target) {
					$.data(event.target, this.widgetName + ".preventClickEvent", true);
				}
	
				this._mouseStop(event);
			}
	
			mouseHandled = false;
			return false;
		},
	
		_mouseDistanceMet: function(event) {
			return (Math.max(
					Math.abs(this._mouseDownEvent.pageX - event.pageX),
					Math.abs(this._mouseDownEvent.pageY - event.pageY)
				) >= this.options.distance
			);
		},
	
		_mouseDelayMet: function(/* event */) {
			return this.mouseDelayMet;
		},
	
		// These are placeholder methods, to be overriden by extending plugin
		_mouseStart: function(/* event */) {},
		_mouseDrag: function(/* event */) {},
		_mouseStop: function(/* event */) {},
		_mouseCapture: function(/* event */) { return true; }
	});
	
	
	/*!
	 * jQuery UI Position 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/position/
	 */
	
	(function() {
	
	$.ui = $.ui || {};
	
	var cachedScrollbarWidth, supportsOffsetFractions,
		max = Math.max,
		abs = Math.abs,
		round = Math.round,
		rhorizontal = /left|center|right/,
		rvertical = /top|center|bottom/,
		roffset = /[\+\-]\d+(\.[\d]+)?%?/,
		rposition = /^\w+/,
		rpercent = /%$/,
		_position = $.fn.position;
	
	function getOffsets( offsets, width, height ) {
		return [
			parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
			parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
		];
	}
	
	function parseCss( element, property ) {
		return parseInt( $.css( element, property ), 10 ) || 0;
	}
	
	function getDimensions( elem ) {
		var raw = elem[0];
		if ( raw.nodeType === 9 ) {
			return {
				width: elem.width(),
				height: elem.height(),
				offset: { top: 0, left: 0 }
			};
		}
		if ( $.isWindow( raw ) ) {
			return {
				width: elem.width(),
				height: elem.height(),
				offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
			};
		}
		if ( raw.preventDefault ) {
			return {
				width: 0,
				height: 0,
				offset: { top: raw.pageY, left: raw.pageX }
			};
		}
		return {
			width: elem.outerWidth(),
			height: elem.outerHeight(),
			offset: elem.offset()
		};
	}
	
	$.position = {
		scrollbarWidth: function() {
			if ( cachedScrollbarWidth !== undefined ) {
				return cachedScrollbarWidth;
			}
			var w1, w2,
				div = $( "<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>" ),
				innerDiv = div.children()[0];
	
			$( "body" ).append( div );
			w1 = innerDiv.offsetWidth;
			div.css( "overflow", "scroll" );
	
			w2 = innerDiv.offsetWidth;
	
			if ( w1 === w2 ) {
				w2 = div[0].clientWidth;
			}
	
			div.remove();
	
			return (cachedScrollbarWidth = w1 - w2);
		},
		getScrollInfo: function( within ) {
			var overflowX = within.isWindow || within.isDocument ? "" :
					within.element.css( "overflow-x" ),
				overflowY = within.isWindow || within.isDocument ? "" :
					within.element.css( "overflow-y" ),
				hasOverflowX = overflowX === "scroll" ||
					( overflowX === "auto" && within.width < within.element[0].scrollWidth ),
				hasOverflowY = overflowY === "scroll" ||
					( overflowY === "auto" && within.height < within.element[0].scrollHeight );
			return {
				width: hasOverflowY ? $.position.scrollbarWidth() : 0,
				height: hasOverflowX ? $.position.scrollbarWidth() : 0
			};
		},
		getWithinInfo: function( element ) {
			var withinElement = $( element || window ),
				isWindow = $.isWindow( withinElement[0] ),
				isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9;
			return {
				element: withinElement,
				isWindow: isWindow,
				isDocument: isDocument,
				offset: withinElement.offset() || { left: 0, top: 0 },
				scrollLeft: withinElement.scrollLeft(),
				scrollTop: withinElement.scrollTop(),
	
				// support: jQuery 1.6.x
				// jQuery 1.6 doesn't support .outerWidth/Height() on documents or windows
				width: isWindow || isDocument ? withinElement.width() : withinElement.outerWidth(),
				height: isWindow || isDocument ? withinElement.height() : withinElement.outerHeight()
			};
		}
	};
	
	$.fn.position = function( options ) {
		if ( !options || !options.of ) {
			return _position.apply( this, arguments );
		}
	
		// make a copy, we don't want to modify arguments
		options = $.extend( {}, options );
	
		var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
			target = $( options.of ),
			within = $.position.getWithinInfo( options.within ),
			scrollInfo = $.position.getScrollInfo( within ),
			collision = ( options.collision || "flip" ).split( " " ),
			offsets = {};
	
		dimensions = getDimensions( target );
		if ( target[0].preventDefault ) {
			// force left top to allow flipping
			options.at = "left top";
		}
		targetWidth = dimensions.width;
		targetHeight = dimensions.height;
		targetOffset = dimensions.offset;
		// clone to reuse original targetOffset later
		basePosition = $.extend( {}, targetOffset );
	
		// force my and at to have valid horizontal and vertical positions
		// if a value is missing or invalid, it will be converted to center
		$.each( [ "my", "at" ], function() {
			var pos = ( options[ this ] || "" ).split( " " ),
				horizontalOffset,
				verticalOffset;
	
			if ( pos.length === 1) {
				pos = rhorizontal.test( pos[ 0 ] ) ?
					pos.concat( [ "center" ] ) :
					rvertical.test( pos[ 0 ] ) ?
						[ "center" ].concat( pos ) :
						[ "center", "center" ];
			}
			pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
			pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";
	
			// calculate offsets
			horizontalOffset = roffset.exec( pos[ 0 ] );
			verticalOffset = roffset.exec( pos[ 1 ] );
			offsets[ this ] = [
				horizontalOffset ? horizontalOffset[ 0 ] : 0,
				verticalOffset ? verticalOffset[ 0 ] : 0
			];
	
			// reduce to just the positions without the offsets
			options[ this ] = [
				rposition.exec( pos[ 0 ] )[ 0 ],
				rposition.exec( pos[ 1 ] )[ 0 ]
			];
		});
	
		// normalize collision option
		if ( collision.length === 1 ) {
			collision[ 1 ] = collision[ 0 ];
		}
	
		if ( options.at[ 0 ] === "right" ) {
			basePosition.left += targetWidth;
		} else if ( options.at[ 0 ] === "center" ) {
			basePosition.left += targetWidth / 2;
		}
	
		if ( options.at[ 1 ] === "bottom" ) {
			basePosition.top += targetHeight;
		} else if ( options.at[ 1 ] === "center" ) {
			basePosition.top += targetHeight / 2;
		}
	
		atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
		basePosition.left += atOffset[ 0 ];
		basePosition.top += atOffset[ 1 ];
	
		return this.each(function() {
			var collisionPosition, using,
				elem = $( this ),
				elemWidth = elem.outerWidth(),
				elemHeight = elem.outerHeight(),
				marginLeft = parseCss( this, "marginLeft" ),
				marginTop = parseCss( this, "marginTop" ),
				collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) + scrollInfo.width,
				collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) + scrollInfo.height,
				position = $.extend( {}, basePosition ),
				myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );
	
			if ( options.my[ 0 ] === "right" ) {
				position.left -= elemWidth;
			} else if ( options.my[ 0 ] === "center" ) {
				position.left -= elemWidth / 2;
			}
	
			if ( options.my[ 1 ] === "bottom" ) {
				position.top -= elemHeight;
			} else if ( options.my[ 1 ] === "center" ) {
				position.top -= elemHeight / 2;
			}
	
			position.left += myOffset[ 0 ];
			position.top += myOffset[ 1 ];
	
			// if the browser doesn't support fractions, then round for consistent results
			if ( !supportsOffsetFractions ) {
				position.left = round( position.left );
				position.top = round( position.top );
			}
	
			collisionPosition = {
				marginLeft: marginLeft,
				marginTop: marginTop
			};
	
			$.each( [ "left", "top" ], function( i, dir ) {
				if ( $.ui.position[ collision[ i ] ] ) {
					$.ui.position[ collision[ i ] ][ dir ]( position, {
						targetWidth: targetWidth,
						targetHeight: targetHeight,
						elemWidth: elemWidth,
						elemHeight: elemHeight,
						collisionPosition: collisionPosition,
						collisionWidth: collisionWidth,
						collisionHeight: collisionHeight,
						offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
						my: options.my,
						at: options.at,
						within: within,
						elem: elem
					});
				}
			});
	
			if ( options.using ) {
				// adds feedback as second argument to using callback, if present
				using = function( props ) {
					var left = targetOffset.left - position.left,
						right = left + targetWidth - elemWidth,
						top = targetOffset.top - position.top,
						bottom = top + targetHeight - elemHeight,
						feedback = {
							target: {
								element: target,
								left: targetOffset.left,
								top: targetOffset.top,
								width: targetWidth,
								height: targetHeight
							},
							element: {
								element: elem,
								left: position.left,
								top: position.top,
								width: elemWidth,
								height: elemHeight
							},
							horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
							vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
						};
					if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
						feedback.horizontal = "center";
					}
					if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
						feedback.vertical = "middle";
					}
					if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
						feedback.important = "horizontal";
					} else {
						feedback.important = "vertical";
					}
					options.using.call( this, props, feedback );
				};
			}
	
			elem.offset( $.extend( position, { using: using } ) );
		});
	};
	
	$.ui.position = {
		fit: {
			left: function( position, data ) {
				var within = data.within,
					withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
					outerWidth = within.width,
					collisionPosLeft = position.left - data.collisionPosition.marginLeft,
					overLeft = withinOffset - collisionPosLeft,
					overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
					newOverRight;
	
				// element is wider than within
				if ( data.collisionWidth > outerWidth ) {
					// element is initially over the left side of within
					if ( overLeft > 0 && overRight <= 0 ) {
						newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
						position.left += overLeft - newOverRight;
					// element is initially over right side of within
					} else if ( overRight > 0 && overLeft <= 0 ) {
						position.left = withinOffset;
					// element is initially over both left and right sides of within
					} else {
						if ( overLeft > overRight ) {
							position.left = withinOffset + outerWidth - data.collisionWidth;
						} else {
							position.left = withinOffset;
						}
					}
				// too far left -> align with left edge
				} else if ( overLeft > 0 ) {
					position.left += overLeft;
				// too far right -> align with right edge
				} else if ( overRight > 0 ) {
					position.left -= overRight;
				// adjust based on position and margin
				} else {
					position.left = max( position.left - collisionPosLeft, position.left );
				}
			},
			top: function( position, data ) {
				var within = data.within,
					withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
					outerHeight = data.within.height,
					collisionPosTop = position.top - data.collisionPosition.marginTop,
					overTop = withinOffset - collisionPosTop,
					overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
					newOverBottom;
	
				// element is taller than within
				if ( data.collisionHeight > outerHeight ) {
					// element is initially over the top of within
					if ( overTop > 0 && overBottom <= 0 ) {
						newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
						position.top += overTop - newOverBottom;
					// element is initially over bottom of within
					} else if ( overBottom > 0 && overTop <= 0 ) {
						position.top = withinOffset;
					// element is initially over both top and bottom of within
					} else {
						if ( overTop > overBottom ) {
							position.top = withinOffset + outerHeight - data.collisionHeight;
						} else {
							position.top = withinOffset;
						}
					}
				// too far up -> align with top
				} else if ( overTop > 0 ) {
					position.top += overTop;
				// too far down -> align with bottom edge
				} else if ( overBottom > 0 ) {
					position.top -= overBottom;
				// adjust based on position and margin
				} else {
					position.top = max( position.top - collisionPosTop, position.top );
				}
			}
		},
		flip: {
			left: function( position, data ) {
				var within = data.within,
					withinOffset = within.offset.left + within.scrollLeft,
					outerWidth = within.width,
					offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
					collisionPosLeft = position.left - data.collisionPosition.marginLeft,
					overLeft = collisionPosLeft - offsetLeft,
					overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
					myOffset = data.my[ 0 ] === "left" ?
						-data.elemWidth :
						data.my[ 0 ] === "right" ?
							data.elemWidth :
							0,
					atOffset = data.at[ 0 ] === "left" ?
						data.targetWidth :
						data.at[ 0 ] === "right" ?
							-data.targetWidth :
							0,
					offset = -2 * data.offset[ 0 ],
					newOverRight,
					newOverLeft;
	
				if ( overLeft < 0 ) {
					newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
					if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
						position.left += myOffset + atOffset + offset;
					}
				} else if ( overRight > 0 ) {
					newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
					if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
						position.left += myOffset + atOffset + offset;
					}
				}
			},
			top: function( position, data ) {
				var within = data.within,
					withinOffset = within.offset.top + within.scrollTop,
					outerHeight = within.height,
					offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
					collisionPosTop = position.top - data.collisionPosition.marginTop,
					overTop = collisionPosTop - offsetTop,
					overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
					top = data.my[ 1 ] === "top",
					myOffset = top ?
						-data.elemHeight :
						data.my[ 1 ] === "bottom" ?
							data.elemHeight :
							0,
					atOffset = data.at[ 1 ] === "top" ?
						data.targetHeight :
						data.at[ 1 ] === "bottom" ?
							-data.targetHeight :
							0,
					offset = -2 * data.offset[ 1 ],
					newOverTop,
					newOverBottom;
				if ( overTop < 0 ) {
					newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
					if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
						position.top += myOffset + atOffset + offset;
					}
				} else if ( overBottom > 0 ) {
					newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
					if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
						position.top += myOffset + atOffset + offset;
					}
				}
			}
		},
		flipfit: {
			left: function() {
				$.ui.position.flip.left.apply( this, arguments );
				$.ui.position.fit.left.apply( this, arguments );
			},
			top: function() {
				$.ui.position.flip.top.apply( this, arguments );
				$.ui.position.fit.top.apply( this, arguments );
			}
		}
	};
	
	// fraction support test
	(function() {
		var testElement, testElementParent, testElementStyle, offsetLeft, i,
			body = document.getElementsByTagName( "body" )[ 0 ],
			div = document.createElement( "div" );
	
		//Create a "fake body" for testing based on method used in jQuery.support
		testElement = document.createElement( body ? "div" : "body" );
		testElementStyle = {
			visibility: "hidden",
			width: 0,
			height: 0,
			border: 0,
			margin: 0,
			background: "none"
		};
		if ( body ) {
			$.extend( testElementStyle, {
				position: "absolute",
				left: "-1000px",
				top: "-1000px"
			});
		}
		for ( i in testElementStyle ) {
			testElement.style[ i ] = testElementStyle[ i ];
		}
		testElement.appendChild( div );
		testElementParent = body || document.documentElement;
		testElementParent.insertBefore( testElement, testElementParent.firstChild );
	
		div.style.cssText = "position: absolute; left: 10.7432222px;";
	
		offsetLeft = $( div ).offset().left;
		supportsOffsetFractions = offsetLeft > 10 && offsetLeft < 11;
	
		testElement.innerHTML = "";
		testElementParent.removeChild( testElement );
	})();
	
	})();
	
	var position = $.ui.position;
	
	
	/*!
	 * jQuery UI Draggable 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/draggable/
	 */
	
	
	$.widget("ui.draggable", $.ui.mouse, {
		version: "1.11.4",
		widgetEventPrefix: "drag",
		options: {
			addClasses: true,
			appendTo: "parent",
			axis: false,
			connectToSortable: false,
			containment: false,
			cursor: "auto",
			cursorAt: false,
			grid: false,
			handle: false,
			helper: "original",
			iframeFix: false,
			opacity: false,
			refreshPositions: false,
			revert: false,
			revertDuration: 500,
			scope: "default",
			scroll: true,
			scrollSensitivity: 20,
			scrollSpeed: 20,
			snap: false,
			snapMode: "both",
			snapTolerance: 20,
			stack: false,
			zIndex: false,
	
			// callbacks
			drag: null,
			start: null,
			stop: null
		},
		_create: function() {
	
			if ( this.options.helper === "original" ) {
				this._setPositionRelative();
			}
			if (this.options.addClasses){
				this.element.addClass("ui-draggable");
			}
			if (this.options.disabled){
				this.element.addClass("ui-draggable-disabled");
			}
			this._setHandleClassName();
	
			this._mouseInit();
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
			if ( key === "handle" ) {
				this._removeHandleClassName();
				this._setHandleClassName();
			}
		},
	
		_destroy: function() {
			if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
				this.destroyOnClear = true;
				return;
			}
			this.element.removeClass( "ui-draggable ui-draggable-dragging ui-draggable-disabled" );
			this._removeHandleClassName();
			this._mouseDestroy();
		},
	
		_mouseCapture: function(event) {
			var o = this.options;
	
			this._blurActiveElement( event );
	
			// among others, prevent a drag on a resizable-handle
			if (this.helper || o.disabled || $(event.target).closest(".ui-resizable-handle").length > 0) {
				return false;
			}
	
			//Quit if we're not on a valid handle
			this.handle = this._getHandle(event);
			if (!this.handle) {
				return false;
			}
	
			this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );
	
			return true;
	
		},
	
		_blockFrames: function( selector ) {
			this.iframeBlocks = this.document.find( selector ).map(function() {
				var iframe = $( this );
	
				return $( "<div>" )
					.css( "position", "absolute" )
					.appendTo( iframe.parent() )
					.outerWidth( iframe.outerWidth() )
					.outerHeight( iframe.outerHeight() )
					.offset( iframe.offset() )[ 0 ];
			});
		},
	
		_unblockFrames: function() {
			if ( this.iframeBlocks ) {
				this.iframeBlocks.remove();
				delete this.iframeBlocks;
			}
		},
	
		_blurActiveElement: function( event ) {
			var document = this.document[ 0 ];
	
			// Only need to blur if the event occurred on the draggable itself, see #10527
			if ( !this.handleElement.is( event.target ) ) {
				return;
			}
	
			// support: IE9
			// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
			try {
	
				// Support: IE9, IE10
				// If the <body> is blurred, IE will switch windows, see #9520
				if ( document.activeElement && document.activeElement.nodeName.toLowerCase() !== "body" ) {
	
					// Blur any element that currently has focus, see #4261
					$( document.activeElement ).blur();
				}
			} catch ( error ) {}
		},
	
		_mouseStart: function(event) {
	
			var o = this.options;
	
			//Create and append the visible helper
			this.helper = this._createHelper(event);
	
			this.helper.addClass("ui-draggable-dragging");
	
			//Cache the helper size
			this._cacheHelperProportions();
	
			//If ddmanager is used for droppables, set the global draggable
			if ($.ui.ddmanager) {
				$.ui.ddmanager.current = this;
			}
	
			/*
			 * - Position generation -
			 * This block generates everything position related - it's the core of draggables.
			 */
	
			//Cache the margins of the original element
			this._cacheMargins();
	
			//Store the helper's css position
			this.cssPosition = this.helper.css( "position" );
			this.scrollParent = this.helper.scrollParent( true );
			this.offsetParent = this.helper.offsetParent();
			this.hasFixedAncestor = this.helper.parents().filter(function() {
					return $( this ).css( "position" ) === "fixed";
				}).length > 0;
	
			//The element's absolute position on the page minus margins
			this.positionAbs = this.element.offset();
			this._refreshOffsets( event );
	
			//Generate the original position
			this.originalPosition = this.position = this._generatePosition( event, false );
			this.originalPageX = event.pageX;
			this.originalPageY = event.pageY;
	
			//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
			(o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));
	
			//Set a containment if given in the options
			this._setContainment();
	
			//Trigger event + callbacks
			if (this._trigger("start", event) === false) {
				this._clear();
				return false;
			}
	
			//Recache the helper size
			this._cacheHelperProportions();
	
			//Prepare the droppable offsets
			if ($.ui.ddmanager && !o.dropBehaviour) {
				$.ui.ddmanager.prepareOffsets(this, event);
			}
	
			// Reset helper's right/bottom css if they're set and set explicit width/height instead
			// as this prevents resizing of elements with right/bottom set (see #7772)
			this._normalizeRightBottom();
	
			this._mouseDrag(event, true); //Execute the drag once - this causes the helper not to be visible before getting its correct position
	
			//If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.dragStart(this, event);
			}
	
			return true;
		},
	
		_refreshOffsets: function( event ) {
			this.offset = {
				top: this.positionAbs.top - this.margins.top,
				left: this.positionAbs.left - this.margins.left,
				scroll: false,
				parent: this._getParentOffset(),
				relative: this._getRelativeOffset()
			};
	
			this.offset.click = {
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			};
		},
	
		_mouseDrag: function(event, noPropagation) {
			// reset any necessary cached properties (see #5009)
			if ( this.hasFixedAncestor ) {
				this.offset.parent = this._getParentOffset();
			}
	
			//Compute the helpers position
			this.position = this._generatePosition( event, true );
			this.positionAbs = this._convertPositionTo("absolute");
	
			//Call plugins and callbacks and use the resulting position if something is returned
			if (!noPropagation) {
				var ui = this._uiHash();
				if (this._trigger("drag", event, ui) === false) {
					this._mouseUp({});
					return false;
				}
				this.position = ui.position;
			}
	
			this.helper[ 0 ].style.left = this.position.left + "px";
			this.helper[ 0 ].style.top = this.position.top + "px";
	
			if ($.ui.ddmanager) {
				$.ui.ddmanager.drag(this, event);
			}
	
			return false;
		},
	
		_mouseStop: function(event) {
	
			//If we are using droppables, inform the manager about the drop
			var that = this,
				dropped = false;
			if ($.ui.ddmanager && !this.options.dropBehaviour) {
				dropped = $.ui.ddmanager.drop(this, event);
			}
	
			//if a drop comes from outside (a sortable)
			if (this.dropped) {
				dropped = this.dropped;
				this.dropped = false;
			}
	
			if ((this.options.revert === "invalid" && !dropped) || (this.options.revert === "valid" && dropped) || this.options.revert === true || ($.isFunction(this.options.revert) && this.options.revert.call(this.element, dropped))) {
				$(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function() {
					if (that._trigger("stop", event) !== false) {
						that._clear();
					}
				});
			} else {
				if (this._trigger("stop", event) !== false) {
					this._clear();
				}
			}
	
			return false;
		},
	
		_mouseUp: function( event ) {
			this._unblockFrames();
	
			//If the ddmanager is used for droppables, inform the manager that dragging has stopped (see #5003)
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.dragStop(this, event);
			}
	
			// Only need to focus if the event occurred on the draggable itself, see #10527
			if ( this.handleElement.is( event.target ) ) {
				// The interaction is over; whether or not the click resulted in a drag, focus the element
				this.element.focus();
			}
	
			return $.ui.mouse.prototype._mouseUp.call(this, event);
		},
	
		cancel: function() {
	
			if (this.helper.is(".ui-draggable-dragging")) {
				this._mouseUp({});
			} else {
				this._clear();
			}
	
			return this;
	
		},
	
		_getHandle: function(event) {
			return this.options.handle ?
				!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
				true;
		},
	
		_setHandleClassName: function() {
			this.handleElement = this.options.handle ?
				this.element.find( this.options.handle ) : this.element;
			this.handleElement.addClass( "ui-draggable-handle" );
		},
	
		_removeHandleClassName: function() {
			this.handleElement.removeClass( "ui-draggable-handle" );
		},
	
		_createHelper: function(event) {
	
			var o = this.options,
				helperIsFunction = $.isFunction( o.helper ),
				helper = helperIsFunction ?
					$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
					( o.helper === "clone" ?
						this.element.clone().removeAttr( "id" ) :
						this.element );
	
			if (!helper.parents("body").length) {
				helper.appendTo((o.appendTo === "parent" ? this.element[0].parentNode : o.appendTo));
			}
	
			// http://bugs.jqueryui.com/ticket/9446
			// a helper function can return the original element
			// which wouldn't have been set to relative in _create
			if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
				this._setPositionRelative();
			}
	
			if (helper[0] !== this.element[0] && !(/(fixed|absolute)/).test(helper.css("position"))) {
				helper.css("position", "absolute");
			}
	
			return helper;
	
		},
	
		_setPositionRelative: function() {
			if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
				this.element[ 0 ].style.position = "relative";
			}
		},
	
		_adjustOffsetFromHelper: function(obj) {
			if (typeof obj === "string") {
				obj = obj.split(" ");
			}
			if ($.isArray(obj)) {
				obj = { left: +obj[0], top: +obj[1] || 0 };
			}
			if ("left" in obj) {
				this.offset.click.left = obj.left + this.margins.left;
			}
			if ("right" in obj) {
				this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
			}
			if ("top" in obj) {
				this.offset.click.top = obj.top + this.margins.top;
			}
			if ("bottom" in obj) {
				this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
			}
		},
	
		_isRootNode: function( element ) {
			return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
		},
	
		_getParentOffset: function() {
	
			//Get the offsetParent and cache its position
			var po = this.offsetParent.offset(),
				document = this.document[ 0 ];
	
			// This is a special case where we need to modify a offset calculated on start, since the following happened:
			// 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
			// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
			//    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
			if (this.cssPosition === "absolute" && this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) {
				po.left += this.scrollParent.scrollLeft();
				po.top += this.scrollParent.scrollTop();
			}
	
			if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
				po = { top: 0, left: 0 };
			}
	
			return {
				top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
				left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
			};
	
		},
	
		_getRelativeOffset: function() {
			if ( this.cssPosition !== "relative" ) {
				return { top: 0, left: 0 };
			}
	
			var p = this.element.position(),
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );
	
			return {
				top: p.top - ( parseInt(this.helper.css( "top" ), 10) || 0 ) + ( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
				left: p.left - ( parseInt(this.helper.css( "left" ), 10) || 0 ) + ( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
			};
	
		},
	
		_cacheMargins: function() {
			this.margins = {
				left: (parseInt(this.element.css("marginLeft"), 10) || 0),
				top: (parseInt(this.element.css("marginTop"), 10) || 0),
				right: (parseInt(this.element.css("marginRight"), 10) || 0),
				bottom: (parseInt(this.element.css("marginBottom"), 10) || 0)
			};
		},
	
		_cacheHelperProportions: function() {
			this.helperProportions = {
				width: this.helper.outerWidth(),
				height: this.helper.outerHeight()
			};
		},
	
		_setContainment: function() {
	
			var isUserScrollable, c, ce,
				o = this.options,
				document = this.document[ 0 ];
	
			this.relativeContainer = null;
	
			if ( !o.containment ) {
				this.containment = null;
				return;
			}
	
			if ( o.containment === "window" ) {
				this.containment = [
					$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
					$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
					$( window ).scrollLeft() + $( window ).width() - this.helperProportions.width - this.margins.left,
					$( window ).scrollTop() + ( $( window ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
				];
				return;
			}
	
			if ( o.containment === "document") {
				this.containment = [
					0,
					0,
					$( document ).width() - this.helperProportions.width - this.margins.left,
					( $( document ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
				];
				return;
			}
	
			if ( o.containment.constructor === Array ) {
				this.containment = o.containment;
				return;
			}
	
			if ( o.containment === "parent" ) {
				o.containment = this.helper[ 0 ].parentNode;
			}
	
			c = $( o.containment );
			ce = c[ 0 ];
	
			if ( !ce ) {
				return;
			}
	
			isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );
	
			this.containment = [
				( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
				( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
				( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
					( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
					( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
					this.helperProportions.width -
					this.margins.left -
					this.margins.right,
				( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
					( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
					( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
					this.helperProportions.height -
					this.margins.top -
					this.margins.bottom
			];
			this.relativeContainer = c;
		},
	
		_convertPositionTo: function(d, pos) {
	
			if (!pos) {
				pos = this.position;
			}
	
			var mod = d === "absolute" ? 1 : -1,
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );
	
			return {
				top: (
					pos.top	+																// The absolute mouse position
					this.offset.relative.top * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.top * mod -										// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.offset.scroll.top : ( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod)
				),
				left: (
					pos.left +																// The absolute mouse position
					this.offset.relative.left * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.left * mod	-										// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.offset.scroll.left : ( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod)
				)
			};
	
		},
	
		_generatePosition: function( event, constrainPosition ) {
	
			var containment, co, top, left,
				o = this.options,
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
				pageX = event.pageX,
				pageY = event.pageY;
	
			// Cache the scroll
			if ( !scrollIsRootNode || !this.offset.scroll ) {
				this.offset.scroll = {
					top: this.scrollParent.scrollTop(),
					left: this.scrollParent.scrollLeft()
				};
			}
	
			/*
			 * - Position constraining -
			 * Constrain the position to a mix of grid, containment.
			 */
	
			// If we are not dragging yet, we won't check for options
			if ( constrainPosition ) {
				if ( this.containment ) {
					if ( this.relativeContainer ){
						co = this.relativeContainer.offset();
						containment = [
							this.containment[ 0 ] + co.left,
							this.containment[ 1 ] + co.top,
							this.containment[ 2 ] + co.left,
							this.containment[ 3 ] + co.top
						];
					} else {
						containment = this.containment;
					}
	
					if (event.pageX - this.offset.click.left < containment[0]) {
						pageX = containment[0] + this.offset.click.left;
					}
					if (event.pageY - this.offset.click.top < containment[1]) {
						pageY = containment[1] + this.offset.click.top;
					}
					if (event.pageX - this.offset.click.left > containment[2]) {
						pageX = containment[2] + this.offset.click.left;
					}
					if (event.pageY - this.offset.click.top > containment[3]) {
						pageY = containment[3] + this.offset.click.top;
					}
				}
	
				if (o.grid) {
					//Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
					top = o.grid[1] ? this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY;
					pageY = containment ? ((top - this.offset.click.top >= containment[1] || top - this.offset.click.top > containment[3]) ? top : ((top - this.offset.click.top >= containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;
	
					left = o.grid[0] ? this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX;
					pageX = containment ? ((left - this.offset.click.left >= containment[0] || left - this.offset.click.left > containment[2]) ? left : ((left - this.offset.click.left >= containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
				}
	
				if ( o.axis === "y" ) {
					pageX = this.originalPageX;
				}
	
				if ( o.axis === "x" ) {
					pageY = this.originalPageY;
				}
			}
	
			return {
				top: (
					pageY -																	// The absolute mouse position
					this.offset.click.top	-												// Click offset (relative to the element)
					this.offset.relative.top -												// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.top +												// The offsetParent's offset without borders (offset + border)
					( this.cssPosition === "fixed" ? -this.offset.scroll.top : ( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
				),
				left: (
					pageX -																	// The absolute mouse position
					this.offset.click.left -												// Click offset (relative to the element)
					this.offset.relative.left -												// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.left +												// The offsetParent's offset without borders (offset + border)
					( this.cssPosition === "fixed" ? -this.offset.scroll.left : ( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
				)
			};
	
		},
	
		_clear: function() {
			this.helper.removeClass("ui-draggable-dragging");
			if (this.helper[0] !== this.element[0] && !this.cancelHelperRemoval) {
				this.helper.remove();
			}
			this.helper = null;
			this.cancelHelperRemoval = false;
			if ( this.destroyOnClear ) {
				this.destroy();
			}
		},
	
		_normalizeRightBottom: function() {
			if ( this.options.axis !== "y" && this.helper.css( "right" ) !== "auto" ) {
				this.helper.width( this.helper.width() );
				this.helper.css( "right", "auto" );
			}
			if ( this.options.axis !== "x" && this.helper.css( "bottom" ) !== "auto" ) {
				this.helper.height( this.helper.height() );
				this.helper.css( "bottom", "auto" );
			}
		},
	
		// From now on bulk stuff - mainly helpers
	
		_trigger: function( type, event, ui ) {
			ui = ui || this._uiHash();
			$.ui.plugin.call( this, type, [ event, ui, this ], true );
	
			// Absolute position and offset (see #6884 ) have to be recalculated after plugins
			if ( /^(drag|start|stop)/.test( type ) ) {
				this.positionAbs = this._convertPositionTo( "absolute" );
				ui.offset = this.positionAbs;
			}
			return $.Widget.prototype._trigger.call( this, type, event, ui );
		},
	
		plugins: {},
	
		_uiHash: function() {
			return {
				helper: this.helper,
				position: this.position,
				originalPosition: this.originalPosition,
				offset: this.positionAbs
			};
		}
	
	});
	
	$.ui.plugin.add( "draggable", "connectToSortable", {
		start: function( event, ui, draggable ) {
			var uiSortable = $.extend( {}, ui, {
				item: draggable.element
			});
	
			draggable.sortables = [];
			$( draggable.options.connectToSortable ).each(function() {
				var sortable = $( this ).sortable( "instance" );
	
				if ( sortable && !sortable.options.disabled ) {
					draggable.sortables.push( sortable );
	
					// refreshPositions is called at drag start to refresh the containerCache
					// which is used in drag. This ensures it's initialized and synchronized
					// with any changes that might have happened on the page since initialization.
					sortable.refreshPositions();
					sortable._trigger("activate", event, uiSortable);
				}
			});
		},
		stop: function( event, ui, draggable ) {
			var uiSortable = $.extend( {}, ui, {
				item: draggable.element
			});
	
			draggable.cancelHelperRemoval = false;
	
			$.each( draggable.sortables, function() {
				var sortable = this;
	
				if ( sortable.isOver ) {
					sortable.isOver = 0;
	
					// Allow this sortable to handle removing the helper
					draggable.cancelHelperRemoval = true;
					sortable.cancelHelperRemoval = false;
	
					// Use _storedCSS To restore properties in the sortable,
					// as this also handles revert (#9675) since the draggable
					// may have modified them in unexpected ways (#8809)
					sortable._storedCSS = {
						position: sortable.placeholder.css( "position" ),
						top: sortable.placeholder.css( "top" ),
						left: sortable.placeholder.css( "left" )
					};
	
					sortable._mouseStop(event);
	
					// Once drag has ended, the sortable should return to using
					// its original helper, not the shared helper from draggable
					sortable.options.helper = sortable.options._helper;
				} else {
					// Prevent this Sortable from removing the helper.
					// However, don't set the draggable to remove the helper
					// either as another connected Sortable may yet handle the removal.
					sortable.cancelHelperRemoval = true;
	
					sortable._trigger( "deactivate", event, uiSortable );
				}
			});
		},
		drag: function( event, ui, draggable ) {
			$.each( draggable.sortables, function() {
				var innermostIntersecting = false,
					sortable = this;
	
				// Copy over variables that sortable's _intersectsWith uses
				sortable.positionAbs = draggable.positionAbs;
				sortable.helperProportions = draggable.helperProportions;
				sortable.offset.click = draggable.offset.click;
	
				if ( sortable._intersectsWith( sortable.containerCache ) ) {
					innermostIntersecting = true;
	
					$.each( draggable.sortables, function() {
						// Copy over variables that sortable's _intersectsWith uses
						this.positionAbs = draggable.positionAbs;
						this.helperProportions = draggable.helperProportions;
						this.offset.click = draggable.offset.click;
	
						if ( this !== sortable &&
								this._intersectsWith( this.containerCache ) &&
								$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
							innermostIntersecting = false;
						}
	
						return innermostIntersecting;
					});
				}
	
				if ( innermostIntersecting ) {
					// If it intersects, we use a little isOver variable and set it once,
					// so that the move-in stuff gets fired only once.
					if ( !sortable.isOver ) {
						sortable.isOver = 1;
	
						// Store draggable's parent in case we need to reappend to it later.
						draggable._parent = ui.helper.parent();
	
						sortable.currentItem = ui.helper
							.appendTo( sortable.element )
							.data( "ui-sortable-item", true );
	
						// Store helper option to later restore it
						sortable.options._helper = sortable.options.helper;
	
						sortable.options.helper = function() {
							return ui.helper[ 0 ];
						};
	
						// Fire the start events of the sortable with our passed browser event,
						// and our own helper (so it doesn't create a new one)
						event.target = sortable.currentItem[ 0 ];
						sortable._mouseCapture( event, true );
						sortable._mouseStart( event, true, true );
	
						// Because the browser event is way off the new appended portlet,
						// modify necessary variables to reflect the changes
						sortable.offset.click.top = draggable.offset.click.top;
						sortable.offset.click.left = draggable.offset.click.left;
						sortable.offset.parent.left -= draggable.offset.parent.left -
							sortable.offset.parent.left;
						sortable.offset.parent.top -= draggable.offset.parent.top -
							sortable.offset.parent.top;
	
						draggable._trigger( "toSortable", event );
	
						// Inform draggable that the helper is in a valid drop zone,
						// used solely in the revert option to handle "valid/invalid".
						draggable.dropped = sortable.element;
	
						// Need to refreshPositions of all sortables in the case that
						// adding to one sortable changes the location of the other sortables (#9675)
						$.each( draggable.sortables, function() {
							this.refreshPositions();
						});
	
						// hack so receive/update callbacks work (mostly)
						draggable.currentItem = draggable.element;
						sortable.fromOutside = draggable;
					}
	
					if ( sortable.currentItem ) {
						sortable._mouseDrag( event );
						// Copy the sortable's position because the draggable's can potentially reflect
						// a relative position, while sortable is always absolute, which the dragged
						// element has now become. (#8809)
						ui.position = sortable.position;
					}
				} else {
					// If it doesn't intersect with the sortable, and it intersected before,
					// we fake the drag stop of the sortable, but make sure it doesn't remove
					// the helper by using cancelHelperRemoval.
					if ( sortable.isOver ) {
	
						sortable.isOver = 0;
						sortable.cancelHelperRemoval = true;
	
						// Calling sortable's mouseStop would trigger a revert,
						// so revert must be temporarily false until after mouseStop is called.
						sortable.options._revert = sortable.options.revert;
						sortable.options.revert = false;
	
						sortable._trigger( "out", event, sortable._uiHash( sortable ) );
						sortable._mouseStop( event, true );
	
						// restore sortable behaviors that were modfied
						// when the draggable entered the sortable area (#9481)
						sortable.options.revert = sortable.options._revert;
						sortable.options.helper = sortable.options._helper;
	
						if ( sortable.placeholder ) {
							sortable.placeholder.remove();
						}
	
						// Restore and recalculate the draggable's offset considering the sortable
						// may have modified them in unexpected ways. (#8809, #10669)
						ui.helper.appendTo( draggable._parent );
						draggable._refreshOffsets( event );
						ui.position = draggable._generatePosition( event, true );
	
						draggable._trigger( "fromSortable", event );
	
						// Inform draggable that the helper is no longer in a valid drop zone
						draggable.dropped = false;
	
						// Need to refreshPositions of all sortables just in case removing
						// from one sortable changes the location of other sortables (#9675)
						$.each( draggable.sortables, function() {
							this.refreshPositions();
						});
					}
				}
			});
		}
	});
	
	$.ui.plugin.add("draggable", "cursor", {
		start: function( event, ui, instance ) {
			var t = $( "body" ),
				o = instance.options;
	
			if (t.css("cursor")) {
				o._cursor = t.css("cursor");
			}
			t.css("cursor", o.cursor);
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
			if (o._cursor) {
				$("body").css("cursor", o._cursor);
			}
		}
	});
	
	$.ui.plugin.add("draggable", "opacity", {
		start: function( event, ui, instance ) {
			var t = $( ui.helper ),
				o = instance.options;
			if (t.css("opacity")) {
				o._opacity = t.css("opacity");
			}
			t.css("opacity", o.opacity);
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
			if (o._opacity) {
				$(ui.helper).css("opacity", o._opacity);
			}
		}
	});
	
	$.ui.plugin.add("draggable", "scroll", {
		start: function( event, ui, i ) {
			if ( !i.scrollParentNotHidden ) {
				i.scrollParentNotHidden = i.helper.scrollParent( false );
			}
	
			if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] && i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
				i.overflowOffset = i.scrollParentNotHidden.offset();
			}
		},
		drag: function( event, ui, i  ) {
	
			var o = i.options,
				scrolled = false,
				scrollParent = i.scrollParentNotHidden[ 0 ],
				document = i.document[ 0 ];
	
			if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
				if ( !o.axis || o.axis !== "x" ) {
					if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY < o.scrollSensitivity ) {
						scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
					} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
						scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
					}
				}
	
				if ( !o.axis || o.axis !== "y" ) {
					if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX < o.scrollSensitivity ) {
						scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
					} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
						scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
					}
				}
	
			} else {
	
				if (!o.axis || o.axis !== "x") {
					if (event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
						scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
					} else if ($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity) {
						scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);
					}
				}
	
				if (!o.axis || o.axis !== "y") {
					if (event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
						scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
					} else if ($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity) {
						scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);
					}
				}
	
			}
	
			if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
				$.ui.ddmanager.prepareOffsets(i, event);
			}
	
		}
	});
	
	$.ui.plugin.add("draggable", "snap", {
		start: function( event, ui, i ) {
	
			var o = i.options;
	
			i.snapElements = [];
	
			$(o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap).each(function() {
				var $t = $(this),
					$o = $t.offset();
				if (this !== i.element[0]) {
					i.snapElements.push({
						item: this,
						width: $t.outerWidth(), height: $t.outerHeight(),
						top: $o.top, left: $o.left
					});
				}
			});
	
		},
		drag: function( event, ui, inst ) {
	
			var ts, bs, ls, rs, l, r, t, b, i, first,
				o = inst.options,
				d = o.snapTolerance,
				x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
				y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;
	
			for (i = inst.snapElements.length - 1; i >= 0; i--){
	
				l = inst.snapElements[i].left - inst.margins.left;
				r = l + inst.snapElements[i].width;
				t = inst.snapElements[i].top - inst.margins.top;
				b = t + inst.snapElements[i].height;
	
				if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d || !$.contains( inst.snapElements[ i ].item.ownerDocument, inst.snapElements[ i ].item ) ) {
					if (inst.snapElements[i].snapping) {
						(inst.options.snap.release && inst.options.snap.release.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
					}
					inst.snapElements[i].snapping = false;
					continue;
				}
	
				if (o.snapMode !== "inner") {
					ts = Math.abs(t - y2) <= d;
					bs = Math.abs(b - y1) <= d;
					ls = Math.abs(l - x2) <= d;
					rs = Math.abs(r - x1) <= d;
					if (ts) {
						ui.position.top = inst._convertPositionTo("relative", { top: t - inst.helperProportions.height, left: 0 }).top;
					}
					if (bs) {
						ui.position.top = inst._convertPositionTo("relative", { top: b, left: 0 }).top;
					}
					if (ls) {
						ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l - inst.helperProportions.width }).left;
					}
					if (rs) {
						ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r }).left;
					}
				}
	
				first = (ts || bs || ls || rs);
	
				if (o.snapMode !== "outer") {
					ts = Math.abs(t - y1) <= d;
					bs = Math.abs(b - y2) <= d;
					ls = Math.abs(l - x1) <= d;
					rs = Math.abs(r - x2) <= d;
					if (ts) {
						ui.position.top = inst._convertPositionTo("relative", { top: t, left: 0 }).top;
					}
					if (bs) {
						ui.position.top = inst._convertPositionTo("relative", { top: b - inst.helperProportions.height, left: 0 }).top;
					}
					if (ls) {
						ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l }).left;
					}
					if (rs) {
						ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r - inst.helperProportions.width }).left;
					}
				}
	
				if (!inst.snapElements[i].snapping && (ts || bs || ls || rs || first)) {
					(inst.options.snap.snap && inst.options.snap.snap.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
				}
				inst.snapElements[i].snapping = (ts || bs || ls || rs || first);
	
			}
	
		}
	});
	
	$.ui.plugin.add("draggable", "stack", {
		start: function( event, ui, instance ) {
			var min,
				o = instance.options,
				group = $.makeArray($(o.stack)).sort(function(a, b) {
					return (parseInt($(a).css("zIndex"), 10) || 0) - (parseInt($(b).css("zIndex"), 10) || 0);
				});
	
			if (!group.length) { return; }
	
			min = parseInt($(group[0]).css("zIndex"), 10) || 0;
			$(group).each(function(i) {
				$(this).css("zIndex", min + i);
			});
			this.css("zIndex", (min + group.length));
		}
	});
	
	$.ui.plugin.add("draggable", "zIndex", {
		start: function( event, ui, instance ) {
			var t = $( ui.helper ),
				o = instance.options;
	
			if (t.css("zIndex")) {
				o._zIndex = t.css("zIndex");
			}
			t.css("zIndex", o.zIndex);
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
	
			if (o._zIndex) {
				$(ui.helper).css("zIndex", o._zIndex);
			}
		}
	});
	
	var draggable = $.ui.draggable;
	
	
	/*!
	 * jQuery UI Droppable 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/droppable/
	 */
	
	
	$.widget( "ui.droppable", {
		version: "1.11.4",
		widgetEventPrefix: "drop",
		options: {
			accept: "*",
			activeClass: false,
			addClasses: true,
			greedy: false,
			hoverClass: false,
			scope: "default",
			tolerance: "intersect",
	
			// callbacks
			activate: null,
			deactivate: null,
			drop: null,
			out: null,
			over: null
		},
		_create: function() {
	
			var proportions,
				o = this.options,
				accept = o.accept;
	
			this.isover = false;
			this.isout = true;
	
			this.accept = $.isFunction( accept ) ? accept : function( d ) {
				return d.is( accept );
			};
	
			this.proportions = function( /* valueToWrite */ ) {
				if ( arguments.length ) {
					// Store the droppable's proportions
					proportions = arguments[ 0 ];
				} else {
					// Retrieve or derive the droppable's proportions
					return proportions ?
						proportions :
						proportions = {
							width: this.element[ 0 ].offsetWidth,
							height: this.element[ 0 ].offsetHeight
						};
				}
			};
	
			this._addToManager( o.scope );
	
			o.addClasses && this.element.addClass( "ui-droppable" );
	
		},
	
		_addToManager: function( scope ) {
			// Add the reference and positions to the manager
			$.ui.ddmanager.droppables[ scope ] = $.ui.ddmanager.droppables[ scope ] || [];
			$.ui.ddmanager.droppables[ scope ].push( this );
		},
	
		_splice: function( drop ) {
			var i = 0;
			for ( ; i < drop.length; i++ ) {
				if ( drop[ i ] === this ) {
					drop.splice( i, 1 );
				}
			}
		},
	
		_destroy: function() {
			var drop = $.ui.ddmanager.droppables[ this.options.scope ];
	
			this._splice( drop );
	
			this.element.removeClass( "ui-droppable ui-droppable-disabled" );
		},
	
		_setOption: function( key, value ) {
	
			if ( key === "accept" ) {
				this.accept = $.isFunction( value ) ? value : function( d ) {
					return d.is( value );
				};
			} else if ( key === "scope" ) {
				var drop = $.ui.ddmanager.droppables[ this.options.scope ];
	
				this._splice( drop );
				this._addToManager( value );
			}
	
			this._super( key, value );
		},
	
		_activate: function( event ) {
			var draggable = $.ui.ddmanager.current;
			if ( this.options.activeClass ) {
				this.element.addClass( this.options.activeClass );
			}
			if ( draggable ){
				this._trigger( "activate", event, this.ui( draggable ) );
			}
		},
	
		_deactivate: function( event ) {
			var draggable = $.ui.ddmanager.current;
			if ( this.options.activeClass ) {
				this.element.removeClass( this.options.activeClass );
			}
			if ( draggable ){
				this._trigger( "deactivate", event, this.ui( draggable ) );
			}
		},
	
		_over: function( event ) {
	
			var draggable = $.ui.ddmanager.current;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem || draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return;
			}
	
			if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem || draggable.element ) ) ) {
				if ( this.options.hoverClass ) {
					this.element.addClass( this.options.hoverClass );
				}
				this._trigger( "over", event, this.ui( draggable ) );
			}
	
		},
	
		_out: function( event ) {
	
			var draggable = $.ui.ddmanager.current;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem || draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return;
			}
	
			if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem || draggable.element ) ) ) {
				if ( this.options.hoverClass ) {
					this.element.removeClass( this.options.hoverClass );
				}
				this._trigger( "out", event, this.ui( draggable ) );
			}
	
		},
	
		_drop: function( event, custom ) {
	
			var draggable = custom || $.ui.ddmanager.current,
				childrenIntersection = false;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem || draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return false;
			}
	
			this.element.find( ":data(ui-droppable)" ).not( ".ui-draggable-dragging" ).each(function() {
				var inst = $( this ).droppable( "instance" );
				if (
					inst.options.greedy &&
					!inst.options.disabled &&
					inst.options.scope === draggable.options.scope &&
					inst.accept.call( inst.element[ 0 ], ( draggable.currentItem || draggable.element ) ) &&
					$.ui.intersect( draggable, $.extend( inst, { offset: inst.element.offset() } ), inst.options.tolerance, event )
				) { childrenIntersection = true; return false; }
			});
			if ( childrenIntersection ) {
				return false;
			}
	
			if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem || draggable.element ) ) ) {
				if ( this.options.activeClass ) {
					this.element.removeClass( this.options.activeClass );
				}
				if ( this.options.hoverClass ) {
					this.element.removeClass( this.options.hoverClass );
				}
				this._trigger( "drop", event, this.ui( draggable ) );
				return this.element;
			}
	
			return false;
	
		},
	
		ui: function( c ) {
			return {
				draggable: ( c.currentItem || c.element ),
				helper: c.helper,
				position: c.position,
				offset: c.positionAbs
			};
		}
	
	});
	
	$.ui.intersect = (function() {
		function isOverAxis( x, reference, size ) {
			return ( x >= reference ) && ( x < ( reference + size ) );
		}
	
		return function( draggable, droppable, toleranceMode, event ) {
	
			if ( !droppable.offset ) {
				return false;
			}
	
			var x1 = ( draggable.positionAbs || draggable.position.absolute ).left + draggable.margins.left,
				y1 = ( draggable.positionAbs || draggable.position.absolute ).top + draggable.margins.top,
				x2 = x1 + draggable.helperProportions.width,
				y2 = y1 + draggable.helperProportions.height,
				l = droppable.offset.left,
				t = droppable.offset.top,
				r = l + droppable.proportions().width,
				b = t + droppable.proportions().height;
	
			switch ( toleranceMode ) {
			case "fit":
				return ( l <= x1 && x2 <= r && t <= y1 && y2 <= b );
			case "intersect":
				return ( l < x1 + ( draggable.helperProportions.width / 2 ) && // Right Half
					x2 - ( draggable.helperProportions.width / 2 ) < r && // Left Half
					t < y1 + ( draggable.helperProportions.height / 2 ) && // Bottom Half
					y2 - ( draggable.helperProportions.height / 2 ) < b ); // Top Half
			case "pointer":
				return isOverAxis( event.pageY, t, droppable.proportions().height ) && isOverAxis( event.pageX, l, droppable.proportions().width );
			case "touch":
				return (
					( y1 >= t && y1 <= b ) || // Top edge touching
					( y2 >= t && y2 <= b ) || // Bottom edge touching
					( y1 < t && y2 > b ) // Surrounded vertically
				) && (
					( x1 >= l && x1 <= r ) || // Left edge touching
					( x2 >= l && x2 <= r ) || // Right edge touching
					( x1 < l && x2 > r ) // Surrounded horizontally
				);
			default:
				return false;
			}
		};
	})();
	
	/*
		This manager tracks offsets of draggables and droppables
	*/
	$.ui.ddmanager = {
		current: null,
		droppables: { "default": [] },
		prepareOffsets: function( t, event ) {
	
			var i, j,
				m = $.ui.ddmanager.droppables[ t.options.scope ] || [],
				type = event ? event.type : null, // workaround for #2317
				list = ( t.currentItem || t.element ).find( ":data(ui-droppable)" ).addBack();
	
			droppablesLoop: for ( i = 0; i < m.length; i++ ) {
	
				// No disabled and non-accepted
				if ( m[ i ].options.disabled || ( t && !m[ i ].accept.call( m[ i ].element[ 0 ], ( t.currentItem || t.element ) ) ) ) {
					continue;
				}
	
				// Filter out elements in the current dragged item
				for ( j = 0; j < list.length; j++ ) {
					if ( list[ j ] === m[ i ].element[ 0 ] ) {
						m[ i ].proportions().height = 0;
						continue droppablesLoop;
					}
				}
	
				m[ i ].visible = m[ i ].element.css( "display" ) !== "none";
				if ( !m[ i ].visible ) {
					continue;
				}
	
				// Activate the droppable if used directly from draggables
				if ( type === "mousedown" ) {
					m[ i ]._activate.call( m[ i ], event );
				}
	
				m[ i ].offset = m[ i ].element.offset();
				m[ i ].proportions({ width: m[ i ].element[ 0 ].offsetWidth, height: m[ i ].element[ 0 ].offsetHeight });
	
			}
	
		},
		drop: function( draggable, event ) {
	
			var dropped = false;
			// Create a copy of the droppables in case the list changes during the drop (#9116)
			$.each( ( $.ui.ddmanager.droppables[ draggable.options.scope ] || [] ).slice(), function() {
	
				if ( !this.options ) {
					return;
				}
				if ( !this.options.disabled && this.visible && $.ui.intersect( draggable, this, this.options.tolerance, event ) ) {
					dropped = this._drop.call( this, event ) || dropped;
				}
	
				if ( !this.options.disabled && this.visible && this.accept.call( this.element[ 0 ], ( draggable.currentItem || draggable.element ) ) ) {
					this.isout = true;
					this.isover = false;
					this._deactivate.call( this, event );
				}
	
			});
			return dropped;
	
		},
		dragStart: function( draggable, event ) {
			// Listen for scrolling so that if the dragging causes scrolling the position of the droppables can be recalculated (see #5003)
			draggable.element.parentsUntil( "body" ).bind( "scroll.droppable", function() {
				if ( !draggable.options.refreshPositions ) {
					$.ui.ddmanager.prepareOffsets( draggable, event );
				}
			});
		},
		drag: function( draggable, event ) {
	
			// If you have a highly dynamic page, you might try this option. It renders positions every time you move the mouse.
			if ( draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
	
			// Run through all droppables and check their positions based on specific tolerance options
			$.each( $.ui.ddmanager.droppables[ draggable.options.scope ] || [], function() {
	
				if ( this.options.disabled || this.greedyChild || !this.visible ) {
					return;
				}
	
				var parentInstance, scope, parent,
					intersects = $.ui.intersect( draggable, this, this.options.tolerance, event ),
					c = !intersects && this.isover ? "isout" : ( intersects && !this.isover ? "isover" : null );
				if ( !c ) {
					return;
				}
	
				if ( this.options.greedy ) {
					// find droppable parents with same scope
					scope = this.options.scope;
					parent = this.element.parents( ":data(ui-droppable)" ).filter(function() {
						return $( this ).droppable( "instance" ).options.scope === scope;
					});
	
					if ( parent.length ) {
						parentInstance = $( parent[ 0 ] ).droppable( "instance" );
						parentInstance.greedyChild = ( c === "isover" );
					}
				}
	
				// we just moved into a greedy child
				if ( parentInstance && c === "isover" ) {
					parentInstance.isover = false;
					parentInstance.isout = true;
					parentInstance._out.call( parentInstance, event );
				}
	
				this[ c ] = true;
				this[c === "isout" ? "isover" : "isout"] = false;
				this[c === "isover" ? "_over" : "_out"].call( this, event );
	
				// we just moved out of a greedy child
				if ( parentInstance && c === "isout" ) {
					parentInstance.isout = false;
					parentInstance.isover = true;
					parentInstance._over.call( parentInstance, event );
				}
			});
	
		},
		dragStop: function( draggable, event ) {
			draggable.element.parentsUntil( "body" ).unbind( "scroll.droppable" );
			// Call prepareOffsets one final time since IE does not fire return scroll events when overflow was caused by drag (see #5003)
			if ( !draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
		}
	};
	
	var droppable = $.ui.droppable;
	
	
	/*!
	 * jQuery UI Resizable 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/resizable/
	 */
	
	
	$.widget("ui.resizable", $.ui.mouse, {
		version: "1.11.4",
		widgetEventPrefix: "resize",
		options: {
			alsoResize: false,
			animate: false,
			animateDuration: "slow",
			animateEasing: "swing",
			aspectRatio: false,
			autoHide: false,
			containment: false,
			ghost: false,
			grid: false,
			handles: "e,s,se",
			helper: false,
			maxHeight: null,
			maxWidth: null,
			minHeight: 10,
			minWidth: 10,
			// See #7960
			zIndex: 90,
	
			// callbacks
			resize: null,
			start: null,
			stop: null
		},
	
		_num: function( value ) {
			return parseInt( value, 10 ) || 0;
		},
	
		_isNumber: function( value ) {
			return !isNaN( parseInt( value, 10 ) );
		},
	
		_hasScroll: function( el, a ) {
	
			if ( $( el ).css( "overflow" ) === "hidden") {
				return false;
			}
	
			var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
				has = false;
	
			if ( el[ scroll ] > 0 ) {
				return true;
			}
	
			// TODO: determine which cases actually cause this to happen
			// if the element doesn't have the scroll set, see if it's possible to
			// set the scroll
			el[ scroll ] = 1;
			has = ( el[ scroll ] > 0 );
			el[ scroll ] = 0;
			return has;
		},
	
		_create: function() {
	
			var n, i, handle, axis, hname,
				that = this,
				o = this.options;
			this.element.addClass("ui-resizable");
	
			$.extend(this, {
				_aspectRatio: !!(o.aspectRatio),
				aspectRatio: o.aspectRatio,
				originalElement: this.element,
				_proportionallyResizeElements: [],
				_helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
			});
	
			// Wrap the element if it cannot hold child nodes
			if (this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)) {
	
				this.element.wrap(
					$("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({
						position: this.element.css("position"),
						width: this.element.outerWidth(),
						height: this.element.outerHeight(),
						top: this.element.css("top"),
						left: this.element.css("left")
					})
				);
	
				this.element = this.element.parent().data(
					"ui-resizable", this.element.resizable( "instance" )
				);
	
				this.elementIsWrapper = true;
	
				this.element.css({
					marginLeft: this.originalElement.css("marginLeft"),
					marginTop: this.originalElement.css("marginTop"),
					marginRight: this.originalElement.css("marginRight"),
					marginBottom: this.originalElement.css("marginBottom")
				});
				this.originalElement.css({
					marginLeft: 0,
					marginTop: 0,
					marginRight: 0,
					marginBottom: 0
				});
				// support: Safari
				// Prevent Safari textarea resize
				this.originalResizeStyle = this.originalElement.css("resize");
				this.originalElement.css("resize", "none");
	
				this._proportionallyResizeElements.push( this.originalElement.css({
					position: "static",
					zoom: 1,
					display: "block"
				}) );
	
				// support: IE9
				// avoid IE jump (hard set the margin)
				this.originalElement.css({ margin: this.originalElement.css("margin") });
	
				this._proportionallyResize();
			}
	
			this.handles = o.handles ||
				( !$(".ui-resizable-handle", this.element).length ?
					"e,s,se" : {
						n: ".ui-resizable-n",
						e: ".ui-resizable-e",
						s: ".ui-resizable-s",
						w: ".ui-resizable-w",
						se: ".ui-resizable-se",
						sw: ".ui-resizable-sw",
						ne: ".ui-resizable-ne",
						nw: ".ui-resizable-nw"
					} );
	
			this._handles = $();
			if ( this.handles.constructor === String ) {
	
				if ( this.handles === "all") {
					this.handles = "n,e,s,w,se,sw,ne,nw";
				}
	
				n = this.handles.split(",");
				this.handles = {};
	
				for (i = 0; i < n.length; i++) {
	
					handle = $.trim(n[i]);
					hname = "ui-resizable-" + handle;
					axis = $("<div class='ui-resizable-handle " + hname + "'></div>");
	
					axis.css({ zIndex: o.zIndex });
	
					// TODO : What's going on here?
					if ("se" === handle) {
						axis.addClass("ui-icon ui-icon-gripsmall-diagonal-se");
					}
	
					this.handles[handle] = ".ui-resizable-" + handle;
					this.element.append(axis);
				}
	
			}
	
			this._renderAxis = function(target) {
	
				var i, axis, padPos, padWrapper;
	
				target = target || this.element;
	
				for (i in this.handles) {
	
					if (this.handles[i].constructor === String) {
						this.handles[i] = this.element.children( this.handles[ i ] ).first().show();
					} else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
						this.handles[ i ] = $( this.handles[ i ] );
						this._on( this.handles[ i ], { "mousedown": that._mouseDown });
					}
	
					if (this.elementIsWrapper && this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)) {
	
						axis = $(this.handles[i], this.element);
	
						padWrapper = /sw|ne|nw|se|n|s/.test(i) ? axis.outerHeight() : axis.outerWidth();
	
						padPos = [ "padding",
							/ne|nw|n/.test(i) ? "Top" :
							/se|sw|s/.test(i) ? "Bottom" :
							/^e$/.test(i) ? "Right" : "Left" ].join("");
	
						target.css(padPos, padWrapper);
	
						this._proportionallyResize();
					}
	
					this._handles = this._handles.add( this.handles[ i ] );
				}
			};
	
			// TODO: make renderAxis a prototype function
			this._renderAxis(this.element);
	
			this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
			this._handles.disableSelection();
	
			this._handles.mouseover(function() {
				if (!that.resizing) {
					if (this.className) {
						axis = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i);
					}
					that.axis = axis && axis[1] ? axis[1] : "se";
				}
			});
	
			if (o.autoHide) {
				this._handles.hide();
				$(this.element)
					.addClass("ui-resizable-autohide")
					.mouseenter(function() {
						if (o.disabled) {
							return;
						}
						$(this).removeClass("ui-resizable-autohide");
						that._handles.show();
					})
					.mouseleave(function() {
						if (o.disabled) {
							return;
						}
						if (!that.resizing) {
							$(this).addClass("ui-resizable-autohide");
							that._handles.hide();
						}
					});
			}
	
			this._mouseInit();
		},
	
		_destroy: function() {
	
			this._mouseDestroy();
	
			var wrapper,
				_destroy = function(exp) {
					$(exp)
						.removeClass("ui-resizable ui-resizable-disabled ui-resizable-resizing")
						.removeData("resizable")
						.removeData("ui-resizable")
						.unbind(".resizable")
						.find(".ui-resizable-handle")
							.remove();
				};
	
			// TODO: Unwrap at same DOM position
			if (this.elementIsWrapper) {
				_destroy(this.element);
				wrapper = this.element;
				this.originalElement.css({
					position: wrapper.css("position"),
					width: wrapper.outerWidth(),
					height: wrapper.outerHeight(),
					top: wrapper.css("top"),
					left: wrapper.css("left")
				}).insertAfter( wrapper );
				wrapper.remove();
			}
	
			this.originalElement.css("resize", this.originalResizeStyle);
			_destroy(this.originalElement);
	
			return this;
		},
	
		_mouseCapture: function(event) {
			var i, handle,
				capture = false;
	
			for (i in this.handles) {
				handle = $(this.handles[i])[0];
				if (handle === event.target || $.contains(handle, event.target)) {
					capture = true;
				}
			}
	
			return !this.options.disabled && capture;
		},
	
		_mouseStart: function(event) {
	
			var curleft, curtop, cursor,
				o = this.options,
				el = this.element;
	
			this.resizing = true;
	
			this._renderProxy();
	
			curleft = this._num(this.helper.css("left"));
			curtop = this._num(this.helper.css("top"));
	
			if (o.containment) {
				curleft += $(o.containment).scrollLeft() || 0;
				curtop += $(o.containment).scrollTop() || 0;
			}
	
			this.offset = this.helper.offset();
			this.position = { left: curleft, top: curtop };
	
			this.size = this._helper ? {
					width: this.helper.width(),
					height: this.helper.height()
				} : {
					width: el.width(),
					height: el.height()
				};
	
			this.originalSize = this._helper ? {
					width: el.outerWidth(),
					height: el.outerHeight()
				} : {
					width: el.width(),
					height: el.height()
				};
	
			this.sizeDiff = {
				width: el.outerWidth() - el.width(),
				height: el.outerHeight() - el.height()
			};
	
			this.originalPosition = { left: curleft, top: curtop };
			this.originalMousePosition = { left: event.pageX, top: event.pageY };
	
			this.aspectRatio = (typeof o.aspectRatio === "number") ?
				o.aspectRatio :
				((this.originalSize.width / this.originalSize.height) || 1);
	
			cursor = $(".ui-resizable-" + this.axis).css("cursor");
			$("body").css("cursor", cursor === "auto" ? this.axis + "-resize" : cursor);
	
			el.addClass("ui-resizable-resizing");
			this._propagate("start", event);
			return true;
		},
	
		_mouseDrag: function(event) {
	
			var data, props,
				smp = this.originalMousePosition,
				a = this.axis,
				dx = (event.pageX - smp.left) || 0,
				dy = (event.pageY - smp.top) || 0,
				trigger = this._change[a];
	
			this._updatePrevProperties();
	
			if (!trigger) {
				return false;
			}
	
			data = trigger.apply(this, [ event, dx, dy ]);
	
			this._updateVirtualBoundaries(event.shiftKey);
			if (this._aspectRatio || event.shiftKey) {
				data = this._updateRatio(data, event);
			}
	
			data = this._respectSize(data, event);
	
			this._updateCache(data);
	
			this._propagate("resize", event);
	
			props = this._applyChanges();
	
			if ( !this._helper && this._proportionallyResizeElements.length ) {
				this._proportionallyResize();
			}
	
			if ( !$.isEmptyObject( props ) ) {
				this._updatePrevProperties();
				this._trigger( "resize", event, this.ui() );
				this._applyChanges();
			}
	
			return false;
		},
	
		_mouseStop: function(event) {
	
			this.resizing = false;
			var pr, ista, soffseth, soffsetw, s, left, top,
				o = this.options, that = this;
	
			if (this._helper) {
	
				pr = this._proportionallyResizeElements;
				ista = pr.length && (/textarea/i).test(pr[0].nodeName);
				soffseth = ista && this._hasScroll(pr[0], "left") ? 0 : that.sizeDiff.height;
				soffsetw = ista ? 0 : that.sizeDiff.width;
	
				s = {
					width: (that.helper.width()  - soffsetw),
					height: (that.helper.height() - soffseth)
				};
				left = (parseInt(that.element.css("left"), 10) +
					(that.position.left - that.originalPosition.left)) || null;
				top = (parseInt(that.element.css("top"), 10) +
					(that.position.top - that.originalPosition.top)) || null;
	
				if (!o.animate) {
					this.element.css($.extend(s, { top: top, left: left }));
				}
	
				that.helper.height(that.size.height);
				that.helper.width(that.size.width);
	
				if (this._helper && !o.animate) {
					this._proportionallyResize();
				}
			}
	
			$("body").css("cursor", "auto");
	
			this.element.removeClass("ui-resizable-resizing");
	
			this._propagate("stop", event);
	
			if (this._helper) {
				this.helper.remove();
			}
	
			return false;
	
		},
	
		_updatePrevProperties: function() {
			this.prevPosition = {
				top: this.position.top,
				left: this.position.left
			};
			this.prevSize = {
				width: this.size.width,
				height: this.size.height
			};
		},
	
		_applyChanges: function() {
			var props = {};
	
			if ( this.position.top !== this.prevPosition.top ) {
				props.top = this.position.top + "px";
			}
			if ( this.position.left !== this.prevPosition.left ) {
				props.left = this.position.left + "px";
			}
			if ( this.size.width !== this.prevSize.width ) {
				props.width = this.size.width + "px";
			}
			if ( this.size.height !== this.prevSize.height ) {
				props.height = this.size.height + "px";
			}
	
			this.helper.css( props );
	
			return props;
		},
	
		_updateVirtualBoundaries: function(forceAspectRatio) {
			var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
				o = this.options;
	
			b = {
				minWidth: this._isNumber(o.minWidth) ? o.minWidth : 0,
				maxWidth: this._isNumber(o.maxWidth) ? o.maxWidth : Infinity,
				minHeight: this._isNumber(o.minHeight) ? o.minHeight : 0,
				maxHeight: this._isNumber(o.maxHeight) ? o.maxHeight : Infinity
			};
	
			if (this._aspectRatio || forceAspectRatio) {
				pMinWidth = b.minHeight * this.aspectRatio;
				pMinHeight = b.minWidth / this.aspectRatio;
				pMaxWidth = b.maxHeight * this.aspectRatio;
				pMaxHeight = b.maxWidth / this.aspectRatio;
	
				if (pMinWidth > b.minWidth) {
					b.minWidth = pMinWidth;
				}
				if (pMinHeight > b.minHeight) {
					b.minHeight = pMinHeight;
				}
				if (pMaxWidth < b.maxWidth) {
					b.maxWidth = pMaxWidth;
				}
				if (pMaxHeight < b.maxHeight) {
					b.maxHeight = pMaxHeight;
				}
			}
			this._vBoundaries = b;
		},
	
		_updateCache: function(data) {
			this.offset = this.helper.offset();
			if (this._isNumber(data.left)) {
				this.position.left = data.left;
			}
			if (this._isNumber(data.top)) {
				this.position.top = data.top;
			}
			if (this._isNumber(data.height)) {
				this.size.height = data.height;
			}
			if (this._isNumber(data.width)) {
				this.size.width = data.width;
			}
		},
	
		_updateRatio: function( data ) {
	
			var cpos = this.position,
				csize = this.size,
				a = this.axis;
	
			if (this._isNumber(data.height)) {
				data.width = (data.height * this.aspectRatio);
			} else if (this._isNumber(data.width)) {
				data.height = (data.width / this.aspectRatio);
			}
	
			if (a === "sw") {
				data.left = cpos.left + (csize.width - data.width);
				data.top = null;
			}
			if (a === "nw") {
				data.top = cpos.top + (csize.height - data.height);
				data.left = cpos.left + (csize.width - data.width);
			}
	
			return data;
		},
	
		_respectSize: function( data ) {
	
			var o = this._vBoundaries,
				a = this.axis,
				ismaxw = this._isNumber(data.width) && o.maxWidth && (o.maxWidth < data.width),
				ismaxh = this._isNumber(data.height) && o.maxHeight && (o.maxHeight < data.height),
				isminw = this._isNumber(data.width) && o.minWidth && (o.minWidth > data.width),
				isminh = this._isNumber(data.height) && o.minHeight && (o.minHeight > data.height),
				dw = this.originalPosition.left + this.originalSize.width,
				dh = this.position.top + this.size.height,
				cw = /sw|nw|w/.test(a), ch = /nw|ne|n/.test(a);
			if (isminw) {
				data.width = o.minWidth;
			}
			if (isminh) {
				data.height = o.minHeight;
			}
			if (ismaxw) {
				data.width = o.maxWidth;
			}
			if (ismaxh) {
				data.height = o.maxHeight;
			}
	
			if (isminw && cw) {
				data.left = dw - o.minWidth;
			}
			if (ismaxw && cw) {
				data.left = dw - o.maxWidth;
			}
			if (isminh && ch) {
				data.top = dh - o.minHeight;
			}
			if (ismaxh && ch) {
				data.top = dh - o.maxHeight;
			}
	
			// Fixing jump error on top/left - bug #2330
			if (!data.width && !data.height && !data.left && data.top) {
				data.top = null;
			} else if (!data.width && !data.height && !data.top && data.left) {
				data.left = null;
			}
	
			return data;
		},
	
		_getPaddingPlusBorderDimensions: function( element ) {
			var i = 0,
				widths = [],
				borders = [
					element.css( "borderTopWidth" ),
					element.css( "borderRightWidth" ),
					element.css( "borderBottomWidth" ),
					element.css( "borderLeftWidth" )
				],
				paddings = [
					element.css( "paddingTop" ),
					element.css( "paddingRight" ),
					element.css( "paddingBottom" ),
					element.css( "paddingLeft" )
				];
	
			for ( ; i < 4; i++ ) {
				widths[ i ] = ( parseInt( borders[ i ], 10 ) || 0 );
				widths[ i ] += ( parseInt( paddings[ i ], 10 ) || 0 );
			}
	
			return {
				height: widths[ 0 ] + widths[ 2 ],
				width: widths[ 1 ] + widths[ 3 ]
			};
		},
	
		_proportionallyResize: function() {
	
			if (!this._proportionallyResizeElements.length) {
				return;
			}
	
			var prel,
				i = 0,
				element = this.helper || this.element;
	
			for ( ; i < this._proportionallyResizeElements.length; i++) {
	
				prel = this._proportionallyResizeElements[i];
	
				// TODO: Seems like a bug to cache this.outerDimensions
				// considering that we are in a loop.
				if (!this.outerDimensions) {
					this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
				}
	
				prel.css({
					height: (element.height() - this.outerDimensions.height) || 0,
					width: (element.width() - this.outerDimensions.width) || 0
				});
	
			}
	
		},
	
		_renderProxy: function() {
	
			var el = this.element, o = this.options;
			this.elementOffset = el.offset();
	
			if (this._helper) {
	
				this.helper = this.helper || $("<div style='overflow:hidden;'></div>");
	
				this.helper.addClass(this._helper).css({
					width: this.element.outerWidth() - 1,
					height: this.element.outerHeight() - 1,
					position: "absolute",
					left: this.elementOffset.left + "px",
					top: this.elementOffset.top + "px",
					zIndex: ++o.zIndex //TODO: Don't modify option
				});
	
				this.helper
					.appendTo("body")
					.disableSelection();
	
			} else {
				this.helper = this.element;
			}
	
		},
	
		_change: {
			e: function(event, dx) {
				return { width: this.originalSize.width + dx };
			},
			w: function(event, dx) {
				var cs = this.originalSize, sp = this.originalPosition;
				return { left: sp.left + dx, width: cs.width - dx };
			},
			n: function(event, dx, dy) {
				var cs = this.originalSize, sp = this.originalPosition;
				return { top: sp.top + dy, height: cs.height - dy };
			},
			s: function(event, dx, dy) {
				return { height: this.originalSize.height + dy };
			},
			se: function(event, dx, dy) {
				return $.extend(this._change.s.apply(this, arguments),
					this._change.e.apply(this, [ event, dx, dy ]));
			},
			sw: function(event, dx, dy) {
				return $.extend(this._change.s.apply(this, arguments),
					this._change.w.apply(this, [ event, dx, dy ]));
			},
			ne: function(event, dx, dy) {
				return $.extend(this._change.n.apply(this, arguments),
					this._change.e.apply(this, [ event, dx, dy ]));
			},
			nw: function(event, dx, dy) {
				return $.extend(this._change.n.apply(this, arguments),
					this._change.w.apply(this, [ event, dx, dy ]));
			}
		},
	
		_propagate: function(n, event) {
			$.ui.plugin.call(this, n, [ event, this.ui() ]);
			(n !== "resize" && this._trigger(n, event, this.ui()));
		},
	
		plugins: {},
	
		ui: function() {
			return {
				originalElement: this.originalElement,
				element: this.element,
				helper: this.helper,
				position: this.position,
				size: this.size,
				originalSize: this.originalSize,
				originalPosition: this.originalPosition
			};
		}
	
	});
	
	/*
	 * Resizable Extensions
	 */
	
	$.ui.plugin.add("resizable", "animate", {
	
		stop: function( event ) {
			var that = $(this).resizable( "instance" ),
				o = that.options,
				pr = that._proportionallyResizeElements,
				ista = pr.length && (/textarea/i).test(pr[0].nodeName),
				soffseth = ista && that._hasScroll(pr[0], "left") ? 0 : that.sizeDiff.height,
				soffsetw = ista ? 0 : that.sizeDiff.width,
				style = { width: (that.size.width - soffsetw), height: (that.size.height - soffseth) },
				left = (parseInt(that.element.css("left"), 10) +
					(that.position.left - that.originalPosition.left)) || null,
				top = (parseInt(that.element.css("top"), 10) +
					(that.position.top - that.originalPosition.top)) || null;
	
			that.element.animate(
				$.extend(style, top && left ? { top: top, left: left } : {}), {
					duration: o.animateDuration,
					easing: o.animateEasing,
					step: function() {
	
						var data = {
							width: parseInt(that.element.css("width"), 10),
							height: parseInt(that.element.css("height"), 10),
							top: parseInt(that.element.css("top"), 10),
							left: parseInt(that.element.css("left"), 10)
						};
	
						if (pr && pr.length) {
							$(pr[0]).css({ width: data.width, height: data.height });
						}
	
						// propagating resize, and updating values for each animation step
						that._updateCache(data);
						that._propagate("resize", event);
	
					}
				}
			);
		}
	
	});
	
	$.ui.plugin.add( "resizable", "containment", {
	
		start: function() {
			var element, p, co, ch, cw, width, height,
				that = $( this ).resizable( "instance" ),
				o = that.options,
				el = that.element,
				oc = o.containment,
				ce = ( oc instanceof $ ) ? oc.get( 0 ) : ( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;
	
			if ( !ce ) {
				return;
			}
	
			that.containerElement = $( ce );
	
			if ( /document/.test( oc ) || oc === document ) {
				that.containerOffset = {
					left: 0,
					top: 0
				};
				that.containerPosition = {
					left: 0,
					top: 0
				};
	
				that.parentData = {
					element: $( document ),
					left: 0,
					top: 0,
					width: $( document ).width(),
					height: $( document ).height() || document.body.parentNode.scrollHeight
				};
			} else {
				element = $( ce );
				p = [];
				$([ "Top", "Right", "Left", "Bottom" ]).each(function( i, name ) {
					p[ i ] = that._num( element.css( "padding" + name ) );
				});
	
				that.containerOffset = element.offset();
				that.containerPosition = element.position();
				that.containerSize = {
					height: ( element.innerHeight() - p[ 3 ] ),
					width: ( element.innerWidth() - p[ 1 ] )
				};
	
				co = that.containerOffset;
				ch = that.containerSize.height;
				cw = that.containerSize.width;
				width = ( that._hasScroll ( ce, "left" ) ? ce.scrollWidth : cw );
				height = ( that._hasScroll ( ce ) ? ce.scrollHeight : ch ) ;
	
				that.parentData = {
					element: ce,
					left: co.left,
					top: co.top,
					width: width,
					height: height
				};
			}
		},
	
		resize: function( event ) {
			var woset, hoset, isParent, isOffsetRelative,
				that = $( this ).resizable( "instance" ),
				o = that.options,
				co = that.containerOffset,
				cp = that.position,
				pRatio = that._aspectRatio || event.shiftKey,
				cop = {
					top: 0,
					left: 0
				},
				ce = that.containerElement,
				continueResize = true;
	
			if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
				cop = co;
			}
	
			if ( cp.left < ( that._helper ? co.left : 0 ) ) {
				that.size.width = that.size.width +
					( that._helper ?
						( that.position.left - co.left ) :
						( that.position.left - cop.left ) );
	
				if ( pRatio ) {
					that.size.height = that.size.width / that.aspectRatio;
					continueResize = false;
				}
				that.position.left = o.helper ? co.left : 0;
			}
	
			if ( cp.top < ( that._helper ? co.top : 0 ) ) {
				that.size.height = that.size.height +
					( that._helper ?
						( that.position.top - co.top ) :
						that.position.top );
	
				if ( pRatio ) {
					that.size.width = that.size.height * that.aspectRatio;
					continueResize = false;
				}
				that.position.top = that._helper ? co.top : 0;
			}
	
			isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
			isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );
	
			if ( isParent && isOffsetRelative ) {
				that.offset.left = that.parentData.left + that.position.left;
				that.offset.top = that.parentData.top + that.position.top;
			} else {
				that.offset.left = that.element.offset().left;
				that.offset.top = that.element.offset().top;
			}
	
			woset = Math.abs( that.sizeDiff.width +
				(that._helper ?
					that.offset.left - cop.left :
					(that.offset.left - co.left)) );
	
			hoset = Math.abs( that.sizeDiff.height +
				(that._helper ?
					that.offset.top - cop.top :
					(that.offset.top - co.top)) );
	
			if ( woset + that.size.width >= that.parentData.width ) {
				that.size.width = that.parentData.width - woset;
				if ( pRatio ) {
					that.size.height = that.size.width / that.aspectRatio;
					continueResize = false;
				}
			}
	
			if ( hoset + that.size.height >= that.parentData.height ) {
				that.size.height = that.parentData.height - hoset;
				if ( pRatio ) {
					that.size.width = that.size.height * that.aspectRatio;
					continueResize = false;
				}
			}
	
			if ( !continueResize ) {
				that.position.left = that.prevPosition.left;
				that.position.top = that.prevPosition.top;
				that.size.width = that.prevSize.width;
				that.size.height = that.prevSize.height;
			}
		},
	
		stop: function() {
			var that = $( this ).resizable( "instance" ),
				o = that.options,
				co = that.containerOffset,
				cop = that.containerPosition,
				ce = that.containerElement,
				helper = $( that.helper ),
				ho = helper.offset(),
				w = helper.outerWidth() - that.sizeDiff.width,
				h = helper.outerHeight() - that.sizeDiff.height;
	
			if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
				$( this ).css({
					left: ho.left - cop.left - co.left,
					width: w,
					height: h
				});
			}
	
			if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
				$( this ).css({
					left: ho.left - cop.left - co.left,
					width: w,
					height: h
				});
			}
		}
	});
	
	$.ui.plugin.add("resizable", "alsoResize", {
	
		start: function() {
			var that = $(this).resizable( "instance" ),
				o = that.options;
	
			$(o.alsoResize).each(function() {
				var el = $(this);
				el.data("ui-resizable-alsoresize", {
					width: parseInt(el.width(), 10), height: parseInt(el.height(), 10),
					left: parseInt(el.css("left"), 10), top: parseInt(el.css("top"), 10)
				});
			});
		},
	
		resize: function(event, ui) {
			var that = $(this).resizable( "instance" ),
				o = that.options,
				os = that.originalSize,
				op = that.originalPosition,
				delta = {
					height: (that.size.height - os.height) || 0,
					width: (that.size.width - os.width) || 0,
					top: (that.position.top - op.top) || 0,
					left: (that.position.left - op.left) || 0
				};
	
				$(o.alsoResize).each(function() {
					var el = $(this), start = $(this).data("ui-resizable-alsoresize"), style = {},
						css = el.parents(ui.originalElement[0]).length ?
								[ "width", "height" ] :
								[ "width", "height", "top", "left" ];
	
					$.each(css, function(i, prop) {
						var sum = (start[prop] || 0) + (delta[prop] || 0);
						if (sum && sum >= 0) {
							style[prop] = sum || null;
						}
					});
	
					el.css(style);
				});
		},
	
		stop: function() {
			$(this).removeData("resizable-alsoresize");
		}
	});
	
	$.ui.plugin.add("resizable", "ghost", {
	
		start: function() {
	
			var that = $(this).resizable( "instance" ), o = that.options, cs = that.size;
	
			that.ghost = that.originalElement.clone();
			that.ghost
				.css({
					opacity: 0.25,
					display: "block",
					position: "relative",
					height: cs.height,
					width: cs.width,
					margin: 0,
					left: 0,
					top: 0
				})
				.addClass("ui-resizable-ghost")
				.addClass(typeof o.ghost === "string" ? o.ghost : "");
	
			that.ghost.appendTo(that.helper);
	
		},
	
		resize: function() {
			var that = $(this).resizable( "instance" );
			if (that.ghost) {
				that.ghost.css({
					position: "relative",
					height: that.size.height,
					width: that.size.width
				});
			}
		},
	
		stop: function() {
			var that = $(this).resizable( "instance" );
			if (that.ghost && that.helper) {
				that.helper.get(0).removeChild(that.ghost.get(0));
			}
		}
	
	});
	
	$.ui.plugin.add("resizable", "grid", {
	
		resize: function() {
			var outerDimensions,
				that = $(this).resizable( "instance" ),
				o = that.options,
				cs = that.size,
				os = that.originalSize,
				op = that.originalPosition,
				a = that.axis,
				grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
				gridX = (grid[0] || 1),
				gridY = (grid[1] || 1),
				ox = Math.round((cs.width - os.width) / gridX) * gridX,
				oy = Math.round((cs.height - os.height) / gridY) * gridY,
				newWidth = os.width + ox,
				newHeight = os.height + oy,
				isMaxWidth = o.maxWidth && (o.maxWidth < newWidth),
				isMaxHeight = o.maxHeight && (o.maxHeight < newHeight),
				isMinWidth = o.minWidth && (o.minWidth > newWidth),
				isMinHeight = o.minHeight && (o.minHeight > newHeight);
	
			o.grid = grid;
	
			if (isMinWidth) {
				newWidth += gridX;
			}
			if (isMinHeight) {
				newHeight += gridY;
			}
			if (isMaxWidth) {
				newWidth -= gridX;
			}
			if (isMaxHeight) {
				newHeight -= gridY;
			}
	
			if (/^(se|s|e)$/.test(a)) {
				that.size.width = newWidth;
				that.size.height = newHeight;
			} else if (/^(ne)$/.test(a)) {
				that.size.width = newWidth;
				that.size.height = newHeight;
				that.position.top = op.top - oy;
			} else if (/^(sw)$/.test(a)) {
				that.size.width = newWidth;
				that.size.height = newHeight;
				that.position.left = op.left - ox;
			} else {
				if ( newHeight - gridY <= 0 || newWidth - gridX <= 0) {
					outerDimensions = that._getPaddingPlusBorderDimensions( this );
				}
	
				if ( newHeight - gridY > 0 ) {
					that.size.height = newHeight;
					that.position.top = op.top - oy;
				} else {
					newHeight = gridY - outerDimensions.height;
					that.size.height = newHeight;
					that.position.top = op.top + os.height - newHeight;
				}
				if ( newWidth - gridX > 0 ) {
					that.size.width = newWidth;
					that.position.left = op.left - ox;
				} else {
					newWidth = gridX - outerDimensions.width;
					that.size.width = newWidth;
					that.position.left = op.left + os.width - newWidth;
				}
			}
		}
	
	});
	
	var resizable = $.ui.resizable;
	
	
	/*!
	 * jQuery UI Selectable 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/selectable/
	 */
	
	
	var selectable = $.widget("ui.selectable", $.ui.mouse, {
		version: "1.11.4",
		options: {
			appendTo: "body",
			autoRefresh: true,
			distance: 0,
			filter: "*",
			tolerance: "touch",
	
			// callbacks
			selected: null,
			selecting: null,
			start: null,
			stop: null,
			unselected: null,
			unselecting: null
		},
		_create: function() {
			var selectees,
				that = this;
	
			this.element.addClass("ui-selectable");
	
			this.dragged = false;
	
			// cache selectee children based on filter
			this.refresh = function() {
				selectees = $(that.options.filter, that.element[0]);
				selectees.addClass("ui-selectee");
				selectees.each(function() {
					var $this = $(this),
						pos = $this.offset();
					$.data(this, "selectable-item", {
						element: this,
						$element: $this,
						left: pos.left,
						top: pos.top,
						right: pos.left + $this.outerWidth(),
						bottom: pos.top + $this.outerHeight(),
						startselected: false,
						selected: $this.hasClass("ui-selected"),
						selecting: $this.hasClass("ui-selecting"),
						unselecting: $this.hasClass("ui-unselecting")
					});
				});
			};
			this.refresh();
	
			this.selectees = selectees.addClass("ui-selectee");
	
			this._mouseInit();
	
			this.helper = $("<div class='ui-selectable-helper'></div>");
		},
	
		_destroy: function() {
			this.selectees
				.removeClass("ui-selectee")
				.removeData("selectable-item");
			this.element
				.removeClass("ui-selectable ui-selectable-disabled");
			this._mouseDestroy();
		},
	
		_mouseStart: function(event) {
			var that = this,
				options = this.options;
	
			this.opos = [ event.pageX, event.pageY ];
	
			if (this.options.disabled) {
				return;
			}
	
			this.selectees = $(options.filter, this.element[0]);
	
			this._trigger("start", event);
	
			$(options.appendTo).append(this.helper);
			// position helper (lasso)
			this.helper.css({
				"left": event.pageX,
				"top": event.pageY,
				"width": 0,
				"height": 0
			});
	
			if (options.autoRefresh) {
				this.refresh();
			}
	
			this.selectees.filter(".ui-selected").each(function() {
				var selectee = $.data(this, "selectable-item");
				selectee.startselected = true;
				if (!event.metaKey && !event.ctrlKey) {
					selectee.$element.removeClass("ui-selected");
					selectee.selected = false;
					selectee.$element.addClass("ui-unselecting");
					selectee.unselecting = true;
					// selectable UNSELECTING callback
					that._trigger("unselecting", event, {
						unselecting: selectee.element
					});
				}
			});
	
			$(event.target).parents().addBack().each(function() {
				var doSelect,
					selectee = $.data(this, "selectable-item");
				if (selectee) {
					doSelect = (!event.metaKey && !event.ctrlKey) || !selectee.$element.hasClass("ui-selected");
					selectee.$element
						.removeClass(doSelect ? "ui-unselecting" : "ui-selected")
						.addClass(doSelect ? "ui-selecting" : "ui-unselecting");
					selectee.unselecting = !doSelect;
					selectee.selecting = doSelect;
					selectee.selected = doSelect;
					// selectable (UN)SELECTING callback
					if (doSelect) {
						that._trigger("selecting", event, {
							selecting: selectee.element
						});
					} else {
						that._trigger("unselecting", event, {
							unselecting: selectee.element
						});
					}
					return false;
				}
			});
	
		},
	
		_mouseDrag: function(event) {
	
			this.dragged = true;
	
			if (this.options.disabled) {
				return;
			}
	
			var tmp,
				that = this,
				options = this.options,
				x1 = this.opos[0],
				y1 = this.opos[1],
				x2 = event.pageX,
				y2 = event.pageY;
	
			if (x1 > x2) { tmp = x2; x2 = x1; x1 = tmp; }
			if (y1 > y2) { tmp = y2; y2 = y1; y1 = tmp; }
			this.helper.css({ left: x1, top: y1, width: x2 - x1, height: y2 - y1 });
	
			this.selectees.each(function() {
				var selectee = $.data(this, "selectable-item"),
					hit = false;
	
				//prevent helper from being selected if appendTo: selectable
				if (!selectee || selectee.element === that.element[0]) {
					return;
				}
	
				if (options.tolerance === "touch") {
					hit = ( !(selectee.left > x2 || selectee.right < x1 || selectee.top > y2 || selectee.bottom < y1) );
				} else if (options.tolerance === "fit") {
					hit = (selectee.left > x1 && selectee.right < x2 && selectee.top > y1 && selectee.bottom < y2);
				}
	
				if (hit) {
					// SELECT
					if (selectee.selected) {
						selectee.$element.removeClass("ui-selected");
						selectee.selected = false;
					}
					if (selectee.unselecting) {
						selectee.$element.removeClass("ui-unselecting");
						selectee.unselecting = false;
					}
					if (!selectee.selecting) {
						selectee.$element.addClass("ui-selecting");
						selectee.selecting = true;
						// selectable SELECTING callback
						that._trigger("selecting", event, {
							selecting: selectee.element
						});
					}
				} else {
					// UNSELECT
					if (selectee.selecting) {
						if ((event.metaKey || event.ctrlKey) && selectee.startselected) {
							selectee.$element.removeClass("ui-selecting");
							selectee.selecting = false;
							selectee.$element.addClass("ui-selected");
							selectee.selected = true;
						} else {
							selectee.$element.removeClass("ui-selecting");
							selectee.selecting = false;
							if (selectee.startselected) {
								selectee.$element.addClass("ui-unselecting");
								selectee.unselecting = true;
							}
							// selectable UNSELECTING callback
							that._trigger("unselecting", event, {
								unselecting: selectee.element
							});
						}
					}
					if (selectee.selected) {
						if (!event.metaKey && !event.ctrlKey && !selectee.startselected) {
							selectee.$element.removeClass("ui-selected");
							selectee.selected = false;
	
							selectee.$element.addClass("ui-unselecting");
							selectee.unselecting = true;
							// selectable UNSELECTING callback
							that._trigger("unselecting", event, {
								unselecting: selectee.element
							});
						}
					}
				}
			});
	
			return false;
		},
	
		_mouseStop: function(event) {
			var that = this;
	
			this.dragged = false;
	
			$(".ui-unselecting", this.element[0]).each(function() {
				var selectee = $.data(this, "selectable-item");
				selectee.$element.removeClass("ui-unselecting");
				selectee.unselecting = false;
				selectee.startselected = false;
				that._trigger("unselected", event, {
					unselected: selectee.element
				});
			});
			$(".ui-selecting", this.element[0]).each(function() {
				var selectee = $.data(this, "selectable-item");
				selectee.$element.removeClass("ui-selecting").addClass("ui-selected");
				selectee.selecting = false;
				selectee.selected = true;
				selectee.startselected = true;
				that._trigger("selected", event, {
					selected: selectee.element
				});
			});
			this._trigger("stop", event);
	
			this.helper.remove();
	
			return false;
		}
	
	});
	
	
	/*!
	 * jQuery UI Sortable 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/sortable/
	 */
	
	
	var sortable = $.widget("ui.sortable", $.ui.mouse, {
		version: "1.11.4",
		widgetEventPrefix: "sort",
		ready: false,
		options: {
			appendTo: "parent",
			axis: false,
			connectWith: false,
			containment: false,
			cursor: "auto",
			cursorAt: false,
			dropOnEmpty: true,
			forcePlaceholderSize: false,
			forceHelperSize: false,
			grid: false,
			handle: false,
			helper: "original",
			items: "> *",
			opacity: false,
			placeholder: false,
			revert: false,
			scroll: true,
			scrollSensitivity: 20,
			scrollSpeed: 20,
			scope: "default",
			tolerance: "intersect",
			zIndex: 1000,
	
			// callbacks
			activate: null,
			beforeStop: null,
			change: null,
			deactivate: null,
			out: null,
			over: null,
			receive: null,
			remove: null,
			sort: null,
			start: null,
			stop: null,
			update: null
		},
	
		_isOverAxis: function( x, reference, size ) {
			return ( x >= reference ) && ( x < ( reference + size ) );
		},
	
		_isFloating: function( item ) {
			return (/left|right/).test(item.css("float")) || (/inline|table-cell/).test(item.css("display"));
		},
	
		_create: function() {
			this.containerCache = {};
			this.element.addClass("ui-sortable");
	
			//Get the items
			this.refresh();
	
			//Let's determine the parent's offset
			this.offset = this.element.offset();
	
			//Initialize mouse events for interaction
			this._mouseInit();
	
			this._setHandleClassName();
	
			//We're ready to go
			this.ready = true;
	
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
	
			if ( key === "handle" ) {
				this._setHandleClassName();
			}
		},
	
		_setHandleClassName: function() {
			this.element.find( ".ui-sortable-handle" ).removeClass( "ui-sortable-handle" );
			$.each( this.items, function() {
				( this.instance.options.handle ?
					this.item.find( this.instance.options.handle ) : this.item )
					.addClass( "ui-sortable-handle" );
			});
		},
	
		_destroy: function() {
			this.element
				.removeClass( "ui-sortable ui-sortable-disabled" )
				.find( ".ui-sortable-handle" )
					.removeClass( "ui-sortable-handle" );
			this._mouseDestroy();
	
			for ( var i = this.items.length - 1; i >= 0; i-- ) {
				this.items[i].item.removeData(this.widgetName + "-item");
			}
	
			return this;
		},
	
		_mouseCapture: function(event, overrideHandle) {
			var currentItem = null,
				validHandle = false,
				that = this;
	
			if (this.reverting) {
				return false;
			}
	
			if(this.options.disabled || this.options.type === "static") {
				return false;
			}
	
			//We have to refresh the items data once first
			this._refreshItems(event);
	
			//Find out if the clicked node (or one of its parents) is a actual item in this.items
			$(event.target).parents().each(function() {
				if($.data(this, that.widgetName + "-item") === that) {
					currentItem = $(this);
					return false;
				}
			});
			if($.data(event.target, that.widgetName + "-item") === that) {
				currentItem = $(event.target);
			}
	
			if(!currentItem) {
				return false;
			}
			if(this.options.handle && !overrideHandle) {
				$(this.options.handle, currentItem).find("*").addBack().each(function() {
					if(this === event.target) {
						validHandle = true;
					}
				});
				if(!validHandle) {
					return false;
				}
			}
	
			this.currentItem = currentItem;
			this._removeCurrentsFromItems();
			return true;
	
		},
	
		_mouseStart: function(event, overrideHandle, noActivation) {
	
			var i, body,
				o = this.options;
	
			this.currentContainer = this;
	
			//We only need to call refreshPositions, because the refreshItems call has been moved to mouseCapture
			this.refreshPositions();
	
			//Create and append the visible helper
			this.helper = this._createHelper(event);
	
			//Cache the helper size
			this._cacheHelperProportions();
	
			/*
			 * - Position generation -
			 * This block generates everything position related - it's the core of draggables.
			 */
	
			//Cache the margins of the original element
			this._cacheMargins();
	
			//Get the next scrolling parent
			this.scrollParent = this.helper.scrollParent();
	
			//The element's absolute position on the page minus margins
			this.offset = this.currentItem.offset();
			this.offset = {
				top: this.offset.top - this.margins.top,
				left: this.offset.left - this.margins.left
			};
	
			$.extend(this.offset, {
				click: { //Where the click happened, relative to the element
					left: event.pageX - this.offset.left,
					top: event.pageY - this.offset.top
				},
				parent: this._getParentOffset(),
				relative: this._getRelativeOffset() //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
			});
	
			// Only after we got the offset, we can change the helper's position to absolute
			// TODO: Still need to figure out a way to make relative sorting possible
			this.helper.css("position", "absolute");
			this.cssPosition = this.helper.css("position");
	
			//Generate the original position
			this.originalPosition = this._generatePosition(event);
			this.originalPageX = event.pageX;
			this.originalPageY = event.pageY;
	
			//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
			(o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));
	
			//Cache the former DOM position
			this.domPosition = { prev: this.currentItem.prev()[0], parent: this.currentItem.parent()[0] };
	
			//If the helper is not the original, hide the original so it's not playing any role during the drag, won't cause anything bad this way
			if(this.helper[0] !== this.currentItem[0]) {
				this.currentItem.hide();
			}
	
			//Create the placeholder
			this._createPlaceholder();
	
			//Set a containment if given in the options
			if(o.containment) {
				this._setContainment();
			}
	
			if( o.cursor && o.cursor !== "auto" ) { // cursor option
				body = this.document.find( "body" );
	
				// support: IE
				this.storedCursor = body.css( "cursor" );
				body.css( "cursor", o.cursor );
	
				this.storedStylesheet = $( "<style>*{ cursor: "+o.cursor+" !important; }</style>" ).appendTo( body );
			}
	
			if(o.opacity) { // opacity option
				if (this.helper.css("opacity")) {
					this._storedOpacity = this.helper.css("opacity");
				}
				this.helper.css("opacity", o.opacity);
			}
	
			if(o.zIndex) { // zIndex option
				if (this.helper.css("zIndex")) {
					this._storedZIndex = this.helper.css("zIndex");
				}
				this.helper.css("zIndex", o.zIndex);
			}
	
			//Prepare scrolling
			if(this.scrollParent[0] !== this.document[0] && this.scrollParent[0].tagName !== "HTML") {
				this.overflowOffset = this.scrollParent.offset();
			}
	
			//Call callbacks
			this._trigger("start", event, this._uiHash());
	
			//Recache the helper size
			if(!this._preserveHelperProportions) {
				this._cacheHelperProportions();
			}
	
	
			//Post "activate" events to possible containers
			if( !noActivation ) {
				for ( i = this.containers.length - 1; i >= 0; i-- ) {
					this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
				}
			}
	
			//Prepare possible droppables
			if($.ui.ddmanager) {
				$.ui.ddmanager.current = this;
			}
	
			if ($.ui.ddmanager && !o.dropBehaviour) {
				$.ui.ddmanager.prepareOffsets(this, event);
			}
	
			this.dragging = true;
	
			this.helper.addClass("ui-sortable-helper");
			this._mouseDrag(event); //Execute the drag once - this causes the helper not to be visible before getting its correct position
			return true;
	
		},
	
		_mouseDrag: function(event) {
			var i, item, itemElement, intersection,
				o = this.options,
				scrolled = false;
	
			//Compute the helpers position
			this.position = this._generatePosition(event);
			this.positionAbs = this._convertPositionTo("absolute");
	
			if (!this.lastPositionAbs) {
				this.lastPositionAbs = this.positionAbs;
			}
	
			//Do scrolling
			if(this.options.scroll) {
				if(this.scrollParent[0] !== this.document[0] && this.scrollParent[0].tagName !== "HTML") {
	
					if((this.overflowOffset.top + this.scrollParent[0].offsetHeight) - event.pageY < o.scrollSensitivity) {
						this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop + o.scrollSpeed;
					} else if(event.pageY - this.overflowOffset.top < o.scrollSensitivity) {
						this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop - o.scrollSpeed;
					}
	
					if((this.overflowOffset.left + this.scrollParent[0].offsetWidth) - event.pageX < o.scrollSensitivity) {
						this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft + o.scrollSpeed;
					} else if(event.pageX - this.overflowOffset.left < o.scrollSensitivity) {
						this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft - o.scrollSpeed;
					}
	
				} else {
	
					if(event.pageY - this.document.scrollTop() < o.scrollSensitivity) {
						scrolled = this.document.scrollTop(this.document.scrollTop() - o.scrollSpeed);
					} else if(this.window.height() - (event.pageY - this.document.scrollTop()) < o.scrollSensitivity) {
						scrolled = this.document.scrollTop(this.document.scrollTop() + o.scrollSpeed);
					}
	
					if(event.pageX - this.document.scrollLeft() < o.scrollSensitivity) {
						scrolled = this.document.scrollLeft(this.document.scrollLeft() - o.scrollSpeed);
					} else if(this.window.width() - (event.pageX - this.document.scrollLeft()) < o.scrollSensitivity) {
						scrolled = this.document.scrollLeft(this.document.scrollLeft() + o.scrollSpeed);
					}
	
				}
	
				if(scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
					$.ui.ddmanager.prepareOffsets(this, event);
				}
			}
	
			//Regenerate the absolute position used for position checks
			this.positionAbs = this._convertPositionTo("absolute");
	
			//Set the helper position
			if(!this.options.axis || this.options.axis !== "y") {
				this.helper[0].style.left = this.position.left+"px";
			}
			if(!this.options.axis || this.options.axis !== "x") {
				this.helper[0].style.top = this.position.top+"px";
			}
	
			//Rearrange
			for (i = this.items.length - 1; i >= 0; i--) {
	
				//Cache variables and intersection, continue if no intersection
				item = this.items[i];
				itemElement = item.item[0];
				intersection = this._intersectsWithPointer(item);
				if (!intersection) {
					continue;
				}
	
				// Only put the placeholder inside the current Container, skip all
				// items from other containers. This works because when moving
				// an item from one container to another the
				// currentContainer is switched before the placeholder is moved.
				//
				// Without this, moving items in "sub-sortables" can cause
				// the placeholder to jitter between the outer and inner container.
				if (item.instance !== this.currentContainer) {
					continue;
				}
	
				// cannot intersect with itself
				// no useless actions that have been done before
				// no action if the item moved is the parent of the item checked
				if (itemElement !== this.currentItem[0] &&
					this.placeholder[intersection === 1 ? "next" : "prev"]()[0] !== itemElement &&
					!$.contains(this.placeholder[0], itemElement) &&
					(this.options.type === "semi-dynamic" ? !$.contains(this.element[0], itemElement) : true)
				) {
	
					this.direction = intersection === 1 ? "down" : "up";
	
					if (this.options.tolerance === "pointer" || this._intersectsWithSides(item)) {
						this._rearrange(event, item);
					} else {
						break;
					}
	
					this._trigger("change", event, this._uiHash());
					break;
				}
			}
	
			//Post events to containers
			this._contactContainers(event);
	
			//Interconnect with droppables
			if($.ui.ddmanager) {
				$.ui.ddmanager.drag(this, event);
			}
	
			//Call callbacks
			this._trigger("sort", event, this._uiHash());
	
			this.lastPositionAbs = this.positionAbs;
			return false;
	
		},
	
		_mouseStop: function(event, noPropagation) {
	
			if(!event) {
				return;
			}
	
			//If we are using droppables, inform the manager about the drop
			if ($.ui.ddmanager && !this.options.dropBehaviour) {
				$.ui.ddmanager.drop(this, event);
			}
	
			if(this.options.revert) {
				var that = this,
					cur = this.placeholder.offset(),
					axis = this.options.axis,
					animation = {};
	
				if ( !axis || axis === "x" ) {
					animation.left = cur.left - this.offset.parent.left - this.margins.left + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollLeft);
				}
				if ( !axis || axis === "y" ) {
					animation.top = cur.top - this.offset.parent.top - this.margins.top + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollTop);
				}
				this.reverting = true;
				$(this.helper).animate( animation, parseInt(this.options.revert, 10) || 500, function() {
					that._clear(event);
				});
			} else {
				this._clear(event, noPropagation);
			}
	
			return false;
	
		},
	
		cancel: function() {
	
			if(this.dragging) {
	
				this._mouseUp({ target: null });
	
				if(this.options.helper === "original") {
					this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
				} else {
					this.currentItem.show();
				}
	
				//Post deactivating events to containers
				for (var i = this.containers.length - 1; i >= 0; i--){
					this.containers[i]._trigger("deactivate", null, this._uiHash(this));
					if(this.containers[i].containerCache.over) {
						this.containers[i]._trigger("out", null, this._uiHash(this));
						this.containers[i].containerCache.over = 0;
					}
				}
	
			}
	
			if (this.placeholder) {
				//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
				if(this.placeholder[0].parentNode) {
					this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
				}
				if(this.options.helper !== "original" && this.helper && this.helper[0].parentNode) {
					this.helper.remove();
				}
	
				$.extend(this, {
					helper: null,
					dragging: false,
					reverting: false,
					_noFinalSort: null
				});
	
				if(this.domPosition.prev) {
					$(this.domPosition.prev).after(this.currentItem);
				} else {
					$(this.domPosition.parent).prepend(this.currentItem);
				}
			}
	
			return this;
	
		},
	
		serialize: function(o) {
	
			var items = this._getItemsAsjQuery(o && o.connected),
				str = [];
			o = o || {};
	
			$(items).each(function() {
				var res = ($(o.item || this).attr(o.attribute || "id") || "").match(o.expression || (/(.+)[\-=_](.+)/));
				if (res) {
					str.push((o.key || res[1]+"[]")+"="+(o.key && o.expression ? res[1] : res[2]));
				}
			});
	
			if(!str.length && o.key) {
				str.push(o.key + "=");
			}
	
			return str.join("&");
	
		},
	
		toArray: function(o) {
	
			var items = this._getItemsAsjQuery(o && o.connected),
				ret = [];
	
			o = o || {};
	
			items.each(function() { ret.push($(o.item || this).attr(o.attribute || "id") || ""); });
			return ret;
	
		},
	
		/* Be careful with the following core functions */
		_intersectsWith: function(item) {
	
			var x1 = this.positionAbs.left,
				x2 = x1 + this.helperProportions.width,
				y1 = this.positionAbs.top,
				y2 = y1 + this.helperProportions.height,
				l = item.left,
				r = l + item.width,
				t = item.top,
				b = t + item.height,
				dyClick = this.offset.click.top,
				dxClick = this.offset.click.left,
				isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t && ( y1 + dyClick ) < b ),
				isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l && ( x1 + dxClick ) < r ),
				isOverElement = isOverElementHeight && isOverElementWidth;
	
			if ( this.options.tolerance === "pointer" ||
				this.options.forcePointerForContainers ||
				(this.options.tolerance !== "pointer" && this.helperProportions[this.floating ? "width" : "height"] > item[this.floating ? "width" : "height"])
			) {
				return isOverElement;
			} else {
	
				return (l < x1 + (this.helperProportions.width / 2) && // Right Half
					x2 - (this.helperProportions.width / 2) < r && // Left Half
					t < y1 + (this.helperProportions.height / 2) && // Bottom Half
					y2 - (this.helperProportions.height / 2) < b ); // Top Half
	
			}
		},
	
		_intersectsWithPointer: function(item) {
	
			var isOverElementHeight = (this.options.axis === "x") || this._isOverAxis(this.positionAbs.top + this.offset.click.top, item.top, item.height),
				isOverElementWidth = (this.options.axis === "y") || this._isOverAxis(this.positionAbs.left + this.offset.click.left, item.left, item.width),
				isOverElement = isOverElementHeight && isOverElementWidth,
				verticalDirection = this._getDragVerticalDirection(),
				horizontalDirection = this._getDragHorizontalDirection();
	
			if (!isOverElement) {
				return false;
			}
	
			return this.floating ?
				( ((horizontalDirection && horizontalDirection === "right") || verticalDirection === "down") ? 2 : 1 )
				: ( verticalDirection && (verticalDirection === "down" ? 2 : 1) );
	
		},
	
		_intersectsWithSides: function(item) {
	
			var isOverBottomHalf = this._isOverAxis(this.positionAbs.top + this.offset.click.top, item.top + (item.height/2), item.height),
				isOverRightHalf = this._isOverAxis(this.positionAbs.left + this.offset.click.left, item.left + (item.width/2), item.width),
				verticalDirection = this._getDragVerticalDirection(),
				horizontalDirection = this._getDragHorizontalDirection();
	
			if (this.floating && horizontalDirection) {
				return ((horizontalDirection === "right" && isOverRightHalf) || (horizontalDirection === "left" && !isOverRightHalf));
			} else {
				return verticalDirection && ((verticalDirection === "down" && isOverBottomHalf) || (verticalDirection === "up" && !isOverBottomHalf));
			}
	
		},
	
		_getDragVerticalDirection: function() {
			var delta = this.positionAbs.top - this.lastPositionAbs.top;
			return delta !== 0 && (delta > 0 ? "down" : "up");
		},
	
		_getDragHorizontalDirection: function() {
			var delta = this.positionAbs.left - this.lastPositionAbs.left;
			return delta !== 0 && (delta > 0 ? "right" : "left");
		},
	
		refresh: function(event) {
			this._refreshItems(event);
			this._setHandleClassName();
			this.refreshPositions();
			return this;
		},
	
		_connectWith: function() {
			var options = this.options;
			return options.connectWith.constructor === String ? [options.connectWith] : options.connectWith;
		},
	
		_getItemsAsjQuery: function(connected) {
	
			var i, j, cur, inst,
				items = [],
				queries = [],
				connectWith = this._connectWith();
	
			if(connectWith && connected) {
				for (i = connectWith.length - 1; i >= 0; i--){
					cur = $(connectWith[i], this.document[0]);
					for ( j = cur.length - 1; j >= 0; j--){
						inst = $.data(cur[j], this.widgetFullName);
						if(inst && inst !== this && !inst.options.disabled) {
							queries.push([$.isFunction(inst.options.items) ? inst.options.items.call(inst.element) : $(inst.options.items, inst.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), inst]);
						}
					}
				}
			}
	
			queries.push([$.isFunction(this.options.items) ? this.options.items.call(this.element, null, { options: this.options, item: this.currentItem }) : $(this.options.items, this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), this]);
	
			function addItems() {
				items.push( this );
			}
			for (i = queries.length - 1; i >= 0; i--){
				queries[i][0].each( addItems );
			}
	
			return $(items);
	
		},
	
		_removeCurrentsFromItems: function() {
	
			var list = this.currentItem.find(":data(" + this.widgetName + "-item)");
	
			this.items = $.grep(this.items, function (item) {
				for (var j=0; j < list.length; j++) {
					if(list[j] === item.item[0]) {
						return false;
					}
				}
				return true;
			});
	
		},
	
		_refreshItems: function(event) {
	
			this.items = [];
			this.containers = [this];
	
			var i, j, cur, inst, targetData, _queries, item, queriesLength,
				items = this.items,
				queries = [[$.isFunction(this.options.items) ? this.options.items.call(this.element[0], event, { item: this.currentItem }) : $(this.options.items, this.element), this]],
				connectWith = this._connectWith();
	
			if(connectWith && this.ready) { //Shouldn't be run the first time through due to massive slow-down
				for (i = connectWith.length - 1; i >= 0; i--){
					cur = $(connectWith[i], this.document[0]);
					for (j = cur.length - 1; j >= 0; j--){
						inst = $.data(cur[j], this.widgetFullName);
						if(inst && inst !== this && !inst.options.disabled) {
							queries.push([$.isFunction(inst.options.items) ? inst.options.items.call(inst.element[0], event, { item: this.currentItem }) : $(inst.options.items, inst.element), inst]);
							this.containers.push(inst);
						}
					}
				}
			}
	
			for (i = queries.length - 1; i >= 0; i--) {
				targetData = queries[i][1];
				_queries = queries[i][0];
	
				for (j=0, queriesLength = _queries.length; j < queriesLength; j++) {
					item = $(_queries[j]);
	
					item.data(this.widgetName + "-item", targetData); // Data for target checking (mouse manager)
	
					items.push({
						item: item,
						instance: targetData,
						width: 0, height: 0,
						left: 0, top: 0
					});
				}
			}
	
		},
	
		refreshPositions: function(fast) {
	
			// Determine whether items are being displayed horizontally
			this.floating = this.items.length ?
				this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
				false;
	
			//This has to be redone because due to the item being moved out/into the offsetParent, the offsetParent's position will change
			if(this.offsetParent && this.helper) {
				this.offset.parent = this._getParentOffset();
			}
	
			var i, item, t, p;
	
			for (i = this.items.length - 1; i >= 0; i--){
				item = this.items[i];
	
				//We ignore calculating positions of all connected containers when we're not over them
				if(item.instance !== this.currentContainer && this.currentContainer && item.item[0] !== this.currentItem[0]) {
					continue;
				}
	
				t = this.options.toleranceElement ? $(this.options.toleranceElement, item.item) : item.item;
	
				if (!fast) {
					item.width = t.outerWidth();
					item.height = t.outerHeight();
				}
	
				p = t.offset();
				item.left = p.left;
				item.top = p.top;
			}
	
			if(this.options.custom && this.options.custom.refreshContainers) {
				this.options.custom.refreshContainers.call(this);
			} else {
				for (i = this.containers.length - 1; i >= 0; i--){
					p = this.containers[i].element.offset();
					this.containers[i].containerCache.left = p.left;
					this.containers[i].containerCache.top = p.top;
					this.containers[i].containerCache.width = this.containers[i].element.outerWidth();
					this.containers[i].containerCache.height = this.containers[i].element.outerHeight();
				}
			}
	
			return this;
		},
	
		_createPlaceholder: function(that) {
			that = that || this;
			var className,
				o = that.options;
	
			if(!o.placeholder || o.placeholder.constructor === String) {
				className = o.placeholder;
				o.placeholder = {
					element: function() {
	
						var nodeName = that.currentItem[0].nodeName.toLowerCase(),
							element = $( "<" + nodeName + ">", that.document[0] )
								.addClass(className || that.currentItem[0].className+" ui-sortable-placeholder")
								.removeClass("ui-sortable-helper");
	
						if ( nodeName === "tbody" ) {
							that._createTrPlaceholder(
								that.currentItem.find( "tr" ).eq( 0 ),
								$( "<tr>", that.document[ 0 ] ).appendTo( element )
							);
						} else if ( nodeName === "tr" ) {
							that._createTrPlaceholder( that.currentItem, element );
						} else if ( nodeName === "img" ) {
							element.attr( "src", that.currentItem.attr( "src" ) );
						}
	
						if ( !className ) {
							element.css( "visibility", "hidden" );
						}
	
						return element;
					},
					update: function(container, p) {
	
						// 1. If a className is set as 'placeholder option, we don't force sizes - the class is responsible for that
						// 2. The option 'forcePlaceholderSize can be enabled to force it even if a class name is specified
						if(className && !o.forcePlaceholderSize) {
							return;
						}
	
						//If the element doesn't have a actual height by itself (without styles coming from a stylesheet), it receives the inline height from the dragged item
						if(!p.height()) { p.height(that.currentItem.innerHeight() - parseInt(that.currentItem.css("paddingTop")||0, 10) - parseInt(that.currentItem.css("paddingBottom")||0, 10)); }
						if(!p.width()) { p.width(that.currentItem.innerWidth() - parseInt(that.currentItem.css("paddingLeft")||0, 10) - parseInt(that.currentItem.css("paddingRight")||0, 10)); }
					}
				};
			}
	
			//Create the placeholder
			that.placeholder = $(o.placeholder.element.call(that.element, that.currentItem));
	
			//Append it after the actual current item
			that.currentItem.after(that.placeholder);
	
			//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
			o.placeholder.update(that, that.placeholder);
	
		},
	
		_createTrPlaceholder: function( sourceTr, targetTr ) {
			var that = this;
	
			sourceTr.children().each(function() {
				$( "<td>&#160;</td>", that.document[ 0 ] )
					.attr( "colspan", $( this ).attr( "colspan" ) || 1 )
					.appendTo( targetTr );
			});
		},
	
		_contactContainers: function(event) {
			var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom, floating, axis,
				innermostContainer = null,
				innermostIndex = null;
	
			// get innermost container that intersects with item
			for (i = this.containers.length - 1; i >= 0; i--) {
	
				// never consider a container that's located within the item itself
				if($.contains(this.currentItem[0], this.containers[i].element[0])) {
					continue;
				}
	
				if(this._intersectsWith(this.containers[i].containerCache)) {
	
					// if we've already found a container and it's more "inner" than this, then continue
					if(innermostContainer && $.contains(this.containers[i].element[0], innermostContainer.element[0])) {
						continue;
					}
	
					innermostContainer = this.containers[i];
					innermostIndex = i;
	
				} else {
					// container doesn't intersect. trigger "out" event if necessary
					if(this.containers[i].containerCache.over) {
						this.containers[i]._trigger("out", event, this._uiHash(this));
						this.containers[i].containerCache.over = 0;
					}
				}
	
			}
	
			// if no intersecting containers found, return
			if(!innermostContainer) {
				return;
			}
	
			// move the item into the container if it's not there already
			if(this.containers.length === 1) {
				if (!this.containers[innermostIndex].containerCache.over) {
					this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
					this.containers[innermostIndex].containerCache.over = 1;
				}
			} else {
	
				//When entering a new container, we will find the item with the least distance and append our item near it
				dist = 10000;
				itemWithLeastDistance = null;
				floating = innermostContainer.floating || this._isFloating(this.currentItem);
				posProperty = floating ? "left" : "top";
				sizeProperty = floating ? "width" : "height";
				axis = floating ? "clientX" : "clientY";
	
				for (j = this.items.length - 1; j >= 0; j--) {
					if(!$.contains(this.containers[innermostIndex].element[0], this.items[j].item[0])) {
						continue;
					}
					if(this.items[j].item[0] === this.currentItem[0]) {
						continue;
					}
	
					cur = this.items[j].item.offset()[posProperty];
					nearBottom = false;
					if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
						nearBottom = true;
					}
	
					if ( Math.abs( event[ axis ] - cur ) < dist ) {
						dist = Math.abs( event[ axis ] - cur );
						itemWithLeastDistance = this.items[ j ];
						this.direction = nearBottom ? "up": "down";
					}
				}
	
				//Check if dropOnEmpty is enabled
				if(!itemWithLeastDistance && !this.options.dropOnEmpty) {
					return;
				}
	
				if(this.currentContainer === this.containers[innermostIndex]) {
					if ( !this.currentContainer.containerCache.over ) {
						this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
						this.currentContainer.containerCache.over = 1;
					}
					return;
				}
	
				itemWithLeastDistance ? this._rearrange(event, itemWithLeastDistance, null, true) : this._rearrange(event, null, this.containers[innermostIndex].element, true);
				this._trigger("change", event, this._uiHash());
				this.containers[innermostIndex]._trigger("change", event, this._uiHash(this));
				this.currentContainer = this.containers[innermostIndex];
	
				//Update the placeholder
				this.options.placeholder.update(this.currentContainer, this.placeholder);
	
				this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
				this.containers[innermostIndex].containerCache.over = 1;
			}
	
	
		},
	
		_createHelper: function(event) {
	
			var o = this.options,
				helper = $.isFunction(o.helper) ? $(o.helper.apply(this.element[0], [event, this.currentItem])) : (o.helper === "clone" ? this.currentItem.clone() : this.currentItem);
	
			//Add the helper to the DOM if that didn't happen already
			if(!helper.parents("body").length) {
				$(o.appendTo !== "parent" ? o.appendTo : this.currentItem[0].parentNode)[0].appendChild(helper[0]);
			}
	
			if(helper[0] === this.currentItem[0]) {
				this._storedCSS = { width: this.currentItem[0].style.width, height: this.currentItem[0].style.height, position: this.currentItem.css("position"), top: this.currentItem.css("top"), left: this.currentItem.css("left") };
			}
	
			if(!helper[0].style.width || o.forceHelperSize) {
				helper.width(this.currentItem.width());
			}
			if(!helper[0].style.height || o.forceHelperSize) {
				helper.height(this.currentItem.height());
			}
	
			return helper;
	
		},
	
		_adjustOffsetFromHelper: function(obj) {
			if (typeof obj === "string") {
				obj = obj.split(" ");
			}
			if ($.isArray(obj)) {
				obj = {left: +obj[0], top: +obj[1] || 0};
			}
			if ("left" in obj) {
				this.offset.click.left = obj.left + this.margins.left;
			}
			if ("right" in obj) {
				this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
			}
			if ("top" in obj) {
				this.offset.click.top = obj.top + this.margins.top;
			}
			if ("bottom" in obj) {
				this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
			}
		},
	
		_getParentOffset: function() {
	
	
			//Get the offsetParent and cache its position
			this.offsetParent = this.helper.offsetParent();
			var po = this.offsetParent.offset();
	
			// This is a special case where we need to modify a offset calculated on start, since the following happened:
			// 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
			// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
			//    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
			if(this.cssPosition === "absolute" && this.scrollParent[0] !== this.document[0] && $.contains(this.scrollParent[0], this.offsetParent[0])) {
				po.left += this.scrollParent.scrollLeft();
				po.top += this.scrollParent.scrollTop();
			}
	
			// This needs to be actually done for all browsers, since pageX/pageY includes this information
			// with an ugly IE fix
			if( this.offsetParent[0] === this.document[0].body || (this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() === "html" && $.ui.ie)) {
				po = { top: 0, left: 0 };
			}
	
			return {
				top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"),10) || 0),
				left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"),10) || 0)
			};
	
		},
	
		_getRelativeOffset: function() {
	
			if(this.cssPosition === "relative") {
				var p = this.currentItem.position();
				return {
					top: p.top - (parseInt(this.helper.css("top"),10) || 0) + this.scrollParent.scrollTop(),
					left: p.left - (parseInt(this.helper.css("left"),10) || 0) + this.scrollParent.scrollLeft()
				};
			} else {
				return { top: 0, left: 0 };
			}
	
		},
	
		_cacheMargins: function() {
			this.margins = {
				left: (parseInt(this.currentItem.css("marginLeft"),10) || 0),
				top: (parseInt(this.currentItem.css("marginTop"),10) || 0)
			};
		},
	
		_cacheHelperProportions: function() {
			this.helperProportions = {
				width: this.helper.outerWidth(),
				height: this.helper.outerHeight()
			};
		},
	
		_setContainment: function() {
	
			var ce, co, over,
				o = this.options;
			if(o.containment === "parent") {
				o.containment = this.helper[0].parentNode;
			}
			if(o.containment === "document" || o.containment === "window") {
				this.containment = [
					0 - this.offset.relative.left - this.offset.parent.left,
					0 - this.offset.relative.top - this.offset.parent.top,
					o.containment === "document" ? this.document.width() : this.window.width() - this.helperProportions.width - this.margins.left,
					(o.containment === "document" ? this.document.width() : this.window.height() || this.document[0].body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top
				];
			}
	
			if(!(/^(document|window|parent)$/).test(o.containment)) {
				ce = $(o.containment)[0];
				co = $(o.containment).offset();
				over = ($(ce).css("overflow") !== "hidden");
	
				this.containment = [
					co.left + (parseInt($(ce).css("borderLeftWidth"),10) || 0) + (parseInt($(ce).css("paddingLeft"),10) || 0) - this.margins.left,
					co.top + (parseInt($(ce).css("borderTopWidth"),10) || 0) + (parseInt($(ce).css("paddingTop"),10) || 0) - this.margins.top,
					co.left+(over ? Math.max(ce.scrollWidth,ce.offsetWidth) : ce.offsetWidth) - (parseInt($(ce).css("borderLeftWidth"),10) || 0) - (parseInt($(ce).css("paddingRight"),10) || 0) - this.helperProportions.width - this.margins.left,
					co.top+(over ? Math.max(ce.scrollHeight,ce.offsetHeight) : ce.offsetHeight) - (parseInt($(ce).css("borderTopWidth"),10) || 0) - (parseInt($(ce).css("paddingBottom"),10) || 0) - this.helperProportions.height - this.margins.top
				];
			}
	
		},
	
		_convertPositionTo: function(d, pos) {
	
			if(!pos) {
				pos = this.position;
			}
			var mod = d === "absolute" ? 1 : -1,
				scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== this.document[0] && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent,
				scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);
	
			return {
				top: (
					pos.top	+																// The absolute mouse position
					this.offset.relative.top * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.top * mod -											// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod)
				),
				left: (
					pos.left +																// The absolute mouse position
					this.offset.relative.left * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.left * mod	-										// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ) * mod)
				)
			};
	
		},
	
		_generatePosition: function(event) {
	
			var top, left,
				o = this.options,
				pageX = event.pageX,
				pageY = event.pageY,
				scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== this.document[0] && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent, scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);
	
			// This is another very weird special case that only happens for relative elements:
			// 1. If the css position is relative
			// 2. and the scroll parent is the document or similar to the offset parent
			// we have to refresh the relative offset during the scroll so there are no jumps
			if(this.cssPosition === "relative" && !(this.scrollParent[0] !== this.document[0] && this.scrollParent[0] !== this.offsetParent[0])) {
				this.offset.relative = this._getRelativeOffset();
			}
	
			/*
			 * - Position constraining -
			 * Constrain the position to a mix of grid, containment.
			 */
	
			if(this.originalPosition) { //If we are not dragging yet, we won't check for options
	
				if(this.containment) {
					if(event.pageX - this.offset.click.left < this.containment[0]) {
						pageX = this.containment[0] + this.offset.click.left;
					}
					if(event.pageY - this.offset.click.top < this.containment[1]) {
						pageY = this.containment[1] + this.offset.click.top;
					}
					if(event.pageX - this.offset.click.left > this.containment[2]) {
						pageX = this.containment[2] + this.offset.click.left;
					}
					if(event.pageY - this.offset.click.top > this.containment[3]) {
						pageY = this.containment[3] + this.offset.click.top;
					}
				}
	
				if(o.grid) {
					top = this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1];
					pageY = this.containment ? ( (top - this.offset.click.top >= this.containment[1] && top - this.offset.click.top <= this.containment[3]) ? top : ((top - this.offset.click.top >= this.containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;
	
					left = this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0];
					pageX = this.containment ? ( (left - this.offset.click.left >= this.containment[0] && left - this.offset.click.left <= this.containment[2]) ? left : ((left - this.offset.click.left >= this.containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
				}
	
			}
	
			return {
				top: (
					pageY -																// The absolute mouse position
					this.offset.click.top -													// Click offset (relative to the element)
					this.offset.relative.top	-											// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.top +												// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ))
				),
				left: (
					pageX -																// The absolute mouse position
					this.offset.click.left -												// Click offset (relative to the element)
					this.offset.relative.left	-											// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.left +												// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ))
				)
			};
	
		},
	
		_rearrange: function(event, i, a, hardRefresh) {
	
			a ? a[0].appendChild(this.placeholder[0]) : i.item[0].parentNode.insertBefore(this.placeholder[0], (this.direction === "down" ? i.item[0] : i.item[0].nextSibling));
	
			//Various things done here to improve the performance:
			// 1. we create a setTimeout, that calls refreshPositions
			// 2. on the instance, we have a counter variable, that get's higher after every append
			// 3. on the local scope, we copy the counter variable, and check in the timeout, if it's still the same
			// 4. this lets only the last addition to the timeout stack through
			this.counter = this.counter ? ++this.counter : 1;
			var counter = this.counter;
	
			this._delay(function() {
				if(counter === this.counter) {
					this.refreshPositions(!hardRefresh); //Precompute after each DOM insertion, NOT on mousemove
				}
			});
	
		},
	
		_clear: function(event, noPropagation) {
	
			this.reverting = false;
			// We delay all events that have to be triggered to after the point where the placeholder has been removed and
			// everything else normalized again
			var i,
				delayedTriggers = [];
	
			// We first have to update the dom position of the actual currentItem
			// Note: don't do it if the current item is already removed (by a user), or it gets reappended (see #4088)
			if(!this._noFinalSort && this.currentItem.parent().length) {
				this.placeholder.before(this.currentItem);
			}
			this._noFinalSort = null;
	
			if(this.helper[0] === this.currentItem[0]) {
				for(i in this._storedCSS) {
					if(this._storedCSS[i] === "auto" || this._storedCSS[i] === "static") {
						this._storedCSS[i] = "";
					}
				}
				this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
			} else {
				this.currentItem.show();
			}
	
			if(this.fromOutside && !noPropagation) {
				delayedTriggers.push(function(event) { this._trigger("receive", event, this._uiHash(this.fromOutside)); });
			}
			if((this.fromOutside || this.domPosition.prev !== this.currentItem.prev().not(".ui-sortable-helper")[0] || this.domPosition.parent !== this.currentItem.parent()[0]) && !noPropagation) {
				delayedTriggers.push(function(event) { this._trigger("update", event, this._uiHash()); }); //Trigger update callback if the DOM position has changed
			}
	
			// Check if the items Container has Changed and trigger appropriate
			// events.
			if (this !== this.currentContainer) {
				if(!noPropagation) {
					delayedTriggers.push(function(event) { this._trigger("remove", event, this._uiHash()); });
					delayedTriggers.push((function(c) { return function(event) { c._trigger("receive", event, this._uiHash(this)); };  }).call(this, this.currentContainer));
					delayedTriggers.push((function(c) { return function(event) { c._trigger("update", event, this._uiHash(this));  }; }).call(this, this.currentContainer));
				}
			}
	
	
			//Post events to containers
			function delayEvent( type, instance, container ) {
				return function( event ) {
					container._trigger( type, event, instance._uiHash( instance ) );
				};
			}
			for (i = this.containers.length - 1; i >= 0; i--){
				if (!noPropagation) {
					delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
				}
				if(this.containers[i].containerCache.over) {
					delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
					this.containers[i].containerCache.over = 0;
				}
			}
	
			//Do what was originally in plugins
			if ( this.storedCursor ) {
				this.document.find( "body" ).css( "cursor", this.storedCursor );
				this.storedStylesheet.remove();
			}
			if(this._storedOpacity) {
				this.helper.css("opacity", this._storedOpacity);
			}
			if(this._storedZIndex) {
				this.helper.css("zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex);
			}
	
			this.dragging = false;
	
			if(!noPropagation) {
				this._trigger("beforeStop", event, this._uiHash());
			}
	
			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
			this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
	
			if ( !this.cancelHelperRemoval ) {
				if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
					this.helper.remove();
				}
				this.helper = null;
			}
	
			if(!noPropagation) {
				for (i=0; i < delayedTriggers.length; i++) {
					delayedTriggers[i].call(this, event);
				} //Trigger all delayed events
				this._trigger("stop", event, this._uiHash());
			}
	
			this.fromOutside = false;
			return !this.cancelHelperRemoval;
	
		},
	
		_trigger: function() {
			if ($.Widget.prototype._trigger.apply(this, arguments) === false) {
				this.cancel();
			}
		},
	
		_uiHash: function(_inst) {
			var inst = _inst || this;
			return {
				helper: inst.helper,
				placeholder: inst.placeholder || $([]),
				position: inst.position,
				originalPosition: inst.originalPosition,
				offset: inst.positionAbs,
				item: inst.currentItem,
				sender: _inst ? _inst.element : null
			};
		}
	
	});
	
	
	/*!
	 * jQuery UI Slider 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/slider/
	 */
	
	
	var slider = $.widget( "ui.slider", $.ui.mouse, {
		version: "1.11.4",
		widgetEventPrefix: "slide",
	
		options: {
			animate: false,
			distance: 0,
			max: 100,
			min: 0,
			orientation: "horizontal",
			range: false,
			step: 1,
			value: 0,
			values: null,
	
			// callbacks
			change: null,
			slide: null,
			start: null,
			stop: null
		},
	
		// number of pages in a slider
		// (how many times can you page up/down to go through the whole range)
		numPages: 5,
	
		_create: function() {
			this._keySliding = false;
			this._mouseSliding = false;
			this._animateOff = true;
			this._handleIndex = null;
			this._detectOrientation();
			this._mouseInit();
			this._calculateNewMax();
	
			this.element
				.addClass( "ui-slider" +
					" ui-slider-" + this.orientation +
					" ui-widget" +
					" ui-widget-content" +
					" ui-corner-all");
	
			this._refresh();
			this._setOption( "disabled", this.options.disabled );
	
			this._animateOff = false;
		},
	
		_refresh: function() {
			this._createRange();
			this._createHandles();
			this._setupEvents();
			this._refreshValue();
		},
	
		_createHandles: function() {
			var i, handleCount,
				options = this.options,
				existingHandles = this.element.find( ".ui-slider-handle" ).addClass( "ui-state-default ui-corner-all" ),
				handle = "<span class='ui-slider-handle ui-state-default ui-corner-all' tabindex='0'></span>",
				handles = [];
	
			handleCount = ( options.values && options.values.length ) || 1;
	
			if ( existingHandles.length > handleCount ) {
				existingHandles.slice( handleCount ).remove();
				existingHandles = existingHandles.slice( 0, handleCount );
			}
	
			for ( i = existingHandles.length; i < handleCount; i++ ) {
				handles.push( handle );
			}
	
			this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );
	
			this.handle = this.handles.eq( 0 );
	
			this.handles.each(function( i ) {
				$( this ).data( "ui-slider-handle-index", i );
			});
		},
	
		_createRange: function() {
			var options = this.options,
				classes = "";
	
			if ( options.range ) {
				if ( options.range === true ) {
					if ( !options.values ) {
						options.values = [ this._valueMin(), this._valueMin() ];
					} else if ( options.values.length && options.values.length !== 2 ) {
						options.values = [ options.values[0], options.values[0] ];
					} else if ( $.isArray( options.values ) ) {
						options.values = options.values.slice(0);
					}
				}
	
				if ( !this.range || !this.range.length ) {
					this.range = $( "<div></div>" )
						.appendTo( this.element );
	
					classes = "ui-slider-range" +
					// note: this isn't the most fittingly semantic framework class for this element,
					// but worked best visually with a variety of themes
					" ui-widget-header ui-corner-all";
				} else {
					this.range.removeClass( "ui-slider-range-min ui-slider-range-max" )
						// Handle range switching from true to min/max
						.css({
							"left": "",
							"bottom": ""
						});
				}
	
				this.range.addClass( classes +
					( ( options.range === "min" || options.range === "max" ) ? " ui-slider-range-" + options.range : "" ) );
			} else {
				if ( this.range ) {
					this.range.remove();
				}
				this.range = null;
			}
		},
	
		_setupEvents: function() {
			this._off( this.handles );
			this._on( this.handles, this._handleEvents );
			this._hoverable( this.handles );
			this._focusable( this.handles );
		},
	
		_destroy: function() {
			this.handles.remove();
			if ( this.range ) {
				this.range.remove();
			}
	
			this.element
				.removeClass( "ui-slider" +
					" ui-slider-horizontal" +
					" ui-slider-vertical" +
					" ui-widget" +
					" ui-widget-content" +
					" ui-corner-all" );
	
			this._mouseDestroy();
		},
	
		_mouseCapture: function( event ) {
			var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
				that = this,
				o = this.options;
	
			if ( o.disabled ) {
				return false;
			}
	
			this.elementSize = {
				width: this.element.outerWidth(),
				height: this.element.outerHeight()
			};
			this.elementOffset = this.element.offset();
	
			position = { x: event.pageX, y: event.pageY };
			normValue = this._normValueFromMouse( position );
			distance = this._valueMax() - this._valueMin() + 1;
			this.handles.each(function( i ) {
				var thisDistance = Math.abs( normValue - that.values(i) );
				if (( distance > thisDistance ) ||
					( distance === thisDistance &&
						(i === that._lastChangedValue || that.values(i) === o.min ))) {
					distance = thisDistance;
					closestHandle = $( this );
					index = i;
				}
			});
	
			allowed = this._start( event, index );
			if ( allowed === false ) {
				return false;
			}
			this._mouseSliding = true;
	
			this._handleIndex = index;
	
			closestHandle
				.addClass( "ui-state-active" )
				.focus();
	
			offset = closestHandle.offset();
			mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
			this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
				left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
				top: event.pageY - offset.top -
					( closestHandle.height() / 2 ) -
					( parseInt( closestHandle.css("borderTopWidth"), 10 ) || 0 ) -
					( parseInt( closestHandle.css("borderBottomWidth"), 10 ) || 0) +
					( parseInt( closestHandle.css("marginTop"), 10 ) || 0)
			};
	
			if ( !this.handles.hasClass( "ui-state-hover" ) ) {
				this._slide( event, index, normValue );
			}
			this._animateOff = true;
			return true;
		},
	
		_mouseStart: function() {
			return true;
		},
	
		_mouseDrag: function( event ) {
			var position = { x: event.pageX, y: event.pageY },
				normValue = this._normValueFromMouse( position );
	
			this._slide( event, this._handleIndex, normValue );
	
			return false;
		},
	
		_mouseStop: function( event ) {
			this.handles.removeClass( "ui-state-active" );
			this._mouseSliding = false;
	
			this._stop( event, this._handleIndex );
			this._change( event, this._handleIndex );
	
			this._handleIndex = null;
			this._clickOffset = null;
			this._animateOff = false;
	
			return false;
		},
	
		_detectOrientation: function() {
			this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
		},
	
		_normValueFromMouse: function( position ) {
			var pixelTotal,
				pixelMouse,
				percentMouse,
				valueTotal,
				valueMouse;
	
			if ( this.orientation === "horizontal" ) {
				pixelTotal = this.elementSize.width;
				pixelMouse = position.x - this.elementOffset.left - ( this._clickOffset ? this._clickOffset.left : 0 );
			} else {
				pixelTotal = this.elementSize.height;
				pixelMouse = position.y - this.elementOffset.top - ( this._clickOffset ? this._clickOffset.top : 0 );
			}
	
			percentMouse = ( pixelMouse / pixelTotal );
			if ( percentMouse > 1 ) {
				percentMouse = 1;
			}
			if ( percentMouse < 0 ) {
				percentMouse = 0;
			}
			if ( this.orientation === "vertical" ) {
				percentMouse = 1 - percentMouse;
			}
	
			valueTotal = this._valueMax() - this._valueMin();
			valueMouse = this._valueMin() + percentMouse * valueTotal;
	
			return this._trimAlignValue( valueMouse );
		},
	
		_start: function( event, index ) {
			var uiHash = {
				handle: this.handles[ index ],
				value: this.value()
			};
			if ( this.options.values && this.options.values.length ) {
				uiHash.value = this.values( index );
				uiHash.values = this.values();
			}
			return this._trigger( "start", event, uiHash );
		},
	
		_slide: function( event, index, newVal ) {
			var otherVal,
				newValues,
				allowed;
	
			if ( this.options.values && this.options.values.length ) {
				otherVal = this.values( index ? 0 : 1 );
	
				if ( ( this.options.values.length === 2 && this.options.range === true ) &&
						( ( index === 0 && newVal > otherVal) || ( index === 1 && newVal < otherVal ) )
					) {
					newVal = otherVal;
				}
	
				if ( newVal !== this.values( index ) ) {
					newValues = this.values();
					newValues[ index ] = newVal;
					// A slide can be canceled by returning false from the slide callback
					allowed = this._trigger( "slide", event, {
						handle: this.handles[ index ],
						value: newVal,
						values: newValues
					} );
					otherVal = this.values( index ? 0 : 1 );
					if ( allowed !== false ) {
						this.values( index, newVal );
					}
				}
			} else {
				if ( newVal !== this.value() ) {
					// A slide can be canceled by returning false from the slide callback
					allowed = this._trigger( "slide", event, {
						handle: this.handles[ index ],
						value: newVal
					} );
					if ( allowed !== false ) {
						this.value( newVal );
					}
				}
			}
		},
	
		_stop: function( event, index ) {
			var uiHash = {
				handle: this.handles[ index ],
				value: this.value()
			};
			if ( this.options.values && this.options.values.length ) {
				uiHash.value = this.values( index );
				uiHash.values = this.values();
			}
	
			this._trigger( "stop", event, uiHash );
		},
	
		_change: function( event, index ) {
			if ( !this._keySliding && !this._mouseSliding ) {
				var uiHash = {
					handle: this.handles[ index ],
					value: this.value()
				};
				if ( this.options.values && this.options.values.length ) {
					uiHash.value = this.values( index );
					uiHash.values = this.values();
				}
	
				//store the last changed value index for reference when handles overlap
				this._lastChangedValue = index;
	
				this._trigger( "change", event, uiHash );
			}
		},
	
		value: function( newValue ) {
			if ( arguments.length ) {
				this.options.value = this._trimAlignValue( newValue );
				this._refreshValue();
				this._change( null, 0 );
				return;
			}
	
			return this._value();
		},
	
		values: function( index, newValue ) {
			var vals,
				newValues,
				i;
	
			if ( arguments.length > 1 ) {
				this.options.values[ index ] = this._trimAlignValue( newValue );
				this._refreshValue();
				this._change( null, index );
				return;
			}
	
			if ( arguments.length ) {
				if ( $.isArray( arguments[ 0 ] ) ) {
					vals = this.options.values;
					newValues = arguments[ 0 ];
					for ( i = 0; i < vals.length; i += 1 ) {
						vals[ i ] = this._trimAlignValue( newValues[ i ] );
						this._change( null, i );
					}
					this._refreshValue();
				} else {
					if ( this.options.values && this.options.values.length ) {
						return this._values( index );
					} else {
						return this.value();
					}
				}
			} else {
				return this._values();
			}
		},
	
		_setOption: function( key, value ) {
			var i,
				valsLength = 0;
	
			if ( key === "range" && this.options.range === true ) {
				if ( value === "min" ) {
					this.options.value = this._values( 0 );
					this.options.values = null;
				} else if ( value === "max" ) {
					this.options.value = this._values( this.options.values.length - 1 );
					this.options.values = null;
				}
			}
	
			if ( $.isArray( this.options.values ) ) {
				valsLength = this.options.values.length;
			}
	
			if ( key === "disabled" ) {
				this.element.toggleClass( "ui-state-disabled", !!value );
			}
	
			this._super( key, value );
	
			switch ( key ) {
				case "orientation":
					this._detectOrientation();
					this.element
						.removeClass( "ui-slider-horizontal ui-slider-vertical" )
						.addClass( "ui-slider-" + this.orientation );
					this._refreshValue();
	
					// Reset positioning from previous orientation
					this.handles.css( value === "horizontal" ? "bottom" : "left", "" );
					break;
				case "value":
					this._animateOff = true;
					this._refreshValue();
					this._change( null, 0 );
					this._animateOff = false;
					break;
				case "values":
					this._animateOff = true;
					this._refreshValue();
					for ( i = 0; i < valsLength; i += 1 ) {
						this._change( null, i );
					}
					this._animateOff = false;
					break;
				case "step":
				case "min":
				case "max":
					this._animateOff = true;
					this._calculateNewMax();
					this._refreshValue();
					this._animateOff = false;
					break;
				case "range":
					this._animateOff = true;
					this._refresh();
					this._animateOff = false;
					break;
			}
		},
	
		//internal value getter
		// _value() returns value trimmed by min and max, aligned by step
		_value: function() {
			var val = this.options.value;
			val = this._trimAlignValue( val );
	
			return val;
		},
	
		//internal values getter
		// _values() returns array of values trimmed by min and max, aligned by step
		// _values( index ) returns single value trimmed by min and max, aligned by step
		_values: function( index ) {
			var val,
				vals,
				i;
	
			if ( arguments.length ) {
				val = this.options.values[ index ];
				val = this._trimAlignValue( val );
	
				return val;
			} else if ( this.options.values && this.options.values.length ) {
				// .slice() creates a copy of the array
				// this copy gets trimmed by min and max and then returned
				vals = this.options.values.slice();
				for ( i = 0; i < vals.length; i += 1) {
					vals[ i ] = this._trimAlignValue( vals[ i ] );
				}
	
				return vals;
			} else {
				return [];
			}
		},
	
		// returns the step-aligned value that val is closest to, between (inclusive) min and max
		_trimAlignValue: function( val ) {
			if ( val <= this._valueMin() ) {
				return this._valueMin();
			}
			if ( val >= this._valueMax() ) {
				return this._valueMax();
			}
			var step = ( this.options.step > 0 ) ? this.options.step : 1,
				valModStep = (val - this._valueMin()) % step,
				alignValue = val - valModStep;
	
			if ( Math.abs(valModStep) * 2 >= step ) {
				alignValue += ( valModStep > 0 ) ? step : ( -step );
			}
	
			// Since JavaScript has problems with large floats, round
			// the final value to 5 digits after the decimal point (see #4124)
			return parseFloat( alignValue.toFixed(5) );
		},
	
		_calculateNewMax: function() {
			var max = this.options.max,
				min = this._valueMin(),
				step = this.options.step,
				aboveMin = Math.floor( ( +( max - min ).toFixed( this._precision() ) ) / step ) * step;
			max = aboveMin + min;
			this.max = parseFloat( max.toFixed( this._precision() ) );
		},
	
		_precision: function() {
			var precision = this._precisionOf( this.options.step );
			if ( this.options.min !== null ) {
				precision = Math.max( precision, this._precisionOf( this.options.min ) );
			}
			return precision;
		},
	
		_precisionOf: function( num ) {
			var str = num.toString(),
				decimal = str.indexOf( "." );
			return decimal === -1 ? 0 : str.length - decimal - 1;
		},
	
		_valueMin: function() {
			return this.options.min;
		},
	
		_valueMax: function() {
			return this.max;
		},
	
		_refreshValue: function() {
			var lastValPercent, valPercent, value, valueMin, valueMax,
				oRange = this.options.range,
				o = this.options,
				that = this,
				animate = ( !this._animateOff ) ? o.animate : false,
				_set = {};
	
			if ( this.options.values && this.options.values.length ) {
				this.handles.each(function( i ) {
					valPercent = ( that.values(i) - that._valueMin() ) / ( that._valueMax() - that._valueMin() ) * 100;
					_set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
					$( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
					if ( that.options.range === true ) {
						if ( that.orientation === "horizontal" ) {
							if ( i === 0 ) {
								that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { left: valPercent + "%" }, o.animate );
							}
							if ( i === 1 ) {
								that.range[ animate ? "animate" : "css" ]( { width: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
							}
						} else {
							if ( i === 0 ) {
								that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { bottom: ( valPercent ) + "%" }, o.animate );
							}
							if ( i === 1 ) {
								that.range[ animate ? "animate" : "css" ]( { height: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
							}
						}
					}
					lastValPercent = valPercent;
				});
			} else {
				value = this.value();
				valueMin = this._valueMin();
				valueMax = this._valueMax();
				valPercent = ( valueMax !== valueMin ) ?
						( value - valueMin ) / ( valueMax - valueMin ) * 100 :
						0;
				_set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
				this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
	
				if ( oRange === "min" && this.orientation === "horizontal" ) {
					this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { width: valPercent + "%" }, o.animate );
				}
				if ( oRange === "max" && this.orientation === "horizontal" ) {
					this.range[ animate ? "animate" : "css" ]( { width: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
				}
				if ( oRange === "min" && this.orientation === "vertical" ) {
					this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { height: valPercent + "%" }, o.animate );
				}
				if ( oRange === "max" && this.orientation === "vertical" ) {
					this.range[ animate ? "animate" : "css" ]( { height: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
				}
			}
		},
	
		_handleEvents: {
			keydown: function( event ) {
				var allowed, curVal, newVal, step,
					index = $( event.target ).data( "ui-slider-handle-index" );
	
				switch ( event.keyCode ) {
					case $.ui.keyCode.HOME:
					case $.ui.keyCode.END:
					case $.ui.keyCode.PAGE_UP:
					case $.ui.keyCode.PAGE_DOWN:
					case $.ui.keyCode.UP:
					case $.ui.keyCode.RIGHT:
					case $.ui.keyCode.DOWN:
					case $.ui.keyCode.LEFT:
						event.preventDefault();
						if ( !this._keySliding ) {
							this._keySliding = true;
							$( event.target ).addClass( "ui-state-active" );
							allowed = this._start( event, index );
							if ( allowed === false ) {
								return;
							}
						}
						break;
				}
	
				step = this.options.step;
				if ( this.options.values && this.options.values.length ) {
					curVal = newVal = this.values( index );
				} else {
					curVal = newVal = this.value();
				}
	
				switch ( event.keyCode ) {
					case $.ui.keyCode.HOME:
						newVal = this._valueMin();
						break;
					case $.ui.keyCode.END:
						newVal = this._valueMax();
						break;
					case $.ui.keyCode.PAGE_UP:
						newVal = this._trimAlignValue(
							curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
						);
						break;
					case $.ui.keyCode.PAGE_DOWN:
						newVal = this._trimAlignValue(
							curVal - ( (this._valueMax() - this._valueMin()) / this.numPages ) );
						break;
					case $.ui.keyCode.UP:
					case $.ui.keyCode.RIGHT:
						if ( curVal === this._valueMax() ) {
							return;
						}
						newVal = this._trimAlignValue( curVal + step );
						break;
					case $.ui.keyCode.DOWN:
					case $.ui.keyCode.LEFT:
						if ( curVal === this._valueMin() ) {
							return;
						}
						newVal = this._trimAlignValue( curVal - step );
						break;
				}
	
				this._slide( event, index, newVal );
			},
			keyup: function( event ) {
				var index = $( event.target ).data( "ui-slider-handle-index" );
	
				if ( this._keySliding ) {
					this._keySliding = false;
					this._stop( event, index );
					this._change( event, index );
					$( event.target ).removeClass( "ui-state-active" );
				}
			}
		}
	});
	
	
	
	}));

/***/ },

/***/ 1109:
/***/ function(module, exports, __webpack_require__) {

	/**!
	 * easyPieChart
	 * Lightweight plugin to render simple, animated and retina optimized pie charts
	 *
	 * @license 
	 * @author Robert Fleischmann <rendro87@gmail.com> (http://robert-fleischmann.de)
	 * @version 2.1.6
	 **/
	
	(function(root, factory) {
	    if(true) {
	        module.exports = factory(__webpack_require__(10));
	    }
	    else if(typeof define === 'function' && define.amd) {
	        define(['jquery'], factory);
	    }
	    else {
	        factory(root.jQuery);
	    }
	}(this, function($) {
	
	/**
	 * Renderer to render the chart on a canvas object
	 * @param {DOMElement} el      DOM element to host the canvas (root of the plugin)
	 * @param {object}     options options object of the plugin
	 */
	var CanvasRenderer = function(el, options) {
		var cachedBackground;
		var canvas = document.createElement('canvas');
	
		el.appendChild(canvas);
	
		if (typeof(G_vmlCanvasManager) !== 'undefined') {
			G_vmlCanvasManager.initElement(canvas);
		}
	
		var ctx = canvas.getContext('2d');
	
		canvas.width = canvas.height = options.size;
	
		// canvas on retina devices
		var scaleBy = 1;
		if (window.devicePixelRatio > 1) {
			scaleBy = window.devicePixelRatio;
			canvas.style.width = canvas.style.height = [options.size, 'px'].join('');
			canvas.width = canvas.height = options.size * scaleBy;
			ctx.scale(scaleBy, scaleBy);
		}
	
		// move 0,0 coordinates to the center
		ctx.translate(options.size / 2, options.size / 2);
	
		// rotate canvas -90deg
		ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI);
	
		var radius = (options.size - options.lineWidth) / 2;
		if (options.scaleColor && options.scaleLength) {
			radius -= options.scaleLength + 2; // 2 is the distance between scale and bar
		}
	
		// IE polyfill for Date
		Date.now = Date.now || function() {
			return +(new Date());
		};
	
		/**
		 * Draw a circle around the center of the canvas
		 * @param {strong} color     Valid CSS color string
		 * @param {number} lineWidth Width of the line in px
		 * @param {number} percent   Percentage to draw (float between -1 and 1)
		 */
		var drawCircle = function(color, lineWidth, percent) {
			percent = Math.min(Math.max(-1, percent || 0), 1);
			var isNegative = percent <= 0 ? true : false;
	
			ctx.beginPath();
			ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, isNegative);
	
			ctx.strokeStyle = color;
			ctx.lineWidth = lineWidth;
	
			ctx.stroke();
		};
	
		/**
		 * Draw the scale of the chart
		 */
		var drawScale = function() {
			var offset;
			var length;
	
			ctx.lineWidth = 1;
			ctx.fillStyle = options.scaleColor;
	
			ctx.save();
			for (var i = 24; i > 0; --i) {
				if (i % 6 === 0) {
					length = options.scaleLength;
					offset = 0;
				} else {
					length = options.scaleLength * 0.6;
					offset = options.scaleLength - length;
				}
				ctx.fillRect(-options.size/2 + offset, 0, length, 1);
				ctx.rotate(Math.PI / 12);
			}
			ctx.restore();
		};
	
		/**
		 * Request animation frame wrapper with polyfill
		 * @return {function} Request animation frame method or timeout fallback
		 */
		var reqAnimationFrame = (function() {
			return  window.requestAnimationFrame ||
					window.webkitRequestAnimationFrame ||
					window.mozRequestAnimationFrame ||
					function(callback) {
						window.setTimeout(callback, 1000 / 60);
					};
		}());
	
		/**
		 * Draw the background of the plugin including the scale and the track
		 */
		var drawBackground = function() {
			if(options.scaleColor) drawScale();
			if(options.trackColor) drawCircle(options.trackColor, options.trackWidth || options.lineWidth, 1);
		};
	
	  /**
	    * Canvas accessor
	   */
	  this.getCanvas = function() {
	    return canvas;
	  };
	
	  /**
	    * Canvas 2D context 'ctx' accessor
	   */
	  this.getCtx = function() {
	    return ctx;
	  };
	
		/**
		 * Clear the complete canvas
		 */
		this.clear = function() {
			ctx.clearRect(options.size / -2, options.size / -2, options.size, options.size);
		};
	
		/**
		 * Draw the complete chart
		 * @param {number} percent Percent shown by the chart between -100 and 100
		 */
		this.draw = function(percent) {
			// do we need to render a background
			if (!!options.scaleColor || !!options.trackColor) {
				// getImageData and putImageData are supported
				if (ctx.getImageData && ctx.putImageData) {
					if (!cachedBackground) {
						drawBackground();
						cachedBackground = ctx.getImageData(0, 0, options.size * scaleBy, options.size * scaleBy);
					} else {
						ctx.putImageData(cachedBackground, 0, 0);
					}
				} else {
					this.clear();
					drawBackground();
				}
			} else {
				this.clear();
			}
	
			ctx.lineCap = options.lineCap;
	
			// if barcolor is a function execute it and pass the percent as a value
			var color;
			if (typeof(options.barColor) === 'function') {
				color = options.barColor(percent);
			} else {
				color = options.barColor;
			}
	
			// draw bar
			drawCircle(color, options.lineWidth, percent / 100);
		}.bind(this);
	
		/**
		 * Animate from some percent to some other percentage
		 * @param {number} from Starting percentage
		 * @param {number} to   Final percentage
		 */
		this.animate = function(from, to) {
			var startTime = Date.now();
			options.onStart(from, to);
			var animation = function() {
				var process = Math.min(Date.now() - startTime, options.animate.duration);
				var currentValue = options.easing(this, process, from, to - from, options.animate.duration);
				this.draw(currentValue);
				options.onStep(from, to, currentValue);
				if (process >= options.animate.duration) {
					options.onStop(from, to);
				} else {
					reqAnimationFrame(animation);
				}
			}.bind(this);
	
			reqAnimationFrame(animation);
		}.bind(this);
	};
	
	var EasyPieChart = function(el, opts) {
		var defaultOptions = {
			barColor: '#ef1e25',
			trackColor: '#f9f9f9',
			scaleColor: '#dfe0e0',
			scaleLength: 5,
			lineCap: 'round',
			lineWidth: 3,
			trackWidth: undefined,
			size: 110,
			rotate: 0,
			animate: {
				duration: 1000,
				enabled: true
			},
			easing: function (x, t, b, c, d) { // more can be found here: http://gsgd.co.uk/sandbox/jquery/easing/
				t = t / (d/2);
				if (t < 1) {
					return c / 2 * t * t + b;
				}
				return -c/2 * ((--t)*(t-2) - 1) + b;
			},
			onStart: function(from, to) {
				return;
			},
			onStep: function(from, to, currentValue) {
				return;
			},
			onStop: function(from, to) {
				return;
			}
		};
	
		// detect present renderer
		if (typeof(CanvasRenderer) !== 'undefined') {
			defaultOptions.renderer = CanvasRenderer;
		} else if (typeof(SVGRenderer) !== 'undefined') {
			defaultOptions.renderer = SVGRenderer;
		} else {
			throw new Error('Please load either the SVG- or the CanvasRenderer');
		}
	
		var options = {};
		var currentValue = 0;
	
		/**
		 * Initialize the plugin by creating the options object and initialize rendering
		 */
		var init = function() {
			this.el = el;
			this.options = options;
	
			// merge user options into default options
			for (var i in defaultOptions) {
				if (defaultOptions.hasOwnProperty(i)) {
					options[i] = opts && typeof(opts[i]) !== 'undefined' ? opts[i] : defaultOptions[i];
					if (typeof(options[i]) === 'function') {
						options[i] = options[i].bind(this);
					}
				}
			}
	
			// check for jQuery easing
			if (typeof(options.easing) === 'string' && typeof(jQuery) !== 'undefined' && jQuery.isFunction(jQuery.easing[options.easing])) {
				options.easing = jQuery.easing[options.easing];
			} else {
				options.easing = defaultOptions.easing;
			}
	
			// process earlier animate option to avoid bc breaks
			if (typeof(options.animate) === 'number') {
				options.animate = {
					duration: options.animate,
					enabled: true
				};
			}
	
			if (typeof(options.animate) === 'boolean' && !options.animate) {
				options.animate = {
					duration: 1000,
					enabled: options.animate
				};
			}
	
			// create renderer
			this.renderer = new options.renderer(el, options);
	
			// initial draw
			this.renderer.draw(currentValue);
	
			// initial update
			if (el.dataset && el.dataset.percent) {
				this.update(parseFloat(el.dataset.percent));
			} else if (el.getAttribute && el.getAttribute('data-percent')) {
				this.update(parseFloat(el.getAttribute('data-percent')));
			}
			
			el.style['width'] = el.style['height'] = options.size + 'px';//ACE
			el.style['lineHeight'] = (options.size - 1) + 'px';//ACE
		}.bind(this);
	
		/**
		 * Update the value of the chart
		 * @param  {number} newValue Number between 0 and 100
		 * @return {object}          Instance of the plugin for method chaining
		 */
		this.update = function(newValue) {
			newValue = parseFloat(newValue);
			if (options.animate.enabled) {
				this.renderer.animate(currentValue, newValue);
			} else {
				this.renderer.draw(newValue);
			}
			currentValue = newValue;
			return this;
		}.bind(this);
	
		/**
		 * Disable animation
		 * @return {object} Instance of the plugin for method chaining
		 */
		this.disableAnimation = function() {
			options.animate.enabled = false;
			return this;
		};
	
		/**
		 * Enable animation
		 * @return {object} Instance of the plugin for method chaining
		 */
		this.enableAnimation = function() {
			options.animate.enabled = true;
			return this;
		};
	
		init();
	};
	
	$.fn.easyPieChart = function(options) {
		return this.each(function() {
			var instanceOptions;
	
			if (!$.data(this, 'easyPieChart')) {
				instanceOptions = $.extend({}, options, $(this).data());
				$.data(this, 'easyPieChart', new EasyPieChart(this, instanceOptions));
			}
		});
	};
	
	
	}));


/***/ },

/***/ 1110:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	*
	* jquery.sparkline.js
	*
	* v2.1.2
	* (c) Splunk, Inc
	* Contact: Gareth Watts (gareth@splunk.com)
	* http://omnipotent.net/jquery.sparkline/
	*
	* Generates inline sparkline charts from data supplied either to the method
	* or inline in HTML
	*
	* Compatible with Internet Explorer 6.0+ and modern browsers equipped with the canvas tag
	* (Firefox 2.0+, Safari, Opera, etc)
	*
	* License: New BSD License
	*
	* Copyright (c) 2012, Splunk Inc.
	* All rights reserved.
	*
	* Redistribution and use in source and binary forms, with or without modification,
	* are permitted provided that the following conditions are met:
	*
	*     * Redistributions of source code must retain the above copyright notice,
	*       this list of conditions and the following disclaimer.
	*     * Redistributions in binary form must reproduce the above copyright notice,
	*       this list of conditions and the following disclaimer in the documentation
	*       and/or other materials provided with the distribution.
	*     * Neither the name of Splunk Inc nor the names of its contributors may
	*       be used to endorse or promote products derived from this software without
	*       specific prior written permission.
	*
	* THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
	* EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES
	* OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT
	* SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	* SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
	* OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
	* HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
	* OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	* SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*
	*
	* Usage:
	*  $(selector).sparkline(values, options)
	*
	* If values is undefined or set to 'html' then the data values are read from the specified tag:
	*   <p>Sparkline: <span class="sparkline">1,4,6,6,8,5,3,5</span></p>
	*   $('.sparkline').sparkline();
	* There must be no spaces in the enclosed data set
	*
	* Otherwise values must be an array of numbers or null values
	*    <p>Sparkline: <span id="sparkline1">This text replaced if the browser is compatible</span></p>
	*    $('#sparkline1').sparkline([1,4,6,6,8,5,3,5])
	*    $('#sparkline2').sparkline([1,4,6,null,null,5,3,5])
	*
	* Values can also be specified in an HTML comment, or as a values attribute:
	*    <p>Sparkline: <span class="sparkline"><!--1,4,6,6,8,5,3,5 --></span></p>
	*    <p>Sparkline: <span class="sparkline" values="1,4,6,6,8,5,3,5"></span></p>
	*    $('.sparkline').sparkline();
	*
	* For line charts, x values can also be specified:
	*   <p>Sparkline: <span class="sparkline">1:1,2.7:4,3.4:6,5:6,6:8,8.7:5,9:3,10:5</span></p>
	*    $('#sparkline1').sparkline([ [1,1], [2.7,4], [3.4,6], [5,6], [6,8], [8.7,5], [9,3], [10,5] ])
	*
	* By default, options should be passed in as teh second argument to the sparkline function:
	*   $('.sparkline').sparkline([1,2,3,4], {type: 'bar'})
	*
	* Options can also be set by passing them on the tag itself.  This feature is disabled by default though
	* as there's a slight performance overhead:
	*   $('.sparkline').sparkline([1,2,3,4], {enableTagOptions: true})
	*   <p>Sparkline: <span class="sparkline" sparkType="bar" sparkBarColor="red">loading</span></p>
	* Prefix all options supplied as tag attribute with "spark" (configurable by setting tagOptionPrefix)
	*
	* Supported options:
	*   lineColor - Color of the line used for the chart
	*   fillColor - Color used to fill in the chart - Set to '' or false for a transparent chart
	*   width - Width of the chart - Defaults to 3 times the number of values in pixels
	*   height - Height of the chart - Defaults to the height of the containing element
	*   chartRangeMin - Specify the minimum value to use for the Y range of the chart - Defaults to the minimum value supplied
	*   chartRangeMax - Specify the maximum value to use for the Y range of the chart - Defaults to the maximum value supplied
	*   chartRangeClip - Clip out of range values to the max/min specified by chartRangeMin and chartRangeMax
	*   chartRangeMinX - Specify the minimum value to use for the X range of the chart - Defaults to the minimum value supplied
	*   chartRangeMaxX - Specify the maximum value to use for the X range of the chart - Defaults to the maximum value supplied
	*   composite - If true then don't erase any existing chart attached to the tag, but draw
	*           another chart over the top - Note that width and height are ignored if an
	*           existing chart is detected.
	*   tagValuesAttribute - Name of tag attribute to check for data values - Defaults to 'values'
	*   enableTagOptions - Whether to check tags for sparkline options
	*   tagOptionPrefix - Prefix used for options supplied as tag attributes - Defaults to 'spark'
	*   disableHiddenCheck - If set to true, then the plugin will assume that charts will never be drawn into a
	*           hidden dom element, avoding a browser reflow
	*   disableInteraction - If set to true then all mouseover/click interaction behaviour will be disabled,
	*       making the plugin perform much like it did in 1.x
	*   disableTooltips - If set to true then tooltips will be disabled - Defaults to false (tooltips enabled)
	*   disableHighlight - If set to true then highlighting of selected chart elements on mouseover will be disabled
	*       defaults to false (highlights enabled)
	*   highlightLighten - Factor to lighten/darken highlighted chart values by - Defaults to 1.4 for a 40% increase
	*   tooltipContainer - Specify which DOM element the tooltip should be rendered into - defaults to document.body
	*   tooltipClassname - Optional CSS classname to apply to tooltips - If not specified then a default style will be applied
	*   tooltipOffsetX - How many pixels away from the mouse pointer to render the tooltip on the X axis
	*   tooltipOffsetY - How many pixels away from the mouse pointer to render the tooltip on the r axis
	*   tooltipFormatter  - Optional callback that allows you to override the HTML displayed in the tooltip
	*       callback is given arguments of (sparkline, options, fields)
	*   tooltipChartTitle - If specified then the tooltip uses the string specified by this setting as a title
	*   tooltipFormat - A format string or SPFormat object  (or an array thereof for multiple entries)
	*       to control the format of the tooltip
	*   tooltipPrefix - A string to prepend to each field displayed in a tooltip
	*   tooltipSuffix - A string to append to each field displayed in a tooltip
	*   tooltipSkipNull - If true then null values will not have a tooltip displayed (defaults to true)
	*   tooltipValueLookups - An object or range map to map field values to tooltip strings
	*       (eg. to map -1 to "Lost", 0 to "Draw", and 1 to "Win")
	*   numberFormatter - Optional callback for formatting numbers in tooltips
	*   numberDigitGroupSep - Character to use for group separator in numbers "1,234" - Defaults to ","
	*   numberDecimalMark - Character to use for the decimal point when formatting numbers - Defaults to "."
	*   numberDigitGroupCount - Number of digits between group separator - Defaults to 3
	*
	* There are 7 types of sparkline, selected by supplying a "type" option of 'line' (default),
	* 'bar', 'tristate', 'bullet', 'discrete', 'pie' or 'box'
	*    line - Line chart.  Options:
	*       spotColor - Set to '' to not end each line in a circular spot
	*       minSpotColor - If set, color of spot at minimum value
	*       maxSpotColor - If set, color of spot at maximum value
	*       spotRadius - Radius in pixels
	*       lineWidth - Width of line in pixels
	*       normalRangeMin
	*       normalRangeMax - If set draws a filled horizontal bar between these two values marking the "normal"
	*                      or expected range of values
	*       normalRangeColor - Color to use for the above bar
	*       drawNormalOnTop - Draw the normal range above the chart fill color if true
	*       defaultPixelsPerValue - Defaults to 3 pixels of width for each value in the chart
	*       highlightSpotColor - The color to use for drawing a highlight spot on mouseover - Set to null to disable
	*       highlightLineColor - The color to use for drawing a highlight line on mouseover - Set to null to disable
	*       valueSpots - Specify which points to draw spots on, and in which color.  Accepts a range map
	*
	*   bar - Bar chart.  Options:
	*       barColor - Color of bars for postive values
	*       negBarColor - Color of bars for negative values
	*       zeroColor - Color of bars with zero values
	*       nullColor - Color of bars with null values - Defaults to omitting the bar entirely
	*       barWidth - Width of bars in pixels
	*       colorMap - Optional mappnig of values to colors to override the *BarColor values above
	*                  can be an Array of values to control the color of individual bars or a range map
	*                  to specify colors for individual ranges of values
	*       barSpacing - Gap between bars in pixels
	*       zeroAxis - Centers the y-axis around zero if true
	*
	*   tristate - Charts values of win (>0), lose (<0) or draw (=0)
	*       posBarColor - Color of win values
	*       negBarColor - Color of lose values
	*       zeroBarColor - Color of draw values
	*       barWidth - Width of bars in pixels
	*       barSpacing - Gap between bars in pixels
	*       colorMap - Optional mappnig of values to colors to override the *BarColor values above
	*                  can be an Array of values to control the color of individual bars or a range map
	*                  to specify colors for individual ranges of values
	*
	*   discrete - Options:
	*       lineHeight - Height of each line in pixels - Defaults to 30% of the graph height
	*       thesholdValue - Values less than this value will be drawn using thresholdColor instead of lineColor
	*       thresholdColor
	*
	*   bullet - Values for bullet graphs msut be in the order: target, performance, range1, range2, range3, ...
	*       options:
	*       targetColor - The color of the vertical target marker
	*       targetWidth - The width of the target marker in pixels
	*       performanceColor - The color of the performance measure horizontal bar
	*       rangeColors - Colors to use for each qualitative range background color
	*
	*   pie - Pie chart. Options:
	*       sliceColors - An array of colors to use for pie slices
	*       offset - Angle in degrees to offset the first slice - Try -90 or +90
	*       borderWidth - Width of border to draw around the pie chart, in pixels - Defaults to 0 (no border)
	*       borderColor - Color to use for the pie chart border - Defaults to #000
	*
	*   box - Box plot. Options:
	*       raw - Set to true to supply pre-computed plot points as values
	*             values should be: low_outlier, low_whisker, q1, median, q3, high_whisker, high_outlier
	*             When set to false you can supply any number of values and the box plot will
	*             be computed for you.  Default is false.
	*       showOutliers - Set to true (default) to display outliers as circles
	*       outlierIQR - Interquartile range used to determine outliers.  Default 1.5
	*       boxLineColor - Outline color of the box
	*       boxFillColor - Fill color for the box
	*       whiskerColor - Line color used for whiskers
	*       outlierLineColor - Outline color of outlier circles
	*       outlierFillColor - Fill color of the outlier circles
	*       spotRadius - Radius of outlier circles
	*       medianColor - Line color of the median line
	*       target - Draw a target cross hair at the supplied value (default undefined)
	*
	*
	*
	*   Examples:
	*   $('#sparkline1').sparkline(myvalues, { lineColor: '#f00', fillColor: false });
	*   $('.barsparks').sparkline('html', { type:'bar', height:'40px', barWidth:5 });
	*   $('#tristate').sparkline([1,1,-1,1,0,0,-1], { type:'tristate' }):
	*   $('#discrete').sparkline([1,3,4,5,5,3,4,5], { type:'discrete' });
	*   $('#bullet').sparkline([10,12,12,9,7], { type:'bullet' });
	*   $('#pie').sparkline([1,1,2], { type:'pie' });
	*/
	
	/*jslint regexp: true, browser: true, jquery: true, white: true, nomen: false, plusplus: false, maxerr: 500, indent: 4 */
	
	(function(document, Math, undefined) { // performance/minified-size optimization
	(function(factory) {
	    if(true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (jQuery && !jQuery.fn.sparkline) {
	        factory(jQuery);
	    }
	}
	(function($) {
	    'use strict';
	
	    var UNSET_OPTION = {},
	        getDefaults, createClass, SPFormat, clipval, quartile, normalizeValue, normalizeValues,
	        remove, isNumber, all, sum, addCSS, ensureArray, formatNumber, RangeMap,
	        MouseHandler, Tooltip, barHighlightMixin,
	        line, bar, tristate, discrete, bullet, pie, box, defaultStyles, initStyles,
	        VShape, VCanvas_base, VCanvas_canvas, VCanvas_vml, pending, shapeCount = 0;
	
	    /**
	     * Default configuration settings
	     */
	    getDefaults = function () {
	        return {
	            // Settings common to most/all chart types
	            common: {
	                type: 'line',
	                lineColor: '#00f',
	                fillColor: '#cdf',
	                defaultPixelsPerValue: 3,
	                width: 'auto',
	                height: 'auto',
	                composite: false,
	                tagValuesAttribute: 'values',
	                tagOptionsPrefix: 'spark',
	                enableTagOptions: false,
	                enableHighlight: true,
	                highlightLighten: 1.4,
	                tooltipSkipNull: true,
	                tooltipPrefix: '',
	                tooltipSuffix: '',
	                disableHiddenCheck: false,
	                numberFormatter: false,
	                numberDigitGroupCount: 3,
	                numberDigitGroupSep: ',',
	                numberDecimalMark: '.',
	                disableTooltips: false,
	                disableInteraction: false
	            },
	            // Defaults for line charts
	            line: {
	                spotColor: '#f80',
	                highlightSpotColor: '#5f5',
	                highlightLineColor: '#f22',
	                spotRadius: 1.5,
	                minSpotColor: '#f80',
	                maxSpotColor: '#f80',
	                lineWidth: 1,
	                normalRangeMin: undefined,
	                normalRangeMax: undefined,
	                normalRangeColor: '#ccc',
	                drawNormalOnTop: false,
	                chartRangeMin: undefined,
	                chartRangeMax: undefined,
	                chartRangeMinX: undefined,
	                chartRangeMaxX: undefined,
	                tooltipFormat: new SPFormat('<span style="color: {{color}}">&#9679;</span> {{prefix}}{{y}}{{suffix}}')
	            },
	            // Defaults for bar charts
	            bar: {
	                barColor: '#3366cc',
	                negBarColor: '#f44',
	                stackedBarColor: ['#3366cc', '#dc3912', '#ff9900', '#109618', '#66aa00',
	                    '#dd4477', '#0099c6', '#990099'],
	                zeroColor: undefined,
	                nullColor: undefined,
	                zeroAxis: true,
	                barWidth: 4,
	                barSpacing: 1,
	                chartRangeMax: undefined,
	                chartRangeMin: undefined,
	                chartRangeClip: false,
	                colorMap: undefined,
	                tooltipFormat: new SPFormat('<span style="color: {{color}}">&#9679;</span> {{prefix}}{{value}}{{suffix}}')
	            },
	            // Defaults for tristate charts
	            tristate: {
	                barWidth: 4,
	                barSpacing: 1,
	                posBarColor: '#6f6',
	                negBarColor: '#f44',
	                zeroBarColor: '#999',
	                colorMap: {},
	                tooltipFormat: new SPFormat('<span style="color: {{color}}">&#9679;</span> {{value:map}}'),
	                tooltipValueLookups: { map: { '-1': 'Loss', '0': 'Draw', '1': 'Win' } }
	            },
	            // Defaults for discrete charts
	            discrete: {
	                lineHeight: 'auto',
	                thresholdColor: undefined,
	                thresholdValue: 0,
	                chartRangeMax: undefined,
	                chartRangeMin: undefined,
	                chartRangeClip: false,
	                tooltipFormat: new SPFormat('{{prefix}}{{value}}{{suffix}}')
	            },
	            // Defaults for bullet charts
	            bullet: {
	                targetColor: '#f33',
	                targetWidth: 3, // width of the target bar in pixels
	                performanceColor: '#33f',
	                rangeColors: ['#d3dafe', '#a8b6ff', '#7f94ff'],
	                base: undefined, // set this to a number to change the base start number
	                tooltipFormat: new SPFormat('{{fieldkey:fields}} - {{value}}'),
	                tooltipValueLookups: { fields: {r: 'Range', p: 'Performance', t: 'Target'} }
	            },
	            // Defaults for pie charts
	            pie: {
	                offset: 0,
	                sliceColors: ['#3366cc', '#dc3912', '#ff9900', '#109618', '#66aa00',
	                    '#dd4477', '#0099c6', '#990099'],
	                borderWidth: 0,
	                borderColor: '#000',
	                tooltipFormat: new SPFormat('<span style="color: {{color}}">&#9679;</span> {{value}} ({{percent.1}}%)')
	            },
	            // Defaults for box plots
	            box: {
	                raw: false,
	                boxLineColor: '#000',
	                boxFillColor: '#cdf',
	                whiskerColor: '#000',
	                outlierLineColor: '#333',
	                outlierFillColor: '#fff',
	                medianColor: '#f00',
	                showOutliers: true,
	                outlierIQR: 1.5,
	                spotRadius: 1.5,
	                target: undefined,
	                targetColor: '#4a2',
	                chartRangeMax: undefined,
	                chartRangeMin: undefined,
	                tooltipFormat: new SPFormat('{{field:fields}}: {{value}}'),
	                tooltipFormatFieldlistKey: 'field',
	                tooltipValueLookups: { fields: { lq: 'Lower Quartile', med: 'Median',
	                    uq: 'Upper Quartile', lo: 'Left Outlier', ro: 'Right Outlier',
	                    lw: 'Left Whisker', rw: 'Right Whisker'} }
	            }
	        };
	    };
	
	    // You can have tooltips use a css class other than jqstooltip by specifying tooltipClassname
	    defaultStyles = '.jqstooltip { ' +
	            'position: absolute;' +
	            'left: 0px;' +
	            'top: 0px;' +
	            'visibility: hidden;' +
	            'background: rgb(0, 0, 0) transparent;' +
	            'background-color: rgba(0,0,0,0.6);' +
	            'filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000);' +
	            '-ms-filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000)";' +
	            'color: white;' +
	            'font: 10px arial, san serif;' +
	            'text-align: left;' +
	            'white-space: nowrap;' +
	            'padding: 5px;' +
	            'border: 1px solid white;' +
	            'z-index: 10000;' +
	            '}' +
	            '.jqsfield { ' +
	            'color: white;' +
	            'font: 10px arial, san serif;' +
	            'text-align: left;' +
	            '}';
	
	    /**
	     * Utilities
	     */
	
	    createClass = function (/* [baseclass, [mixin, ...]], definition */) {
	        var Class, args;
	        Class = function () {
	            this.init.apply(this, arguments);
	        };
	        if (arguments.length > 1) {
	            if (arguments[0]) {
	                Class.prototype = $.extend(new arguments[0](), arguments[arguments.length - 1]);
	                Class._super = arguments[0].prototype;
	            } else {
	                Class.prototype = arguments[arguments.length - 1];
	            }
	            if (arguments.length > 2) {
	                args = Array.prototype.slice.call(arguments, 1, -1);
	                args.unshift(Class.prototype);
	                $.extend.apply($, args);
	            }
	        } else {
	            Class.prototype = arguments[0];
	        }
	        Class.prototype.cls = Class;
	        return Class;
	    };
	
	    /**
	     * Wraps a format string for tooltips
	     * {{x}}
	     * {{x.2}
	     * {{x:months}}
	     */
	    $.SPFormatClass = SPFormat = createClass({
	        fre: /\{\{([\w.]+?)(:(.+?))?\}\}/g,
	        precre: /(\w+)\.(\d+)/,
	
	        init: function (format, fclass) {
	            this.format = format;
	            this.fclass = fclass;
	        },
	
	        render: function (fieldset, lookups, options) {
	            var self = this,
	                fields = fieldset,
	                match, token, lookupkey, fieldvalue, prec;
	            return this.format.replace(this.fre, function () {
	                var lookup;
	                token = arguments[1];
	                lookupkey = arguments[3];
	                match = self.precre.exec(token);
	                if (match) {
	                    prec = match[2];
	                    token = match[1];
	                } else {
	                    prec = false;
	                }
	                fieldvalue = fields[token];
	                if (fieldvalue === undefined) {
	                    return '';
	                }
	                if (lookupkey && lookups && lookups[lookupkey]) {
	                    lookup = lookups[lookupkey];
	                    if (lookup.get) { // RangeMap
	                        return lookups[lookupkey].get(fieldvalue) || fieldvalue;
	                    } else {
	                        return lookups[lookupkey][fieldvalue] || fieldvalue;
	                    }
	                }
	                if (isNumber(fieldvalue)) {
	                    if (options.get('numberFormatter')) {
	                        fieldvalue = options.get('numberFormatter')(fieldvalue);
	                    } else {
	                        fieldvalue = formatNumber(fieldvalue, prec,
	                            options.get('numberDigitGroupCount'),
	                            options.get('numberDigitGroupSep'),
	                            options.get('numberDecimalMark'));
	                    }
	                }
	                return fieldvalue;
	            });
	        }
	    });
	
	    // convience method to avoid needing the new operator
	    $.spformat = function(format, fclass) {
	        return new SPFormat(format, fclass);
	    };
	
	    clipval = function (val, min, max) {
	        if (val < min) {
	            return min;
	        }
	        if (val > max) {
	            return max;
	        }
	        return val;
	    };
	
	    quartile = function (values, q) {
	        var vl;
	        if (q === 2) {
	            vl = Math.floor(values.length / 2);
	            return values.length % 2 ? values[vl] : (values[vl-1] + values[vl]) / 2;
	        } else {
	            if (values.length % 2 ) { // odd
	                vl = (values.length * q + q) / 4;
	                return vl % 1 ? (values[Math.floor(vl)] + values[Math.floor(vl) - 1]) / 2 : values[vl-1];
	            } else { //even
	                vl = (values.length * q + 2) / 4;
	                return vl % 1 ? (values[Math.floor(vl)] + values[Math.floor(vl) - 1]) / 2 :  values[vl-1];
	
	            }
	        }
	    };
	
	    normalizeValue = function (val) {
	        var nf;
	        switch (val) {
	            case 'undefined':
	                val = undefined;
	                break;
	            case 'null':
	                val = null;
	                break;
	            case 'true':
	                val = true;
	                break;
	            case 'false':
	                val = false;
	                break;
	            default:
	                nf = parseFloat(val);
	                if (val == nf) {
	                    val = nf;
	                }
	        }
	        return val;
	    };
	
	    normalizeValues = function (vals) {
	        var i, result = [];
	        for (i = vals.length; i--;) {
	            result[i] = normalizeValue(vals[i]);
	        }
	        return result;
	    };
	
	    remove = function (vals, filter) {
	        var i, vl, result = [];
	        for (i = 0, vl = vals.length; i < vl; i++) {
	            if (vals[i] !== filter) {
	                result.push(vals[i]);
	            }
	        }
	        return result;
	    };
	
	    isNumber = function (num) {
	        return !isNaN(parseFloat(num)) && isFinite(num);
	    };
	
	    formatNumber = function (num, prec, groupsize, groupsep, decsep) {
	        var p, i;
	        num = (prec === false ? parseFloat(num).toString() : num.toFixed(prec)).split('');
	        p = (p = $.inArray('.', num)) < 0 ? num.length : p;
	        if (p < num.length) {
	            num[p] = decsep;
	        }
	        for (i = p - groupsize; i > 0; i -= groupsize) {
	            num.splice(i, 0, groupsep);
	        }
	        return num.join('');
	    };
	
	    // determine if all values of an array match a value
	    // returns true if the array is empty
	    all = function (val, arr, ignoreNull) {
	        var i;
	        for (i = arr.length; i--; ) {
	            if (ignoreNull && arr[i] === null) continue;
	            if (arr[i] !== val) {
	                return false;
	            }
	        }
	        return true;
	    };
	
	    // sums the numeric values in an array, ignoring other values
	    sum = function (vals) {
	        var total = 0, i;
	        for (i = vals.length; i--;) {
	            total += typeof vals[i] === 'number' ? vals[i] : 0;
	        }
	        return total;
	    };
	
	    ensureArray = function (val) {
	        return $.isArray(val) ? val : [val];
	    };
	
	    // http://paulirish.com/2008/bookmarklet-inject-new-css-rules/
	    addCSS = function(css) {
	        var tag;
	        //if ('\v' == 'v') /* ie only */ {
	        if (document.createStyleSheet) {
	            document.createStyleSheet().cssText = css;
	        } else {
	            tag = document.createElement('style');
	            tag.type = 'text/css';
	            document.getElementsByTagName('head')[0].appendChild(tag);
	            tag[(typeof document.body.style.WebkitAppearance == 'string') /* webkit only */ ? 'innerText' : 'innerHTML'] = css;
	        }
	    };
	
	    // Provide a cross-browser interface to a few simple drawing primitives
	    $.fn.simpledraw = function (width, height, useExisting, interact) {
	        var target, mhandler;
	        if (useExisting && (target = this.data('_jqs_vcanvas'))) {
	            return target;
	        }
	
	        if ($.fn.sparkline.canvas === false) {
	            // We've already determined that neither Canvas nor VML are available
	            return false;
	
	        } else if ($.fn.sparkline.canvas === undefined) {
	            // No function defined yet -- need to see if we support Canvas or VML
	            var el = document.createElement('canvas');
	            if (!!(el.getContext && el.getContext('2d'))) {
	                // Canvas is available
	                $.fn.sparkline.canvas = function(width, height, target, interact) {
	                    return new VCanvas_canvas(width, height, target, interact);
	                };
	            } else if (document.namespaces && !document.namespaces.v) {
	                // VML is available
	                document.namespaces.add('v', 'urn:schemas-microsoft-com:vml', '#default#VML');
	                $.fn.sparkline.canvas = function(width, height, target, interact) {
	                    return new VCanvas_vml(width, height, target);
	                };
	            } else {
	                // Neither Canvas nor VML are available
	                $.fn.sparkline.canvas = false;
	                return false;
	            }
	        }
	
	        if (width === undefined) {
	            width = $(this).innerWidth();
	        }
	        if (height === undefined) {
	            height = $(this).innerHeight();
	        }
	
	        target = $.fn.sparkline.canvas(width, height, this, interact);
	
	        mhandler = $(this).data('_jqs_mhandler');
	        if (mhandler) {
	            mhandler.registerCanvas(target);
	        }
	        return target;
	    };
	
	    $.fn.cleardraw = function () {
	        var target = this.data('_jqs_vcanvas');
	        if (target) {
	            target.reset();
	        }
	    };
	
	    $.RangeMapClass = RangeMap = createClass({
	        init: function (map) {
	            var key, range, rangelist = [];
	            for (key in map) {
	                if (map.hasOwnProperty(key) && typeof key === 'string' && key.indexOf(':') > -1) {
	                    range = key.split(':');
	                    range[0] = range[0].length === 0 ? -Infinity : parseFloat(range[0]);
	                    range[1] = range[1].length === 0 ? Infinity : parseFloat(range[1]);
	                    range[2] = map[key];
	                    rangelist.push(range);
	                }
	            }
	            this.map = map;
	            this.rangelist = rangelist || false;
	        },
	
	        get: function (value) {
	            var rangelist = this.rangelist,
	                i, range, result;
	            if ((result = this.map[value]) !== undefined) {
	                return result;
	            }
	            if (rangelist) {
	                for (i = rangelist.length; i--;) {
	                    range = rangelist[i];
	                    if (range[0] <= value && range[1] >= value) {
	                        return range[2];
	                    }
	                }
	            }
	            return undefined;
	        }
	    });
	
	    // Convenience function
	    $.range_map = function(map) {
	        return new RangeMap(map);
	    };
	
	    MouseHandler = createClass({
	        init: function (el, options) {
	            var $el = $(el);
	            this.$el = $el;
	            this.options = options;
	            this.currentPageX = 0;
	            this.currentPageY = 0;
	            this.el = el;
	            this.splist = [];
	            this.tooltip = null;
	            this.over = false;
	            this.displayTooltips = !options.get('disableTooltips');
	            this.highlightEnabled = !options.get('disableHighlight');
	        },
	
	        registerSparkline: function (sp) {
	            this.splist.push(sp);
	            if (this.over) {
	                this.updateDisplay();
	            }
	        },
	
	        registerCanvas: function (canvas) {
	            var $canvas = $(canvas.canvas);
	            this.canvas = canvas;
	            this.$canvas = $canvas;
	            $canvas.mouseenter($.proxy(this.mouseenter, this));
	            $canvas.mouseleave($.proxy(this.mouseleave, this));
	            $canvas.click($.proxy(this.mouseclick, this));
	        },
	
	        reset: function (removeTooltip) {
	            this.splist = [];
	            if (this.tooltip && removeTooltip) {
	                this.tooltip.remove();
	                this.tooltip = undefined;
	            }
	        },
	
	        mouseclick: function (e) {
	            var clickEvent = $.Event('sparklineClick');
	            clickEvent.originalEvent = e;
	            clickEvent.sparklines = this.splist;
	            this.$el.trigger(clickEvent);
	        },
	
	        mouseenter: function (e) {
	            $(document.body).unbind('mousemove.jqs');
	            $(document.body).bind('mousemove.jqs', $.proxy(this.mousemove, this));
	            this.over = true;
	            this.currentPageX = e.pageX;
	            this.currentPageY = e.pageY;
	            this.currentEl = e.target;
	            if (!this.tooltip && this.displayTooltips) {
	                this.tooltip = new Tooltip(this.options);
	                this.tooltip.updatePosition(e.pageX, e.pageY);
	            }
	            this.updateDisplay();
	        },
	
	        mouseleave: function () {
	            $(document.body).unbind('mousemove.jqs');
	            var splist = this.splist,
	                 spcount = splist.length,
	                 needsRefresh = false,
	                 sp, i;
	            this.over = false;
	            this.currentEl = null;
	
	            if (this.tooltip) {
	                this.tooltip.remove();
	                this.tooltip = null;
	            }
	
	            for (i = 0; i < spcount; i++) {
	                sp = splist[i];
	                if (sp.clearRegionHighlight()) {
	                    needsRefresh = true;
	                }
	            }
	
	            if (needsRefresh) {
	                this.canvas.render();
	            }
	        },
	
	        mousemove: function (e) {
	            this.currentPageX = e.pageX;
	            this.currentPageY = e.pageY;
	            this.currentEl = e.target;
	            if (this.tooltip) {
	                this.tooltip.updatePosition(e.pageX, e.pageY);
	            }
	            this.updateDisplay();
	        },
	
	        updateDisplay: function () {
	            var splist = this.splist,
	                 spcount = splist.length,
	                 needsRefresh = false,
	                 offset = this.$canvas.offset(),
	                 localX = this.currentPageX - offset.left,
	                 localY = this.currentPageY - offset.top,
	                 tooltiphtml, sp, i, result, changeEvent;
	            if (!this.over) {
	                return;
	            }
	            for (i = 0; i < spcount; i++) {
	                sp = splist[i];
	                result = sp.setRegionHighlight(this.currentEl, localX, localY);
	                if (result) {
	                    needsRefresh = true;
	                }
	            }
	            if (needsRefresh) {
	                changeEvent = $.Event('sparklineRegionChange');
	                changeEvent.sparklines = this.splist;
	                this.$el.trigger(changeEvent);
	                if (this.tooltip) {
	                    tooltiphtml = '';
	                    for (i = 0; i < spcount; i++) {
	                        sp = splist[i];
	                        tooltiphtml += sp.getCurrentRegionTooltip();
	                    }
	                    this.tooltip.setContent(tooltiphtml);
	                }
	                if (!this.disableHighlight) {
	                    this.canvas.render();
	                }
	            }
	            if (result === null) {
	                this.mouseleave();
	            }
	        }
	    });
	
	
	    Tooltip = createClass({
	        sizeStyle: 'position: static !important;' +
	            'display: block !important;' +
	            'visibility: hidden !important;' +
	            'float: left !important;',
	
	        init: function (options) {
	            var tooltipClassname = options.get('tooltipClassname', 'jqstooltip'),
	                sizetipStyle = this.sizeStyle,
	                offset;
	            this.container = options.get('tooltipContainer') || document.body;
	            this.tooltipOffsetX = options.get('tooltipOffsetX', 10);
	            this.tooltipOffsetY = options.get('tooltipOffsetY', 12);
	            // remove any previous lingering tooltip
	            $('#jqssizetip').remove();
	            $('#jqstooltip').remove();
	            this.sizetip = $('<div/>', {
	                id: 'jqssizetip',
	                style: sizetipStyle,
	                'class': tooltipClassname
	            });
	            this.tooltip = $('<div/>', {
	                id: 'jqstooltip',
	                'class': tooltipClassname
	            }).appendTo(this.container);
	            // account for the container's location
	            offset = this.tooltip.offset();
	            this.offsetLeft = offset.left;
	            this.offsetTop = offset.top;
	            this.hidden = true;
	            $(window).unbind('resize.jqs scroll.jqs');
	            $(window).bind('resize.jqs scroll.jqs', $.proxy(this.updateWindowDims, this));
	            this.updateWindowDims();
	        },
	
	        updateWindowDims: function () {
	            this.scrollTop = $(window).scrollTop();
	            this.scrollLeft = $(window).scrollLeft();
	            this.scrollRight = this.scrollLeft + $(window).width();
	            this.updatePosition();
	        },
	
	        getSize: function (content) {
	            this.sizetip.html(content).appendTo(this.container);
	            this.width = this.sizetip.width() + 1;
	            this.height = this.sizetip.height();
	            this.sizetip.remove();
	        },
	
	        setContent: function (content) {
	            if (!content) {
	                this.tooltip.css('visibility', 'hidden');
	                this.hidden = true;
	                return;
	            }
	            this.getSize(content);
	            this.tooltip.html(content)
	                .css({
	                    'width': this.width,
	                    'height': this.height,
	                    'visibility': 'visible'
	                });
	            if (this.hidden) {
	                this.hidden = false;
	                this.updatePosition();
	            }
	        },
	
	        updatePosition: function (x, y) {
	            if (x === undefined) {
	                if (this.mousex === undefined) {
	                    return;
	                }
	                x = this.mousex - this.offsetLeft;
	                y = this.mousey - this.offsetTop;
	
	            } else {
	                this.mousex = x = x - this.offsetLeft;
	                this.mousey = y = y - this.offsetTop;
	            }
	            if (!this.height || !this.width || this.hidden) {
	                return;
	            }
	
	            y -= this.height + this.tooltipOffsetY;
	            x += this.tooltipOffsetX;
	
	            if (y < this.scrollTop) {
	                y = this.scrollTop;
	            }
	            if (x < this.scrollLeft) {
	                x = this.scrollLeft;
	            } else if (x + this.width > this.scrollRight) {
	                x = this.scrollRight - this.width;
	            }
	
	            this.tooltip.css({
	                'left': x,
	                'top': y
	            });
	        },
	
	        remove: function () {
	            this.tooltip.remove();
	            this.sizetip.remove();
	            this.sizetip = this.tooltip = undefined;
	            $(window).unbind('resize.jqs scroll.jqs');
	        }
	    });
	
	    initStyles = function() {
	        addCSS(defaultStyles);
	    };
	
	    $(initStyles);
	
	    pending = [];
	    $.fn.sparkline = function (userValues, userOptions) {
	        return this.each(function () {
	            var options = new $.fn.sparkline.options(this, userOptions),
	                 $this = $(this),
	                 render, i;
	            render = function () {
	                var values, width, height, tmp, mhandler, sp, vals;
	                if (userValues === 'html' || userValues === undefined) {
	                    vals = this.getAttribute(options.get('tagValuesAttribute'));
	                    if (vals === undefined || vals === null) {
	                        vals = $this.html();
	                    }
	                    values = vals.replace(/(^\s*<!--)|(-->\s*$)|\s+/g, '').split(',');
	                } else {
	                    values = userValues;
	                }
	
	                width = options.get('width') === 'auto' ? values.length * options.get('defaultPixelsPerValue') : options.get('width');
	                if (options.get('height') === 'auto') {
	                    if (!options.get('composite') || !$.data(this, '_jqs_vcanvas')) {
	                        // must be a better way to get the line height
	                        tmp = document.createElement('span');
	                        tmp.innerHTML = 'a';
	                        $this.html(tmp);
	                        height = $(tmp).innerHeight() || $(tmp).height();
	                        $(tmp).remove();
	                        tmp = null;
	                    }
	                } else {
	                    height = options.get('height');
	                }
	
	                if (!options.get('disableInteraction')) {
	                    mhandler = $.data(this, '_jqs_mhandler');
	                    if (!mhandler) {
	                        mhandler = new MouseHandler(this, options);
	                        $.data(this, '_jqs_mhandler', mhandler);
	                    } else if (!options.get('composite')) {
	                        mhandler.reset();
	                    }
	                } else {
	                    mhandler = false;
	                }
	
	                if (options.get('composite') && !$.data(this, '_jqs_vcanvas')) {
	                    if (!$.data(this, '_jqs_errnotify')) {
	                        alert('Attempted to attach a composite sparkline to an element with no existing sparkline');
	                        $.data(this, '_jqs_errnotify', true);
	                    }
	                    return;
	                }
	
	                sp = new $.fn.sparkline[options.get('type')](this, values, options, width, height);
	
	                sp.render();
	
	                if (mhandler) {
	                    mhandler.registerSparkline(sp);
	                }
	            };
	            if (($(this).html() && !options.get('disableHiddenCheck') && $(this).is(':hidden')) || !$(this).parents('body').length) {
	                if (!options.get('composite') && $.data(this, '_jqs_pending')) {
	                    // remove any existing references to the element
	                    for (i = pending.length; i; i--) {
	                        if (pending[i - 1][0] == this) {
	                            pending.splice(i - 1, 1);
	                        }
	                    }
	                }
	                pending.push([this, render]);
	                $.data(this, '_jqs_pending', true);
	            } else {
	                render.call(this);
	            }
	        });
	    };
	
	    $.fn.sparkline.defaults = getDefaults();
	
	
	    $.sparkline_display_visible = function () {
	        var el, i, pl;
	        var done = [];
	        for (i = 0, pl = pending.length; i < pl; i++) {
	            el = pending[i][0];
	            if ($(el).is(':visible') && !$(el).parents().is(':hidden')) {
	                pending[i][1].call(el);
	                $.data(pending[i][0], '_jqs_pending', false);
	                done.push(i);
	            } else if (!$(el).closest('html').length && !$.data(el, '_jqs_pending')) {
	                // element has been inserted and removed from the DOM
	                // If it was not yet inserted into the dom then the .data request
	                // will return true.
	                // removing from the dom causes the data to be removed.
	                $.data(pending[i][0], '_jqs_pending', false);
	                done.push(i);
	            }
	        }
	        for (i = done.length; i; i--) {
	            pending.splice(done[i - 1], 1);
	        }
	    };
	
	
	    /**
	     * User option handler
	     */
	    $.fn.sparkline.options = createClass({
	        init: function (tag, userOptions) {
	            var extendedOptions, defaults, base, tagOptionType;
	            this.userOptions = userOptions = userOptions || {};
	            this.tag = tag;
	            this.tagValCache = {};
	            defaults = $.fn.sparkline.defaults;
	            base = defaults.common;
	            this.tagOptionsPrefix = userOptions.enableTagOptions && (userOptions.tagOptionsPrefix || base.tagOptionsPrefix);
	
	            tagOptionType = this.getTagSetting('type');
	            if (tagOptionType === UNSET_OPTION) {
	                extendedOptions = defaults[userOptions.type || base.type];
	            } else {
	                extendedOptions = defaults[tagOptionType];
	            }
	            this.mergedOptions = $.extend({}, base, extendedOptions, userOptions);
	        },
	
	
	        getTagSetting: function (key) {
	            var prefix = this.tagOptionsPrefix,
	                val, i, pairs, keyval;
	            if (prefix === false || prefix === undefined) {
	                return UNSET_OPTION;
	            }
	            if (this.tagValCache.hasOwnProperty(key)) {
	                val = this.tagValCache.key;
	            } else {
	                val = this.tag.getAttribute(prefix + key);
	                if (val === undefined || val === null) {
	                    val = UNSET_OPTION;
	                } else if (val.substr(0, 1) === '[') {
	                    val = val.substr(1, val.length - 2).split(',');
	                    for (i = val.length; i--;) {
	                        val[i] = normalizeValue(val[i].replace(/(^\s*)|(\s*$)/g, ''));
	                    }
	                } else if (val.substr(0, 1) === '{') {
	                    pairs = val.substr(1, val.length - 2).split(',');
	                    val = {};
	                    for (i = pairs.length; i--;) {
	                        keyval = pairs[i].split(':', 2);
	                        val[keyval[0].replace(/(^\s*)|(\s*$)/g, '')] = normalizeValue(keyval[1].replace(/(^\s*)|(\s*$)/g, ''));
	                    }
	                } else {
	                    val = normalizeValue(val);
	                }
	                this.tagValCache.key = val;
	            }
	            return val;
	        },
	
	        get: function (key, defaultval) {
	            var tagOption = this.getTagSetting(key),
	                result;
	            if (tagOption !== UNSET_OPTION) {
	                return tagOption;
	            }
	            return (result = this.mergedOptions[key]) === undefined ? defaultval : result;
	        }
	    });
	
	
	    $.fn.sparkline._base = createClass({
	        disabled: false,
	
	        init: function (el, values, options, width, height) {
	            this.el = el;
	            this.$el = $(el);
	            this.values = values;
	            this.options = options;
	            this.width = width;
	            this.height = height;
	            this.currentRegion = undefined;
	        },
	
	        /**
	         * Setup the canvas
	         */
	        initTarget: function () {
	            var interactive = !this.options.get('disableInteraction');
	            if (!(this.target = this.$el.simpledraw(this.width, this.height, this.options.get('composite'), interactive))) {
	                this.disabled = true;
	            } else {
	                this.canvasWidth = this.target.pixelWidth;
	                this.canvasHeight = this.target.pixelHeight;
	            }
	        },
	
	        /**
	         * Actually render the chart to the canvas
	         */
	        render: function () {
	            if (this.disabled) {
	                this.el.innerHTML = '';
	                return false;
	            }
	            return true;
	        },
	
	        /**
	         * Return a region id for a given x/y co-ordinate
	         */
	        getRegion: function (x, y) {
	        },
	
	        /**
	         * Highlight an item based on the moused-over x,y co-ordinate
	         */
	        setRegionHighlight: function (el, x, y) {
	            var currentRegion = this.currentRegion,
	                highlightEnabled = !this.options.get('disableHighlight'),
	                newRegion;
	            if (x > this.canvasWidth || y > this.canvasHeight || x < 0 || y < 0) {
	                return null;
	            }
	            newRegion = this.getRegion(el, x, y);
	            if (currentRegion !== newRegion) {
	                if (currentRegion !== undefined && highlightEnabled) {
	                    this.removeHighlight();
	                }
	                this.currentRegion = newRegion;
	                if (newRegion !== undefined && highlightEnabled) {
	                    this.renderHighlight();
	                }
	                return true;
	            }
	            return false;
	        },
	
	        /**
	         * Reset any currently highlighted item
	         */
	        clearRegionHighlight: function () {
	            if (this.currentRegion !== undefined) {
	                this.removeHighlight();
	                this.currentRegion = undefined;
	                return true;
	            }
	            return false;
	        },
	
	        renderHighlight: function () {
	            this.changeHighlight(true);
	        },
	
	        removeHighlight: function () {
	            this.changeHighlight(false);
	        },
	
	        changeHighlight: function (highlight)  {},
	
	        /**
	         * Fetch the HTML to display as a tooltip
	         */
	        getCurrentRegionTooltip: function () {
	            var options = this.options,
	                header = '',
	                entries = [],
	                fields, formats, formatlen, fclass, text, i,
	                showFields, showFieldsKey, newFields, fv,
	                formatter, format, fieldlen, j;
	            if (this.currentRegion === undefined) {
	                return '';
	            }
	            fields = this.getCurrentRegionFields();
	            formatter = options.get('tooltipFormatter');
	            if (formatter) {
	                return formatter(this, options, fields);
	            }
	            if (options.get('tooltipChartTitle')) {
	                header += '<div class="jqs jqstitle">' + options.get('tooltipChartTitle') + '</div>\n';
	            }
	            formats = this.options.get('tooltipFormat');
	            if (!formats) {
	                return '';
	            }
	            if (!$.isArray(formats)) {
	                formats = [formats];
	            }
	            if (!$.isArray(fields)) {
	                fields = [fields];
	            }
	            showFields = this.options.get('tooltipFormatFieldlist');
	            showFieldsKey = this.options.get('tooltipFormatFieldlistKey');
	            if (showFields && showFieldsKey) {
	                // user-selected ordering of fields
	                newFields = [];
	                for (i = fields.length; i--;) {
	                    fv = fields[i][showFieldsKey];
	                    if ((j = $.inArray(fv, showFields)) != -1) {
	                        newFields[j] = fields[i];
	                    }
	                }
	                fields = newFields;
	            }
	            formatlen = formats.length;
	            fieldlen = fields.length;
	            for (i = 0; i < formatlen; i++) {
	                format = formats[i];
	                if (typeof format === 'string') {
	                    format = new SPFormat(format);
	                }
	                fclass = format.fclass || 'jqsfield';
	                for (j = 0; j < fieldlen; j++) {
	                    if (!fields[j].isNull || !options.get('tooltipSkipNull')) {
	                        $.extend(fields[j], {
	                            prefix: options.get('tooltipPrefix'),
	                            suffix: options.get('tooltipSuffix')
	                        });
	                        text = format.render(fields[j], options.get('tooltipValueLookups'), options);
	                        entries.push('<div class="' + fclass + '">' + text + '</div>');
	                    }
	                }
	            }
	            if (entries.length) {
	                return header + entries.join('\n');
	            }
	            return '';
	        },
	
	        getCurrentRegionFields: function () {},
	
	        calcHighlightColor: function (color, options) {
	            var highlightColor = options.get('highlightColor'),
	                lighten = options.get('highlightLighten'),
	                parse, mult, rgbnew, i;
	            if (highlightColor) {
	                return highlightColor;
	            }
	            if (lighten) {
	                // extract RGB values
	                parse = /^#([0-9a-f])([0-9a-f])([0-9a-f])$/i.exec(color) || /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(color);
	                if (parse) {
	                    rgbnew = [];
	                    mult = color.length === 4 ? 16 : 1;
	                    for (i = 0; i < 3; i++) {
	                        rgbnew[i] = clipval(Math.round(parseInt(parse[i + 1], 16) * mult * lighten), 0, 255);
	                    }
	                    return 'rgb(' + rgbnew.join(',') + ')';
	                }
	
	            }
	            return color;
	        }
	
	    });
	
	    barHighlightMixin = {
	        changeHighlight: function (highlight) {
	            var currentRegion = this.currentRegion,
	                target = this.target,
	                shapeids = this.regionShapes[currentRegion],
	                newShapes;
	            // will be null if the region value was null
	            if (shapeids) {
	                newShapes = this.renderRegion(currentRegion, highlight);
	                if ($.isArray(newShapes) || $.isArray(shapeids)) {
	                    target.replaceWithShapes(shapeids, newShapes);
	                    this.regionShapes[currentRegion] = $.map(newShapes, function (newShape) {
	                        return newShape.id;
	                    });
	                } else {
	                    target.replaceWithShape(shapeids, newShapes);
	                    this.regionShapes[currentRegion] = newShapes.id;
	                }
	            }
	        },
	
	        render: function () {
	            var values = this.values,
	                target = this.target,
	                regionShapes = this.regionShapes,
	                shapes, ids, i, j;
	
	            if (!this.cls._super.render.call(this)) {
	                return;
	            }
	            for (i = values.length; i--;) {
	                shapes = this.renderRegion(i);
	                if (shapes) {
	                    if ($.isArray(shapes)) {
	                        ids = [];
	                        for (j = shapes.length; j--;) {
	                            shapes[j].append();
	                            ids.push(shapes[j].id);
	                        }
	                        regionShapes[i] = ids;
	                    } else {
	                        shapes.append();
	                        regionShapes[i] = shapes.id; // store just the shapeid
	                    }
	                } else {
	                    // null value
	                    regionShapes[i] = null;
	                }
	            }
	            target.render();
	        }
	    };
	
	    /**
	     * Line charts
	     */
	    $.fn.sparkline.line = line = createClass($.fn.sparkline._base, {
	        type: 'line',
	
	        init: function (el, values, options, width, height) {
	            line._super.init.call(this, el, values, options, width, height);
	            this.vertices = [];
	            this.regionMap = [];
	            this.xvalues = [];
	            this.yvalues = [];
	            this.yminmax = [];
	            this.hightlightSpotId = null;
	            this.lastShapeId = null;
	            this.initTarget();
	        },
	
	        getRegion: function (el, x, y) {
	            var i,
	                regionMap = this.regionMap; // maps regions to value positions
	            for (i = regionMap.length; i--;) {
	                if (regionMap[i] !== null && x >= regionMap[i][0] && x <= regionMap[i][1]) {
	                    return regionMap[i][2];
	                }
	            }
	            return undefined;
	        },
	
	        getCurrentRegionFields: function () {
	            var currentRegion = this.currentRegion;
	            return {
	                isNull: this.yvalues[currentRegion] === null,
	                x: this.xvalues[currentRegion],
	                y: this.yvalues[currentRegion],
	                color: this.options.get('lineColor'),
	                fillColor: this.options.get('fillColor'),
	                offset: currentRegion
	            };
	        },
	
	        renderHighlight: function () {
	            var currentRegion = this.currentRegion,
	                target = this.target,
	                vertex = this.vertices[currentRegion],
	                options = this.options,
	                spotRadius = options.get('spotRadius'),
	                highlightSpotColor = options.get('highlightSpotColor'),
	                highlightLineColor = options.get('highlightLineColor'),
	                highlightSpot, highlightLine;
	
	            if (!vertex) {
	                return;
	            }
	            if (spotRadius && highlightSpotColor) {
	                highlightSpot = target.drawCircle(vertex[0], vertex[1],
	                    spotRadius, undefined, highlightSpotColor);
	                this.highlightSpotId = highlightSpot.id;
	                target.insertAfterShape(this.lastShapeId, highlightSpot);
	            }
	            if (highlightLineColor) {
	                highlightLine = target.drawLine(vertex[0], this.canvasTop, vertex[0],
	                    this.canvasTop + this.canvasHeight, highlightLineColor);
	                this.highlightLineId = highlightLine.id;
	                target.insertAfterShape(this.lastShapeId, highlightLine);
	            }
	        },
	
	        removeHighlight: function () {
	            var target = this.target;
	            if (this.highlightSpotId) {
	                target.removeShapeId(this.highlightSpotId);
	                this.highlightSpotId = null;
	            }
	            if (this.highlightLineId) {
	                target.removeShapeId(this.highlightLineId);
	                this.highlightLineId = null;
	            }
	        },
	
	        scanValues: function () {
	            var values = this.values,
	                valcount = values.length,
	                xvalues = this.xvalues,
	                yvalues = this.yvalues,
	                yminmax = this.yminmax,
	                i, val, isStr, isArray, sp;
	            for (i = 0; i < valcount; i++) {
	                val = values[i];
	                isStr = typeof(values[i]) === 'string';
	                isArray = typeof(values[i]) === 'object' && values[i] instanceof Array;
	                sp = isStr && values[i].split(':');
	                if (isStr && sp.length === 2) { // x:y
	                    xvalues.push(Number(sp[0]));
	                    yvalues.push(Number(sp[1]));
	                    yminmax.push(Number(sp[1]));
	                } else if (isArray) {
	                    xvalues.push(val[0]);
	                    yvalues.push(val[1]);
	                    yminmax.push(val[1]);
	                } else {
	                    xvalues.push(i);
	                    if (values[i] === null || values[i] === 'null') {
	                        yvalues.push(null);
	                    } else {
	                        yvalues.push(Number(val));
	                        yminmax.push(Number(val));
	                    }
	                }
	            }
	            if (this.options.get('xvalues')) {
	                xvalues = this.options.get('xvalues');
	            }
	
	            this.maxy = this.maxyorg = Math.max.apply(Math, yminmax);
	            this.miny = this.minyorg = Math.min.apply(Math, yminmax);
	
	            this.maxx = Math.max.apply(Math, xvalues);
	            this.minx = Math.min.apply(Math, xvalues);
	
	            this.xvalues = xvalues;
	            this.yvalues = yvalues;
	            this.yminmax = yminmax;
	
	        },
	
	        processRangeOptions: function () {
	            var options = this.options,
	                normalRangeMin = options.get('normalRangeMin'),
	                normalRangeMax = options.get('normalRangeMax');
	
	            if (normalRangeMin !== undefined) {
	                if (normalRangeMin < this.miny) {
	                    this.miny = normalRangeMin;
	                }
	                if (normalRangeMax > this.maxy) {
	                    this.maxy = normalRangeMax;
	                }
	            }
	            if (options.get('chartRangeMin') !== undefined && (options.get('chartRangeClip') || options.get('chartRangeMin') < this.miny)) {
	                this.miny = options.get('chartRangeMin');
	            }
	            if (options.get('chartRangeMax') !== undefined && (options.get('chartRangeClip') || options.get('chartRangeMax') > this.maxy)) {
	                this.maxy = options.get('chartRangeMax');
	            }
	            if (options.get('chartRangeMinX') !== undefined && (options.get('chartRangeClipX') || options.get('chartRangeMinX') < this.minx)) {
	                this.minx = options.get('chartRangeMinX');
	            }
	            if (options.get('chartRangeMaxX') !== undefined && (options.get('chartRangeClipX') || options.get('chartRangeMaxX') > this.maxx)) {
	                this.maxx = options.get('chartRangeMaxX');
	            }
	
	        },
	
	        drawNormalRange: function (canvasLeft, canvasTop, canvasHeight, canvasWidth, rangey) {
	            var normalRangeMin = this.options.get('normalRangeMin'),
	                normalRangeMax = this.options.get('normalRangeMax'),
	                ytop = canvasTop + Math.round(canvasHeight - (canvasHeight * ((normalRangeMax - this.miny) / rangey))),
	                height = Math.round((canvasHeight * (normalRangeMax - normalRangeMin)) / rangey);
	            this.target.drawRect(canvasLeft, ytop, canvasWidth, height, undefined, this.options.get('normalRangeColor')).append();
	        },
	
	        render: function () {
	            var options = this.options,
	                target = this.target,
	                canvasWidth = this.canvasWidth,
	                canvasHeight = this.canvasHeight,
	                vertices = this.vertices,
	                spotRadius = options.get('spotRadius'),
	                regionMap = this.regionMap,
	                rangex, rangey, yvallast,
	                canvasTop, canvasLeft,
	                vertex, path, paths, x, y, xnext, xpos, xposnext,
	                last, next, yvalcount, lineShapes, fillShapes, plen,
	                valueSpots, hlSpotsEnabled, color, xvalues, yvalues, i;
	
	            if (!line._super.render.call(this)) {
	                return;
	            }
	
	            this.scanValues();
	            this.processRangeOptions();
	
	            xvalues = this.xvalues;
	            yvalues = this.yvalues;
	
	            if (!this.yminmax.length || this.yvalues.length < 2) {
	                // empty or all null valuess
	                return;
	            }
	
	            canvasTop = canvasLeft = 0;
	
	            rangex = this.maxx - this.minx === 0 ? 1 : this.maxx - this.minx;
	            rangey = this.maxy - this.miny === 0 ? 1 : this.maxy - this.miny;
	            yvallast = this.yvalues.length - 1;
	
	            if (spotRadius && (canvasWidth < (spotRadius * 4) || canvasHeight < (spotRadius * 4))) {
	                spotRadius = 0;
	            }
	            if (spotRadius) {
	                // adjust the canvas size as required so that spots will fit
	                hlSpotsEnabled = options.get('highlightSpotColor') &&  !options.get('disableInteraction');
	                if (hlSpotsEnabled || options.get('minSpotColor') || (options.get('spotColor') && yvalues[yvallast] === this.miny)) {
	                    canvasHeight -= Math.ceil(spotRadius);
	                }
	                if (hlSpotsEnabled || options.get('maxSpotColor') || (options.get('spotColor') && yvalues[yvallast] === this.maxy)) {
	                    canvasHeight -= Math.ceil(spotRadius);
	                    canvasTop += Math.ceil(spotRadius);
	                }
	                if (hlSpotsEnabled ||
	                     ((options.get('minSpotColor') || options.get('maxSpotColor')) && (yvalues[0] === this.miny || yvalues[0] === this.maxy))) {
	                    canvasLeft += Math.ceil(spotRadius);
	                    canvasWidth -= Math.ceil(spotRadius);
	                }
	                if (hlSpotsEnabled || options.get('spotColor') ||
	                    (options.get('minSpotColor') || options.get('maxSpotColor') &&
	                        (yvalues[yvallast] === this.miny || yvalues[yvallast] === this.maxy))) {
	                    canvasWidth -= Math.ceil(spotRadius);
	                }
	            }
	
	
	            canvasHeight--;
	
	            if (options.get('normalRangeMin') !== undefined && !options.get('drawNormalOnTop')) {
	                this.drawNormalRange(canvasLeft, canvasTop, canvasHeight, canvasWidth, rangey);
	            }
	
	            path = [];
	            paths = [path];
	            last = next = null;
	            yvalcount = yvalues.length;
	            for (i = 0; i < yvalcount; i++) {
	                x = xvalues[i];
	                xnext = xvalues[i + 1];
	                y = yvalues[i];
	                xpos = canvasLeft + Math.round((x - this.minx) * (canvasWidth / rangex));
	                xposnext = i < yvalcount - 1 ? canvasLeft + Math.round((xnext - this.minx) * (canvasWidth / rangex)) : canvasWidth;
	                next = xpos + ((xposnext - xpos) / 2);
	                regionMap[i] = [last || 0, next, i];
	                last = next;
	                if (y === null) {
	                    if (i) {
	                        if (yvalues[i - 1] !== null) {
	                            path = [];
	                            paths.push(path);
	                        }
	                        vertices.push(null);
	                    }
	                } else {
	                    if (y < this.miny) {
	                        y = this.miny;
	                    }
	                    if (y > this.maxy) {
	                        y = this.maxy;
	                    }
	                    if (!path.length) {
	                        // previous value was null
	                        path.push([xpos, canvasTop + canvasHeight]);
	                    }
	                    vertex = [xpos, canvasTop + Math.round(canvasHeight - (canvasHeight * ((y - this.miny) / rangey)))];
	                    path.push(vertex);
	                    vertices.push(vertex);
	                }
	            }
	
	            lineShapes = [];
	            fillShapes = [];
	            plen = paths.length;
	            for (i = 0; i < plen; i++) {
	                path = paths[i];
	                if (path.length) {
	                    if (options.get('fillColor')) {
	                        path.push([path[path.length - 1][0], (canvasTop + canvasHeight)]);
	                        fillShapes.push(path.slice(0));
	                        path.pop();
	                    }
	                    // if there's only a single point in this path, then we want to display it
	                    // as a vertical line which means we keep path[0]  as is
	                    if (path.length > 2) {
	                        // else we want the first value
	                        path[0] = [path[0][0], path[1][1]];
	                    }
	                    lineShapes.push(path);
	                }
	            }
	
	            // draw the fill first, then optionally the normal range, then the line on top of that
	            plen = fillShapes.length;
	            for (i = 0; i < plen; i++) {
	                target.drawShape(fillShapes[i],
	                    options.get('fillColor'), options.get('fillColor')).append();
	            }
	
	            if (options.get('normalRangeMin') !== undefined && options.get('drawNormalOnTop')) {
	                this.drawNormalRange(canvasLeft, canvasTop, canvasHeight, canvasWidth, rangey);
	            }
	
	            plen = lineShapes.length;
	            for (i = 0; i < plen; i++) {
	                target.drawShape(lineShapes[i], options.get('lineColor'), undefined,
	                    options.get('lineWidth')).append();
	            }
	
	            if (spotRadius && options.get('valueSpots')) {
	                valueSpots = options.get('valueSpots');
	                if (valueSpots.get === undefined) {
	                    valueSpots = new RangeMap(valueSpots);
	                }
	                for (i = 0; i < yvalcount; i++) {
	                    color = valueSpots.get(yvalues[i]);
	                    if (color) {
	                        target.drawCircle(canvasLeft + Math.round((xvalues[i] - this.minx) * (canvasWidth / rangex)),
	                            canvasTop + Math.round(canvasHeight - (canvasHeight * ((yvalues[i] - this.miny) / rangey))),
	                            spotRadius, undefined,
	                            color).append();
	                    }
	                }
	
	            }
	            if (spotRadius && options.get('spotColor') && yvalues[yvallast] !== null) {
	                target.drawCircle(canvasLeft + Math.round((xvalues[xvalues.length - 1] - this.minx) * (canvasWidth / rangex)),
	                    canvasTop + Math.round(canvasHeight - (canvasHeight * ((yvalues[yvallast] - this.miny) / rangey))),
	                    spotRadius, undefined,
	                    options.get('spotColor')).append();
	            }
	            if (this.maxy !== this.minyorg) {
	                if (spotRadius && options.get('minSpotColor')) {
	                    x = xvalues[$.inArray(this.minyorg, yvalues)];
	                    target.drawCircle(canvasLeft + Math.round((x - this.minx) * (canvasWidth / rangex)),
	                        canvasTop + Math.round(canvasHeight - (canvasHeight * ((this.minyorg - this.miny) / rangey))),
	                        spotRadius, undefined,
	                        options.get('minSpotColor')).append();
	                }
	                if (spotRadius && options.get('maxSpotColor')) {
	                    x = xvalues[$.inArray(this.maxyorg, yvalues)];
	                    target.drawCircle(canvasLeft + Math.round((x - this.minx) * (canvasWidth / rangex)),
	                        canvasTop + Math.round(canvasHeight - (canvasHeight * ((this.maxyorg - this.miny) / rangey))),
	                        spotRadius, undefined,
	                        options.get('maxSpotColor')).append();
	                }
	            }
	
	            this.lastShapeId = target.getLastShapeId();
	            this.canvasTop = canvasTop;
	            target.render();
	        }
	    });
	
	    /**
	     * Bar charts
	     */
	    $.fn.sparkline.bar = bar = createClass($.fn.sparkline._base, barHighlightMixin, {
	        type: 'bar',
	
	        init: function (el, values, options, width, height) {
	            var barWidth = parseInt(options.get('barWidth'), 10),
	                barSpacing = parseInt(options.get('barSpacing'), 10),
	                chartRangeMin = options.get('chartRangeMin'),
	                chartRangeMax = options.get('chartRangeMax'),
	                chartRangeClip = options.get('chartRangeClip'),
	                stackMin = Infinity,
	                stackMax = -Infinity,
	                isStackString, groupMin, groupMax, stackRanges,
	                numValues, i, vlen, range, zeroAxis, xaxisOffset, min, max, clipMin, clipMax,
	                stacked, vlist, j, slen, svals, val, yoffset, yMaxCalc, canvasHeightEf;
	            bar._super.init.call(this, el, values, options, width, height);
	
	            // scan values to determine whether to stack bars
	            for (i = 0, vlen = values.length; i < vlen; i++) {
	                val = values[i];
	                isStackString = typeof(val) === 'string' && val.indexOf(':') > -1;
	                if (isStackString || $.isArray(val)) {
	                    stacked = true;
	                    if (isStackString) {
	                        val = values[i] = normalizeValues(val.split(':'));
	                    }
	                    val = remove(val, null); // min/max will treat null as zero
	                    groupMin = Math.min.apply(Math, val);
	                    groupMax = Math.max.apply(Math, val);
	                    if (groupMin < stackMin) {
	                        stackMin = groupMin;
	                    }
	                    if (groupMax > stackMax) {
	                        stackMax = groupMax;
	                    }
	                }
	            }
	
	            this.stacked = stacked;
	            this.regionShapes = {};
	            this.barWidth = barWidth;
	            this.barSpacing = barSpacing;
	            this.totalBarWidth = barWidth + barSpacing;
	            this.width = width = (values.length * barWidth) + ((values.length - 1) * barSpacing);
	
	            this.initTarget();
	
	            if (chartRangeClip) {
	                clipMin = chartRangeMin === undefined ? -Infinity : chartRangeMin;
	                clipMax = chartRangeMax === undefined ? Infinity : chartRangeMax;
	            }
	
	            numValues = [];
	            stackRanges = stacked ? [] : numValues;
	            var stackTotals = [];
	            var stackRangesNeg = [];
	            for (i = 0, vlen = values.length; i < vlen; i++) {
	                if (stacked) {
	                    vlist = values[i];
	                    values[i] = svals = [];
	                    stackTotals[i] = 0;
	                    stackRanges[i] = stackRangesNeg[i] = 0;
	                    for (j = 0, slen = vlist.length; j < slen; j++) {
	                        val = svals[j] = chartRangeClip ? clipval(vlist[j], clipMin, clipMax) : vlist[j];
	                        if (val !== null) {
	                            if (val > 0) {
	                                stackTotals[i] += val;
	                            }
	                            if (stackMin < 0 && stackMax > 0) {
	                                if (val < 0) {
	                                    stackRangesNeg[i] += Math.abs(val);
	                                } else {
	                                    stackRanges[i] += val;
	                                }
	                            } else {
	                                stackRanges[i] += Math.abs(val - (val < 0 ? stackMax : stackMin));
	                            }
	                            numValues.push(val);
	                        }
	                    }
	                } else {
	                    val = chartRangeClip ? clipval(values[i], clipMin, clipMax) : values[i];
	                    val = values[i] = normalizeValue(val);
	                    if (val !== null) {
	                        numValues.push(val);
	                    }
	                }
	            }
	            this.max = max = Math.max.apply(Math, numValues);
	            this.min = min = Math.min.apply(Math, numValues);
	            this.stackMax = stackMax = stacked ? Math.max.apply(Math, stackTotals) : max;
	            this.stackMin = stackMin = stacked ? Math.min.apply(Math, numValues) : min;
	
	            if (options.get('chartRangeMin') !== undefined && (options.get('chartRangeClip') || options.get('chartRangeMin') < min)) {
	                min = options.get('chartRangeMin');
	            }
	            if (options.get('chartRangeMax') !== undefined && (options.get('chartRangeClip') || options.get('chartRangeMax') > max)) {
	                max = options.get('chartRangeMax');
	            }
	
	            this.zeroAxis = zeroAxis = options.get('zeroAxis', true);
	            if (min <= 0 && max >= 0 && zeroAxis) {
	                xaxisOffset = 0;
	            } else if (zeroAxis == false) {
	                xaxisOffset = min;
	            } else if (min > 0) {
	                xaxisOffset = min;
	            } else {
	                xaxisOffset = max;
	            }
	            this.xaxisOffset = xaxisOffset;
	
	            range = stacked ? (Math.max.apply(Math, stackRanges) + Math.max.apply(Math, stackRangesNeg)) : max - min;
	
	            // as we plot zero/min values a single pixel line, we add a pixel to all other
	            // values - Reduce the effective canvas size to suit
	            this.canvasHeightEf = (zeroAxis && min < 0) ? this.canvasHeight - 2 : this.canvasHeight - 1;
	
	            if (min < xaxisOffset) {
	                yMaxCalc = (stacked && max >= 0) ? stackMax : max;
	                yoffset = (yMaxCalc - xaxisOffset) / range * this.canvasHeight;
	                if (yoffset !== Math.ceil(yoffset)) {
	                    this.canvasHeightEf -= 2;
	                    yoffset = Math.ceil(yoffset);
	                }
	            } else {
	                yoffset = this.canvasHeight;
	            }
	            this.yoffset = yoffset;
	
	            if ($.isArray(options.get('colorMap'))) {
	                this.colorMapByIndex = options.get('colorMap');
	                this.colorMapByValue = null;
	            } else {
	                this.colorMapByIndex = null;
	                this.colorMapByValue = options.get('colorMap');
	                if (this.colorMapByValue && this.colorMapByValue.get === undefined) {
	                    this.colorMapByValue = new RangeMap(this.colorMapByValue);
	                }
	            }
	
	            this.range = range;
	        },
	
	        getRegion: function (el, x, y) {
	            var result = Math.floor(x / this.totalBarWidth);
	            return (result < 0 || result >= this.values.length) ? undefined : result;
	        },
	
	        getCurrentRegionFields: function () {
	            var currentRegion = this.currentRegion,
	                values = ensureArray(this.values[currentRegion]),
	                result = [],
	                value, i;
	            for (i = values.length; i--;) {
	                value = values[i];
	                result.push({
	                    isNull: value === null,
	                    value: value,
	                    color: this.calcColor(i, value, currentRegion),
	                    offset: currentRegion
	                });
	            }
	            return result;
	        },
	
	        calcColor: function (stacknum, value, valuenum) {
	            var colorMapByIndex = this.colorMapByIndex,
	                colorMapByValue = this.colorMapByValue,
	                options = this.options,
	                color, newColor;
	            if (this.stacked) {
	                color = options.get('stackedBarColor');
	            } else {
	                color = (value < 0) ? options.get('negBarColor') : options.get('barColor');
	            }
	            if (value === 0 && options.get('zeroColor') !== undefined) {
	                color = options.get('zeroColor');
	            }
	            if (colorMapByValue && (newColor = colorMapByValue.get(value))) {
	                color = newColor;
	            } else if (colorMapByIndex && colorMapByIndex.length > valuenum) {
	                color = colorMapByIndex[valuenum];
	            }
	            return $.isArray(color) ? color[stacknum % color.length] : color;
	        },
	
	        /**
	         * Render bar(s) for a region
	         */
	        renderRegion: function (valuenum, highlight) {
	            var vals = this.values[valuenum],
	                options = this.options,
	                xaxisOffset = this.xaxisOffset,
	                result = [],
	                range = this.range,
	                stacked = this.stacked,
	                target = this.target,
	                x = valuenum * this.totalBarWidth,
	                canvasHeightEf = this.canvasHeightEf,
	                yoffset = this.yoffset,
	                y, height, color, isNull, yoffsetNeg, i, valcount, val, minPlotted, allMin;
	
	            vals = $.isArray(vals) ? vals : [vals];
	            valcount = vals.length;
	            val = vals[0];
	            isNull = all(null, vals);
	            allMin = all(xaxisOffset, vals, true);
	
	            if (isNull) {
	                if (options.get('nullColor')) {
	                    color = highlight ? options.get('nullColor') : this.calcHighlightColor(options.get('nullColor'), options);
	                    y = (yoffset > 0) ? yoffset - 1 : yoffset;
	                    return target.drawRect(x, y, this.barWidth - 1, 0, color, color);
	                } else {
	                    return undefined;
	                }
	            }
	            yoffsetNeg = yoffset;
	            for (i = 0; i < valcount; i++) {
	                val = vals[i];
	
	                if (stacked && val === xaxisOffset) {
	                    if (!allMin || minPlotted) {
	                        continue;
	                    }
	                    minPlotted = true;
	                }
	
	                if (range > 0) {
	                    height = Math.floor(canvasHeightEf * ((Math.abs(val - xaxisOffset) / range))) + 1;
	                } else {
	                    height = 1;
	                }
	                if (val < xaxisOffset || (val === xaxisOffset && yoffset === 0)) {
	                    y = yoffsetNeg;
	                    yoffsetNeg += height;
	                } else {
	                    y = yoffset - height;
	                    yoffset -= height;
	                }
	                color = this.calcColor(i, val, valuenum);
	                if (highlight) {
	                    color = this.calcHighlightColor(color, options);
	                }
	                result.push(target.drawRect(x, y, this.barWidth - 1, height - 1, color, color));
	            }
	            if (result.length === 1) {
	                return result[0];
	            }
	            return result;
	        }
	    });
	
	    /**
	     * Tristate charts
	     */
	    $.fn.sparkline.tristate = tristate = createClass($.fn.sparkline._base, barHighlightMixin, {
	        type: 'tristate',
	
	        init: function (el, values, options, width, height) {
	            var barWidth = parseInt(options.get('barWidth'), 10),
	                barSpacing = parseInt(options.get('barSpacing'), 10);
	            tristate._super.init.call(this, el, values, options, width, height);
	
	            this.regionShapes = {};
	            this.barWidth = barWidth;
	            this.barSpacing = barSpacing;
	            this.totalBarWidth = barWidth + barSpacing;
	            this.values = $.map(values, Number);
	            this.width = width = (values.length * barWidth) + ((values.length - 1) * barSpacing);
	
	            if ($.isArray(options.get('colorMap'))) {
	                this.colorMapByIndex = options.get('colorMap');
	                this.colorMapByValue = null;
	            } else {
	                this.colorMapByIndex = null;
	                this.colorMapByValue = options.get('colorMap');
	                if (this.colorMapByValue && this.colorMapByValue.get === undefined) {
	                    this.colorMapByValue = new RangeMap(this.colorMapByValue);
	                }
	            }
	            this.initTarget();
	        },
	
	        getRegion: function (el, x, y) {
	            return Math.floor(x / this.totalBarWidth);
	        },
	
	        getCurrentRegionFields: function () {
	            var currentRegion = this.currentRegion;
	            return {
	                isNull: this.values[currentRegion] === undefined,
	                value: this.values[currentRegion],
	                color: this.calcColor(this.values[currentRegion], currentRegion),
	                offset: currentRegion
	            };
	        },
	
	        calcColor: function (value, valuenum) {
	            var values = this.values,
	                options = this.options,
	                colorMapByIndex = this.colorMapByIndex,
	                colorMapByValue = this.colorMapByValue,
	                color, newColor;
	
	            if (colorMapByValue && (newColor = colorMapByValue.get(value))) {
	                color = newColor;
	            } else if (colorMapByIndex && colorMapByIndex.length > valuenum) {
	                color = colorMapByIndex[valuenum];
	            } else if (values[valuenum] < 0) {
	                color = options.get('negBarColor');
	            } else if (values[valuenum] > 0) {
	                color = options.get('posBarColor');
	            } else {
	                color = options.get('zeroBarColor');
	            }
	            return color;
	        },
	
	        renderRegion: function (valuenum, highlight) {
	            var values = this.values,
	                options = this.options,
	                target = this.target,
	                canvasHeight, height, halfHeight,
	                x, y, color;
	
	            canvasHeight = target.pixelHeight;
	            halfHeight = Math.round(canvasHeight / 2);
	
	            x = valuenum * this.totalBarWidth;
	            if (values[valuenum] < 0) {
	                y = halfHeight;
	                height = halfHeight - 1;
	            } else if (values[valuenum] > 0) {
	                y = 0;
	                height = halfHeight - 1;
	            } else {
	                y = halfHeight - 1;
	                height = 2;
	            }
	            color = this.calcColor(values[valuenum], valuenum);
	            if (color === null) {
	                return;
	            }
	            if (highlight) {
	                color = this.calcHighlightColor(color, options);
	            }
	            return target.drawRect(x, y, this.barWidth - 1, height - 1, color, color);
	        }
	    });
	
	    /**
	     * Discrete charts
	     */
	    $.fn.sparkline.discrete = discrete = createClass($.fn.sparkline._base, barHighlightMixin, {
	        type: 'discrete',
	
	        init: function (el, values, options, width, height) {
	            discrete._super.init.call(this, el, values, options, width, height);
	
	            this.regionShapes = {};
	            this.values = values = $.map(values, Number);
	            this.min = Math.min.apply(Math, values);
	            this.max = Math.max.apply(Math, values);
	            this.range = this.max - this.min;
	            this.width = width = options.get('width') === 'auto' ? values.length * 2 : this.width;
	            this.interval = Math.floor(width / values.length);
	            this.itemWidth = width / values.length;
	            if (options.get('chartRangeMin') !== undefined && (options.get('chartRangeClip') || options.get('chartRangeMin') < this.min)) {
	                this.min = options.get('chartRangeMin');
	            }
	            if (options.get('chartRangeMax') !== undefined && (options.get('chartRangeClip') || options.get('chartRangeMax') > this.max)) {
	                this.max = options.get('chartRangeMax');
	            }
	            this.initTarget();
	            if (this.target) {
	                this.lineHeight = options.get('lineHeight') === 'auto' ? Math.round(this.canvasHeight * 0.3) : options.get('lineHeight');
	            }
	        },
	
	        getRegion: function (el, x, y) {
	            return Math.floor(x / this.itemWidth);
	        },
	
	        getCurrentRegionFields: function () {
	            var currentRegion = this.currentRegion;
	            return {
	                isNull: this.values[currentRegion] === undefined,
	                value: this.values[currentRegion],
	                offset: currentRegion
	            };
	        },
	
	        renderRegion: function (valuenum, highlight) {
	            var values = this.values,
	                options = this.options,
	                min = this.min,
	                max = this.max,
	                range = this.range,
	                interval = this.interval,
	                target = this.target,
	                canvasHeight = this.canvasHeight,
	                lineHeight = this.lineHeight,
	                pheight = canvasHeight - lineHeight,
	                ytop, val, color, x;
	
	            val = clipval(values[valuenum], min, max);
	            x = valuenum * interval;
	            ytop = Math.round(pheight - pheight * ((val - min) / range));
	            color = (options.get('thresholdColor') && val < options.get('thresholdValue')) ? options.get('thresholdColor') : options.get('lineColor');
	            if (highlight) {
	                color = this.calcHighlightColor(color, options);
	            }
	            return target.drawLine(x, ytop, x, ytop + lineHeight, color);
	        }
	    });
	
	    /**
	     * Bullet charts
	     */
	    $.fn.sparkline.bullet = bullet = createClass($.fn.sparkline._base, {
	        type: 'bullet',
	
	        init: function (el, values, options, width, height) {
	            var min, max, vals;
	            bullet._super.init.call(this, el, values, options, width, height);
	
	            // values: target, performance, range1, range2, range3
	            this.values = values = normalizeValues(values);
	            // target or performance could be null
	            vals = values.slice();
	            vals[0] = vals[0] === null ? vals[2] : vals[0];
	            vals[1] = values[1] === null ? vals[2] : vals[1];
	            min = Math.min.apply(Math, values);
	            max = Math.max.apply(Math, values);
	            if (options.get('base') === undefined) {
	                min = min < 0 ? min : 0;
	            } else {
	                min = options.get('base');
	            }
	            this.min = min;
	            this.max = max;
	            this.range = max - min;
	            this.shapes = {};
	            this.valueShapes = {};
	            this.regiondata = {};
	            this.width = width = options.get('width') === 'auto' ? '4.0em' : width;
	            this.target = this.$el.simpledraw(width, height, options.get('composite'));
	            if (!values.length) {
	                this.disabled = true;
	            }
	            this.initTarget();
	        },
	
	        getRegion: function (el, x, y) {
	            var shapeid = this.target.getShapeAt(el, x, y);
	            return (shapeid !== undefined && this.shapes[shapeid] !== undefined) ? this.shapes[shapeid] : undefined;
	        },
	
	        getCurrentRegionFields: function () {
	            var currentRegion = this.currentRegion;
	            return {
	                fieldkey: currentRegion.substr(0, 1),
	                value: this.values[currentRegion.substr(1)],
	                region: currentRegion
	            };
	        },
	
	        changeHighlight: function (highlight) {
	            var currentRegion = this.currentRegion,
	                shapeid = this.valueShapes[currentRegion],
	                shape;
	            delete this.shapes[shapeid];
	            switch (currentRegion.substr(0, 1)) {
	                case 'r':
	                    shape = this.renderRange(currentRegion.substr(1), highlight);
	                    break;
	                case 'p':
	                    shape = this.renderPerformance(highlight);
	                    break;
	                case 't':
	                    shape = this.renderTarget(highlight);
	                    break;
	            }
	            this.valueShapes[currentRegion] = shape.id;
	            this.shapes[shape.id] = currentRegion;
	            this.target.replaceWithShape(shapeid, shape);
	        },
	
	        renderRange: function (rn, highlight) {
	            var rangeval = this.values[rn],
	                rangewidth = Math.round(this.canvasWidth * ((rangeval - this.min) / this.range)),
	                color = this.options.get('rangeColors')[rn - 2];
	            if (highlight) {
	                color = this.calcHighlightColor(color, this.options);
	            }
	            return this.target.drawRect(0, 0, rangewidth - 1, this.canvasHeight - 1, color, color);
	        },
	
	        renderPerformance: function (highlight) {
	            var perfval = this.values[1],
	                perfwidth = Math.round(this.canvasWidth * ((perfval - this.min) / this.range)),
	                color = this.options.get('performanceColor');
	            if (highlight) {
	                color = this.calcHighlightColor(color, this.options);
	            }
	            return this.target.drawRect(0, Math.round(this.canvasHeight * 0.3), perfwidth - 1,
	                Math.round(this.canvasHeight * 0.4) - 1, color, color);
	        },
	
	        renderTarget: function (highlight) {
	            var targetval = this.values[0],
	                x = Math.round(this.canvasWidth * ((targetval - this.min) / this.range) - (this.options.get('targetWidth') / 2)),
	                targettop = Math.round(this.canvasHeight * 0.10),
	                targetheight = this.canvasHeight - (targettop * 2),
	                color = this.options.get('targetColor');
	            if (highlight) {
	                color = this.calcHighlightColor(color, this.options);
	            }
	            return this.target.drawRect(x, targettop, this.options.get('targetWidth') - 1, targetheight - 1, color, color);
	        },
	
	        render: function () {
	            var vlen = this.values.length,
	                target = this.target,
	                i, shape;
	            if (!bullet._super.render.call(this)) {
	                return;
	            }
	            for (i = 2; i < vlen; i++) {
	                shape = this.renderRange(i).append();
	                this.shapes[shape.id] = 'r' + i;
	                this.valueShapes['r' + i] = shape.id;
	            }
	            if (this.values[1] !== null) {
	                shape = this.renderPerformance().append();
	                this.shapes[shape.id] = 'p1';
	                this.valueShapes.p1 = shape.id;
	            }
	            if (this.values[0] !== null) {
	                shape = this.renderTarget().append();
	                this.shapes[shape.id] = 't0';
	                this.valueShapes.t0 = shape.id;
	            }
	            target.render();
	        }
	    });
	
	    /**
	     * Pie charts
	     */
	    $.fn.sparkline.pie = pie = createClass($.fn.sparkline._base, {
	        type: 'pie',
	
	        init: function (el, values, options, width, height) {
	            var total = 0, i;
	
	            pie._super.init.call(this, el, values, options, width, height);
	
	            this.shapes = {}; // map shape ids to value offsets
	            this.valueShapes = {}; // maps value offsets to shape ids
	            this.values = values = $.map(values, Number);
	
	            if (options.get('width') === 'auto') {
	                this.width = this.height;
	            }
	
	            if (values.length > 0) {
	                for (i = values.length; i--;) {
	                    total += values[i];
	                }
	            }
	            this.total = total;
	            this.initTarget();
	            this.radius = Math.floor(Math.min(this.canvasWidth, this.canvasHeight) / 2);
	        },
	
	        getRegion: function (el, x, y) {
	            var shapeid = this.target.getShapeAt(el, x, y);
	            return (shapeid !== undefined && this.shapes[shapeid] !== undefined) ? this.shapes[shapeid] : undefined;
	        },
	
	        getCurrentRegionFields: function () {
	            var currentRegion = this.currentRegion;
	            return {
	                isNull: this.values[currentRegion] === undefined,
	                value: this.values[currentRegion],
	                percent: this.values[currentRegion] / this.total * 100,
	                color: this.options.get('sliceColors')[currentRegion % this.options.get('sliceColors').length],
	                offset: currentRegion
	            };
	        },
	
	        changeHighlight: function (highlight) {
	            var currentRegion = this.currentRegion,
	                 newslice = this.renderSlice(currentRegion, highlight),
	                 shapeid = this.valueShapes[currentRegion];
	            delete this.shapes[shapeid];
	            this.target.replaceWithShape(shapeid, newslice);
	            this.valueShapes[currentRegion] = newslice.id;
	            this.shapes[newslice.id] = currentRegion;
	        },
	
	        renderSlice: function (valuenum, highlight) {
	            var target = this.target,
	                options = this.options,
	                radius = this.radius,
	                borderWidth = options.get('borderWidth'),
	                offset = options.get('offset'),
	                circle = 2 * Math.PI,
	                values = this.values,
	                total = this.total,
	                next = offset ? (2*Math.PI)*(offset/360) : 0,
	                start, end, i, vlen, color;
	
	            vlen = values.length;
	            for (i = 0; i < vlen; i++) {
	                start = next;
	                end = next;
	                if (total > 0) {  // avoid divide by zero
	                    end = next + (circle * (values[i] / total));
	                }
	                if (valuenum === i) {
	                    color = options.get('sliceColors')[i % options.get('sliceColors').length];
	                    if (highlight) {
	                        color = this.calcHighlightColor(color, options);
	                    }
	
	                    return target.drawPieSlice(radius, radius, radius - borderWidth, start, end, undefined, color);
	                }
	                next = end;
	            }
	        },
	
	        render: function () {
	            var target = this.target,
	                values = this.values,
	                options = this.options,
	                radius = this.radius,
	                borderWidth = options.get('borderWidth'),
	                shape, i;
	
	            if (!pie._super.render.call(this)) {
	                return;
	            }
	            if (borderWidth) {
	                target.drawCircle(radius, radius, Math.floor(radius - (borderWidth / 2)),
	                    options.get('borderColor'), undefined, borderWidth).append();
	            }
	            for (i = values.length; i--;) {
	                if (values[i]) { // don't render zero values
	                    shape = this.renderSlice(i).append();
	                    this.valueShapes[i] = shape.id; // store just the shapeid
	                    this.shapes[shape.id] = i;
	                }
	            }
	            target.render();
	        }
	    });
	
	    /**
	     * Box plots
	     */
	    $.fn.sparkline.box = box = createClass($.fn.sparkline._base, {
	        type: 'box',
	
	        init: function (el, values, options, width, height) {
	            box._super.init.call(this, el, values, options, width, height);
	            this.values = $.map(values, Number);
	            this.width = options.get('width') === 'auto' ? '4.0em' : width;
	            this.initTarget();
	            if (!this.values.length) {
	                this.disabled = 1;
	            }
	        },
	
	        /**
	         * Simulate a single region
	         */
	        getRegion: function () {
	            return 1;
	        },
	
	        getCurrentRegionFields: function () {
	            var result = [
	                { field: 'lq', value: this.quartiles[0] },
	                { field: 'med', value: this.quartiles[1] },
	                { field: 'uq', value: this.quartiles[2] }
	            ];
	            if (this.loutlier !== undefined) {
	                result.push({ field: 'lo', value: this.loutlier});
	            }
	            if (this.routlier !== undefined) {
	                result.push({ field: 'ro', value: this.routlier});
	            }
	            if (this.lwhisker !== undefined) {
	                result.push({ field: 'lw', value: this.lwhisker});
	            }
	            if (this.rwhisker !== undefined) {
	                result.push({ field: 'rw', value: this.rwhisker});
	            }
	            return result;
	        },
	
	        render: function () {
	            var target = this.target,
	                values = this.values,
	                vlen = values.length,
	                options = this.options,
	                canvasWidth = this.canvasWidth,
	                canvasHeight = this.canvasHeight,
	                minValue = options.get('chartRangeMin') === undefined ? Math.min.apply(Math, values) : options.get('chartRangeMin'),
	                maxValue = options.get('chartRangeMax') === undefined ? Math.max.apply(Math, values) : options.get('chartRangeMax'),
	                canvasLeft = 0,
	                lwhisker, loutlier, iqr, q1, q2, q3, rwhisker, routlier, i,
	                size, unitSize;
	
	            if (!box._super.render.call(this)) {
	                return;
	            }
	
	            if (options.get('raw')) {
	                if (options.get('showOutliers') && values.length > 5) {
	                    loutlier = values[0];
	                    lwhisker = values[1];
	                    q1 = values[2];
	                    q2 = values[3];
	                    q3 = values[4];
	                    rwhisker = values[5];
	                    routlier = values[6];
	                } else {
	                    lwhisker = values[0];
	                    q1 = values[1];
	                    q2 = values[2];
	                    q3 = values[3];
	                    rwhisker = values[4];
	                }
	            } else {
	                values.sort(function (a, b) { return a - b; });
	                q1 = quartile(values, 1);
	                q2 = quartile(values, 2);
	                q3 = quartile(values, 3);
	                iqr = q3 - q1;
	                if (options.get('showOutliers')) {
	                    lwhisker = rwhisker = undefined;
	                    for (i = 0; i < vlen; i++) {
	                        if (lwhisker === undefined && values[i] > q1 - (iqr * options.get('outlierIQR'))) {
	                            lwhisker = values[i];
	                        }
	                        if (values[i] < q3 + (iqr * options.get('outlierIQR'))) {
	                            rwhisker = values[i];
	                        }
	                    }
	                    loutlier = values[0];
	                    routlier = values[vlen - 1];
	                } else {
	                    lwhisker = values[0];
	                    rwhisker = values[vlen - 1];
	                }
	            }
	            this.quartiles = [q1, q2, q3];
	            this.lwhisker = lwhisker;
	            this.rwhisker = rwhisker;
	            this.loutlier = loutlier;
	            this.routlier = routlier;
	
	            unitSize = canvasWidth / (maxValue - minValue + 1);
	            if (options.get('showOutliers')) {
	                canvasLeft = Math.ceil(options.get('spotRadius'));
	                canvasWidth -= 2 * Math.ceil(options.get('spotRadius'));
	                unitSize = canvasWidth / (maxValue - minValue + 1);
	                if (loutlier < lwhisker) {
	                    target.drawCircle((loutlier - minValue) * unitSize + canvasLeft,
	                        canvasHeight / 2,
	                        options.get('spotRadius'),
	                        options.get('outlierLineColor'),
	                        options.get('outlierFillColor')).append();
	                }
	                if (routlier > rwhisker) {
	                    target.drawCircle((routlier - minValue) * unitSize + canvasLeft,
	                        canvasHeight / 2,
	                        options.get('spotRadius'),
	                        options.get('outlierLineColor'),
	                        options.get('outlierFillColor')).append();
	                }
	            }
	
	            // box
	            target.drawRect(
	                Math.round((q1 - minValue) * unitSize + canvasLeft),
	                Math.round(canvasHeight * 0.1),
	                Math.round((q3 - q1) * unitSize),
	                Math.round(canvasHeight * 0.8),
	                options.get('boxLineColor'),
	                options.get('boxFillColor')).append();
	            // left whisker
	            target.drawLine(
	                Math.round((lwhisker - minValue) * unitSize + canvasLeft),
	                Math.round(canvasHeight / 2),
	                Math.round((q1 - minValue) * unitSize + canvasLeft),
	                Math.round(canvasHeight / 2),
	                options.get('lineColor')).append();
	            target.drawLine(
	                Math.round((lwhisker - minValue) * unitSize + canvasLeft),
	                Math.round(canvasHeight / 4),
	                Math.round((lwhisker - minValue) * unitSize + canvasLeft),
	                Math.round(canvasHeight - canvasHeight / 4),
	                options.get('whiskerColor')).append();
	            // right whisker
	            target.drawLine(Math.round((rwhisker - minValue) * unitSize + canvasLeft),
	                Math.round(canvasHeight / 2),
	                Math.round((q3 - minValue) * unitSize + canvasLeft),
	                Math.round(canvasHeight / 2),
	                options.get('lineColor')).append();
	            target.drawLine(
	                Math.round((rwhisker - minValue) * unitSize + canvasLeft),
	                Math.round(canvasHeight / 4),
	                Math.round((rwhisker - minValue) * unitSize + canvasLeft),
	                Math.round(canvasHeight - canvasHeight / 4),
	                options.get('whiskerColor')).append();
	            // median line
	            target.drawLine(
	                Math.round((q2 - minValue) * unitSize + canvasLeft),
	                Math.round(canvasHeight * 0.1),
	                Math.round((q2 - minValue) * unitSize + canvasLeft),
	                Math.round(canvasHeight * 0.9),
	                options.get('medianColor')).append();
	            if (options.get('target')) {
	                size = Math.ceil(options.get('spotRadius'));
	                target.drawLine(
	                    Math.round((options.get('target') - minValue) * unitSize + canvasLeft),
	                    Math.round((canvasHeight / 2) - size),
	                    Math.round((options.get('target') - minValue) * unitSize + canvasLeft),
	                    Math.round((canvasHeight / 2) + size),
	                    options.get('targetColor')).append();
	                target.drawLine(
	                    Math.round((options.get('target') - minValue) * unitSize + canvasLeft - size),
	                    Math.round(canvasHeight / 2),
	                    Math.round((options.get('target') - minValue) * unitSize + canvasLeft + size),
	                    Math.round(canvasHeight / 2),
	                    options.get('targetColor')).append();
	            }
	            target.render();
	        }
	    });
	
	    // Setup a very simple "virtual canvas" to make drawing the few shapes we need easier
	    // This is accessible as $(foo).simpledraw()
	
	    VShape = createClass({
	        init: function (target, id, type, args) {
	            this.target = target;
	            this.id = id;
	            this.type = type;
	            this.args = args;
	        },
	        append: function () {
	            this.target.appendShape(this);
	            return this;
	        }
	    });
	
	    VCanvas_base = createClass({
	        _pxregex: /(\d+)(px)?\s*$/i,
	
	        init: function (width, height, target) {
	            if (!width) {
	                return;
	            }
	            this.width = width;
	            this.height = height;
	            this.target = target;
	            this.lastShapeId = null;
	            if (target[0]) {
	                target = target[0];
	            }
	            $.data(target, '_jqs_vcanvas', this);
	        },
	
	        drawLine: function (x1, y1, x2, y2, lineColor, lineWidth) {
	            return this.drawShape([[x1, y1], [x2, y2]], lineColor, lineWidth);
	        },
	
	        drawShape: function (path, lineColor, fillColor, lineWidth) {
	            return this._genShape('Shape', [path, lineColor, fillColor, lineWidth]);
	        },
	
	        drawCircle: function (x, y, radius, lineColor, fillColor, lineWidth) {
	            return this._genShape('Circle', [x, y, radius, lineColor, fillColor, lineWidth]);
	        },
	
	        drawPieSlice: function (x, y, radius, startAngle, endAngle, lineColor, fillColor) {
	            return this._genShape('PieSlice', [x, y, radius, startAngle, endAngle, lineColor, fillColor]);
	        },
	
	        drawRect: function (x, y, width, height, lineColor, fillColor) {
	            return this._genShape('Rect', [x, y, width, height, lineColor, fillColor]);
	        },
	
	        getElement: function () {
	            return this.canvas;
	        },
	
	        /**
	         * Return the most recently inserted shape id
	         */
	        getLastShapeId: function () {
	            return this.lastShapeId;
	        },
	
	        /**
	         * Clear and reset the canvas
	         */
	        reset: function () {
	            alert('reset not implemented');
	        },
	
	        _insert: function (el, target) {
	            $(target).html(el);
	        },
	
	        /**
	         * Calculate the pixel dimensions of the canvas
	         */
	        _calculatePixelDims: function (width, height, canvas) {
	            // XXX This should probably be a configurable option
	            var match;
	            match = this._pxregex.exec(height);
	            if (match) {
	                this.pixelHeight = match[1];
	            } else {
	                this.pixelHeight = $(canvas).height();
	            }
	            match = this._pxregex.exec(width);
	            if (match) {
	                this.pixelWidth = match[1];
	            } else {
	                this.pixelWidth = $(canvas).width();
	            }
	        },
	
	        /**
	         * Generate a shape object and id for later rendering
	         */
	        _genShape: function (shapetype, shapeargs) {
	            var id = shapeCount++;
	            shapeargs.unshift(id);
	            return new VShape(this, id, shapetype, shapeargs);
	        },
	
	        /**
	         * Add a shape to the end of the render queue
	         */
	        appendShape: function (shape) {
	            alert('appendShape not implemented');
	        },
	
	        /**
	         * Replace one shape with another
	         */
	        replaceWithShape: function (shapeid, shape) {
	            alert('replaceWithShape not implemented');
	        },
	
	        /**
	         * Insert one shape after another in the render queue
	         */
	        insertAfterShape: function (shapeid, shape) {
	            alert('insertAfterShape not implemented');
	        },
	
	        /**
	         * Remove a shape from the queue
	         */
	        removeShapeId: function (shapeid) {
	            alert('removeShapeId not implemented');
	        },
	
	        /**
	         * Find a shape at the specified x/y co-ordinates
	         */
	        getShapeAt: function (el, x, y) {
	            alert('getShapeAt not implemented');
	        },
	
	        /**
	         * Render all queued shapes onto the canvas
	         */
	        render: function () {
	            alert('render not implemented');
	        }
	    });
	
	    VCanvas_canvas = createClass(VCanvas_base, {
	        init: function (width, height, target, interact) {
	            VCanvas_canvas._super.init.call(this, width, height, target);
	            this.canvas = document.createElement('canvas');
	            if (target[0]) {
	                target = target[0];
	            }
	            $.data(target, '_jqs_vcanvas', this);
	            $(this.canvas).css({ display: 'inline-block', width: width, height: height, verticalAlign: 'top' });
	            this._insert(this.canvas, target);
	            this._calculatePixelDims(width, height, this.canvas);
	            this.canvas.width = this.pixelWidth;
	            this.canvas.height = this.pixelHeight;
	            this.interact = interact;
	            this.shapes = {};
	            this.shapeseq = [];
	            this.currentTargetShapeId = undefined;
	            $(this.canvas).css({width: this.pixelWidth, height: this.pixelHeight});
	        },
	
	        _getContext: function (lineColor, fillColor, lineWidth) {
	            var context = this.canvas.getContext('2d');
	            if (lineColor !== undefined) {
	                context.strokeStyle = lineColor;
	            }
	            context.lineWidth = lineWidth === undefined ? 1 : lineWidth;
	            if (fillColor !== undefined) {
	                context.fillStyle = fillColor;
	            }
	            return context;
	        },
	
	        reset: function () {
	            var context = this._getContext();
	            context.clearRect(0, 0, this.pixelWidth, this.pixelHeight);
	            this.shapes = {};
	            this.shapeseq = [];
	            this.currentTargetShapeId = undefined;
	        },
	
	        _drawShape: function (shapeid, path, lineColor, fillColor, lineWidth) {
	            var context = this._getContext(lineColor, fillColor, lineWidth),
	                i, plen;
	            context.beginPath();
	            context.moveTo(path[0][0] + 0.5, path[0][1] + 0.5);
	            for (i = 1, plen = path.length; i < plen; i++) {
	                context.lineTo(path[i][0] + 0.5, path[i][1] + 0.5); // the 0.5 offset gives us crisp pixel-width lines
	            }
	            if (lineColor !== undefined) {
	                context.stroke();
	            }
	            if (fillColor !== undefined) {
	                context.fill();
	            }
	            if (this.targetX !== undefined && this.targetY !== undefined &&
	                context.isPointInPath(this.targetX, this.targetY)) {
	                this.currentTargetShapeId = shapeid;
	            }
	        },
	
	        _drawCircle: function (shapeid, x, y, radius, lineColor, fillColor, lineWidth) {
	            var context = this._getContext(lineColor, fillColor, lineWidth);
	            context.beginPath();
	            context.arc(x, y, radius, 0, 2 * Math.PI, false);
	            if (this.targetX !== undefined && this.targetY !== undefined &&
	                context.isPointInPath(this.targetX, this.targetY)) {
	                this.currentTargetShapeId = shapeid;
	            }
	            if (lineColor !== undefined) {
	                context.stroke();
	            }
	            if (fillColor !== undefined) {
	                context.fill();
	            }
	        },
	
	        _drawPieSlice: function (shapeid, x, y, radius, startAngle, endAngle, lineColor, fillColor) {
	            var context = this._getContext(lineColor, fillColor);
	            context.beginPath();
	            context.moveTo(x, y);
	            context.arc(x, y, radius, startAngle, endAngle, false);
	            context.lineTo(x, y);
	            context.closePath();
	            if (lineColor !== undefined) {
	                context.stroke();
	            }
	            if (fillColor) {
	                context.fill();
	            }
	            if (this.targetX !== undefined && this.targetY !== undefined &&
	                context.isPointInPath(this.targetX, this.targetY)) {
	                this.currentTargetShapeId = shapeid;
	            }
	        },
	
	        _drawRect: function (shapeid, x, y, width, height, lineColor, fillColor) {
	            return this._drawShape(shapeid, [[x, y], [x + width, y], [x + width, y + height], [x, y + height], [x, y]], lineColor, fillColor);
	        },
	
	        appendShape: function (shape) {
	            this.shapes[shape.id] = shape;
	            this.shapeseq.push(shape.id);
	            this.lastShapeId = shape.id;
	            return shape.id;
	        },
	
	        replaceWithShape: function (shapeid, shape) {
	            var shapeseq = this.shapeseq,
	                i;
	            this.shapes[shape.id] = shape;
	            for (i = shapeseq.length; i--;) {
	                if (shapeseq[i] == shapeid) {
	                    shapeseq[i] = shape.id;
	                }
	            }
	            delete this.shapes[shapeid];
	        },
	
	        replaceWithShapes: function (shapeids, shapes) {
	            var shapeseq = this.shapeseq,
	                shapemap = {},
	                sid, i, first;
	
	            for (i = shapeids.length; i--;) {
	                shapemap[shapeids[i]] = true;
	            }
	            for (i = shapeseq.length; i--;) {
	                sid = shapeseq[i];
	                if (shapemap[sid]) {
	                    shapeseq.splice(i, 1);
	                    delete this.shapes[sid];
	                    first = i;
	                }
	            }
	            for (i = shapes.length; i--;) {
	                shapeseq.splice(first, 0, shapes[i].id);
	                this.shapes[shapes[i].id] = shapes[i];
	            }
	
	        },
	
	        insertAfterShape: function (shapeid, shape) {
	            var shapeseq = this.shapeseq,
	                i;
	            for (i = shapeseq.length; i--;) {
	                if (shapeseq[i] === shapeid) {
	                    shapeseq.splice(i + 1, 0, shape.id);
	                    this.shapes[shape.id] = shape;
	                    return;
	                }
	            }
	        },
	
	        removeShapeId: function (shapeid) {
	            var shapeseq = this.shapeseq,
	                i;
	            for (i = shapeseq.length; i--;) {
	                if (shapeseq[i] === shapeid) {
	                    shapeseq.splice(i, 1);
	                    break;
	                }
	            }
	            delete this.shapes[shapeid];
	        },
	
	        getShapeAt: function (el, x, y) {
	            this.targetX = x;
	            this.targetY = y;
	            this.render();
	            return this.currentTargetShapeId;
	        },
	
	        render: function () {
	            var shapeseq = this.shapeseq,
	                shapes = this.shapes,
	                shapeCount = shapeseq.length,
	                context = this._getContext(),
	                shapeid, shape, i;
	            context.clearRect(0, 0, this.pixelWidth, this.pixelHeight);
	            for (i = 0; i < shapeCount; i++) {
	                shapeid = shapeseq[i];
	                shape = shapes[shapeid];
	                this['_draw' + shape.type].apply(this, shape.args);
	            }
	            if (!this.interact) {
	                // not interactive so no need to keep the shapes array
	                this.shapes = {};
	                this.shapeseq = [];
	            }
	        }
	
	    });
	
	    VCanvas_vml = createClass(VCanvas_base, {
	        init: function (width, height, target) {
	            var groupel;
	            VCanvas_vml._super.init.call(this, width, height, target);
	            if (target[0]) {
	                target = target[0];
	            }
	            $.data(target, '_jqs_vcanvas', this);
	            this.canvas = document.createElement('span');
	            $(this.canvas).css({ display: 'inline-block', position: 'relative', overflow: 'hidden', width: width, height: height, margin: '0px', padding: '0px', verticalAlign: 'top'});
	            this._insert(this.canvas, target);
	            this._calculatePixelDims(width, height, this.canvas);
	            this.canvas.width = this.pixelWidth;
	            this.canvas.height = this.pixelHeight;
	            groupel = '<v:group coordorigin="0 0" coordsize="' + this.pixelWidth + ' ' + this.pixelHeight + '"' +
	                    ' style="position:absolute;top:0;left:0;width:' + this.pixelWidth + 'px;height=' + this.pixelHeight + 'px;"></v:group>';
	            this.canvas.insertAdjacentHTML('beforeEnd', groupel);
	            this.group = $(this.canvas).children()[0];
	            this.rendered = false;
	            this.prerender = '';
	        },
	
	        _drawShape: function (shapeid, path, lineColor, fillColor, lineWidth) {
	            var vpath = [],
	                initial, stroke, fill, closed, vel, plen, i;
	            for (i = 0, plen = path.length; i < plen; i++) {
	                vpath[i] = '' + (path[i][0]) + ',' + (path[i][1]);
	            }
	            initial = vpath.splice(0, 1);
	            lineWidth = lineWidth === undefined ? 1 : lineWidth;
	            stroke = lineColor === undefined ? ' stroked="false" ' : ' strokeWeight="' + lineWidth + 'px" strokeColor="' + lineColor + '" ';
	            fill = fillColor === undefined ? ' filled="false"' : ' fillColor="' + fillColor + '" filled="true" ';
	            closed = vpath[0] === vpath[vpath.length - 1] ? 'x ' : '';
	            vel = '<v:shape coordorigin="0 0" coordsize="' + this.pixelWidth + ' ' + this.pixelHeight + '" ' +
	                 ' id="jqsshape' + shapeid + '" ' +
	                 stroke +
	                 fill +
	                ' style="position:absolute;left:0px;top:0px;height:' + this.pixelHeight + 'px;width:' + this.pixelWidth + 'px;padding:0px;margin:0px;" ' +
	                ' path="m ' + initial + ' l ' + vpath.join(', ') + ' ' + closed + 'e">' +
	                ' </v:shape>';
	            return vel;
	        },
	
	        _drawCircle: function (shapeid, x, y, radius, lineColor, fillColor, lineWidth) {
	            var stroke, fill, vel;
	            x -= radius;
	            y -= radius;
	            stroke = lineColor === undefined ? ' stroked="false" ' : ' strokeWeight="' + lineWidth + 'px" strokeColor="' + lineColor + '" ';
	            fill = fillColor === undefined ? ' filled="false"' : ' fillColor="' + fillColor + '" filled="true" ';
	            vel = '<v:oval ' +
	                 ' id="jqsshape' + shapeid + '" ' +
	                stroke +
	                fill +
	                ' style="position:absolute;top:' + y + 'px; left:' + x + 'px; width:' + (radius * 2) + 'px; height:' + (radius * 2) + 'px"></v:oval>';
	            return vel;
	
	        },
	
	        _drawPieSlice: function (shapeid, x, y, radius, startAngle, endAngle, lineColor, fillColor) {
	            var vpath, startx, starty, endx, endy, stroke, fill, vel;
	            if (startAngle === endAngle) {
	                return '';  // VML seems to have problem when start angle equals end angle.
	            }
	            if ((endAngle - startAngle) === (2 * Math.PI)) {
	                startAngle = 0.0;  // VML seems to have a problem when drawing a full circle that doesn't start 0
	                endAngle = (2 * Math.PI);
	            }
	
	            startx = x + Math.round(Math.cos(startAngle) * radius);
	            starty = y + Math.round(Math.sin(startAngle) * radius);
	            endx = x + Math.round(Math.cos(endAngle) * radius);
	            endy = y + Math.round(Math.sin(endAngle) * radius);
	
	            if (startx === endx && starty === endy) {
	                if ((endAngle - startAngle) < Math.PI) {
	                    // Prevent very small slices from being mistaken as a whole pie
	                    return '';
	                }
	                // essentially going to be the entire circle, so ignore startAngle
	                startx = endx = x + radius;
	                starty = endy = y;
	            }
	
	            if (startx === endx && starty === endy && (endAngle - startAngle) < Math.PI) {
	                return '';
	            }
	
	            vpath = [x - radius, y - radius, x + radius, y + radius, startx, starty, endx, endy];
	            stroke = lineColor === undefined ? ' stroked="false" ' : ' strokeWeight="1px" strokeColor="' + lineColor + '" ';
	            fill = fillColor === undefined ? ' filled="false"' : ' fillColor="' + fillColor + '" filled="true" ';
	            vel = '<v:shape coordorigin="0 0" coordsize="' + this.pixelWidth + ' ' + this.pixelHeight + '" ' +
	                 ' id="jqsshape' + shapeid + '" ' +
	                 stroke +
	                 fill +
	                ' style="position:absolute;left:0px;top:0px;height:' + this.pixelHeight + 'px;width:' + this.pixelWidth + 'px;padding:0px;margin:0px;" ' +
	                ' path="m ' + x + ',' + y + ' wa ' + vpath.join(', ') + ' x e">' +
	                ' </v:shape>';
	            return vel;
	        },
	
	        _drawRect: function (shapeid, x, y, width, height, lineColor, fillColor) {
	            return this._drawShape(shapeid, [[x, y], [x, y + height], [x + width, y + height], [x + width, y], [x, y]], lineColor, fillColor);
	        },
	
	        reset: function () {
	            this.group.innerHTML = '';
	        },
	
	        appendShape: function (shape) {
	            var vel = this['_draw' + shape.type].apply(this, shape.args);
	            if (this.rendered) {
	                this.group.insertAdjacentHTML('beforeEnd', vel);
	            } else {
	                this.prerender += vel;
	            }
	            this.lastShapeId = shape.id;
	            return shape.id;
	        },
	
	        replaceWithShape: function (shapeid, shape) {
	            var existing = $('#jqsshape' + shapeid),
	                vel = this['_draw' + shape.type].apply(this, shape.args);
	            existing[0].outerHTML = vel;
	        },
	
	        replaceWithShapes: function (shapeids, shapes) {
	            // replace the first shapeid with all the new shapes then toast the remaining old shapes
	            var existing = $('#jqsshape' + shapeids[0]),
	                replace = '',
	                slen = shapes.length,
	                i;
	            for (i = 0; i < slen; i++) {
	                replace += this['_draw' + shapes[i].type].apply(this, shapes[i].args);
	            }
	            existing[0].outerHTML = replace;
	            for (i = 1; i < shapeids.length; i++) {
	                $('#jqsshape' + shapeids[i]).remove();
	            }
	        },
	
	        insertAfterShape: function (shapeid, shape) {
	            var existing = $('#jqsshape' + shapeid),
	                 vel = this['_draw' + shape.type].apply(this, shape.args);
	            existing[0].insertAdjacentHTML('afterEnd', vel);
	        },
	
	        removeShapeId: function (shapeid) {
	            var existing = $('#jqsshape' + shapeid);
	            this.group.removeChild(existing[0]);
	        },
	
	        getShapeAt: function (el, x, y) {
	            var shapeid = el.id.substr(8);
	            return shapeid;
	        },
	
	        render: function () {
	            if (!this.rendered) {
	                // batch the intial render into a single repaint
	                this.group.innerHTML = this.prerender;
	                this.rendered = true;
	            }
	        }
	    });
	
	}))}(document, Math));


/***/ },

/***/ 1111:
/***/ function(module, exports) {

	/*!
	 * jQuery UI Touch Punch 0.2.3
	 *
	 * Copyright 2011–2014, Dave Furfero
	 * Dual licensed under the MIT or GPL Version 2 licenses.
	 *
	 * Depends:
	 *  jquery.ui.widget.js
	 *  jquery.ui.mouse.js
	 */
	(function ($) {
	
	  // Detect touch support
	  $.support.touch = 'ontouchend' in document;
	
	  // Ignore browsers without touch support
	  if (!$.support.touch) {
	    return;
	  }
	
	  var mouseProto = $.ui.mouse.prototype,
	      _mouseInit = mouseProto._mouseInit,
	      _mouseDestroy = mouseProto._mouseDestroy,
	      touchHandled;
	
	  /**
	   * Simulate a mouse event based on a corresponding touch event
	   * @param {Object} event A touch event
	   * @param {String} simulatedType The corresponding mouse event
	   */
	  function simulateMouseEvent (event, simulatedType) {
	
	    // Ignore multi-touch events
	    if (event.originalEvent.touches.length > 1) {
	      return;
	    }
	
	    event.preventDefault();
	
	    var touch = event.originalEvent.changedTouches[0],
	        simulatedEvent = document.createEvent('MouseEvents');
	    
	    // Initialize the simulated mouse event using the touch event's coordinates
	    simulatedEvent.initMouseEvent(
	      simulatedType,    // type
	      true,             // bubbles                    
	      true,             // cancelable                 
	      window,           // view                       
	      1,                // detail                     
	      touch.screenX,    // screenX                    
	      touch.screenY,    // screenY                    
	      touch.clientX,    // clientX                    
	      touch.clientY,    // clientY                    
	      false,            // ctrlKey                    
	      false,            // altKey                     
	      false,            // shiftKey                   
	      false,            // metaKey                    
	      0,                // button                     
	      null              // relatedTarget              
	    );
	
	    // Dispatch the simulated event to the target element
	    event.target.dispatchEvent(simulatedEvent);
	  }
	
	  /**
	   * Handle the jQuery UI widget's touchstart events
	   * @param {Object} event The widget element's touchstart event
	   */
	  mouseProto._touchStart = function (event) {
	
	    var self = this;
	
	    // Ignore the event if another widget is already being handled
	    if (touchHandled || !self._mouseCapture(event.originalEvent.changedTouches[0])) {
	      return;
	    }
	
	    // Set the flag to prevent other widgets from inheriting the touch event
	    touchHandled = true;
	
	    // Track movement to determine if interaction was a click
	    self._touchMoved = false;
	
	    // Simulate the mouseover event
	    simulateMouseEvent(event, 'mouseover');
	
	    // Simulate the mousemove event
	    simulateMouseEvent(event, 'mousemove');
	
	    // Simulate the mousedown event
	    simulateMouseEvent(event, 'mousedown');
	  };
	
	  /**
	   * Handle the jQuery UI widget's touchmove events
	   * @param {Object} event The document's touchmove event
	   */
	  mouseProto._touchMove = function (event) {
	
	    // Ignore event if not handled
	    if (!touchHandled) {
	      return;
	    }
	
	    // Interaction was not a click
	    this._touchMoved = true;
	
	    // Simulate the mousemove event
	    simulateMouseEvent(event, 'mousemove');
	  };
	
	  /**
	   * Handle the jQuery UI widget's touchend events
	   * @param {Object} event The document's touchend event
	   */
	  mouseProto._touchEnd = function (event) {
	
	    // Ignore event if not handled
	    if (!touchHandled) {
	      return;
	    }
	
	    // Simulate the mouseup event
	    simulateMouseEvent(event, 'mouseup');
	
	    // Simulate the mouseout event
	    simulateMouseEvent(event, 'mouseout');
	
	    // If the touch interaction did not move, it should trigger a click
	    if (!this._touchMoved) {
	
	      // Simulate the click event
	      simulateMouseEvent(event, 'click');
	    }
	
	    // Unset the flag to allow other widgets to inherit the touch event
	    touchHandled = false;
	  };
	
	  /**
	   * A duck punch of the $.ui.mouse _mouseInit method to support touch events.
	   * This method extends the widget with bound touch event handlers that
	   * translate touch events to mouse events and pass them to the widget's
	   * original mouse event handling methods.
	   */
	  mouseProto._mouseInit = function () {
	    
	    var self = this;
	
	    // Delegate the touch handlers to the widget's element
	    self.element.bind({
	      touchstart: $.proxy(self, '_touchStart'),
	      touchmove: $.proxy(self, '_touchMove'),
	      touchend: $.proxy(self, '_touchEnd')
	    });
	
	    // Call the original $.ui.mouse init method
	    _mouseInit.call(self);
	  };
	
	  /**
	   * Remove the touch event handlers
	   */
	  mouseProto._mouseDestroy = function () {
	    
	    var self = this;
	
	    // Delegate the touch handlers to the widget's element
	    self.element.unbind({
	      touchstart: $.proxy(self, '_touchStart'),
	      touchmove: $.proxy(self, '_touchMove'),
	      touchend: $.proxy(self, '_touchEnd')
	    });
	
	    // Call the original $.ui.mouse destroy method
	    _mouseDestroy.call(self);
	  };
	
	})(jQuery);

/***/ },

/***/ 1112:
/***/ function(module, exports, __webpack_require__) {

	/*!
	  * Ace Admin Template v3.1.1
	  * Copyright 2013-2020
	  * You need a commercial license to use this product
	  * https://bit.ly/35ciMLb
	  */
	(function (global, factory) {
	   true ? module.exports = factory(__webpack_require__(10), __webpack_require__(437)) :
	  typeof define === 'function' && define.amd ? define(['jquery', 'bootstrap'], factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.AceApp = factory(global.jQuery, global.bootstrap));
	}(this, (function ($, bootstrap) { 'use strict';
	
	  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	  var $__default = /*#__PURE__*/_interopDefaultLegacy($);
	  var bootstrap__default = /*#__PURE__*/_interopDefaultLegacy(bootstrap);
	
	  function _typeof(obj) {
	    "@babel/helpers - typeof";
	
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function ownKeys(object, enumerableOnly) {
	    var keys = Object.keys(object);
	
	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(object);
	      if (enumerableOnly) symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	      keys.push.apply(keys, symbols);
	    }
	
	    return keys;
	  }
	
	  function _objectSpread2(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i] != null ? arguments[i] : {};
	
	      if (i % 2) {
	        ownKeys(Object(source), true).forEach(function (key) {
	          _defineProperty(target, key, source[key]);
	        });
	      } else if (Object.getOwnPropertyDescriptors) {
	        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	      } else {
	        ownKeys(Object(source)).forEach(function (key) {
	          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	        });
	      }
	    }
	
	    return target;
	  }
	
	  function _slicedToArray(arr, i) {
	    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	  }
	
	  function _toConsumableArray(arr) {
	    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	  }
	
	  function _arrayWithoutHoles(arr) {
	    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	  }
	
	  function _arrayWithHoles(arr) {
	    if (Array.isArray(arr)) return arr;
	  }
	
	  function _iterableToArray(iter) {
	    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	  }
	
	  function _iterableToArrayLimit(arr, i) {
	    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"] != null) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  function _unsupportedIterableToArray(o, minLen) {
	    if (!o) return;
	    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	    var n = Object.prototype.toString.call(o).slice(8, -1);
	    if (n === "Object" && o.constructor) n = o.constructor.name;
	    if (n === "Map" || n === "Set") return Array.from(o);
	    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	  }
	
	  function _arrayLikeToArray(arr, len) {
	    if (len == null || len > arr.length) len = arr.length;
	
	    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	
	    return arr2;
	  }
	
	  function _nonIterableSpread() {
	    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	
	  function _nonIterableRest() {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	
	  /**
	   * --------------------------------------------------------------------------
	   * Ace (v3.1.1): util.js
	     Some Utility Functions
	  */
	  // import $ from 'jquery'
	  // import bootstrap from 'bootstrap'
	  var Util = /*#__PURE__*/function () {
	    function Util() {
	      _classCallCheck(this, Util);
	    }
	
	    _createClass(Util, null, [{
	      key: "isReducedMotion",
	      value: function isReducedMotion() {
	        return window.matchMedia('(prefers-reduced-motion)').matches;
	      }
	    }, {
	      key: "isRTL",
	      value: function isRTL() {
	        return document.documentElement.classList.contains('rtl') || document.documentElement.dir === 'rtl';
	      }
	    }, {
	      key: "hasClosest",
	      value: function hasClosest() {
	        return 'closest' in document.documentElement;
	      }
	      /**
	      static hasTransitionStart () {
	        if (Util._supportsTransitionStart !== null) return Util._supportsTransitionStart
	          Util._supportsTransitionStart = 'ontransitionstart' in window// doesn't work in Chrome
	        if (!Util._supportsTransitionStart) {
	          var tmp = $('<div style="opacity: 0; transition: opacity 1ms" />').appendTo(document.body)
	          tmp.on('transitionstart', function () {
	            Util._supportsTransitionStart = true
	          }).on('transitionend', function () {
	            tmp.remove()
	          })
	            tmp.get(0).offsetTop
	          tmp.css('opacity', '1')
	        }
	          return Util._supportsTransitionStart
	      }
	      */
	
	    }, {
	      key: "getScrollbarInfo",
	      value: function getScrollbarInfo() {
	        var recalc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        if (recalc === false && Util._scrollbarInfo !== null) return Util._scrollbarInfo;
	        var scrollDiv = document.createElement('div');
	        scrollDiv.style.overflow = 'scroll';
	        scrollDiv.style.position = 'absolute';
	        scrollDiv.style.width = '50px';
	        scrollDiv.style.height = '50px';
	        var scrollbar = {};
	        document.body.appendChild(scrollDiv);
	        scrollbar.width = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
	        document.documentElement.style.setProperty('--scrollbar-width', scrollbar.width + 'px');
	        var thinWidth = scrollbar.width;
	
	        if (window.CSS) {
	          scrollbar.thin = window.CSS.supports('scrollbar-width', 'thin'); // currently only firefox 64+ supports it
	
	          if (scrollbar.thin) {
	            scrollDiv.style['scrollbar-width'] = 'thin';
	            thinWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
	          }
	
	          scrollbar.overlay = window.CSS.supports('overflow', 'overlay');
	        } else {
	          scrollbar.thin = false;
	          scrollDiv.style.overflow = 'overlay'; // Webkit/Chromium based browsers support it
	
	          scrollbar.overlay = scrollbar.width > 0 && scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth === 0;
	        }
	
	        document.documentElement.style.setProperty('--moz-scrollbar-thin', thinWidth + 'px');
	        scrollDiv.style['-ms-overflow-style'] = '-ms-autohiding-scrollbar'; // IE
	
	        scrollbar.autohide = scrollbar.width > 0 && scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth === 0; /// //////////////////////////////////
	
	        document.body.removeChild(scrollDiv);
	        Util._scrollbarInfo = scrollbar;
	        return Util._scrollbarInfo;
	      }
	    }]);
	
	    return Util;
	  }();
	
	  Util._supportsTransitionStart = null; // static property
	
	  Util._scrollbarInfo = null; // static property
	
	  var Basic = /*#__PURE__*/function () {
	    function Basic() {
	      _classCallCheck(this, Basic);
	    }
	
	    _createClass(Basic, null, [{
	      key: "_HandleBasics",
	      value: function _HandleBasics() {
	        // for IE
	        if (window.NodeList && !window.NodeList.prototype.forEach) {
	          window.NodeList.prototype.forEach = Array.prototype.forEach;
	        }
	
	        Basic._handleAlerts();
	
	        Basic._handleDropdowns();
	
	        Basic._handleNavbar();
	
	        Basic._handleOther();
	
	        $__default['default'](document.body).addClass('is-document-loaded');
	      }
	      /**
	       * collapse .alert instead of fading it out
	      */
	
	    }, {
	      key: "_handleAlerts",
	      value: function _handleAlerts() {
	        $__default['default'](document).on('close.bs.alert.alert-collapse', '.alert.alert-collapse', function (e) {
	          e.preventDefault();
	          $__default['default'](this).wrap('<div class="collapse show alert-collapse"></div>').parent().collapse('hide').one('hidden.bs.collapse.alert-collapse', function () {
	            $__default['default'](this).remove();
	          });
	        });
	      } /// ////////
	
	    }, {
	      key: "_handleDropdowns",
	      value: function _handleDropdowns() {
	        // dismiss (hide) a dropdown menu
	        var _dismissDropdown = function _dismissDropdown() {
	          var menu = $__default['default'](this).closest('.dropdown-menu');
	          var dropdown = menu.parent();
	          var toggle = dropdown.find('[data-toggle=dropdown]');
	          toggle.dropdown('hide');
	          menu.removeClass('show');
	          dropdown.removeClass('show');
	        }; // hide dropdown when clicked on an element inside it with `data-dismiss=dropdown` attribute
	
	
	        $__default['default'](document).on('click', '[data-dismiss=dropdown]', function (e) {
	          e.preventDefault();
	
	          _dismissDropdown.call(e.target);
	        }); // hide dropdown when a `form` inside it is submitted
	
	        $__default['default'](document).on('submit', '.dropdown-menu form[data-submit=dismiss]', function (e) {
	          e.preventDefault();
	
	          _dismissDropdown.call(e.target);
	        }); // don't hide dropdown when clicked inside a `.dropdown-clickable` element
	
	        $__default['default'](document).on('click.dropdown-clickable', '.dropdown-clickable', function (e) {
	          e.stopImmediatePropagation();
	        }); // hide `body` scrollbars when dropdowns are opened in mobile view
	
	        $__default['default'](document).on('shown.bs.dropdown', '.dropdown.dd-backdrop', function () {
	          // check `display` of .dropdown::before, if not visible it means `backdrop` is not visible (applied)
	          if (window.getComputedStyle(this, ':before').display === 'none') return; // the device width is such that backdrop is visible (.dropdown-inner is visible)
	
	          var scrollbarInfo = Util.getScrollbarInfo();
	
	          if (scrollbarInfo.width === 0) {
	            document.body.classList.add('mob-dropdown-body');
	          }
	
	          this.classList.add('backdrop-shown'); // used later to add `.navbar-modal` class to .navbar
	
	          $__default['default'](this).one('hidden.bs.dropdown', function () {
	            document.body.classList.remove('mob-dropdown-body');
	            this.classList.remove('backdrop-shown');
	          });
	        });
	      } /// ////////
	
	    }, {
	      key: "_handleNavbar",
	      value: function _handleNavbar() {
	        // hide `.navbar-collapse` when clicked on it (specifically on the backdrop in mobile view)
	        $__default['default'](document).on('click', '.navbar-backdrop.collapse.show', function (e) {
	          if (e.target === this) $__default['default'](this).collapse('hide');
	        }); // hide dropdown when a `form` inside it is submitted
	
	        $__default['default'](document).on('submit', '.navbar-collapse.show form[data-submit=dismiss]', function (e) {
	          e.preventDefault();
	          $__default['default'](this).closest('.navbar-collapse').collapse('hide');
	        }); // when navbar or a dropdown-menu inside it is displayed, move focus to the ".autofocus" element.
	        // For example a search box can be .autofocus
	
	        $__default['default'](document).on('shown.bs.dropdown', '.navbar .dropdown', function () {
	          $__default['default'](this).find('.autofocus').focus();
	        }).on('shown.bs.collapse', '.navbar-collapse', function () {
	          $__default['default'](this).find('.autofocus').focus(); // also hide body scrollbars in mobile devices
	
	          if (this.classList.contains('navbar-backdrop')) {
	            var scrollbarInfo = Util.getScrollbarInfo();
	
	            if (scrollbarInfo.width === 0) {
	              document.body.classList.add('mob-navbar-body');
	            }
	          }
	        }).on('hidden.bs.collapse', function () {
	          document.body.classList.remove('mob-navbar-body');
	        }).on('show.bs.collapse', function () {
	          // hide other 'shown/open' ones
	          $__default['default']('.navbar-collapse.show').css('transition-duration', '1ms').collapse('hide').css('transition-duration', '');
	        }); // if navbar dropdowns are not entirely inside window area, move them accordingly
	
	        var _adjustDropdown = function _adjustDropdown() {
	          var isRTL = Util.isRTL();
	          var isRightAligned = this.classList.contains('dropdown-menu-right');
	
	          var _dir = !isRightAligned ? !isRTL ? 'left' : 'right' : !isRTL ? 'right' : 'left';
	
	          var prop = 'margin-' + _dir;
	          this.style.removeProperty(prop);
	          var moveBy = 0;
	          var rect = this.getBoundingClientRect();
	
	          if (rect.left < 0) {
	            moveBy = parseInt(-1 * rect.left) + 5;
	          } else {
	            var sw = document.body.scrollWidth;
	
	            if (rect.right > sw) {
	              moveBy = parseInt(sw - rect.right - 5);
	            }
	          }
	
	          if (moveBy < 5) return;
	          if (isRightAligned) moveBy *= -1;
	          this.style.setProperty(prop, moveBy + 'px', 'important');
	        };
	
	        var _closest = ('closest' in document.documentElement);
	
	        $__default['default'](document).on('transitionstart.adjust', '.navbar .dropdown-mega .dropdown-menu', function (ev) {
	          if (ev.target !== this || ev.originalEvent.propertyName !== 'transform') return;
	
	          _adjustDropdown.call(this);
	        }).on('shown.bs.dropdown', '.navbar .dropdown', function () {
	          if (this.classList.contains('dropdown-mega')) {
	            var dropdown = this.querySelector('.dropdown-menu[data-display="static"]');
	            if (dropdown !== null) _adjustDropdown.call(dropdown);
	          } // when a .dropdown is opened, add .navbar-open to increase z-index, so that dropdowns go above 'asides', etc
	
	
	          if (_closest) {
	            var navbar = this.closest('.navbar');
	            if (this.classList.contains('backdrop-shown')) navbar.classList.add('navbar-modal');else navbar.classList.add('navbar-open');
	          }
	        }).on('hidden.bs.dropdown', '.navbar .dropdown', function () {
	          if (_closest) {
	            var navbar = this.closest('.navbar');
	            navbar.classList.remove('navbar-open');
	            navbar.classList.remove('navbar-modal');
	          }
	        });
	      } /// ////////
	
	    }, {
	      key: "_handleOther",
	      value: function _handleOther() {
	        document.querySelectorAll('.input-floating-label input').forEach(function (inp) {
	          if (inp.value !== '') inp.classList.add('has-content');else inp.classList.remove('has-content');
	        });
	        document.addEventListener('focusout', function (ev) {
	          var inp = ev.target;
	
	          if ('matches' in inp) {
	            if (!inp.matches('.input-floating-label input')) return;
	          } else if ('msMatchesSelector' in inp && !inp.msMatchesSelector('.input-floating-label input')) return;
	
	          if (inp.value !== '') inp.classList.add('has-content');else inp.classList.remove('has-content');
	        });
	      }
	    }]);
	
	    return Basic;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	  */
	
	
	  if (typeof $__default['default'] !== 'undefined') {
	    Basic._HandleBasics();
	  }
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME = 'aceScroll';
	  var VERSION = '3.1.1';
	  var DATA_KEY = 'ace.scroll';
	  var EVENT_KEY = ".".concat(DATA_KEY);
	  var DATA_API_KEY = '.data-api';
	  var Event = {
	    LOAD_DATA_API: "load".concat(EVENT_KEY).concat(DATA_API_KEY)
	  };
	  var Selector = {
	    ACE_SCROLL: '[ace-scroll]',
	    DATA_ACE_SCROLL: '[data-ace-scroll]'
	  };
	  var DefaultType = {
	    type: 'string',
	    smooth: 'boolean',
	    height: '(number|null)',
	    lock: 'boolean',
	    ignore: '(string|null)',
	    plugin: 'string',
	    options: '(object|null)',
	    // plugin settings
	    color: '(string|null)',
	    autohide: '(boolean|null)'
	  };
	  var Default = {
	    type: 'native',
	    smooth: false,
	    height: null,
	    lock: false,
	    ignore: null,
	    plugin: 'SimpleBar',
	    options: null,
	    color: null,
	    autohide: true
	  };
	
	  var Scrollbar = /*#__PURE__*/function () {
	    function Scrollbar(element, config) {
	      _classCallCheck(this, Scrollbar);
	
	      this._element = element;
	      this._config = this._getConfig(config);
	      this._scrollbarInfo = Util.getScrollbarInfo();
	      this.enableScrollbars();
	    }
	
	    _createClass(Scrollbar, [{
	      key: "enableScrollbars",
	      value: function enableScrollbars() {
	        /**
	        this._element.scrollTop = 0
	        // For firefox. Because it has persistent scroll position on page reload
	        // which doesn't look good when changing overflow: hidden to overflow: scroll on hover
	        */
	        // no scrollbars when specified
	        if (this._config.ignore !== null) {
	          if (this._config.ignore === 'mobile' && this._scrollbarInfo.width === 0 && 'ontouchstart' in window && window.matchMedia('(max-width: 840px)').matches) return;else if (this._config.ignore === 'desktop' && this._scrollbarInfo.width > 0) return;
	        }
	
	        this.update(this._config.height);
	        this.lock(this._config.lock);
	
	        this._element.classList.remove('ace-scroll', 'ace-scroll-mob', 'ace-scroll-wrap');
	
	        if (this._config.type === 'native') {
	          this._addNativeScrolls();
	        } else if (this._config.type === 'auto') {
	          this._preferNativeScrolls();
	        } else if (this._config.type === 'plugin') {
	          this._addPluginScrolls();
	        }
	      }
	    }, {
	      key: "update",
	      value: function update(_height) {
	        if (!_height) return;
	        if (!isNaN(_height)) _height += 'px';
	        this._element.style.maxHeight = _height;
	      }
	    }, {
	      key: "lock",
	      value: function lock(_lock) {
	        if (_lock) this._element.classList.add('ace-scroll-lock');else this._element.classList.remove('ace-scroll-lock');
	      }
	    }, {
	      key: "_addNativeScrolls",
	      value: function _addNativeScrolls(smooth) {
	        if (this._scrollbarInfo.width === 0) this._element.classList.add('ace-scroll-mob'); // mobile device
	        else {
	            this._element.classList.add('ace-scroll');
	
	            if (this._config.color !== null) this._element.classList.add('ace-scroll-' + this._config.color);
	            if (this._config.autohide === false) this._element.classList.add('is-always-on');
	
	            var _smooth = typeof smooth !== 'undefined' ? smooth : this._config.smooth;
	
	            if (_smooth) {
	              // wrap children inside an .ace-scroll-inner
	              var wrapper = document.createElement('div');
	              wrapper.classList.add('ace-scroll-inner');
	              wrapper.style.color = window.getComputedStyle(this._element).color;
	
	              while (this._element.firstChild) {
	                wrapper.appendChild(this._element.firstChild);
	              }
	
	              this._element.appendChild(wrapper); /// ///////
	              // disable the initial transition effects
	
	
	              this._element.style.transition = 'none';
	
	              this._element.classList.add('ace-scroll-wrap');
	
	              this._element.offsetHeight; // reflow
	
	              this._element.style.transition = '';
	            }
	          }
	      }
	    }, {
	      key: "_preferNativeScrolls",
	      value: function _preferNativeScrolls() {
	        if (this._scrollbarInfo.width === 0 || this._scrollbarInfo.overlay || this._scrollbarInfo.thin || !this._hasScrollbarPlugin()) {
	          this._addNativeScrolls();
	        } else {
	          this._addPluginScrolls();
	        }
	      }
	    }, {
	      key: "_addPluginScrolls",
	      value: function _addPluginScrolls() {
	        if (this._hasScrollbarPlugin()) {
	          return new window[this._config.plugin](this._element, this._config.options);
	        } else {
	          this._addNativeScrolls();
	        }
	      }
	    }, {
	      key: "_hasScrollbarPlugin",
	      value: function _hasScrollbarPlugin() {
	        return !!window[this._config.plugin];
	      }
	    }, {
	      key: "_getConfig",
	      value: function _getConfig(config) {
	        config = _objectSpread2(_objectSpread2({}, Default), _typeof(config) === 'object' && config ? config : {});
	
	        if (typeof bootstrap__default['default'] !== 'undefined') {
	          bootstrap__default['default'].Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
	        }
	
	        return config;
	      } // Static methods
	
	    }], [{
	      key: "_jQueryInterface",
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          var $this = $__default['default'](this);
	          var data = $this.data(DATA_KEY);
	          var options = this.getAttribute('ace-scroll') || this.getAttribute('data-ace-scroll') || {};
	          if (!isNaN(options)) options = {
	            height: parseInt(options)
	          };else if (options.length > 1) {
	            try {
	              options = JSON.parse(options);
	            } catch (e) {}
	          }
	
	          var _config = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, Default), $this.data()), _typeof(config) === 'object' && config ? config : {}), _typeof(options) === 'object' && options ? options : {});
	
	          if (!data) {
	            data = new Scrollbar(this, _config);
	            $this.data(DATA_KEY, data);
	          }
	
	          if (typeof config === 'string') {
	            if (typeof data[config] === 'undefined') {
	              throw new TypeError("No method named \"".concat(config, "\""));
	            }
	
	            data[config]();
	          }
	        });
	      }
	    }, {
	      key: "VERSION",
	      get: function get() {
	        return VERSION;
	      }
	    }, {
	      key: "DefaultType",
	      get: function get() {
	        return DefaultType;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default;
	      }
	    }]);
	
	    return Scrollbar;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	  */
	
	
	  $__default['default'](window).on(Event.LOAD_DATA_API, function () {
	    var scrollbars = [].slice.call(document.querySelectorAll(Selector.ACE_SCROLL)).concat([].slice.call(document.querySelectorAll(Selector.DATA_ACE_SCROLL)));
	
	    for (var i = 0; i < scrollbars.length; i++) {
	      var $scrollbars = $__default['default'](scrollbars[i]);
	
	      Scrollbar._jQueryInterface.call($scrollbars, $scrollbars.data());
	    }
	  });
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	  */
	
	  if (typeof $__default['default'] !== 'undefined') {
	    var JQUERY_NO_CONFLICT = $__default['default'].fn[NAME];
	    $__default['default'].fn[NAME] = Scrollbar._jQueryInterface;
	    $__default['default'].fn[NAME].Constructor = Scrollbar;
	
	    $__default['default'].fn[NAME].noConflict = function () {
	      $__default['default'].fn[NAME] = JQUERY_NO_CONFLICT;
	      return Scrollbar._jQueryInterface;
	    };
	  }
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$1 = 'aceSidebar';
	  var VERSION$1 = '3.1.1';
	  var DATA_KEY$1 = 'ace.sidebar';
	  var EVENT_KEY$1 = ".".concat(DATA_KEY$1);
	  var DATA_API_KEY$1 = '.data-api';
	  var Event$1 = {
	    SHOW: "show".concat(EVENT_KEY$1),
	    HIDE: "hide".concat(EVENT_KEY$1),
	    COLLAPSE: "collapse".concat(EVENT_KEY$1),
	    EXPAND: "expand".concat(EVENT_KEY$1),
	    SHOWN: "shown".concat(EVENT_KEY$1),
	    HIDDEN: "hidden".concat(EVENT_KEY$1),
	    COLLAPSED: "collapsed".concat(EVENT_KEY$1),
	    EXPANDED: "expanded".concat(EVENT_KEY$1),
	    LOAD_DATA_API: "load".concat(EVENT_KEY$1).concat(DATA_API_KEY$1),
	    CLICK_DATA_API: "click".concat(EVENT_KEY$1).concat(DATA_API_KEY$1)
	  };
	  var Selector$1 = {
	    SIDEBAR: '.sidebar',
	    DATA_TOGGLE: '[data-toggle="sidebar"]',
	    DATA_TOGGLE_MOBILE: '[data-toggle-mobile="sidebar"]'
	  };
	  var DefaultType$1 = {
	    swipe: 'boolean',
	    dismiss: 'boolean',
	    backdrop: 'boolean',
	    gotoactive: 'boolean',
	    subscroll: 'boolean',
	    pullup: 'boolean'
	  };
	  var Default$1 = {
	    swipe: false,
	    dismiss: false,
	    backdrop: false,
	    gotoactive: false,
	    subscroll: true,
	    pullup: false
	  };
	  var ClassName = {
	    DESKTOP_HIDE: 'collapsed',
	    MOBILE_SHOW: 'sidebar-visible',
	    COLLAPSED: 'collapsed',
	    TOGGLING: 'toggling',
	    INNER_HOVER: 'is-hover',
	    BACKDROP: 'sidebar-backdrop',
	    HORIZONTAL: 'sidebar-h'
	  };
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Sidebar = /*#__PURE__*/function () {
	    function Sidebar(element, config) {
	      var _this = this;
	
	      _classCallCheck(this, Sidebar);
	
	      this._hasTransitionEvent = false;
	      this._hasTransitionEvent2 = false;
	      this._isTransitioning = false;
	      this._sidebar = element;
	      this._sidebar.offsetHeight; // force reflow, so that if we instantly call 'collapse' or 'expand', transition effect takes place
	
	      this._sidebar.classList.add('sidebar');
	
	      this._inner = this._sidebar.querySelector('.sidebar-inner');
	      this._config = this._getConfig(config);
	      this._scroller = this._sidebar.querySelector('[class*="ace-scroll"]');
	      if (this._sidebar.querySelector('.submenu.show') !== null) this._sidebar.classList.add('has-open');
	      this._pullupEnabled = false;
	      this._triggerArray = [].slice.call(document.querySelectorAll("[data-toggle=\"sidebar\"][href=\"#".concat(element.id, "\"],") + "[data-toggle=\"sidebar\"][data-target=\"#".concat(element.id, "\"]")));
	      this._triggerArrayMobile = [].slice.call(document.querySelectorAll("[data-toggle-mobile=\"sidebar\"][href=\"#".concat(element.id, "\"],") + "[data-toggle-mobile=\"sidebar\"][data-target=\"#".concat(element.id, "\"]")));
	      this._horizontal = this._sidebar.classList.contains(ClassName.HORIZONTAL);
	      this._desktopCollapsedClass = this._triggerArray.length > 0 ? this._triggerArray[0].getAttribute('data-toggle-class') || ClassName.DESKTOP_HIDE : ClassName.DESKTOP_HIDE; //
	
	      this._collapsed = this._sidebar.classList.contains(this._desktopCollapsedClass);
	      $__default['default'](this._inner).on('focus', 'input', function (e) {
	        if (!_this._collapsed) return;
	
	        _this._inner.classList.add('has-focus');
	
	        $__default['default'](e.target).one('blur', function () {
	          _this._inner.classList.remove('has-focus');
	        });
	      }); //
	
	      this._handleTriggerEvents();
	
	      this.enableSubmenuToggle();
	      if (this._config.pullup) this.enableSubmenuPullup();
	      if (this._config.gotoactive) this.scrollToActive();
	
	      if (this._config.backdrop) {
	        this._sidebar.classList.add(ClassName.BACKDROP);
	      } else if (this._sidebar.classList.contains(ClassName.BACKDROP)) {
	        this._config.backdrop = true;
	      }
	
	      if (!this._horizontal && this._collapsed) {
	        this._addTransitionEvent();
	      }
	    } // Getters
	
	
	    _createClass(Sidebar, [{
	      key: "_handleTriggerEvents",
	      value: function _handleTriggerEvents() {
	        var This = this;
	        $__default['default'](this._triggerArray).on('click', function () {
	          This.toggle(this);
	        });
	        $__default['default'](this._triggerArrayMobile).on('click', function () {
	          This.toggleMobile(this);
	        });
	      }
	    }, {
	      key: "toggle",
	      value: function toggle() {
	        var btn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	        if (this._sidebar.classList.contains(this._desktopCollapsedClass)) {
	          this.expand(btn);
	        } else {
	          this.collapse(btn);
	        }
	      }
	    }, {
	      key: "toggleMobile",
	      value: function toggleMobile() {
	        var btn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	        if (!this._sidebar.classList.contains(ClassName.MOBILE_SHOW)) {
	          this.show(btn);
	        } else {
	          this.hide(btn);
	        }
	      } /// ////
	
	    }, {
	      key: "expand",
	      value: function expand() {
	        if (!this._hasTransitionEvent) this._addTransitionEvent();
	        if (this._isTransitioning) return;
	        var ev = new $__default['default'].Event(Event$1.EXPAND);
	        $__default['default'](this._sidebar).trigger(ev);
	        if (ev.isDefaultPrevented()) return;
	        this._isTransitioning = true;
	
	        this._sidebar.classList.add(ClassName.TOGGLING);
	
	        this._sidebar.classList.remove(this._desktopCollapsedClass);
	
	        this._updateTriggerBtns(this._triggerArray, true);
	
	        this._collapsed = false;
	        if (Util.isReducedMotion() || this._horizontal) this._toggleCompleted(); // call completion now
	        //
	
	        if (this._pullupEnabled) this._resetPullUp(); // this._inner.classList.remove(ClassName.INNER_HOVER)//we'll remove it in _toggleCompleted
	      }
	    }, {
	      key: "collapse",
	      value: function collapse() {
	        var btn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        if (!this._hasTransitionEvent) this._addTransitionEvent();
	        if (this._isTransitioning) return;
	        var ev = new $__default['default'].Event(Event$1.COLLAPSE);
	        $__default['default'](this._sidebar).trigger(ev);
	        if (ev.isDefaultPrevented()) return;
	        this._isTransitioning = true;
	
	        this._sidebar.classList.add(ClassName.TOGGLING);
	
	        this._sidebar.classList.add(this._desktopCollapsedClass);
	
	        this._updateTriggerBtns(this._triggerArray, false);
	
	        this._collapsed = true;
	        if (Util.isReducedMotion() || this._horizontal) this._toggleCompleted(); // call completion now
	        //
	
	        if (this._pullupEnabled) this._resetPullUp(); // if the triggering button is inside sidebar and we want it to remain expaned (.let-expanded), add .is-hover class as well
	
	        if (btn !== null && this._sidebar.classList.contains('expandable') && this._sidebar.classList.contains('let-expanded') && this._inner.contains(btn)) {
	          this._inner.classList.add(ClassName.INNER_HOVER);
	        }
	      }
	    }, {
	      key: "show",
	      value: function show() {
	        var _this2 = this;
	        if (!this._hasTransitionEvent2) this._addTransitionEvent2();
	        var ev = new $__default['default'].Event(Event$1.SHOW);
	        $__default['default'](this._sidebar).trigger(ev);
	        if (ev.isDefaultPrevented()) return;
	
	        this._sidebar.classList.add(ClassName.MOBILE_SHOW);
	
	        this._updateTriggerBtns(this._triggerArrayMobile, true); // hide sidebar if clicked outside of it
	
	
	        if (this._config.dismiss) {
	          $__default['default'](this._triggerArrayMobile).css('pointer-events', 'none'); // disable this button, because if we click on it, it will hide and then instantly show the sidebar again
	
	          $__default['default'](document).on('mouseup.sidebar-dismiss', function (e) {
	            if (!$__default['default'].contains(_this2._sidebar, e.target)) {
	              // if clicked outside sidebar
	              _this2.hide();
	            }
	          });
	        }
	
	        if (this._config.swipe) this.enableSwipeHide();
	        if (Util.isReducedMotion()) this._toggleMobileCompleted(); // call completion now
	        // in some webkit mobile browsers, sidebar scrolling works but scrollbars are not visible, unless something like this forces it to become visible
	
	        if (this._scroller && !this._scroller.classList.contains('overflow-hidden')) {
	          this._scroller.classList.add('overflow-hidden');
	
	          this._scroller.offsetHeight; // force redraw
	
	          this._scroller.classList.remove('overflow-hidden');
	        } // hide body scrollbars
	        // if sidebar is fixed and has backdrop or is .sidebar-push
	
	
	        var scrollbarInfo = Util.getScrollbarInfo();
	
	        if (scrollbarInfo.width === 0 && this._sidebar.classList.contains('sidebar-fixed') && (this._config.backdrop || this._sidebar.classList.contains('sidebar-push'))) {
	          document.body.classList.add('mob-sidebar-body');
	        }
	      }
	    }, {
	      key: "hide",
	      value: function hide() {
	        if (!this._hasTransitionEvent2) this._addTransitionEvent2();
	        var ev = new $__default['default'].Event(Event$1.HIDE);
	        $__default['default'](this._sidebar).trigger(ev);
	        if (ev.isDefaultPrevented()) return;
	
	        this._sidebar.classList.remove(ClassName.MOBILE_SHOW);
	
	        this._updateTriggerBtns(this._triggerArrayMobile, false); // document.body.classList.remove('mob-sidebar-body') // moved to `_toggleMobileCompleted`
	
	
	        if (this._config.dismiss) {
	          $__default['default'](this._triggerArrayMobile).css('pointer-events', '');
	          $__default['default'](document).off('.sidebar-dismiss');
	        }
	
	        if (this._config.swipe) {
	          $__default['default'](document).off('.sidebar-swipe');
	        }
	
	        if (Util.isReducedMotion()) this._toggleMobileCompleted(); // call completion now
	      }
	    }, {
	      key: "_updateTriggerBtns",
	      value: function _updateTriggerBtns(btns) {
	        var expanded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        for (var i = 0, len = btns.length; i < len; i++) {
	          if (expanded) btns[i].classList.remove(ClassName.COLLAPSED);else btns[i].classList.add(ClassName.COLLAPSED);
	          btns[i].setAttribute('aria-expanded', expanded);
	        }
	      }
	    }, {
	      key: "_toggleCompleted",
	      value: function _toggleCompleted() {
	        this._isTransitioning = false;
	
	        this._sidebar.classList.remove(ClassName.TOGGLING);
	
	        var expanded = !this._sidebar.classList.contains(this._desktopCollapsedClass);
	        if (expanded) $__default['default'](this._sidebar).trigger(Event$1.EXPANDED);else $__default['default'](this._sidebar).trigger(Event$1.COLLAPSED);
	        if (expanded) this._inner.classList.remove(ClassName.INNER_HOVER);
	      }
	    }, {
	      key: "_toggleMobileCompleted",
	      value: function _toggleMobileCompleted() {
	        var shown = this._sidebar.classList.contains(ClassName.MOBILE_SHOW);
	
	        if (shown) $__default['default'](this._sidebar).trigger(Event$1.SHOWN);else {
	          document.body.classList.remove('mob-sidebar-body');
	
	          if (this._config.swipe) {
	            document.body.classList.remove('mob-sidebarswipe-body');
	          }
	
	          $__default['default'](this._sidebar).trigger(Event$1.HIDDEN);
	        }
	      }
	    }, {
	      key: "_addTransitionEvent",
	      value: function _addTransitionEvent() {
	        var _this3 = this;
	
	        if (this._hasTransitionEvent) return;
	        this._hasTransitionEvent = true;
	        var counter = 0;
	        $__default['default'](this._sidebar).on('transitionend', function (e) {
	          if (e.target !== _this3._sidebar) return; // make sure its not the children triggerring the event!
	
	          _this3._toggleCompleted();
	
	          counter = 0;
	        }); // add 'is-hover' class to '.sidebar-inner' when it becomes expanded (i.e. when mouse hovers it)
	
	        $__default['default'](this._inner).on('transitionstart', function (e) {
	          // skip on mobile (in which propertyName is `transform`)
	          if (e.target !== _this3._inner || _this3._isTransitioning || e.originalEvent && e.originalEvent.propertyName !== 'width') return;
	          counter++;
	          if (counter === 1) _this3._inner.classList.add(ClassName.INNER_HOVER); // else if (counter >= 2) {
	          //  this.classList.remove(ClassName.INNER_HOVER)
	          //  counter = 0
	          // }
	        }).on('transitionend', function (e) {
	          // skip `transitionend` on mobile (in which propertyName is `transform`)
	          if (e.target !== _this3._inner || e.originalEvent && e.originalEvent.propertyName !== 'width') return;
	
	          if (_this3._inner.clientWidth < 120) {
	            // just to make sure we remove the extra class name when not needed
	            _this3._inner.classList.remove(ClassName.INNER_HOVER);
	
	            counter = 0; // blur input element
	
	            if (document.activeElement.tagName === 'INPUT' && _this3._inner.contains(document.activeElement)) document.activeElement.blur();
	          }
	        });
	      }
	    }, {
	      key: "_addTransitionEvent2",
	      value: function _addTransitionEvent2() {
	        var _this4 = this;
	
	        if (this._hasTransitionEvent2) return;
	        this._hasTransitionEvent2 = true;
	        $__default['default'](this._inner).on('transitionend', function (e) {
	          if (e.target !== _this4._inner || e.originalEvent && e.originalEvent.propertyName !== 'transform') return;
	
	          _this4._toggleMobileCompleted();
	        });
	      }
	    }, {
	      key: "enableSwipeHide",
	      value: function enableSwipeHide() {
	        var _this5 = this;
	
	        // swipe to hide sidebar
	        var x1 = 0;
	        var y1 = 0;
	        var swipeDir = 0;
	        var isRTL = false;
	        var lastX = 0;
	        var pushContent = false;
	        var sidebarWidth = 0;
	
	        var touchMoveCallback = function touchMoveCallback(ev) {
	          var touches = ev.changedTouches[0] || null;
	          if (!touches) return;
	          var newX = touches.pageX;
	          var newY = touches.pageY;
	          lastX = newX;
	
	          if (swipeDir === 0) {
	            var diffY = Math.abs(y1 - newY);
	            var diffX = Math.abs(x1 - newX);
	
	            if (diffY > diffX) {
	              swipeDir = 2; // vertical i.e. scroll
	
	              if (this._scroller) this._scroller.classList.remove('overflow-hidden');
	              document.body.classList.remove('mob-sidebarswipe-body');
	              $__default['default'](document).off('touchmove.sidebar-swipe');
	            } else if (diffX > 10) {
	              swipeDir = 1; // horizontal swipe
	
	              this._inner.setAttribute('style', 'transition: none !important; touch-action: none;');
	
	              if (this._scroller) this._scroller.classList.add('overflow-hidden');
	              document.body.classList.add('mob-sidebarswipe-body');
	            }
	          }
	
	          if (swipeDir !== 1) return;
	          var moveX = parseInt(x1 - newX);
	
	          if (!isRTL && moveX > 0 || isRTL && moveX < 0) {
	            // move it outside of view
	            this._inner.style.transform = 'translateX(' + -1 * moveX + 'px)';
	            if (pushContent) this._sidebar.style.width = sidebarWidth - (moveX > 0 ? moveX : -1 * moveX) + 'px';
	          } else {
	            this._inner.style.transform = '';
	            if (pushContent) this._sidebar.style.width = '';
	          }
	        };
	
	        var t1 = 0;
	        $__default['default'](document).on('touchstart.sidebar-swipe', function (e) {
	          var touches = e.originalEvent.changedTouches[0] || null;
	          if (!touches) return;
	          x1 = touches.pageX;
	          y1 = touches.pageY;
	          t1 = Date.now();
	          isRTL = Util.isRTL();
	          pushContent = _this5._sidebar.classList.contains('sidebar-push');
	
	          if (pushContent) {
	            sidebarWidth = _this5._sidebar.offsetWidth;
	            _this5._sidebar.style.minWidth = 'auto';
	            _this5._sidebar.style.transition = 'none';
	          }
	
	          $__default['default'](document).on('touchmove.sidebar-swipe', function (e) {
	            touchMoveCallback.call(_this5, e.originalEvent);
	          });
	        }).on('touchend.sidebar-swipe touchcancel.sidebar-swipe', function (e) {
	          var touches = e.originalEvent.changedTouches[0] || null; // if (!touches) return // in case we're coming from a `dismiss` mouseup event
	
	          _this5._inner.setAttribute('style', '');
	
	          if (pushContent) {
	            _this5._sidebar.style.width = '';
	            _this5._sidebar.style.minWidth = '';
	            _this5._sidebar.style.transition = '';
	          }
	
	          var x2 = touches !== null ? touches.pageX : lastX;
	          var t2 = Date.now();
	
	          if (swipeDir === 1 && ( // dismiss if moved by more than 100px or moved more than 40px in a short time (less than 300ms)
	          !isRTL && (x1 - x2 > 100 || x1 - x2 > 40 && t2 - t1 < 300) || isRTL && (x1 - x2 < -100 || x1 - x2 < -40 && t2 - t1 < 300))) {
	            // if moved more than 100px or 40px in less than 300ms
	            _this5.hide();
	          } else {
	            // remove '.mob-sidebarswipe-body' to bring back body scrollbars if sidebar isn't swiped to hide
	            // but we probably won't have body scrollbars because of `.mob-sidebar-body`
	            document.body.classList.remove('mob-sidebarswipe-body');
	          } // bring back sidebar scrollbars
	
	
	          if (_this5._scroller) _this5._scroller.classList.remove('overflow-hidden');
	          swipeDir = 0;
	        });
	      }
	    }, {
	      key: "enableSubmenuToggle",
	      value: function enableSubmenuToggle() {
	        var _firefox = ('MozAppearance' in document.documentElement.style);
	
	        var _scrollIntoViewOptions = ('scrollBehavior' in document.documentElement.style);
	
	        var isOpening = false;
	        var This = this;
	        $__default['default'](this._sidebar).on('click', '.dropdown-toggle', function (ev) {
	          ev.preventDefault();
	          if (isOpening) return;
	          var navItem = $__default['default'](this).closest('.nav-item'); // get the parent LI.nav-item
	
	          var subMenu = navItem.find('> .submenu').eq(0); // get the direct submenu (not the children)
	
	          var navLink = navItem.find('> .nav-link').eq(0); // get the parent LI.nav-item
	
	          var subPos = null;
	
	          if (This._collapsed && This._sidebar.classList.contains('hoverable') || This._sidebar.classList.contains('sidebar-hover')) {
	            // don't toggle submenu if submenu is supposed to be displayed as popup (this includes horizontal sidebar when it's `.sidebar-hover`)
	            subPos = window.getComputedStyle(subMenu.get(0)).position;
	            if (subPos === 'absolute') return;
	          }
	
	          if (subMenu.hasClass('collapsing')) return; // don't toggle in the middle of toggling
	          // hide sibling submenus
	
	          navItem.addClass('is-toggling');
	          navItem.parent().find('> .nav-item.open').addClass('is-toggling').not(navItem).removeClass('open').find('> .submenu.show').collapse('hide'); // toggle submenu
	
	          if (navItem.hasClass('open')) {
	            navItem.removeClass('open');
	            navLink.addClass('collapsed');
	
	            This._sidebar.classList.remove('has-open');
	
	            subMenu.collapse('hide');
	          } else {
	            isOpening = true;
	            navItem.addClass('open');
	            navLink.removeClass('collapsed');
	
	            This._sidebar.classList.add('has-open');
	
	            subMenu.collapse('show');
	          }
	
	          if (!subMenu.data('has-event')) {
	            subMenu.data('has-event', true).on('shown.bs.collapse.is-toggling hidden.bs.collapse.is-toggling', function () {
	              isOpening = false;
	              $__default['default'](This._sidebar).find('.is-toggling').removeClass('is-toggling'); // firefox continues to disable scroll chaining when sidebar is not scrollable anymore, so a little fix around here
	
	              if (_firefox) {
	                if (This._scroller === null) return;
	
	                if (This._scroller.scrollHeight <= This._scroller.clientHeight) {
	                  This._scroller.style.overscrollBehavior = 'auto';
	                } else This._scroller.style.overscrollBehavior = '';
	              }
	            });
	          } // scroll submenu into view (only on modern browsers)
	
	
	          if (!Util.isReducedMotion() && _scrollIntoViewOptions && This._config.subscroll && This._sidebar.classList.contains('sidebar-fixed') && navItem.hasClass('open')) {
	            if (This._sidebar.classList.contains(ClassName.HORIZONTAL)) {
	              subPos = window.getComputedStyle(subMenu.get(0)).position;
	              if (subPos === 'absolute') return; // no scroll for desktop horizontal menu (when it's not `.sidebar-hover`)
	            }
	
	            var smooth = !Util.isReducedMotion();
	            setTimeout(function () {
	              try {
	                if (_scrollIntoViewOptions) {
	                  subMenu.get(0).scrollIntoView({
	                    behavior: smooth ? 'smooth' : 'auto',
	                    block: 'nearest'
	                  });
	                } else {// subMenu.get(0).scrollIntoView(false)
	                }
	              } catch (err) {}
	            }, smooth ? 150 : 0);
	          }
	        });
	      }
	    }, {
	      key: "enableSubmenuPullup",
	      value: function enableSubmenuPullup() {
	        if (this._pullupEnabled) return;
	        this._pullupEnabled = true;
	        var marginProp = 'margin-' + (!Util.isRTL() ? 'left' : 'right');
	        var This = this;
	        $__default['default'](this._sidebar).on('transitionstart', '.submenu', function (ev) {
	          if (ev.target !== this || ev.originalEvent.propertyName !== marginProp || !(This._collapsed || This._sidebar.classList.contains('sidebar-hover'))) return;
	          var navItem = $__default['default'](this).parent();
	          var submenu = $__default['default'](this);
	          var navtxt = navItem.find('> .nav-link > .nav-text.fadeable'); // only first level nav-text items
	
	          navItem.removeClass('submenu-pullup');
	          submenu.css('transform', '');
	          navtxt.css('transform', ''); /// ///////////////////////
	
	          var rect = submenu.get(0).getBoundingClientRect();
	          var wh = $__default['default'](window).height();
	          var diff = parseInt(rect.bottom - wh);
	
	          if (diff > 0) {
	            // if submenu bottom is below window area
	            // check to see if submenu top will go out of window if we move it up by "diff" pixels
	            // also consider that the first level item's .nav-text shouldn't go out of window's top
	            var navtxtHeight = navtxt.height() || 0;
	            var diff2 = rect.top - navtxtHeight - diff - $__default['default']('.navbar').height(); // don't go above navbar
	
	            if (diff2 < 0) diff = diff + diff2;
	            diff = parseInt(diff) + 1; // so that submenu's border is visible
	
	            if (This._collapsed) {
	              if (navtxtHeight && diff > navtxtHeight / 2) navItem.addClass('submenu-pullup'); // this class makes the .sub-arrow's color white, to match submenu color
	            } else {
	              navItem.addClass('submenu-pullup');
	            }
	
	            submenu.css('transform', 'translateY(-' + diff + 'px)');
	
	            if (This._collapsed) {
	              navtxt.css('transform', 'translateY(-' + diff + 'px)');
	            }
	          }
	        });
	      }
	    }, {
	      key: "disableSubmenuPullup",
	      value: function disableSubmenuPullup() {
	        this._pullupEnabled = false;
	        $__default['default'](this._sidebar).off('transitionstart.pullup');
	
	        this._resetPullUp();
	      }
	    }, {
	      key: "_resetPullUp",
	      value: function _resetPullUp() {
	        $__default['default'](this._sidebar).find('.submenu-pullup').removeClass('submenu-pullup').find('.nav-text, .submenu').css('transform', '');
	      } // scroll active item into view
	
	    }, {
	      key: "scrollToActive",
	      value: function scrollToActive() {
	        if (!this._sidebar.classList.contains('sidebar-fixed') || this._scroller === null) return;
	
	        var active = this._sidebar.querySelector('.nav-item.active:not(.open) > .nav-link');
	
	        try {
	          active.scrollIntoView({
	            behavior: 'auto',
	            block: 'end'
	          }); // or block: "center"?
	
	          this._scroller.scrollTop = this._scroller.scrollTop + 30;
	        } catch (e) {}
	      }
	    }, {
	      key: "_getConfig",
	      value: function _getConfig(config) {
	        config = _objectSpread2(_objectSpread2({}, Default$1), _typeof(config) === 'object' && config ? config : {});
	
	        if (typeof bootstrap__default['default'] !== 'undefined') {
	          bootstrap__default['default'].Util.typeCheckConfig(NAME$1, config, this.constructor.DefaultType);
	        }
	
	        return config;
	      } // Static methods
	
	    }], [{
	      key: "_jQueryInterface",
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          var $this = $__default['default'](this);
	          var data = $this.data(DATA_KEY$1);
	
	          var _config = _objectSpread2(_objectSpread2(_objectSpread2({}, Default$1), $this.data()), _typeof(config) === 'object' && config ? config : {});
	
	          if (!data) {
	            data = new Sidebar(this, _config);
	            $this.data(DATA_KEY$1, data);
	          }
	
	          if (typeof config === 'string') {
	            if (typeof data[config] === 'undefined') {
	              throw new TypeError("No method named \"".concat(config, "\""));
	            }
	
	            data[config]();
	          }
	        });
	      }
	    }, {
	      key: "VERSION",
	      get: function get() {
	        return VERSION$1;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$1;
	      }
	    }, {
	      key: "DefaultType",
	      get: function get() {
	        return DefaultType$1;
	      }
	    }]);
	
	    return Sidebar;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	  */
	
	
	  $__default['default'](window).on(Event$1.LOAD_DATA_API, function () {
	    var sidebars = [].slice.call(document.querySelectorAll(Selector$1.SIDEBAR));
	
	    for (var i = 0; i < sidebars.length; i++) {
	      var $sidebar = $__default['default'](sidebars[i]);
	
	      Sidebar._jQueryInterface.call($sidebar, $sidebar.data());
	    }
	  });
	  /**
	  $(document).on(Event.CLICK_DATA_API, `${Selector.DATA_TOGGLE} , ${Selector.DATA_TOGGLE_MOBILE}`, function (event) {
	  	if (event.currentTarget.tagName === 'A') {
	  	  event.preventDefault()
	  	}
	
	  	const $trigger = $(this)
	  	const selector = bootstrap.Util.getSelectorFromElement(this)
	  	const selectors = [].slice.call(document.querySelectorAll(selector))
	
	  	$(selectors).each(function () {
	  	  const $target = $(this)
	  	  const data    = $target.data(DATA_KEY)
	  	  const config  = data ? 'toggle' : $trigger.data()
	  	  Sidebar._jQueryInterface.call($target, config)
	  	})
	  })
	  */
	
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	  */
	
	  if (typeof $__default['default'] !== 'undefined') {
	    var JQUERY_NO_CONFLICT$1 = $__default['default'].fn[NAME$1];
	    $__default['default'].fn[NAME$1] = Sidebar._jQueryInterface;
	    $__default['default'].fn[NAME$1].Constructor = Sidebar;
	
	    $__default['default'].fn[NAME$1].noConflict = function () {
	      $__default['default'].fn[NAME$1] = JQUERY_NO_CONFLICT$1;
	      return Sidebar._jQueryInterface;
	    };
	  }
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$2 = 'aceAside';
	  var VERSION$2 = '3.1.1';
	  var DATA_KEY$2 = 'ace.aside';
	  var EVENT_KEY$2 = ".".concat(DATA_KEY$2);
	  var Event$2 = {
	    SHOW: "show".concat(EVENT_KEY$2),
	    HIDE: "hide".concat(EVENT_KEY$2)
	  };
	  var DefaultType$2 = {
	    placement: 'string',
	    // margin: 'number',
	    fade: 'boolean',
	    autohide: '(boolean|number)',
	    dismiss: 'boolean',
	    blocking: 'boolean',
	    backdrop: '(boolean|string)',
	    container: 'boolean',
	    belowNav: 'boolean',
	    aboveNav: 'boolean',
	    width: '(boolean|number)',
	    height: '(boolean|number)',
	    scroll: '(boolean|string)'
	  };
	  var Default$2 = {
	    placement: 'center',
	    // margin: 0,
	    fade: false,
	    autohide: false,
	    dismiss: false,
	    blocking: false,
	    backdrop: false,
	    container: false,
	    belowNav: false,
	    aboveNav: false,
	    width: false,
	    height: false,
	    scroll: 'body'
	  };
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Aside = /*#__PURE__*/function () {
	    function Aside(element, config) {
	      _classCallCheck(this, Aside);
	
	      this._config = this._getConfig(config);
	      this._element = element;
	      this.$element = $__default['default'](element);
	
	      this._init(this._config);
	    }
	
	    _createClass(Aside, [{
	      key: "_init",
	      value: function _init(config) {
	        var _this$_element$classL;
	
	        this._setPlacement(config.placement);
	
	        this._element.classList.add('ace-aside');
	
	        if (!config.blocking) {
	          this._element.classList.add('modal-nb');
	
	          this.$element.attr('data-backdrop', 'false').data('backdrop', false);
	        } else {
	          if (config.backdrop) {
	            this.$element.attr('data-backdrop-bg', config.backdrop);
	          }
	
	          this.$element.attr('data-backdrop', 'true').data('backdrop', true);
	        }
	
	        if (config.dismiss) this._element.classList.add('modal-dismiss');
	
	        if (config.fade) {
	          this._element.classList.add('aside-fade', 'fade');
	        }
	
	        if (config.belowNav) this._element.classList.add('aside-below-nav');
	        if (config.aboveNav) this._element.classList.add('aside-above-nav');
	        if (config.extraClass) (_this$_element$classL = this._element.classList).add.apply(_this$_element$classL, _toConsumableArray(config.extraClass.split(' ')));
	
	        if (config.container) {
	          this._element.classList.add('container');
	
	          var bdc = document.querySelector('.body-container');
	
	          if (bdc !== null && bdc.classList.contains('container-plus')) {
	            this._element.classList.add('container-plus');
	          }
	        }
	
	        if (config.width) {
	          this.$element.find('.modal-dialog').css('width', isNaN(config.width) ? config.width : this._config.width + 'px');
	        }
	
	        if (config.height) {
	          this.$element.find('.modal-dialog').css('height', isNaN(config.height) ? config.height : this._config.height + 'px');
	        } // if (/^(content|body)$/.test(config.scroll)) {
	        //  this.$element.find('.modal-content').addClass('scroll-' + config.scroll)
	        // }
	
	
	        this.$element.off('shown.bs.modal.autohide');
	
	        if (config.autohide) {
	          var This = this;
	          this.$element.on('shown.bs.modal.autohide', function () {
	            setTimeout(function () {
	              This.hide();
	            }, config.autohide);
	          });
	        }
	      }
	    }, {
	      key: "_setPlacement",
	      value: function _setPlacement() {
	        var placement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'center';
	        var placementMap = {
	          t: 'aside-top',
	          top: 'aside-top',
	          tc: 'aside-top aside-c',
	          tr: 'aside-top aside-r',
	          tl: 'aside-top aside-l',
	          b: 'aside-bottom',
	          bottom: 'aside-bottom',
	          bc: 'aside-bottom aside-c',
	          br: 'aside-bottom aside-r',
	          bl: 'aside-bottom aside-l',
	          r: 'aside-right',
	          right: 'aside-right',
	          rc: 'aside-right aside-m',
	          l: 'aside-left',
	          left: 'aside-left',
	          lc: 'aside-left aside-m',
	          c: 'aside-center',
	          center: 'aside-center'
	        };
	        placement = placement || 'c';
	        var className = placementMap[placement] || 'aside-center';
	
	        if (placement === 'c' || placement === 'center') {
	          this._config.fade = true;
	
	          this._element.classList.remove('container');
	        }
	
	        this._element.className = this._element.className + ' ' + className;
	      } // Public methods
	
	    }, {
	      key: "show",
	      value: function show() {
	        var showEvent = new $__default['default'].Event(Event$2.SHOW);
	        this.$element.trigger(showEvent);
	
	        if (showEvent.isDefaultPrevented()) {
	          return;
	        }
	
	        this.$element.modal('show');
	      }
	    }, {
	      key: "hide",
	      value: function hide() {
	        var hideEvent = new $__default['default'].Event(Event$2.HIDE);
	        this.$element.trigger(hideEvent);
	
	        if (hideEvent.isDefaultPrevented()) {
	          return;
	        }
	
	        this.$element.modal('hide');
	      } // Private methods
	
	    }, {
	      key: "_getConfig",
	      value: function _getConfig(config) {
	        config = _objectSpread2(_objectSpread2({}, Default$2), _typeof(config) === 'object' && config ? config : {});
	
	        if (typeof bootstrap__default['default'] !== 'undefined') {
	          bootstrap__default['default'].Util.typeCheckConfig(NAME$2, config, this.constructor.DefaultType);
	        }
	
	        return config;
	      } // Static methods
	
	    }], [{
	      key: "_jQueryInterface",
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          var $this = $__default['default'](this);
	          var data = $this.data(DATA_KEY$2);
	
	          var _config = _objectSpread2(_objectSpread2(_objectSpread2({}, Default$2), $__default['default'](this).data()), _typeof(config) === 'object' && config ? config : {});
	
	          if (!data) {
	            data = new Aside(this, _config);
	            $this.data(DATA_KEY$2, data);
	          }
	
	          if (typeof config === 'string') {
	            if (typeof data[config] === 'undefined') {
	              throw new TypeError("No method named \"".concat(config, "\""));
	            }
	
	            data[config]();
	          }
	        });
	      } //
	
	    }, {
	      key: "_HandleAside",
	      value: function _HandleAside() {
	        var visibleModalSelector = '.modal.show:not(.modal-nb)';
	        var dismissEventId = 0;
	        $__default['default']('.ace-aside.modal-nb').attr('data-backdrop', 'false').data('backdrop', false);
	        $__default['default'](document).on('show.bs.modal', '.modal', function (e) {
	          if (e.isDefaultPrevented()) return;
	          var modal = this;
	
	          if (modal.classList.contains('modal-nb')) {
	            if ($__default['default'](visibleModalSelector).length === 0) {
	              document.body.classList.add('modal-nb'); // disable .modal-open effects for .modal-nb
	            }
	          } else {
	            if (!modal.classList.contains('ace-aside')) {
	              // check to see if we will have modal scrollbars
	              modal.style.display = 'block';
	              if (modal.scrollHeight > modal.clientHeight) document.body.classList.add('modal-scroll');
	              var scrollbars = Util.getScrollbarInfo();
	              if (scrollbars.width === 0) document.body.classList.add('scrollbar-w0');
	              modal.style.display = '';
	            } // set modal padding value (equal to scrollbar width)
	
	
	            document.body.style.setProperty('--modal-padding', window.innerWidth - document.body.scrollWidth + 'px');
	            var isModalOff = modal.className.match(/modal-off(-[a-z0-9]*)?/i);
	            var backdropBg = $__default['default'](modal).attr('data-backdrop-bg');
	
	            if (backdropBg || isModalOff) {
	              setTimeout(function () {
	                var backdrop = document.querySelector('.modal-backdrop:last-child');
	
	                if (backdrop !== null) {
	                  if (backdropBg) backdrop.classList.add(backdropBg); // for example if our modal is a `.modal-off-lg` then we add `.d-lg-none` to `.modal-backdrop` to hide it in `lg+` view
	
	                  if (isModalOff) backdrop.classList.add("d".concat(isModalOff[1] || '', "-none"));
	                }
	              }, 0);
	            }
	
	            var blur = modal.getAttribute('data-blur');
	
	            if (blur !== null && window.CSS) {
	              /**
	               // using `backdrop-filter` is less intrusive but doesn't have the same blur effect
	               if (window.CSS.supports("backdrop-filter", "none")) {
	                setTimeout(function () {
	                  $('.modal-backdrop:last-child').addClass('modal-blur')
	                }, 0)
	              }
	              else */
	              if (window.CSS.supports('filter', 'none')) {
	                var bodyContainer = document.querySelector('.body-container');
	
	                if (bodyContainer !== null) {
	                  document.body.classList.add('modal-blur');
	                  bodyContainer.style.filter = 'blur(' + blur + ')';
	                  var modalParent = modal.parentNode;
	                  var modalSibling = modal.nextSibling;
	                  $__default['default'](modal).appendTo('body').one('hidden.bs.modal.blur', function () {
	                    modalParent.insertBefore(modal, modalSibling);
	                    document.body.classList.remove('modal-blur');
	                    bodyContainer.style.filter = '';
	                  });
	                }
	              }
	            }
	          }
	        }).on('shown.bs.modal', '.modal', function (e) {
	          var modal = this;
	
	          if (modal.classList.contains('modal-nb')) {
	            document.body.classList.remove('modal-nb');
	
	            if ($__default['default'](visibleModalSelector).length === 0) {
	              // if no blocking modals
	              document.body.classList.remove('modal-open'); // disable .modal-open effects
	
	              document.body.style.paddingRight = ''; // and remove paddingRight
	            }
	
	            if (modal.classList.contains('modal-dismiss') || modal.getAttribute('data-dismiss') === 'true') {
	              // we add an extra ID to our event namespace
	              // because sometimes before a dismissible modal is hidden inside the below setTimeout, another dismissible gets shown and registers the following event which gets
	              // cleared in the on.hidden event below ... so we use different IDs for each one ...
	              modal.setAttribute('data-dismiss-event-id', ++dismissEventId);
	              $__default['default'](document).on('mouseup.aside-dismiss.' + dismissEventId, function (e) {
	                // why mouseup? because 'click' may get 'stopPropagated' in some plugins such as Bootstrap's dropdown
	                if (!$__default['default'].contains(modal, e.target)) {
	                  // clicked outside modal
	                  // why timeout?
	                  // because if we click on the same button that triggers this modal, its 'hide' function will be called and instantly followed by 'show' function
	                  // so we first let 'show' be called and then we call 'hide'
	                  setTimeout(function () {
	                    $__default['default'](modal).modal('hide');
	                  }, 0);
	                }
	              });
	            }
	          }
	        }).on('hidden.bs.modal', '.modal', function () {
	          if ($__default['default'](visibleModalSelector).length === 0) document.body.style.paddingRight = ''; // required for rare cases that body padding is still not cleared
	          else document.body.classList.add('modal-open'); // sometimes an aside is closed (so .modal-open is removed) but a .modal is still open (so we add .modal-open again)
	
	          if (!this.classList.contains('modal-nb')) {
	            document.body.classList.remove('modal-scroll');
	            document.body.classList.remove('scrollbar-w0');
	          } // we might have dismissed modal dialog using the close button inside it, so we turn off the events looking for clicks outside modal
	
	
	          if (this.classList.contains('modal-dismiss') || this.getAttribute('data-dismiss') === 'true') {
	            var eid = this.getAttribute('data-dismiss-event-id');
	            $__default['default'](document).off('.aside-dismiss.' + eid);
	          }
	        }); // enable modal functionality for modal boxes and asides that are shown (.show) by default
	
	        $__default['default']('.modal.show').modal('show');
	      }
	    }, {
	      key: "VERSION",
	      get: function get() {
	        return VERSION$2;
	      }
	    }, {
	      key: "DefaultType",
	      get: function get() {
	        return DefaultType$2;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$2;
	      }
	    }]);
	
	    return Aside;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	  */
	
	
	  if (typeof $__default['default'] !== 'undefined') {
	    Aside._HandleAside();
	
	    var JQUERY_NO_CONFLICT$2 = $__default['default'].fn[NAME$2];
	    $__default['default'].fn[NAME$2] = Aside._jQueryInterface;
	    $__default['default'].fn[NAME$2].Constructor = Aside;
	
	    $__default['default'].fn[NAME$2].noConflict = function () {
	      $__default['default'].fn[NAME$2] = JQUERY_NO_CONFLICT$2;
	      return Aside._jQueryInterface;
	    };
	  }
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$3 = 'aceToaster';
	  var VERSION$3 = '3.1.1';
	  var DATA_KEY$3 = 'ace.toaster';
	  var EVENT_KEY$3 = ".".concat(DATA_KEY$3);
	  var Event$3 = {
	    CLEAR: "clear".concat(EVENT_KEY$3),
	    ADD: "add".concat(EVENT_KEY$3),
	    ADDED: "added".concat(EVENT_KEY$3)
	  };
	  var DefaultType$3 = {
	    placement: 'string',
	    close: 'boolean',
	    autoremove: 'boolean',
	    delay: 'number',
	    template: 'string',
	    alert: 'boolean'
	  };
	  var Default$3 = {
	    placement: 'tr',
	    close: true,
	    autoremove: true,
	    delay: 2500,
	    template: '<div class="toast"><div class="d-flex"><div class="toast-image"></div><div class="toast-main"><div class="toast-header"></div><div class="toast-body"></div></div></div></div>',
	    alert: true
	  };
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Toaster = /*#__PURE__*/function () {
	    function Toaster() {
	      _classCallCheck(this, Toaster);
	
	      this._lastToastId = 0;
	      this._toast = null;
	    }
	
	    _createClass(Toaster, [{
	      key: "add",
	      // Public methods
	      value: function add(config) {
	        var _config = this._getConfig(config);
	
	        var $newToast = $__default['default'](_config.template);
	        this._toast = $newToast[0];
	        this._lastToastId++;
	        $newToast.addClass('ace-toaster-item').attr({
	          id: "ace-toaster-item-".concat(this._lastToastId),
	          'aria-atomic': 'true'
	        });
	
	        if (_config.alert) {
	          $newToast.attr({
	            role: 'alert',
	            'aria-live': 'assertive'
	          });
	        } else {
	          $newToast.attr({
	            role: 'status',
	            'aria-live': 'polite'
	          });
	        }
	
	        var $toastHeader = $newToast.find('.toast-header');
	
	        if (_config.title) {
	          var title = typeof _config.title === 'function' ? _config.title.call(this._toast, _config) : _config.title;
	          title = $__default['default']("<div class=\"toast-title\">".concat(title, "</div>"));
	
	          if (_config.titleClass) {
	            title.addClass(_config.titleClass);
	          }
	
	          $toastHeader.append(title);
	        }
	
	        if (_config.close) {
	          var close = $newToast.find('[data-dismiss="toast"]');
	
	          if (close.length === 0) {
	            close = $__default['default']('<button type="button" data-dismiss="toast" aria-label="Close"><span aria-hidden="true">&times;</span></button>');
	            $toastHeader.append(close);
	          }
	
	          close.addClass(_config.closeClass ? _config.closeClass : 'close');
	        }
	
	        if (_config.body) {
	          $newToast.find('.toast-body').append(typeof _config.body === 'function' ? _config.body.call(this._toast, _config) : _config.body);
	
	          if (_config.bodyClass) {
	            $newToast.find('.toast-body').addClass(_config.bodyClass);
	          }
	        }
	
	        if (_config.image) {
	          $newToast.find('.toast-image').append("<img src=\"".concat(_config.image, "\" />"));
	
	          if (_config.imageClass) {
	            $newToast.find('.toast-image').find('img').addClass(_config.imageClass);
	          }
	        }
	
	        if (_config.icon) {
	          var icon = $__default['default'](_config.icon).appendTo($newToast.find('.toast-image'));
	
	          if (!_config.image && _config.imageClass) {
	            icon.addClass(_config.imageClass);
	          }
	        }
	
	        if (!(_config.image || _config.icon)) $newToast.find('.toast-image').remove();
	
	        if (_config.className) {
	          $newToast.addClass(_config.className);
	        }
	
	        if (_config.headerClass) {
	          $toastHeader.addClass(_config.headerClass);
	        } // if delay is below 30, we consider it as seconds, not milliseconds
	
	
	        _config.delay = _config.delay > 30 ? _config.delay : _config.delay * 1000;
	
	        if (_config.progress && !_config.sticky && _config.autohide !== false) {
	          var progress = $__default['default']("<div class=\"toast-progress ".concat(_config.progress, "\"></div>")).appendTo($newToast);
	          progress.get(0).style.transition = "width ".concat(parseInt(_config.delay * 1.015), "ms linear");
	          progress.get(0).style.width = _config.progressReverse ? 'calc(100% - 1px)' : 0; // progress.get(0).offsetWidth
	
	          setTimeout(function () {
	            progress.get(0).style.width = _config.progressReverse ? 0 : 'calc(100% - 2px)';
	          }, 0);
	        }
	
	        return this._addToContainer($newToast, _config);
	      } // add an existing toast element to our container
	
	    }, {
	      key: "addEl",
	      value: function addEl(element, config) {
	        var _config = this._getConfig(config);
	
	        this._toast = element;
	        var $existingToast = $__default['default'](this._toast).addClass('ace-toaster-item');
	        if (!$existingToast.attr('id')) $existingToast.attr('id', "ace-toaster-item-".concat(++this._lastToastId));
	
	        this._addToContainer($existingToast, _config, false);
	      } // add toast element to container
	
	    }, {
	      key: "_addToContainer",
	      value: function _addToContainer($toast, _config) {
	        var isNewElement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	        // trigger ADD event before adding it to our container
	        var addEvent = new $__default['default'].Event(Event$3.ADD);
	
	        var _toast = $toast.get(0);
	
	        addEvent.target = _toast;
	        $__default['default'](document).trigger(addEvent);
	
	        if (addEvent.isDefaultPrevented()) {
	          if (isNewElement) $toast.remove();
	          return null;
	        } // end of trigger
	        // add the toaster container to body
	
	
	        var container = $__default['default'](".ace-toaster-container.position-".concat(_config.placement)).eq(0);
	
	        if (container.length === 0) {
	          container = $__default['default']("<div class=\"ace-toaster-container position-".concat(_config.placement, "\"/>")).appendTo(document.body);
	        }
	
	        if (_config.belowNav) {
	          container.addClass('toaster-below-nav');
	        } // add to container
	
	
	        if (_config.placement.indexOf('b') === 0) {
	          // bottom placement
	          container.prepend($toast);
	        } else {
	          container.append($toast);
	        } // without having an initial .toast element, fade-in animation isn't taking place??!!
	
	
	        var dummy = $__default['default']('#ace-toaster-dummy-toast-1');
	        if (dummy.length === 0) dummy = $__default['default']('<div id="ace-toaster-dummy-toast-1" class="toast d-none invisible"></div>').appendTo('body');
	        dummy.toast('show'); /// ///////////////////////////////////////////////
	
	        var _toastOptions = {};
	        if (_config.sticky === true || _config.autohide === false) _toastOptions.autohide = false;
	        if (_config.animation === false) _toastOptions.animation = false;
	        _toastOptions.delay = _config.delay;
	        if (_config.width) $toast.css('width', isNaN(_config.width) ? _config.width : _config.width + 'px');
	        $toast.toast(_toastOptions).toast('show').one('hidden.bs.toast.1', function () {
	          // show it again (invisibly with opacity = 0) and use bootstrap Collapse plugin to hide it, so that other toasts stacked below it move up smoothly
	          $toast.removeClass('hide').addClass('show').collapse('hide').one('hidden.bs.collapse', function () {
	            $toast.toast('dispose');
	
	            if (_config.autoremove) {
	              $toast.remove();
	            }
	          });
	        }); // trigger ADDED event before adding it to DOM
	
	        var addedEvent = new $__default['default'].Event(Event$3.ADDED);
	        addedEvent.target = _toast;
	        $__default['default'](document).trigger(addedEvent);
	        return _toast;
	      } // hide toasts
	
	    }, {
	      key: "remove",
	      value: function remove(id) {
	        var instant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        this.hide(id, true, instant);
	      }
	    }, {
	      key: "removeAll",
	      value: function removeAll() {
	        var placement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var instant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        this.hideAll(placement, true, instant);
	      } // remove toast by ID or element reference
	
	    }, {
	      key: "hide",
	      value: function hide(id) {
	        var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var instant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	        var selector = isNaN(id) ? id : '#ace-toaster-item-' + parseInt(id);
	
	        this._hideBySelector(selector, remove, instant);
	      } // remove ALL toasts
	
	    }, {
	      key: "hideAll",
	      value: function hideAll() {
	        var placement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var instant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	        // trigger CLEAR event before removing ALL
	        var clearEvent = new $__default['default'].Event(Event$3.CLEAR); // ,  { placement: placement || 'all', remove: remove })
	
	        $__default['default'](document).trigger(clearEvent, {
	          placement: placement || 'all',
	          remove: remove
	        });
	
	        if (clearEvent.isDefaultPrevented()) {
	          return;
	        } // end of trigger
	
	
	        var selector = '.toast.ace-toaster-item';
	        if (placement) selector = ".ace-toaster-container.position-".concat(placement, " ").concat(selector);
	
	        this._hideBySelector(selector, remove, instant);
	      }
	    }, {
	      key: "_hideBySelector",
	      value: function _hideBySelector(selector) {
	        var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var instant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	        $__default['default'](selector).each(function () {
	          var $toast = $__default['default'](this);
	
	          if (!instant && $toast.is(':visible')) {
	            // fade out and then remove
	            $toast.toast('hide').off('hidden.bs.toast.1') // remove the previous handler above (because it has autoremove)
	            .one('hidden.bs.toast.2', function () {
	              $toast.toast('dispose');
	              if (remove) $toast.remove();
	            });
	          } else {
	            $toast.toast('dispose'); // instantly remove if not visible
	
	            if (remove) $toast.remove();
	          }
	        });
	      } // Private methods
	
	    }, {
	      key: "_getConfig",
	      value: function _getConfig(config) {
	        config = _objectSpread2(_objectSpread2({}, Default$3), _typeof(config) === 'object' && config ? config : {});
	
	        if (typeof bootstrap__default['default'] !== 'undefined') {
	          bootstrap__default['default'].Util.typeCheckConfig(NAME$3, config, this.constructor.DefaultType);
	        }
	
	        return config;
	      } // Static methods
	
	    }], [{
	      key: "_jQueryInterface",
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          config = _objectSpread2(_objectSpread2(_objectSpread2({}, {
	            autoremove: false
	          }), $__default['default'](this).data()), _typeof(config) === 'object' && config ? config : {});
	          $__default['default'].aceToaster.addEl(this, config);
	        });
	      }
	    }, {
	      key: "VERSION",
	      get: function get() {
	        return VERSION$3;
	      }
	    }, {
	      key: "DefaultType",
	      get: function get() {
	        return DefaultType$3;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$3;
	      }
	    }]);
	
	    return Toaster;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	  */
	
	
	  if (typeof $__default['default'] !== 'undefined') {
	    $__default['default'][NAME$3] = new Toaster();
	    var JQUERY_NO_CONFLICT$3 = $__default['default'].fn[NAME$3];
	    $__default['default'].fn[NAME$3] = Toaster._jQueryInterface;
	    $__default['default'].fn[NAME$3].Constructor = Toaster;
	
	    $__default['default'].fn[NAME$3].noConflict = function () {
	      $__default['default'].fn[NAME$3] = JQUERY_NO_CONFLICT$3;
	      return Toaster._jQueryInterface;
	    };
	  }
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$4 = 'aceWidget';
	  var VERSION$4 = '3.1.1';
	  var DATA_KEY$4 = 'ace.widget';
	  var EVENT_KEY$4 = ".".concat(DATA_KEY$4);
	  var DATA_API_KEY$2 = '.data-api';
	  var Event$4 = {
	    SHOW: "show".concat(EVENT_KEY$4),
	    HIDE: "hide".concat(EVENT_KEY$4),
	    SHOWN: "shown".concat(EVENT_KEY$4),
	    HIDDEN: "hidden".concat(EVENT_KEY$4),
	    CLOSE: "close".concat(EVENT_KEY$4),
	    CLOSED: "closed".concat(EVENT_KEY$4),
	    EXPAND: "expand".concat(EVENT_KEY$4),
	    EXPANDED: "expanded".concat(EVENT_KEY$4),
	    RESTORE: "restore".concat(EVENT_KEY$4),
	    RESTORED: "restored".concat(EVENT_KEY$4),
	    // RELOADED: `reloaded${EVENT_KEY}`,
	    RELOAD: "reload".concat(EVENT_KEY$4),
	    CLICK_DATA_API: "click".concat(EVENT_KEY$4).concat(DATA_API_KEY$2)
	  };
	  var Selector$2 = {
	    DATA_ACTION: '.card a[data-action]'
	  };
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Widget = /*#__PURE__*/function () {
	    function Widget(element, config) {
	      _classCallCheck(this, Widget);
	
	      this._config = this._getConfig(config);
	      this._element = element;
	      this._element.offsetHeight; // force reflow, so that if we instantly call 'close' etc, transition effect takes place
	
	      this.$box = $__default['default'](element);
	    }
	
	    _createClass(Widget, [{
	      key: "reload",
	
	      /**
	      static get DefaultType () {
	        return DefaultType
	      }
	        static get Default () {
	        return Default
	      }
	      */
	      value: function reload() {
	        var ev = new $__default['default'].Event(Event$4.RELOAD);
	        this.$box.trigger(ev);
	        if (ev.isDefaultPrevented()) return;
	        this.startLoading();
	      }
	    }, {
	      key: "startLoading",
	      value: function startLoading() {
	        var loadingHtml = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '<i class="bs-card-loading-icon fa fa-spinner fa-spin fa-2x text-white"></i>';
	        this.$box.append('<div class="bs-card-loading-overlay">' + loadingHtml + '</div>');
	      }
	    }, {
	      key: "stopLoading",
	      value: function stopLoading() {
	        this.$box.find('.bs-card-loading-overlay').remove();
	      }
	    }, {
	      key: "closeFast",
	      value: function closeFast() {
	        var ev = new $__default['default'].Event(Event$4.CLOSE);
	        this.$box.trigger(ev);
	        if (ev.isDefaultPrevented()) return;
	        this.$box.trigger(Event$4.CLOSED).remove();
	      }
	    }, {
	      key: "close",
	      value: function close() {
	        var ev = new $__default['default'].Event(Event$4.CLOSE);
	        this.$box.trigger(ev);
	        if (ev.isDefaultPrevented()) return;
	        var $box = this.$box;
	
	        var _closeComplete = function _closeComplete() {
	          if (this.hasClass('card-expand')) this.next('.card-expanded-placeholder').remove(); // remove the placeholder
	
	          this.trigger(Event$4.CLOSED).remove();
	        };
	
	        if (Util.isReducedMotion()) _closeComplete.call($box);else {
	          $box.addClass('fade').on('transitionend.close', function (e) {
	            if (e.target !== this) return; // because transitionend might fire for children elements (like animated toolbar buttons)
	
	            _closeComplete.call($box);
	
	            $box.off('transitionend.close');
	          });
	        }
	      }
	    }, {
	      key: "toggle",
	      value: function toggle(type) {
	        var $box = this.$box;
	        var $body = $box.find('.card-body').eq(0);
	        var action = type && typeof type === 'string' && type.match(/show|hide/)[0] || ($body.is(':visible') ? 'hide' : 'show');
	        var eventName = action === 'hide' ? 'hide' : 'show';
	        var ev = new $__default['default'].Event(eventName + EVENT_KEY$4);
	        this.$box.trigger(ev);
	        if (ev.isDefaultPrevented()) return;
	
	        this._toggleIcon(type && _typeof(type) === 'object' && type instanceof window.HTMLElement ? type : null, action); ///
	
	
	        if (action === 'hide') $body.addClass('show'); // .show class required for bs collapse plugin
	
	        var eventCompleteName = action === 'hide' ? 'hidden' : 'shown';
	        $body.collapse(action).one(eventCompleteName + '.bs.collapse', function () {
	          $box.trigger(eventCompleteName + EVENT_KEY$4);
	        });
	      }
	    }, {
	      key: "hide",
	      value: function hide() {
	        this.toggle('hide');
	      }
	    }, {
	      key: "show",
	      value: function show() {
	        this.toggle('show');
	      }
	    }, {
	      key: "toggleFast",
	      value: function toggleFast(type) {
	        var $body = this.$box.find('.card-body').eq(0);
	        var action = type && typeof type === 'string' && type.match(/show|hide/)[0] || ($body.is(':visible') ? 'hide' : 'show');
	        var eventName = action === 'hide' ? 'hide' : 'show';
	        var ev = new $__default['default'].Event(eventName + EVENT_KEY$4);
	        this.$box.trigger(ev);
	        if (ev.isDefaultPrevented()) return;
	        $body.addClass('collapse');
	        if (action === 'hide') $body.removeClass('show');else $body.addClass('show');
	
	        this._toggleIcon(type && _typeof(type) === 'object' && type instanceof window.HTMLElement ? type : null, action);
	
	        var eventCompleteName = action === 'hide' ? 'hidden' : 'shown';
	        this.$box.trigger(eventCompleteName + EVENT_KEY$4);
	      }
	    }, {
	      key: "hideFast",
	      value: function hideFast() {
	        this.toggleFast('hide');
	      }
	    }, {
	      key: "showFast",
	      value: function showFast() {
	        this.toggleFast('show');
	      }
	    }, {
	      key: "_toggleIcon",
	      value: function _toggleIcon(button, action) {
	        if (!button) {
	          button = this.$box.find('a[data-action=toggle]').get(0);
	        } //
	
	
	        if (button) {
	          if (action === 'show') {
	            button.classList.remove('collapsed');
	          } else {
	            button.classList.add('collapsed');
	          }
	        }
	      } // fullscreen
	
	    }, {
	      key: "expand",
	      value: function expand(_expand, animate) {
	        var button = this.$box.find('> .card-header a[data-action=expand]');
	        var $expand = _expand === true || !this.$box.hasClass('card-expand');
	        animate = !(animate === false || Util.isReducedMotion()); // default is true
	
	        var $box = this.$box;
	        var box = $box[0];
	
	        if ($expand) {
	          var ev = new $__default['default'].Event(Event$4.EXPAND);
	          this.$box.trigger(ev);
	          if (ev.isDefaultPrevented()) return;
	          button.addClass('active');
	
	          if (animate) {
	            var rect = box.getBoundingClientRect();
	            box.setAttribute('style', "left: ".concat(rect.left, "px; top: ").concat(rect.top, "px; width: ").concat(rect.width, "px; height: ").concat(rect.height, "px;"));
	            box.classList.add('card-expanding');
	            $box.on('transitionend.expanding', function (e) {
	              if (e.target !== this) return; // because transitionend might fire for children elements (like animated icons of toolbar)
	
	              $box.off('transitionend.expanding').removeClass('card-expanding').trigger(Event$4.EXPANDED);
	            });
	            var placeholder = document.createElement('DIV');
	            placeholder.classList.add('card-expanded-placeholder');
	            placeholder.setAttribute('style', "width: ".concat(rect.width, "px; height: ").concat(rect.height, "px;"));
	            box.parentNode.insertBefore(placeholder, box.nextSibling); // insert after
	
	            box.offsetHeight; // reflow...to force browser apply css/dom changes
	
	            box.removeAttribute('style');
	          }
	
	          box.classList.add('card-expand');
	          if (!animate) $box.trigger(Event$4.EXPANDED);
	        } else {
	          // restore
	          var _ev = new $__default['default'].Event(Event$4.RESTORE);
	
	          this.$box.trigger(_ev);
	          if (_ev.isDefaultPrevented()) return;
	          button.removeClass('active');
	          animate = animate && box.nextElementSibling !== null && box.nextElementSibling.classList.contains('card-expanded-placeholder');
	
	          if (animate) {
	            var rect1 = box.nextElementSibling.getBoundingClientRect();
	            box.classList.add('card-expanding');
	            box.setAttribute('style', "left: ".concat(rect1.left, "px; top: ").concat(rect1.top, "px; width: ").concat(rect1.width, "px; height: ").concat(rect1.height, "px;"));
	            $box.on('transitionend.restoring', function (e) {
	              if (e.target !== this) return; // because transitionend might fire for children elements (like animated icons of toolbar)
	
	              $box.next().remove();
	              $box.off('transitionend.restoring').removeClass('card-expanding').attr('style', '').trigger(Event$4.RESTORED);
	            });
	          }
	
	          box.classList.remove('card-expand');
	          if (!animate) $box.trigger(Event$4.RESTORED);
	        }
	      } // function expand
	
	    }, {
	      key: "expandFast",
	      value: function expandFast() {
	        return this.expand(true, false);
	      }
	    }, {
	      key: "restore",
	      value: function restore() {
	        return this.expand(false);
	      }
	    }, {
	      key: "restoreFast",
	      value: function restoreFast() {
	        return this.expand(false, false);
	      }
	    }, {
	      key: "_getConfig",
	      value: function _getConfig(config) {
	        config = _objectSpread2({}, _typeof(config) === 'object' && config ? config : {});
	
	        if (typeof bootstrap__default['default'] !== 'undefined') {
	          bootstrap__default['default'].Util.typeCheckConfig(NAME$4, config, this.constructor.DefaultType);
	        }
	
	        return config;
	      } // Static methods
	
	    }], [{
	      key: "_jQueryInterface",
	      value: function _jQueryInterface(config, value) {
	        return this.each(function () {
	          var $this = $__default['default'](this);
	          var data = $this.data(DATA_KEY$4);
	
	          var _config = _objectSpread2(_objectSpread2({}, $this.data()), _typeof(config) === 'object' && config ? config : {});
	
	          if (!data) {
	            data = new Widget(this, _config);
	            $this.data(DATA_KEY$4, data);
	          }
	
	          if (typeof config === 'string') {
	            if (typeof data[config] === 'undefined') {
	              throw new TypeError("No method named \"".concat(config, "\""));
	            }
	
	            data[config](value);
	          }
	        });
	      }
	    }, {
	      key: "VERSION",
	      get: function get() {
	        return VERSION$4;
	      }
	    }]);
	
	    return Widget;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	  */
	
	
	  $__default['default'](document).on(Event$4.CLICK_DATA_API, "".concat(Selector$2.DATA_ACTION), function (event) {
	    if (event.currentTarget.tagName === 'A') {
	      event.preventDefault();
	    }
	
	    var $actionBtn = $__default['default'](this);
	    var $box = $actionBtn.closest('.card');
	    if ($box.length === 0) return;
	    var $action = $actionBtn.data('action');
	    $box.trigger(event = $__default['default'].Event($action + EVENT_KEY$4));
	    if (event.isDefaultPrevented()) return;
	    $box.aceWidget($action, this);
	  });
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	  */
	
	  if (typeof $__default['default'] !== 'undefined') {
	    var JQUERY_NO_CONFLICT$4 = $__default['default'].fn[NAME$4];
	    $__default['default'].fn[NAME$4] = Widget._jQueryInterface;
	    $__default['default'].fn[NAME$4].Constructor = Widget;
	
	    $__default['default'].fn[NAME$4].noConflict = function () {
	      $__default['default'].fn[NAME$4] = JQUERY_NO_CONFLICT$4;
	      return Widget._jQueryInterface;
	    };
	  }
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	  */
	
	  var NAME$5 = 'aceFileInput';
	  var VERSION$5 = '3.1.1';
	  var DATA_KEY$5 = 'ace.file';
	  var EVENT_KEY$5 = ".".concat(DATA_KEY$5);
	  var Event$5 = {
	    // PREVIEW: `preview${EVENT_KEY}`,
	    INVALID: "invalid".concat(EVENT_KEY$5),
	    RESET: "reset".concat(EVENT_KEY$5),
	    PREVIEW_FAILED: "preview_failed".concat(EVENT_KEY$5)
	  };
	  var Default$4 = {
	    style: false,
	    persistent: false,
	    container: 'border-1 brc-grey-l2 brc-h-warning-m1',
	    btnChooseClass: 'bgc-default text-white px-2 pt-2 text-90 my-1px mr-1px',
	    btnChangeClass: 'bgc-blue text-white px-2 pt-2 text-90 my-1px mr-1px',
	    btnChooseText: 'Choose',
	    btnChangeText: 'Change',
	    placeholderClass: 'text-grey-m2 px-1',
	    placeholderText: 'No file chosen',
	    placeholderIcon: '<i class="fa fa-upload bgc-grey-m1 text-white w-4 py-2 text-center"></i>',
	    iconClass: 'mx-2px',
	    reset: '',
	    resetText: '',
	    resetIcon: '<i class="fa fa-times"></i>',
	    droppable: false,
	    thumbnail: false,
	    // large, fit, small
	    previewImage: true,
	    allowExt: null,
	    denyExt: null,
	    allowMime: null,
	    denyMime: null,
	    maxSize: null,
	    previewSize: false,
	    previewWidth: false,
	    previewHeight: false,
	    // callbacks
	    beforeChange: null,
	    fileIcons: {
	      file: '<i class="fa fa-file bgc-grey-m1 text-white w-4 py-2 text-center"></i>',
	      image: '<i class="far fa-image bgc-purple-m1 text-white w-4 py-2 text-center"></i>',
	      video: '<i class="fas fa-video bgc-success-m1 text-white w-4 py-2 text-center"></i>',
	      audio: '<i class="fas fa-music bgc-pink-m1 text-white w-4 py-2 text-center"></i>',
	      document: '<i class="far fa-file-alt bgc-default-d1 text-white w-4 py-2 text-center"></i>',
	      archive: '<i class="far fa-file-archive bgc-warning text-white w-4 py-2 text-center"></i>',
	      code: '<i class="fas fa-code file-code bgc-secondary text-white w-4 py-2 text-center"></i>'
	    }
	  };
	  var DefaultType$4 = {
	    persistent: 'boolean',
	    style: '(boolean|string)',
	    btn: '(string|undefined)',
	    container: '(string|undefined)',
	    icon: '(string|undefined)',
	    placeholderText: '(string|undefined)',
	    placeholderIcon: '(string|undefined)',
	    btnChooseText: '(string|undefined)',
	    btnChangeText: '(string|undefined)',
	    reset: '(string|undefined)',
	    resetText: '(string|undefined)',
	    resetIcon: '(string|undefined)',
	    droppable: 'boolean',
	    thumbnail: '(boolean|string)',
	    previewImage: 'boolean',
	    allowExt: '(string|null)',
	    denyExt: '(string|null)',
	    allowMime: '(string|null)',
	    denyMime: '(string|null)',
	    maxSize: '(number|null)',
	    previewSize: '(boolean|number)',
	    previewWidth: '(boolean|number)',
	    previewHeight: '(boolean|number)',
	    fileIcons: '(object|null)',
	    // callbacks
	    beforeChange: '(function|null)'
	  };
	  var PreviewError = {
	    FILE_LOAD_FAILED: 1,
	    IMAGE_LOAD_FAILED: 2,
	    THUMBNAIL_FAILED: 3
	  };
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var FileInput = /*#__PURE__*/function () {
	    function FileInput(element, config) {
	      var _this = this;
	
	      _classCallCheck(this, FileInput);
	
	      this.settings = this._getConfig(config);
	      this.settings.fileIcons = $__default['default'].extend({}, Default$4.fileIcons, this.settings.fileIcons);
	      this.fileList = [];
	      this.selectMethod = '';
	      this._hasMultiple = 'multiple' in document.createElement('INPUT');
	      this._hasFileList = 'FileList' in window; // file list enabled in modern browsers
	
	      this._hasFileReader = 'FileReader' in window;
	      this._hasFile = 'File' in window;
	      this.element = element;
	      this.$element = $__default['default'](element);
	      this.disabled = false;
	      this.canReset = true;
	      this._hasAcceptAttr = this.element.getAttribute('accept') !== null;
	      this.$element.off('change.aceInnerCall').on('change.aceInnerCall', function (e, aceInnerCall) {
	        if (_this.disabled) return;
	        if (aceInnerCall === true) return; // this change Event is called from within this class (_enableFileDrop) and extra checkings are taken care of there
	
	        return _this._handleOnChange();
	      });
	      var parentLabel = this.$element.closest('label').addClass('d-block');
	      var tagName = parentLabel.length === 0 ? 'label' : 'span'; // if not inside a "LABEL" tag, use "LABEL" tag, otherwise use "SPAN"
	
	      this.$element.wrap('<' + tagName + ' class="ace-file-input" />');
	      this.$wrap = this.$element.parent();
	
	      this._applySettings();
	    } // Getters
	
	
	    _createClass(FileInput, [{
	      key: "_getConfig",
	      value: function _getConfig(config, Default) {
	        config = _objectSpread2(_objectSpread2({}, Default), config);
	        bootstrap__default['default'].Util.typeCheckConfig(NAME$5, config, DefaultType$4);
	        return config;
	      }
	    }, {
	      key: "_applySettings",
	      value: function _applySettings() {
	        var _this2 = this;
	
	        this._isMulti = this.$element.attr('multiple') && this._hasMultiple;
	        this._isDropStyle = this.settings.style === 'drop';
	
	        if (this._isDropStyle) {
	          if (!this.settings.thumbnail) this.settings.thumbnail = 'small';
	          this.$wrap.addClass('ace-file-multiple');
	        } else {
	          this.$wrap.removeClass('ace-file-multiple');
	        }
	
	        this.$wrap.find('*:not(input[type=file])').remove(); // remove all except our input, good for when changing settings
	
	        var placeholder = "<div class=\"ace-file-placeholder h-100\">\n<span class=\"ace-file-icon align-self-center ".concat(this.settings.iconClass || '', "\">\n  ").concat(this.settings.placeholderIcon || '', "\n</span>\n<span class=\"ace-file-name ").concat(this.settings.placeholderClass || '', "\">\n  ").concat(this.settings.placeholderText, "\n</span>") + (!this._isDropStyle ? "<span class=\"ace-file-btn ml-auto ".concat(this.settings.btnChooseClass || '', "\">").concat(this.settings.btnChooseText, "</span>") : '') + '</div>';
	        this.$element.after("<div class=\"ace-file-container d-flex flex-column ".concat(this.settings.container || '', "\">").concat(placeholder, "</div>"));
	        this.$container = this.$element.next();
	
	        if (this.settings.reset !== false) {
	          var remove = this.settings.reset.length > 0 ? this.settings.reset : !this._isDropStyle ? 'position-rc text-danger mr-n25 w-3 radius-2 border-1 brc-h-danger-m4 text-center' : 'position-tr bgc-white text-danger mt-n25 mr-n25 w-4 h-4 text-center pt-2px radius-round border-2 brc-grey-m4 brc-h-danger-m3';
	          var btn = $__default['default']("<a title=\"".concat(this.settings.resetText || '', "\" class=\"remove ").concat(remove, "\" href=\"#\">").concat(this.settings.resetIcon, "</a>")).appendTo(this.$wrap);
	          if (this.settings.resetText) btn.tooltip({
	            container: 'body'
	          });
	          btn.on('click', function (e) {
	            e.preventDefault();
	            if (!_this2.canReset) return false;
	            var event;
	
	            _this2.$element.trigger(event = new $__default['default'].Event(Event$5.RESET));
	
	            if (event.isDefaultPrevented()) return false;
	
	            _this2.resetInput();
	
	            _this2.stopLoading();
	
	            return false;
	          });
	        }
	
	        if (this.settings.droppable && this._hasFileList) {
	          this._enableFileDrop();
	        } // set 'accept' attribute if not set
	
	
	        if (!this._hasAcceptAttr) {
	          this._setAcceptAttr(this.settings.allowExt, this.settings.allowMime);
	        }
	      }
	    }, {
	      key: "showFileList",
	      value: function showFileList($files, innerCall) {
	        var _this3 = this;
	
	        var files = $files || this.fileList;
	        if (!files || !files.length) return; /// ///////////////////////////////////////////////////////////////
	
	        if (!this.settings.persistent) {
	          this.resetInputUI();
	        }
	
	        this.$container.addClass('selected');
	        this.$container.find('.ace-file-placeholder').addClass('d-none');
	
	        var _loop = function _loop(i) {
	          var filename = '';
	          var format = false;
	          if (typeof files[i] === 'string') filename = files[i];else if (_this3._hasFile && files[i] instanceof window.File) filename = $__default['default'].trim(files[i].name);else if (files[i] instanceof Object && Object.prototype.hasOwnProperty.call(files[i], 'name')) {
	            // format & name specified by user (pre-displaying name, etc)
	            filename = files[i].name;
	            if (Object.prototype.hasOwnProperty.call(files[i], 'type')) format = files[i].type;
	            if (!Object.prototype.hasOwnProperty.call(files[i], 'path')) files[i].path = files[i].name;
	          } else return "continue";
	          var index = filename.lastIndexOf('\\') + 1;
	          if (index === 0) index = filename.lastIndexOf('/') + 1;
	          filename = filename.substr(index);
	
	          if (!format) {
	            if (/\.(jpe?g|png|gif|svg|bmp|tiff?|webp)$/i.test(filename)) {
	              format = 'image';
	            } else if (/\.(mpe?g|flv|mov|avi|swf|mp4|mkv|webm|wmv|3gp)$/i.test(filename)) {
	              format = 'video';
	            } else if (/\.(mp3|ogg|wav|wma|amr|aac)$/i.test(filename)) {
	              format = 'audio';
	            } else if (/\.(pdf|docx?|rtf|txt)$/i.test(filename)) {
	              format = 'document';
	            } else if (/\.(zip|rar|tar)$/i.test(filename)) {
	              format = 'archive';
	            } else if (/\.(html?|js|s?css|less|php|py|aspx?|rb|c|cpp|java|cs)$/i.test(filename)) {
	              format = 'code';
	            } else format = 'file';
	          }
	
	          var fileIcon = _this3.settings.fileIcons[format];
	          var className = 'ace-file-item d-flex h-100';
	          if (_this3.settings.thumbnail) className += " ".concat(_this3.settings.thumbnail !== 'small' ? 'flex-column my-2px py-2' : 'mx-1 py-1', " align-items-center");
	          var label = $__default['default']("<div class=\"".concat(className, "\">\n<span class=\"ace-file-icon align-self-center ").concat(_this3.settings.iconClass || '', "\">").concat(fileIcon, "</span>\n<span class=\"ace-file-name ").concat(_this3.settings.thumbnail && _this3.settings.thumbnail !== 'small' ? 'px-2' : 'px-1', "\">").concat(filename, "</span>") + (!_this3._isDropStyle ? "<span class=\"ace-file-btn ml-auto ".concat(_this3.settings.btnChangeClass || '', "\">").concat(_this3.settings.btnChangeText, "</span>") : '') + '</div>').appendTo(_this3.$container);
	          var type = innerCall === true && _this3._hasFile && files[i] instanceof window.File ? $__default['default'].trim(files[i].type) : '';
	          var canPreview = _this3.settings.previewImage !== false && _this3._hasFileReader && _this3.settings.thumbnail && (type.length > 0 && type.match('image') || type.length === 0 && format === 'image'); // the second one is for older Android's default browser which gives an empty text for file.type
	
	          if (canPreview) {
	            $__default['default'].when(_this3._previewImage(files[i], label)) // .done( ()  => {
	            // if( this.settings.thumbnail === 'small' ) label.find('.ace-file-icon').addClass('thumbnail-img');
	            // })
	            .fail(function (result) {
	              _this3.$element.trigger(Event$5.PREVIEW_FAILED, {
	                filename: filename,
	                code: result.code
	              });
	            });
	          }
	        };
	
	        for (var i = 0; i < files.length; i++) {
	          var _ret = _loop(i);
	
	          if (_ret === "continue") continue;
	        }
	      }
	    }, {
	      key: "resetInput",
	      value: function resetInput() {
	        this.resetInputUI();
	        this.resetInputField();
	        this.resetInputData();
	        this.$container.removeClass('selected');
	      }
	    }, {
	      key: "resetInputUI",
	      value: function resetInputUI() {
	        this.$container.find('div:not(.ace-file-placeholder)').remove();
	        this.$container.find('.ace-file-placeholder').removeClass('d-none'); // this.resetInputData();
	      }
	    }, {
	      key: "resetInputField",
	      value: function resetInputField() {
	        // http://stackoverflow.com/questions/1043957/clearing-input-type-file-using-jquery/13351234#13351234
	        this.$element.wrap('<form>').parent().each(function (index, formEl) {
	          formEl.reset();
	        });
	        this.$element.unwrap(); // when reset is called on this temporary inner form
	        // only **IE10** triggers 'reset' on the outer form as well
	        // and as we have mentioned to reset input on outer form reset
	        // it causes infinite recusrsion by coming back to resetInputField
	        // thus calling reset again and again and again
	        // so because when "reset" button of outer form is hit, file input is automatically reset
	        // we just resetInputUI to avoid recursion
	      }
	    }, {
	      key: "resetInputData",
	      value: function resetInputData() {
	        this.fileList = [];
	        this.selectMethod = '';
	
	        if (this.$element.data('ace_input_files')) {
	          this.$element.removeData('ace_input_files');
	          this.$element.removeData('ace_input_method');
	        }
	      }
	    }, {
	      key: "enableReset",
	      value: function enableReset() {
	        this.canReset = true;
	      }
	    }, {
	      key: "disableReset",
	      value: function disableReset() {
	        this.canReset = false;
	      }
	    }, {
	      key: "disable",
	      value: function disable() {
	        this.disabled = true;
	        this.$element.attr('disabled', 'disabled').addClass('disabled');
	      }
	    }, {
	      key: "enable",
	      value: function enable() {
	        this.disabled = false;
	        this.$element.removeAttr('disabled').removeClass('disabled');
	      }
	    }, {
	      key: "files",
	      value: function files() {
	        return this.fileList.length > 0 ? this.fileList : null;
	      }
	    }, {
	      key: "method",
	      value: function method() {
	        return this.selectMethod;
	      }
	    }, {
	      key: "updateSettings",
	      value: function updateSettings(newSettings) {
	        this.settings = $__default['default'].extend({}, this.settings, newSettings);
	
	        this._applySettings();
	      }
	    }, {
	      key: "startLoading",
	      value: function startLoading() {
	        var loadingHtml = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '<i class="overlay-content fa fa-spin fa-spinner text-white fa-2x"></i>';
	        var loader = this.$wrap.find('.ace-file-overlay');
	
	        if (loader.length === 0) {
	          loader = $__default['default']('<div class="ace-file-overlay text-center"></div>').appendTo(this.$wrap);
	          loader.on('click', function (e) {
	            e.stopImmediatePropagation();
	            e.preventDefault();
	            return false;
	          });
	          this.element.setAttribute('readonly', 'true'); // for IE
	        }
	
	        loader.empty().append(loadingHtml);
	      }
	    }, {
	      key: "stopLoading",
	      value: function stopLoading() {
	        this.$wrap.find('.ace-file-overlay').remove();
	        this.element.removeAttribute('readonly');
	      }
	    }, {
	      key: "_enableFileDrop",
	      value: function _enableFileDrop() {
	        var _this4 = this;
	
	        var dropbox = this.$element.parent();
	        dropbox.off('dragenter').on('dragenter', function (e) {
	          e.preventDefault();
	          e.stopPropagation();
	        }).off('dragover').on('dragover', function (e) {
	          e.preventDefault();
	          e.stopPropagation();
	        }).off('drop').on('drop', function (e) {
	          e.preventDefault();
	          e.stopPropagation();
	          if (_this4.disabled) return;
	          var dt = e.originalEvent.dataTransfer;
	          var tmpFileList = dt.files;
	
	          if (!_this4._isMulti && tmpFileList.length > 1) {
	            // single file upload, but dragged multiple files
	            var tmpfiles = [];
	            tmpfiles.push(tmpFileList[0]);
	            tmpFileList = tmpfiles; // keep only first file
	          }
	
	          tmpFileList = _this4._processFiles(tmpFileList, true); // true means files have been dropped
	
	          if (tmpFileList === false) return false;
	
	          _this4.$element.data('ace_input_method', 'drop');
	
	          _this4.selectMethod = 'drop'; // const fileArray = [...tmpFileList]
	
	          var fileArray = [];
	
	          for (var f = 0; f < tmpFileList.length; f++) {
	            fileArray.push(tmpFileList[f]);
	          }
	
	          if (_this4.settings.persistent) {
	            _this4.fileList = _this4.fileList.concat(fileArray);
	          } else {
	            _this4.fileList = fileArray;
	          }
	
	          _this4.$element.data('ace_input_files', _this4.fileList);
	
	          _this4.$element.data('ace_input_method', _this4.selectMethod);
	
	          _this4.showFileList(fileArray, true);
	
	          _this4.$element.triggerHandler('change', [true]); // true means aceInnerCall
	
	
	          return true;
	        });
	      } /// ///////////
	
	    }, {
	      key: "_handleOnChange",
	      value: function _handleOnChange() {
	        var tmpFileList = this.element.files || [this.element.value]; // make it an array
	
	        tmpFileList = this._processFiles(tmpFileList, false); // false means files have been selected, not dropped
	
	        if (tmpFileList === false) return false; // const fileArray = [...tmpFileList];
	
	        var fileArray = [];
	
	        for (var f = 0; f < tmpFileList.length; f++) {
	          fileArray.push(tmpFileList[f]);
	        }
	
	        this.selectMethod = 'select';
	
	        if (this.settings.persistent) {
	          this.fileList = this.fileList.concat(fileArray);
	        } else {
	          this.fileList = fileArray;
	        }
	
	        this.$element.data('ace_input_files', this.fileList);
	        this.$element.data('ace_input_method', this.selectMethod);
	        this.showFileList(fileArray, true);
	        return true;
	      }
	    }, {
	      key: "_previewImage",
	      value: function _previewImage(file, label) {
	        var $icon = label.find('.ace-file-icon'); // it should be out of onload, otherwise all onloads may target the same $icon because of delays
	
	        $icon.empty();
	        var deferred = new $__default['default'].Deferred();
	
	        var getImage = function getImage(src, $file) {
	          $icon.prepend("<img style='display: none;' />");
	          var img = $icon.find('img:last').get(0);
	          $__default['default'](img).one('load', function () {
	            imgLoaded(img, $file);
	          }).one('error', function () {
	            imgFailed();
	          });
	          img.src = src;
	        };
	
	        var This = this;
	
	        var imgLoaded = function imgLoaded(img, $file) {
	          // if image loaded successfully
	          var size = This.settings.previewSize;
	
	          if (!size) {
	            if (This.settings.previewWidth || This.settings.previewHeight) {
	              size = {
	                previewWidth: This.settings.previewWidth,
	                previewHeight: This.settings.previewHeight
	              };
	            } else {
	              size = 50;
	              if (This.settings.thumbnail === 'large') size = 150;
	            }
	          }
	
	          if (This.settings.thumbnail === 'fit') size = $icon.parent().width();else if (typeof size === 'number') size = parseInt(Math.min(size, $icon.parent().width()));
	          var svg = /svg/.test($file.type);
	          var thumb = !svg ? This._getThumbnail(img, size, $file.type) : false; //, file.type;
	
	          if (thumb === null) {
	            // if making thumbnail fails
	            $__default['default'](This).remove();
	            deferred.reject({
	              code: PreviewError.THUMBNAIL_FAILED
	            });
	            return;
	          }
	          /**
	          // add width/height info to "file" and trigger preview finished event for each image!
	          if ($file && $file instanceof window.File) {
	            if (thumb) {
	              $file.width = thumb.width
	              $file.height = thumb.height
	            }
	              var event
	            This.$element.trigger(event = new $.Event(Event.PREVIEW), { file: $file })
	            if (event.isDefaultPrevented()) showPreview = false
	          }
	          */
	
	          {
	            if (svg) {
	              if (This.settings.thumbnail === 'small') {
	                $__default['default'](img).css({
	                  width: size
	                });
	              } else {
	                if (img.width > img.height) {
	                  $__default['default'](img).css({
	                    width: size
	                  });
	                } else $__default['default'](img).css({
	                  height: size
	                });
	              }
	            } else {
	              var w = thumb.previewWidth;
	              var h = thumb.previewHeight;
	
	              if (This.settings.thumbnail === 'small') {
	                w = h = parseInt(Math.max(w, h));
	              } else $icon.addClass('thumbnail-large');
	
	              $__default['default'](img).css({
	                background: 'url(' + thumb.src + ') center no-repeat',
	                width: w,
	                height: h
	              }).data('src', thumb.src).attr({
	                src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg=='
	              });
	            }
	
	            img.style.display = '';
	          } /// ////////////////
	
	
	          deferred.resolve();
	        };
	
	        var imgFailed = function imgFailed() {
	          // for example when a file has image extenstion, but format is something else
	          $icon.find('img').remove();
	          deferred.reject({
	            code: PreviewError.IMAGE_LOAD_FAILED
	          });
	        };
	
	        if (this._hasFile && file instanceof window.File) {
	          var reader = new window.FileReader();
	
	          reader.onload = function (e) {
	            getImage(e.target.result, file);
	          };
	
	          reader.onerror = function (e) {
	            deferred.reject({
	              code: PreviewError.FILE_LOAD_FAILED
	            });
	          };
	
	          reader.readAsDataURL(file);
	        } else {
	          if (file instanceof Object && Object.prototype.hasOwnProperty.call(file, 'path')) {
	            getImage(file.path, file); // file is a file name (path) --- this is used to pre-show user-selected image
	          }
	        }
	
	        return deferred.promise();
	      } /// //////////
	
	    }, {
	      key: "_getThumbnail",
	      value: function _getThumbnail(img, size, type) {
	        var imgWidth = img.width;
	        var imgHeight = img.height; //* *IE10** is not giving correct width using img.width so we use $(img).width()
	
	        imgWidth = imgWidth > 0 ? imgWidth : $__default['default'](img).width();
	        imgHeight = imgHeight > 0 ? imgHeight : $__default['default'](img).height();
	        var previewSize = false;
	        var previewHeight = false;
	        var previewWidth = false;
	        if (typeof size === 'number') previewSize = size;else if (size instanceof Object) {
	          if (size.previewWidth && !size.previewHeight) previewWidth = size.previewWidth;else if (size.previewHeight && !size.previewWidth) previewHeight = size.previewHeight;else if (size.previewWidth && size.previewHeight) {
	            previewWidth = size.previewWidth;
	            previewHeight = size.previewHeight;
	          }
	        }
	
	        if (previewSize) {
	          if (imgWidth > imgHeight) {
	            previewWidth = previewSize;
	            previewHeight = parseInt(imgHeight / imgWidth * previewWidth);
	          } else {
	            previewHeight = previewSize;
	            previewWidth = parseInt(imgWidth / imgHeight * previewHeight);
	          }
	        } else {
	          if (!previewHeight && previewWidth) {
	            previewHeight = parseInt(imgHeight / imgWidth * previewWidth);
	          } else if (previewHeight && !previewWidth) {
	            previewWidth = parseInt(imgWidth / imgHeight * previewHeight);
	          }
	        }
	
	        var dataURL;
	
	        try {
	          var canvas = document.createElement('canvas');
	          canvas.width = previewWidth;
	          canvas.height = previewHeight;
	          var context = canvas.getContext('2d');
	          context.imageSmoothingQuality = 'medium';
	          context.drawImage(img, 0, 0, imgWidth, imgHeight, 0, 0, previewWidth, previewHeight);
	          dataURL = canvas.toDataURL(type, 0.8); // dataURL = canvas.toDataURL();
	        } catch (e) {
	          dataURL = null;
	        }
	
	        if (!dataURL) return null; // there was only one image that failed in firefox completely randomly! so let's double check things
	
	        if (!/^data:image\/(png|jpe?g|gif|svg);base64,[0-9A-Za-z+/=]+$/.test(dataURL)) dataURL = null;
	        if (!dataURL) return null;
	        return {
	          src: dataURL,
	          previewWidth: previewWidth,
	          previewHeight: previewHeight,
	          width: imgWidth,
	          height: imgHeight
	        };
	      }
	    }, {
	      key: "_processFiles",
	      value: function _processFiles(tmpFileList, dropped) {
	        var ret = this._checkFileList(tmpFileList, dropped);
	
	        if (ret === -1) {
	          this.resetInput();
	          return false;
	        }
	
	        if (!ret || ret.length === 0) {
	          if (!this.$element.data('ace_input_files')) this.resetInput(); // if nothing selected before, reset because of the newly unacceptable (ret=false||length=0) selection
	          // otherwise leave the previous selection intact?!!!
	
	          return false;
	        }
	
	        if (ret instanceof Array || this._hasFileList && ret instanceof window.FileList) tmpFileList = ret;
	        ret = true;
	        if (this.settings.beforeChange) ret = this.settings.beforeChange.call(this.element, tmpFileList, dropped);
	
	        if (ret === -1) {
	          this.resetInput();
	          return false;
	        }
	
	        if (!ret || ret.length === 0) {
	          if (!this.$element.data('ace_input_files')) this.resetInput();
	          return false;
	        } // inside beforeChange you can return a modified File Array as result
	
	
	        if (ret instanceof Array || this._hasFileList && ret instanceof window.FileList) tmpFileList = ret;
	        return tmpFileList;
	      } /// ///////
	
	    }, {
	      key: "_checkFileList",
	      value: function _checkFileList(files, dropped) {
	        var allowExt = this._getExtRegex(this.settings.allowExt);
	
	        var denyExt = this._getExtRegex(this.settings.denyExt);
	
	        var allowMime = this._getMimeRegex(this.settings.allowMime);
	
	        var denyMime = this._getMimeRegex(this.settings.denyMime);
	
	        var maxSize = this.settings.maxSize || false;
	        if (!(allowExt || denyExt || allowMime || denyMime || maxSize)) return true; // no checking required
	
	        var safeFiles = [];
	        var errorList = {}; // for (const file of files) {
	
	        for (var i = 0; i < files.length; i++) {
	          var file = files[i]; // file is either a string(file name) or a File object
	
	          var filename = !this._hasFile ? file : file.name;
	
	          if (allowExt && !allowExt.test(filename)) {
	            // extension not matching whitelist, so drop it
	            if (!('ext' in errorList)) errorList.ext = [];
	            errorList.ext.push(filename);
	            continue;
	          } else if (denyExt && denyExt.test(filename)) {
	            // extension is matching blacklist, so drop it
	            if (!('ext' in errorList)) errorList.ext = [];
	            errorList.ext.push(filename);
	            continue;
	          }
	
	          var type = void 0;
	
	          if (!this._hasFile) {
	            // in browsers that don't support FileReader API
	            safeFiles.push(file);
	            continue;
	          } else if ((type = $__default['default'].trim(file.type)).length > 0) {
	            // there is a mimetype for file so let's check against are rules
	            if (allowMime && !allowMime.test(type)) {
	              // mimeType is not matching whitelist, so drop it
	              if (!('mime' in errorList)) errorList.mime = [];
	              errorList.mime.push(filename);
	              continue;
	            } else if (denyMime && denyMime.test(type)) {
	              // mimeType is matching blacklist, so drop it
	              if (!('mime' in errorList)) errorList.mime = [];
	              errorList.mime.push(filename);
	              continue;
	            }
	          }
	
	          if (maxSize && file.size > maxSize) {
	            // file size is not acceptable
	            if (!('size' in errorList)) errorList.size = [];
	            errorList.size.push(filename);
	            continue;
	          }
	
	          safeFiles.push(file);
	        }
	
	        if (safeFiles.length === files.length) return files; // return original file list if all are valid
	        /// //////
	
	        var errorCount = {
	          ext: 0,
	          mime: 0,
	          size: 0
	        };
	        if ('ext' in errorList) errorCount.ext = errorList.ext.length;
	        if ('mime' in errorList) errorCount.mime = errorList.mime.length;
	        if ('size' in errorList) errorCount.size = errorList.size.length;
	        var event;
	        this.$element.trigger(event = new $__default['default'].Event(Event$5.INVALID), {
	          fileCount: files.length,
	          invalidCount: files.length - safeFiles.length,
	          errorList: errorList,
	          errorCount: errorCount,
	          dropped: dropped
	        });
	        if (event.isDefaultPrevented()) return -1; // it will reset input
	        /// ///////
	
	        return safeFiles; // return safeFiles
	      }
	    }, {
	      key: "_setAcceptAttr",
	      value: function _setAcceptAttr() {
	        var ext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        var mime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	        if (ext) {
	          if (Array.isArray(ext)) ext = ext.join(',.');else ext = ext.replace(/\|/g, ',.');
	          ext = '.' + ext;
	        }
	
	        if (mime) {
	          if (Array.isArray(mime)) mime = mime.join(','); // replace `/\w+` with `/*` ... for example, `image/\w+` becomes `image/*`
	          else mime = mime.replace(/\|/g, ',').replace(/\/\\w+/g, '/*');
	        }
	
	        var accept = (ext || '') + (ext && mime ? ',' : '') + (mime || '');
	        accept = accept.replace(/\s/g, '');
	        if (accept) this.element.setAttribute('accept', accept);
	      }
	    }, {
	      key: "_getExtRegex",
	      value: function _getExtRegex(ext) {
	        if (!ext) return null;
	        if (Array.isArray(ext)) ext = ext.join('|');
	        if (ext.length === 0) return null;
	        return new RegExp('\\.(?:' + ext + ')$', 'i');
	      }
	    }, {
	      key: "_getMimeRegex",
	      value: function _getMimeRegex(mime) {
	        if (!mime) return null;
	        if (Array.isArray(mime)) mime = mime.join('|');
	        if (mime.length === 0) return null; // replace `/*` with `/\w+` ... for example, `image/*` becomes `image/\w+`
	
	        return new RegExp('^(?:' + mime.replace(/\/\*/g, '/\\w+').replace(/\//g, '\\/') + ')$', 'i');
	      }
	    }], [{
	      key: "_jQueryInterface",
	      value: function _jQueryInterface(config, value) {
	        var retval;
	        var reteach = this.each(function () {
	          var matches = this.matches ? this.matches('input[type=file]') : this.msMatchesSelector ? this.msMatchesSelector('input[type=file]') : false;
	          if (!matches) return;
	          var $this = $__default['default'](this);
	          var data = $this.data(DATA_KEY$5);
	
	          var _config = _objectSpread2(_objectSpread2(_objectSpread2({}, Default$4), $this.data()), _typeof(config) === 'object' && config ? config : {});
	
	          if (!data) {
	            data = new FileInput(this, _config);
	            $this.data(DATA_KEY$5, data);
	          }
	
	          if (typeof config === 'string') {
	            if (typeof data[config] === 'undefined') {
	              throw new TypeError("No method named \"".concat(config, "\""));
	            }
	
	            retval = data[config](value);
	          }
	        });
	        return typeof retval !== 'undefined' ? retval : reteach;
	      }
	    }, {
	      key: "VERSION",
	      get: function get() {
	        return VERSION$5;
	      }
	    }, {
	      key: "DefaultType",
	      get: function get() {
	        return DefaultType$4;
	      }
	    }]);
	
	    return FileInput;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	  */
	
	
	  if (typeof $__default['default'] !== 'undefined') {
	    var JQUERY_NO_CONFLICT$5 = $__default['default'].fn[NAME$5];
	    $__default['default'].fn[NAME$5] = FileInput._jQueryInterface;
	    $__default['default'].fn[NAME$5].Constructor = FileInput;
	
	    $__default['default'].fn[NAME$5].noConflict = function () {
	      $__default['default'].fn[NAME$5] = JQUERY_NO_CONFLICT$5;
	      return FileInput._jQueryInterface;
	    };
	  }
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$6 = 'aceWysiwyg';
	  var VERSION$6 = '3.1.1';
	  var DATA_KEY$6 = 'ace.wysiwyg';
	  var DefaultType$5 = {
	    wysiwyg: 'object',
	    colors: 'array',
	    // speech: 'boolean',
	    toolbar: 'array',
	    toolbarPlacement: '(function|null)',
	    toolbarStyle: '(string|number)'
	  };
	  var Default$5 = {
	    wysiwyg: {},
	    // speech: true,
	    toolbarPlacement: null,
	    toolbarStyle: '',
	    colors: ['#000000', '#424242', '#636363', '#9c9c94', '#cec6ce', '#efefef', '#f7f7f7', '#ffffff', '#ff0000', '#ff9c00', '#ffff00', '#00ff00', '#00ffff', '#0000ff', '#9c00ff', '#ff00ff', '#f7c6ce', '#ffe7ce', '#ffefc6', '#d6efd6', '#cedee7', '#cee7f7', '#d6d6e7', '#e7d6de', '#e79c9c', '#ffc69c', '#ffe79c', '#b5d6a5', '#a5c6ce', '#9cc6ef', '#b5a5d6', '#d6a5bd', '#e76363', '#f7ad6b', '#ffd663', '#94bd7b', '#73a5ad', '#6badde', '#8c7bc6', '#c67ba5', '#ce0000', '#e79439', '#efc631', '#6ba54a', '#4a7b8c', '#3984c6', '#634aa5', '#a54a7b', '#9c0000', '#b56308', '#bd9400', '#397b21', '#104a5a', '#085294', '#311873', '#731842', '#630000', '#7b3900', '#846300', '#295218', '#083139', '#003163', '#21104a', '#4a1031'],
	    toolbar: ['font', null, 'fontSize', null, 'bold', 'italic', 'strikethrough', 'underline', null, 'insertunorderedlist', 'insertorderedlist', 'outdent', 'indent', null, 'justifyleft', 'justifycenter', 'justifyright', 'justifyfull', null, 'createLink', 'unlink', null, 'insertImage', null, 'foreColor', null, 'undo', 'redo', null, 'viewSource']
	  };
	
	  var Wysiwyg = /*#__PURE__*/function () {
	    function Wysiwyg(element, config) {
	      _classCallCheck(this, Wysiwyg);
	
	      this._element = element;
	      this._config = this._getConfig(config);
	      this.initEditor();
	    }
	
	    _createClass(Wysiwyg, [{
	      key: "initEditor",
	      value: function initEditor() {
	        var toolbarHtml = this._createToolbarHtml();
	
	        var toolbar; // if we have a function to decide where to put the toolbar, then call that
	
	        if (this._config.toolbarPlacement) toolbar = this._config.toolbarPlacement.call(this._element, toolbarHtml);else toolbar = $__default['default'](this._element).before(toolbarHtml).prev(); // otherwise put it just before our DIV
	
	        if (this._config.toolbarStyle) toolbar.addClass('bsw-toolbar-style-' + this._config.toolbarStyle); // enable tooltips
	
	        if ($__default['default'].fn.tooltip) toolbar.find('a[title]').tooltip({
	          animation: false,
	          container: 'body'
	        });
	        toolbar.find('.dropdown-menu input[type=text]').on('click', function () {
	          return false;
	        }).on('change', function () {
	          $__default['default'](this).closest('.dropdown-menu').siblings('.dropdown-toggle').dropdown('toggle');
	        }).on('keydown', function (e) {
	          if (e.which === 27) {
	            this.value = '';
	            $__default['default'](this).change();
	          } else if (e.which === 13) {
	            e.preventDefault();
	            e.stopPropagation();
	            $__default['default'](this).change();
	          }
	        });
	        toolbar.find('input[type=file]').prev().on('click', function (e) {
	          $__default['default'](this).next().click();
	        });
	        var self = $__default['default'](this._element); // view source
	
	        var viewSource = false;
	        toolbar.find('a[data-toggle=source]').on('click', function (e) {
	          e.preventDefault();
	
	          if (!viewSource) {
	            $__default['default']('<textarea />').css({
	              width: self.outerWidth(),
	              height: self.outerHeight()
	            }).val(self.html()).insertAfter(self);
	            self.addClass('d-none');
	            $__default['default'](this).addClass('active');
	          } else {
	            var textarea = self.next();
	            self.html(textarea.val()).removeClass('d-none');
	            textarea.remove();
	            $__default['default'](this).removeClass('active');
	          }
	
	          viewSource = !viewSource;
	        }); // initiate wysiwyg plugin
	
	        var $options = $__default['default'].extend({}, {
	          activeToolbarClass: 'active',
	          toolbarSelector: toolbar
	        }, this._config.wysiwyg || {});
	        $__default['default'](this._element).wysiwyg($options);
	
	        this._handleImages();
	      }
	    }, {
	      key: "_createToolbarHtml",
	      value: function _createToolbarHtml() {
	        var _buttonDefaults = {
	          font: {
	            values: ['Arial', 'Courier', 'Comic Sans MS', 'Helvetica', 'Open Sans', 'Tahoma', 'Verdana'],
	            icon: 'fa fa-font text-secondary',
	            title: 'Font'
	          },
	          fontSize: {
	            values: {
	              5: 'Huge',
	              3: 'Normal',
	              1: 'Small'
	            },
	            icon: 'fa fa-text-height text-secondary',
	            title: 'Font Size'
	          },
	          bold: {
	            icon: 'fa fa-bold text-secondary',
	            title: 'Bold (Ctrl/Cmd+B)'
	          },
	          italic: {
	            icon: 'fa fa-italic text-secondary',
	            title: 'Italic (Ctrl/Cmd+I)'
	          },
	          strikethrough: {
	            icon: 'fa fa-strikethrough text-secondary',
	            title: 'Strikethrough'
	          },
	          underline: {
	            icon: 'fa fa-underline text-secondary',
	            title: 'Underline'
	          },
	          insertunorderedlist: {
	            icon: 'fa fa-list-ul text-secondary',
	            title: 'Bullet list'
	          },
	          insertorderedlist: {
	            icon: 'fa fa-list-ol text-secondary',
	            title: 'Number list'
	          },
	          outdent: {
	            icon: 'fa fa-outdent text-secondary',
	            title: 'Reduce indent (Shift+Tab)'
	          },
	          indent: {
	            icon: 'fa fa-indent text-secondary',
	            title: 'Indent (Tab)'
	          },
	          justifyleft: {
	            icon: 'fa fa-align-left text-secondary',
	            title: 'Align Left (Ctrl/Cmd+L)'
	          },
	          justifycenter: {
	            icon: 'fa fa-align-center text-secondary',
	            title: 'Center (Ctrl/Cmd+E)'
	          },
	          justifyright: {
	            icon: 'fa fa-align-right text-secondary',
	            title: 'Align Right (Ctrl/Cmd+R)'
	          },
	          justifyfull: {
	            icon: 'fa fa-align-justify text-secondary',
	            title: 'Justify (Ctrl/Cmd+J)'
	          },
	          createLink: {
	            icon: 'fa fa-link text-secondary',
	            title: 'Hyperlink',
	            button_text: 'Add',
	            placeholder: 'URL',
	            button_class: 'btn-light-primary'
	          },
	          unlink: {
	            icon: 'fa fa-unlink text-secondary',
	            title: 'Remove Hyperlink'
	          },
	          insertImage: {
	            icon: 'fa fa-image text-secondary',
	            title: 'Insert picture',
	            button_text: '<i class="far fa-file mr-1"></i> Choose an Image &hellip;',
	            placeholder: 'Remote Image URL',
	            button_insert: 'Insert',
	            button_class: 'btn-light-success',
	            button_insert_class: 'btn-light-primary',
	            choose_file: true // show the choose file button?
	
	          },
	          foreColor: {
	            icon: 'fas fa-eye-dropper text-pink-m1',
	            values: this._config.colors,
	            title: 'Foreground Color'
	          },
	          backColor: {
	            icon: 'fas fa-fill-drip text-secondary',
	            values: this._config.colors,
	            title: 'Background Color'
	          },
	          removeFormat: {
	            icon: 'fa fa-eraser text-secondary',
	            title: 'Remove Format'
	          },
	          undo: {
	            icon: 'fa fa-undo text-secondary',
	            title: 'Undo (Ctrl/Cmd+Z)'
	          },
	          redo: {
	            icon: 'fa fa-redo text-secondary',
	            title: 'Redo (Ctrl/Cmd+Y)'
	          },
	          viewSource: {
	            icon: 'fa fa-code text-secondary',
	            title: 'View Source'
	          }
	        };
	        var toolbarButtons = this._config.toolbar;
	        var toolbarHtml = ' <div class="bootstrap-wysiwyg-toolbar btn-toolbar text-center"> <div class="btn-group mb-2px"> ';
	
	        for (var tb in toolbarButtons) {
	          if (Object.prototype.hasOwnProperty.call(toolbarButtons, tb)) {
	            var button = toolbarButtons[tb];
	
	            if (button === null) {
	              toolbarHtml += ' </div> <div class="btn-group mb-2px"> ';
	              continue;
	            }
	
	            if (typeof button === 'string' && button in _buttonDefaults) {
	              button = _buttonDefaults[button];
	              button.name = toolbarButtons[tb];
	            } else if (_typeof(button) === 'object' && button.name in _buttonDefaults) {
	              button = $__default['default'].extend(_buttonDefaults[button.name], button);
	            } else continue;
	
	            var className = 'className' in button ? button.className : 'btn-sm btn-outline-secondary btn-h-light-dark btn-a-light-dark';
	
	            switch (button.name) {
	              case 'font':
	                toolbarHtml += " <a class=\"btn btn-sm ".concat(className, " dropdown-toggle\" data-toggle=\"dropdown\" title=\"").concat(button.title, "\"><i class=\"").concat(button.icon, "\">").concat(button.iconText || '', "</i><i class=\"fa fa-angle-down ml-1 text-secondary-m2\"></i></a> ");
	                toolbarHtml += ' <div class="dropdown-menu radius-1 brc-secondary-m4">';
	
	                for (var font in button.values) {
	                  if (Object.prototype.hasOwnProperty.call(button.values, font)) {
	                    toolbarHtml += " <div class=\"dropdown-item\"><a data-edit=\"fontName ".concat(button.values[font], "\" style=\"font-family:'").concat(button.values[font], "'\">").concat(button.values[font], "</a></div> ");
	                  }
	                }
	
	                toolbarHtml += ' </div>';
	                break;
	
	              case 'fontSize':
	                toolbarHtml += " <a class=\"btn btn-sm ".concat(className, " dropdown-toggle\" data-toggle=\"dropdown\" title=\"").concat(button.title, "\"><i class=\"").concat(button.icon, "\">").concat(button.iconText || '', "</i>&nbsp;<i class=\"fa fa-angle-down ml-1 text-secondary-m2\"></i></a> ");
	                toolbarHtml += ' <div class="dropdown-menu radius-1 brc-secondary-m4"> ';
	
	                for (var size in button.values) {
	                  if (Object.prototype.hasOwnProperty.call(button.values, size)) {
	                    toolbarHtml += " <div class=\"dropdown-item\"><a data-edit=\"fontSize ".concat(size, "\"><font size=\"").concat(size, "\">").concat(button.values[size], "</font></a></div> ");
	                  }
	                }
	
	                toolbarHtml += ' </div> ';
	                break;
	
	              case 'createLink':
	                toolbarHtml += " <div class=\"btn-group\"> <a class=\"btn btn-sm ".concat(className, " dropdown-toggle\" data-toggle=\"dropdown\" title=\"").concat(button.title, "\"><i class=\"").concat(button.icon, "\">").concat(button.iconText || '', "</i></a> ");
	                toolbarHtml += " <div class=\"dropdown-menu py-1 px-3 brc-default-m3 border-2 radius-1 shadow-sm\" style=\"min-width: 300px;\">\n\t\t\t\t\t\t <div class=\"input-group my-3\">\n\t\t\t\t\t\t\t<input class=\"form-control\" placeholder=\"".concat(button.placeholder, "\" type=\"text\" data-edit=\"").concat(button.name, "\" />\n\t\t\t\t\t\t\t<div class=\"input-group-append\">\n\t\t\t\t\t\t\t\t<button class=\"btn btn-sm ").concat(button.button_class, "\" type=\"button\">").concat(button.button_text, "</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t </div>\n\t\t\t\t\t</div> </div>");
	                break;
	
	              case 'insertImage':
	                toolbarHtml += " <div class=\"btn-group\"> <a class=\"btn btn-sm ".concat(className, " dropdown-toggle\" data-toggle=\"dropdown\" title=\"").concat(button.title, "\"><i class=\"").concat(button.icon, "\">").concat(button.iconText || '', "</i></a> ");
	                toolbarHtml += ' <div class="dropdown-menu p-3 brc-default-m3 border-2 radius-1 shadow-sm" style="min-width: 300px;">';
	
	                if (button.choose_file && 'FileReader' in window) {
	                  toolbarHtml += "<div class=\"text-secondary-d1\">Drag &amp; drop images into editor or</div>\n\t\t\t\t\t\t   <label class=\"text-center d-block mt-3 mb-0\">\n\t\t\t\t\t\t\t<button class=\"btn btn-sm ".concat(button.button_class, " wysiwyg-choose-file\" type=\"button\">").concat(button.button_text, "</button>\n\t\t\t\t\t\t\t<input type=\"file\" class=\"file-input-invisible\" data-edit=\"").concat(button.name, "\" />\n\t\t\t\t\t\t   </label><hr /> ");
	                }
	
	                toolbarHtml += "<div class=\"input-group my-3\">\n\t\t\t\t\t\t\t<input class=\"form-control\" placeholder=\"".concat(button.placeholder, "\" type=\"text\" data-edit=\"").concat(button.name, "\" />\n\t\t\t\t\t\t\t<div class=\"input-group-append\">\n\t\t\t\t\t\t\t\t<button class=\"btn btn-sm ").concat(button.button_insert_class, "\" type=\"button\">").concat(button.button_insert, "</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t </div>");
	                toolbarHtml += ' </div> </div>';
	                break;
	
	              case 'foreColor':
	              case 'backColor':
	                toolbarHtml += "<div class=\"mr-1px\"><a class=\"btn btn-sm ".concat(className, " dropdown-toggle\" data-toggle=\"dropdown\" title=\"").concat(button.title, "\"><i class=\"").concat(button.icon, "\">").concat(button.iconText || '', "</i></a> ");
	                toolbarHtml += ' <div class="dropdown-menu p-1 brc-secondary-m4 border-1 radius-1" style="min-width:auto;width:10.66rem;"><div class="d-flex flex-wrap">';
	
	                for (var color in button.values) {
	                  if (Object.prototype.hasOwnProperty.call(button.values, color)) {
	                    toolbarHtml += " <div class=\"dropdown-item m-0 p-0 d-inline-block w-auto\"><a class=\"p-0 dh-zoom-3\" role=\"button\" data-edit=\"".concat(button.name, " ").concat(button.values[color], "\" style=\"width:1.25rem;height:1.25rem;background-color:").concat(button.values[color], ";\"></a></div> ");
	                  }
	                }
	
	                toolbarHtml += ' </div></div></div>';
	                break;
	
	              case 'viewSource':
	                toolbarHtml += " <a class=\"btn btn-sm ".concat(className, "\" data-toggle=\"source\" title=\"").concat(button.title, "\"><i class=\"").concat(button.icon, "\">").concat(button.iconText || '', "</i></a> ");
	                break;
	
	              default:
	                toolbarHtml += " <a class=\"btn btn-sm ".concat(className, "\" data-edit=\"").concat(button.name, "\" title=\"").concat(button.title, "\"><i class=\"").concat(button.icon, "\">").concat(button.iconText || '', "</i></a> ");
	                break;
	            }
	          }
	        }
	
	        toolbarHtml += ' </div> '; // for .btn-group
	        // var speech_input;
	        // if (this._config.speech && 'onwebkitspeechchange' in (speech_input = document.createElement('input'))) {
	        // toolbarHtml += ' <input class="wysiwyg-speech-input" type="text" data-edit="inserttext" x-webkit-speech />';
	        // }
	        // speech_input = null;
	        /// /////////
	
	        toolbarHtml += ' </div> '; // for .btn-toolbar
	
	        return toolbarHtml;
	      }
	    }, {
	      key: "_handleImages",
	      value: function _handleImages() {
	        // option for resizing an image
	        var currentImg = null;
	        $__default['default'](this._element).on('click', 'img', function (ev) {
	          if (currentImg) $__default['default'](currentImg).popover('dispose');
	          currentImg = this;
	          if (!$__default['default'](currentImg).data('original-width')) $__default['default'](currentImg).data('original-width', currentImg.width);
	          $__default['default'](currentImg).popover({
	            container: 'body',
	            html: true,
	            placement: function placement(popover) {
	              var offset = currentImg.getBoundingClientRect();
	              var scrollTop = document.scrollTop || document.documentElement.scrollTop || document.body.scrollTop;
	              $__default['default'](popover).addClass('popover-wysiwyg-image shadow brc-secondary-m4').css({
	                'margin-left': offset.left + 4 + 'px',
	                'margin-top': offset.top + scrollTop + 4 + 'px'
	              });
	              return 'auto';
	            },
	            title: 'Image Size & Position',
	            trigger: 'manual',
	            content: function content() {
	              return $__default['default']("<div class='btn-group'>\n\t\t\t\t\t\t\t\t<button type='button' class='btn btn-xs btn-outline-default' data-action='resize' data-value='0.25'>25%</button>\n\t\t\t\t\t\t\t\t<button type='button' class='btn btn-xs btn-outline-default' data-action='resize' data-value='0.50'>50%</button>\n\t\t\t\t\t\t\t\t<button type='button' class='btn btn-xs btn-outline-default' data-action='resize' data-value='1'>100%</button>\n\t\t\t\t\t\t\t  </div>\n\t\t\t\t\t\t\t  <input type='number' class='form-control d-inline-block form-control-sm' data-action='resize' style='max-width: 96px;' placeholder='specify width' value='".concat(currentImg.width, "' />\n\t\t\t\t\t\t\t  <hr class='my-2' />\n\t\t\t\t\t\t\t  <div class='btn-group'>\n\t\t\t\t\t\t\t\t<button type='button' class='btn btn-xs btn-outline-secondary' data-action='align' data-value='left'>left</button>\n\t\t\t\t\t\t\t\t<button type='button' class='btn btn-xs btn-outline-secondary' data-action='align' data-value='right'>right</button>\n\t\t\t\t\t\t\t\t<button type='button' class='btn btn-xs btn-outline-secondary' data-action='align' data-value='none'>none</button>\n\t\t\t\t\t\t\t </div>\n\t\t\t\t\t\t\t <div class='btn-group float-right'>\n\t\t\t\t\t\t\t\t<button type='button' tooltip='Remove image' class='btn btn-sm btn-danger border-2 radius-round' data-action='remove'><i class='fa fa-trash-alt text-red'></i></button>\n\t\t\t\t\t\t\t </div>"));
	            }
	          }).popover('show');
	          $__default['default'](document).on('click.popover-wysiwyg-image', function (ev) {
	            if (ev.target === currentImg) return;
	
	            if ($__default['default'](ev.target).closest('.popover-wysiwyg-image').length > 0) {
	              return;
	            }
	
	            if (currentImg) $__default['default'](currentImg).popover('hide');
	            currentImg = null;
	            $__default['default'](document).off('click.popover-wysiwyg-image');
	          });
	        });
	        $__default['default'](document).on('click', '.popover-wysiwyg-image button.btn', function () {
	          if (!currentImg) return;
	          var action = $__default['default'](this).data('action');
	          var value = $__default['default'](this).data('value');
	
	          if (action === 'resize') {
	            var width = parseInt($__default['default'](currentImg).data('original-width') * value);
	            $__default['default'](currentImg).css({
	              width: width
	            });
	            $__default['default']('.popover-wysiwyg-image input[type=number]').val(width);
	          }
	
	          if (action === 'align') $__default['default'](currentImg).attr('class', 'float-' + value);else if (action === 'remove') {
	            $__default['default'](currentImg).popover('dispose').remove(); // fadeOut(200, function() { $(this).remove() });
	
	            currentImg = null;
	          }
	        });
	        $__default['default'](document).on('change', '.popover-wysiwyg-image input[type=number]', function () {
	          if (currentImg) $__default['default'](currentImg).css({
	            width: $__default['default'](this).val() + 'px'
	          });
	        }); /// //////////////
	      }
	    }, {
	      key: "_getConfig",
	      value: function _getConfig(config) {
	        config = _objectSpread2(_objectSpread2({}, Default$5), _typeof(config) === 'object' && config ? config : {});
	
	        if (typeof bootstrap__default['default'] !== 'undefined') {
	          bootstrap__default['default'].Util.typeCheckConfig(NAME$6, config, this.constructor.DefaultType);
	        }
	
	        return config;
	      } // Static methods
	
	    }], [{
	      key: "_jQueryInterface",
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          var $this = $__default['default'](this);
	          var data = $this.data(DATA_KEY$6);
	
	          var _config = _objectSpread2(_objectSpread2(_objectSpread2({}, Default$5), $this.data()), _typeof(config) === 'object' && config ? config : {});
	
	          if (!data) {
	            data = new Wysiwyg(this, _config);
	            $this.data(DATA_KEY$6, data);
	          }
	
	          if (typeof config === 'string') {
	            if (typeof data[config] === 'undefined') {
	              throw new TypeError("No method named \"".concat(config, "\""));
	            }
	
	            data[config]();
	          }
	        });
	      }
	    }, {
	      key: "VERSION",
	      get: function get() {
	        return VERSION$6;
	      }
	    }, {
	      key: "DefaultType",
	      get: function get() {
	        return DefaultType$5;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$5;
	      }
	    }]);
	
	    return Wysiwyg;
	  }();
	
	  if (typeof $__default['default'] !== 'undefined') {
	    var JQUERY_NO_CONFLICT$6 = $__default['default'].fn[NAME$6];
	    $__default['default'].fn[NAME$6] = Wysiwyg._jQueryInterface;
	    $__default['default'].fn[NAME$6].Constructor = Wysiwyg;
	
	    $__default['default'].fn[NAME$6].noConflict = function () {
	      $__default['default'].fn[NAME$6] = JQUERY_NO_CONFLICT$6;
	      return Wysiwyg._jQueryInterface;
	    };
	  }
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME1 = 'aceTabScroll';
	  var NAME2 = 'aceTabLinkScroll';
	  var VERSION$7 = '3.1.1';
	  var DATA_KEY$7 = 'ace.tabscroll';
	  var EVENT_KEY$6 = ".".concat(DATA_KEY$7);
	  var DATA_API_KEY$3 = '.data-api';
	  var Event$6 = {
	    LOAD_DATA_API: "load".concat(EVENT_KEY$6).concat(DATA_API_KEY$3)
	  };
	  var Selector$3 = {
	    TAB_SCROLL: '.nav-tabs-scroll',
	    ACTIVE: '.active'
	  };
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definitions
	   * ------------------------------------------------------------------------
	   */
	
	  var NavTabScroller = /*#__PURE__*/function () {
	    function NavTabScroller(element) {
	      _classCallCheck(this, NavTabScroller);
	
	      this._element = element;
	      this._firefox = 'MozAppearance' in document.documentElement.style;
	
	      this._init();
	    }
	
	    _createClass(NavTabScroller, [{
	      key: "_init",
	      value: function _init() {
	        var _this = this;
	
	        // scroll to active element on page load
	        var active = this._element.querySelector(Selector$3.ACTIVE);
	
	        if (active) {
	          var navLinkScroll = new NavLinkScroller(active);
	
	          if (!this._firefox) {
	            navLinkScroll._scrollIntoView(false);
	          } else {
	            // still firefox doesn't scroll back to `zero` on page load!
	            setTimeout(function () {
	              _this._element.scrollLeft = 1;
	
	              navLinkScroll._scrollIntoView(false);
	            }, 500);
	          }
	        }
	
	        this.enable();
	      }
	    }, {
	      key: "enable",
	      value: function enable() {
	        if (!('closest' in document.documentElement)) return;
	
	        this._element.addEventListener('click', function (ev) {
	          var navLink = ev.target.closest('a');
	          if (!navLink) return;
	          var navLinkScroll = new NavLinkScroller(navLink);
	
	          navLinkScroll._scrollIntoView();
	        });
	      } // Static methods
	
	    }], [{
	      key: "_jQueryInterface",
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          var $this = $__default['default'](this);
	          var data = $this.data(DATA_KEY$7);
	
	          if (!data) {
	            data = new NavTabScroller(this);
	            $this.data(DATA_KEY$7, data);
	          }
	
	          if (typeof config === 'string') {
	            if (typeof data[config] === 'undefined') {
	              throw new TypeError("No method named \"".concat(config, "\""));
	            }
	
	            data[config]();
	          }
	        });
	      }
	    }, {
	      key: "VERSION",
	      get: function get() {
	        return VERSION$7;
	      }
	    }]);
	
	    return NavTabScroller;
	  }();
	
	  var NavLinkScroller = /*#__PURE__*/function () {
	    function NavLinkScroller(element) {
	      _classCallCheck(this, NavLinkScroller);
	
	      this._element = element;
	      this._firefox = 'MozAppearance' in document.documentElement.style;
	    }
	
	    _createClass(NavLinkScroller, [{
	      key: "_scrollIntoView",
	      // scroll tab button elements into view when clicked
	      value: function _scrollIntoView() {
	        var smooth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        var li = this._element.parentNode;
	        var nav = li.parentNode;
	        var navClientWidth = nav.clientWidth;
	        var navScrollWidth = nav.scrollWidth;
	        if (navScrollWidth <= navClientWidth) return; // don't scroll if not needed
	
	        var isRTL = Util.isRTL(); // scroll to this element (center it)
	
	        var _scrollLeft;
	
	        if (!isRTL) {
	          _scrollLeft = li.offsetLeft - (navClientWidth - li.clientWidth) / 2;
	        } else {
	          // firefox and webkit have different ways of dealing with scrolling right/left and offsets in RTL mode
	          if (!this._firefox) {
	            _scrollLeft = navScrollWidth - navClientWidth + li.offsetLeft - (navClientWidth - li.clientWidth) / 2;
	          } else {
	            _scrollLeft = li.offsetLeft - (navClientWidth - li.clientWidth) / 2;
	          }
	        }
	
	        _scrollLeft = _scrollLeft | 0; // convert FLOAT to INT
	
	        smooth = !Util.isReducedMotion() && smooth === true;
	
	        try {
	          nav.scrollTo({
	            top: 0,
	            left: _scrollLeft,
	            behavior: smooth ? 'smooth' : 'auto'
	          }); // firefox needs extra push when scrolling back
	
	          if (this._firefox && _scrollLeft < nav.scrollLeft) {
	            setTimeout(function () {
	              nav.scrollTo({
	                top: 0,
	                left: _scrollLeft,
	                behavior: smooth ? 'smooth' : 'auto'
	              });
	            }, 0);
	          }
	        } catch (e) {
	          nav.scrollLeft = _scrollLeft;
	        }
	      } // Static methods
	
	    }], [{
	      key: "_jQueryInterface",
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          var $this = $__default['default'](this);
	          var data = $this.data(DATA_KEY$7);
	
	          if (!data) {
	            data = new NavLinkScroller(this);
	            $this.data(DATA_KEY$7, data);
	
	            data._scrollIntoView();
	          }
	
	          if (typeof config === 'string') {
	            if (typeof data[config] === 'undefined') {
	              throw new TypeError("No method named \"".concat(config, "\""));
	            }
	
	            data[config]();
	          }
	        });
	      }
	    }, {
	      key: "VERSION",
	      get: function get() {
	        return VERSION$7;
	      }
	    }]);
	
	    return NavLinkScroller;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	  */
	
	
	  $__default['default'](window).on(Event$6.LOAD_DATA_API, function () {
	    var scrollableNavTabs = document.querySelectorAll(Selector$3.TAB_SCROLL);
	
	    for (var i = 0; i < scrollableNavTabs.length; i++) {
	      var $tabscroll = $__default['default'](scrollableNavTabs[i]);
	
	      NavTabScroller._jQueryInterface.call($tabscroll);
	    }
	  });
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	  */
	
	  if (typeof $__default['default'] !== 'undefined') {
	    var JQUERY_NO_CONFLICT1 = $__default['default'].fn[NAME1];
	    $__default['default'].fn[NAME1] = NavTabScroller._jQueryInterface;
	    $__default['default'].fn[NAME1].Constructor = NavTabScroller;
	
	    $__default['default'].fn[NAME1].noConflict = function () {
	      $__default['default'].fn[NAME1] = JQUERY_NO_CONFLICT1;
	      return NavTabScroller._jQueryInterface;
	    };
	
	    var JQUERY_NO_CONFLICT2 = $__default['default'].fn[NAME2];
	    $__default['default'].fn[NAME2] = NavLinkScroller._jQueryInterface;
	    $__default['default'].fn[NAME2].Constructor = NavLinkScroller;
	
	    $__default['default'].fn[NAME2].noConflict = function () {
	      $__default['default'].fn[NAME2] = JQUERY_NO_CONFLICT2;
	      return NavLinkScroller._jQueryInterface;
	    };
	  }
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$7 = 'aceTabSwipe';
	  var VERSION$8 = '3.1.1';
	  var DATA_KEY$8 = 'ace.tabswipe';
	  var EVENT_KEY$7 = ".".concat(DATA_KEY$8);
	  var DATA_API_KEY$4 = '.data-api';
	  var Event$7 = {
	    LOAD_DATA_API: "load".concat(EVENT_KEY$7).concat(DATA_API_KEY$4)
	  };
	  var Selector$4 = {
	    TAB_SWIPE: '.tab-sliding:not([data-swipe="none"])',
	    ACTIVE: '.active'
	  };
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var TabSwipe = /*#__PURE__*/function () {
	    function TabSwipe(element) {
	      _classCallCheck(this, TabSwipe);
	
	      this._element = element;
	      this._firefox = 'MozAppearance' in document.documentElement.style;
	
	      this._init();
	    }
	
	    _createClass(TabSwipe, [{
	      key: "_init",
	      value: function _init() {
	        var _this = this;
	
	        if (!('closest' in document.documentElement)) return;
	
	        this._element.addEventListener('touchstart', function (ev) {
	          var pane = ev.target.closest('.tab-pane');
	          if (!pane) return;
	
	          _this._startPaneSwipe(ev, pane);
	        });
	      }
	    }, {
	      key: "_startPaneSwipe",
	      value: function _startPaneSwipe(ev, pane) {
	        if (!pane.classList.contains('active')) return;
	        var curPane = pane;
	        var isRTL = Util.isRTL();
	        var initialTransform = !isRTL ? 'translateX(100%)' : 'translateX(-100%)';
	        var touches = ev.changedTouches[0];
	        var swipeDir = 0;
	        var x1 = touches.pageX;
	        var y1 = touches.pageY;
	        var t1 = Date.now();
	        var lastX = 0;
	        var curDir = 0;
	        var paneWidth = curPane.clientWidth;
	        var siblingPane = null;
	        var allowedDir = this._element.getAttribute('data-swipe') || null;
	
	        var paneTouchMoveCallback = function paneTouchMoveCallback(ev) {
	          var touches = ev.changedTouches[0];
	          var newX = touches.pageX;
	          var newY = touches.pageY;
	          lastX = newX;
	
	          if (swipeDir === 0) {
	            var diffY = Math.abs(y1 - newY);
	            var diffX = Math.abs(x1 - newX);
	
	            if (diffY > diffX) {
	              swipeDir = 2; // vertical i.e. scroll
	
	              curPane.removeEventListener('touchmove', paneTouchMoveCallback);
	            } else if (diffX > 10) {
	              swipeDir = 1; // horizontal swipe
	            }
	          }
	
	          if (swipeDir !== 1) return; // return if not horizontal swipe
	
	          var moveX = parseInt(x1 - newX);
	          var newDir = 0;
	          if ((allowedDir === null || allowedDir === 'left') && (!isRTL && moveX > 0 || isRTL && moveX < 0)) newDir = 1;else if ((allowedDir === null || allowedDir === 'right') && (!isRTL && moveX < 0 || isRTL && moveX > 0)) newDir = -1;
	
	          if (newDir !== 0 && newDir !== curDir) {
	            if (siblingPane !== null) _reset(siblingPane); // undo previous direction for when we change swipe direction before a touchend
	
	            curDir = newDir;
	            var targetPane = curPane.getAttribute('data-swipe-' + (curDir === 1 ? 'next' : 'prev'));
	            if (targetPane) targetPane = document.querySelector(targetPane);
	            siblingPane = targetPane || (curDir === 1 ? curPane.nextElementSibling : curPane.previousElementSibling);
	
	            if (siblingPane === null || siblingPane === curPane) {
	              curDir = 0;
	            } else {
	              curPane.classList.add('tab-swiping');
	              siblingPane.classList.add('tab-swiping');
	            }
	          }
	
	          var moveXabs = Math.abs(moveX);
	
	          if (curDir !== 0 && moveXabs < paneWidth + 24) {
	            // don't move more than 24px beyond its size
	            curPane.style.transform = initialTransform + ' translateX(' + -1 * moveX + 'px)';
	            siblingPane.style.transform = 'translateX(' + -1 * moveX + 'px)';
	          } else if (curDir === 0 && moveXabs < 24) {
	            curPane.style.transform = initialTransform + ' translateX(' + -1 * moveX + 'px)';
	          }
	        };
	
	        var paneTouchEndCallback = function paneTouchEndCallback(ev) {
	          var touches = ev.changedTouches[0] || null;
	          var x2 = touches !== null ? touches.pageX : lastX;
	          var t2 = Date.now();
	          var diff = Math.abs(x2 - x1);
	
	          _dismiss();
	
	          if (curDir !== 0 && swipeDir === 1 && (diff > paneWidth / 4 || diff > 100 || diff > paneWidth / 6 && t2 - t1 < 300)) {
	            // if moved more than 1/4 of its width or 100px or 1/6 in less than 300ms
	            siblingPane.classList.add('active', 'show');
	            curPane.classList.remove('active', 'show');
	            var id1 = curPane.id;
	            var id2 = siblingPane.id;
	            document.querySelectorAll('[href="#' + id1 + '"],[data-target="#' + id1 + '"]').forEach(function (a) {
	              return a.classList.remove('active');
	            });
	            var newActive = document.querySelectorAll('[href="#' + id2 + '"],[data-target="#' + id2 + '"]');
	            newActive.forEach(function (a) {
	              return a.classList.add('active');
	            });
	
	            if (newActive.length > 0) {
	              try {
	                /* global AceApp */
	                var navLinkScroll = new AceApp.NavLinkScroller(newActive[0]);
	
	                navLinkScroll._scrollIntoView();
	              } catch (err) {}
	            }
	          }
	        };
	
	        var _dismiss = function _dismiss() {
	          curPane.removeEventListener('touchmove', paneTouchMoveCallback);
	          curPane.removeEventListener('touchend', paneTouchEndCallback);
	          curPane.removeEventListener('touchcancel', paneTouchEndCallback);
	          curPane.style.transform = '';
	          curPane.classList.remove('tab-swiping');
	
	          if (siblingPane) {
	            siblingPane.style.transform = '';
	            siblingPane.classList.remove('tab-swiping');
	          }
	        };
	
	        var _reset = function _reset(sibling) {
	          sibling.style.transform = '';
	          sibling.style.transitionDuration = '0ms'; // so when we quickly and frequently swipe left/right without a `touchend`, the other pane moves away (disappears) instantly
	
	          sibling.classList.remove('tab-swiping');
	          sibling.offsetHeight;
	          sibling.style.transitionDuration = '';
	        };
	
	        pane.addEventListener('touchmove', paneTouchMoveCallback);
	        pane.addEventListener('touchend', paneTouchEndCallback);
	        pane.addEventListener('touchcancel', paneTouchEndCallback);
	      } // Static methods
	
	    }], [{
	      key: "_jQueryInterface",
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          var $this = $__default['default'](this);
	          var data = $this.data(DATA_KEY$8);
	
	          if (!data) {
	            data = new TabSwipe(this);
	            $this.data(DATA_KEY$8, data);
	          }
	
	          if (typeof config === 'string') {
	            if (typeof data[config] === 'undefined') {
	              throw new TypeError("No method named \"".concat(config, "\""));
	            }
	
	            data[config]();
	          }
	        });
	      }
	    }, {
	      key: "VERSION",
	      get: function get() {
	        return VERSION$8;
	      }
	    }]);
	
	    return TabSwipe;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	  */
	
	
	  $__default['default'](window).on(Event$7.LOAD_DATA_API, function () {
	    if (!('ontouchstart' in document.documentElement)) return;
	    var swipeablePanes = document.querySelectorAll(Selector$4.TAB_SWIPE);
	
	    for (var i = 0; i < swipeablePanes.length; i++) {
	      var $tabswipe = $__default['default'](swipeablePanes[i]);
	
	      TabSwipe._jQueryInterface.call($tabswipe);
	    }
	  });
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	  */
	
	  if (typeof $__default['default'] !== 'undefined') {
	    var JQUERY_NO_CONFLICT$7 = $__default['default'].fn[NAME$7];
	    $__default['default'].fn[NAME$7] = TabSwipe._jQueryInterface;
	    $__default['default'].fn[NAME$7].Constructor = TabSwipe;
	
	    $__default['default'].fn[NAME$7].noConflict = function () {
	      $__default['default'].fn[NAME$7] = JQUERY_NO_CONFLICT$7;
	      return TabSwipe._jQueryInterface;
	    };
	  }
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$8 = 'aceScrollTop';
	  var VERSION$9 = '3.1.1';
	  var DATA_KEY$9 = 'ace.scrolltop';
	  var EVENT_KEY$8 = ".".concat(DATA_KEY$9);
	  var DATA_API_KEY$5 = '.data-api';
	  var Event$8 = {
	    LOAD_DATA_API: "load".concat(EVENT_KEY$8).concat(DATA_API_KEY$5)
	  };
	  var Selector$5 = {
	    SCROLL_TOP_BTN: '.btn-scroll-up'
	  };
	  var CLASS_NAME_SHOW = 'scroll-btn-visible';
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var ScrollTop = /*#__PURE__*/function () {
	    function ScrollTop(element) {
	      _classCallCheck(this, ScrollTop);
	
	      this._element = element;
	
	      this._init();
	    }
	
	    _createClass(ScrollTop, [{
	      key: "_init",
	      value: function _init() {
	        var _this = this;
	
	        var _modernBrowser = ('IntersectionObserver' in window);
	
	        this._element.addEventListener('click', function (ev) {
	          ev.preventDefault();
	          if (_modernBrowser) _this.hide();
	
	          _this.scrollToTop();
	        });
	
	        if (!_modernBrowser) {
	          // if browser doesn't support `IntersectionObserver`, always show the scroll to top button
	          this.show();
	        } else {
	          var _scrollBtnObserve = document.createElement('DIV');
	
	          _scrollBtnObserve.classList.add('scroll-btn-observe');
	
	          document.body.appendChild(_scrollBtnObserve);
	          var observer = new window.IntersectionObserver(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 1),
	                entry = _ref2[0];
	
	            var isObserverOut = entry.intersectionRatio < 1 && entry.boundingClientRect.bottom < 0;
	
	            if (isObserverOut) {
	              _this.show();
	            } else {
	              _this.hide();
	            }
	          }, {
	            threshold: [1.0],
	            delay: 100
	          });
	          observer.observe(_scrollBtnObserve);
	        }
	      }
	    }, {
	      key: "show",
	      value: function show() {
	        this._element.classList.add(CLASS_NAME_SHOW);
	      }
	    }, {
	      key: "hide",
	      value: function hide() {
	        this._element.classList.remove(CLASS_NAME_SHOW);
	      }
	    }, {
	      key: "scrollToTop",
	      value: function scrollToTop() {
	        var smooth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        // ScrollToOptions parameter may not be supported on some older browsers
	        // so we use try/catch block in case of an error
	        try {
	          smooth = !Util.isReducedMotion() && smooth === true;
	          window.scroll({
	            top: 0,
	            behavior: smooth ? 'smooth' : 'auto'
	          });
	        } catch (e) {
	          window.scroll(0, 0);
	        }
	      } // Static methods
	
	    }], [{
	      key: "_jQueryInterface",
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          var $this = $__default['default'](this);
	          var data = $this.data(DATA_KEY$9);
	
	          if (!data) {
	            data = new ScrollTop(this);
	            $this.data(DATA_KEY$9, data);
	          }
	
	          if (typeof config === 'string') {
	            if (typeof data[config] === 'undefined') {
	              throw new TypeError("No method named \"".concat(config, "\""));
	            }
	
	            data[config]();
	          }
	        });
	      }
	    }, {
	      key: "VERSION",
	      get: function get() {
	        return VERSION$9;
	      }
	    }]);
	
	    return ScrollTop;
	  }();
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	  */
	
	
	  $__default['default'](window).on(Event$8.LOAD_DATA_API, function () {
	    var scrollTopTopBtn = document.querySelectorAll(Selector$5.SCROLL_TOP_BTN);
	
	    for (var i = 0; i < scrollTopTopBtn.length; i++) {
	      var $scrollTopBtn = $__default['default'](scrollTopTopBtn[i]);
	
	      ScrollTop._jQueryInterface.call($scrollTopBtn);
	    }
	  });
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	  */
	
	  if (typeof $__default['default'] !== 'undefined') {
	    var JQUERY_NO_CONFLICT1$1 = $__default['default'].fn[NAME$8];
	    $__default['default'].fn[NAME$8] = ScrollTop._jQueryInterface;
	    $__default['default'].fn[NAME$8].Constructor = ScrollTop;
	
	    $__default['default'].fn[NAME$8].noConflict = function () {
	      $__default['default'].fn[NAME$8] = JQUERY_NO_CONFLICT1$1;
	      return ScrollTop._jQueryInterface;
	    };
	  }
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME$9 = 'aceSticky';
	  var VERSION$a = '3.1.1';
	  var DATA_KEY$a = 'ace.sticky';
	  var EVENT_KEY$9 = ".".concat(DATA_KEY$a);
	  var DATA_API_KEY$6 = '.data-api';
	  var Event$9 = {
	    LOAD_DATA_API: "load".concat(EVENT_KEY$9).concat(DATA_API_KEY$6)
	  };
	  var Selector$6 = {
	    STICKY: '[class*="sticky-nav"]'
	  };
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	  var Sticky = /*#__PURE__*/function () {
	    function Sticky(element) {
	      _classCallCheck(this, Sticky);
	
	      this._element = element;
	
	      this._init();
	    }
	
	    _createClass(Sticky, [{
	      key: "_init",
	      value: function _init() {
	        var _this = this;
	
	        if (!window.IntersectionObserver) return;
	
	        this._initObserver(); // add a dummy child to be observed
	        // when it goes out of window it means .sticky-nav is sticky now
	        // because dummy element is `top: -1px` or when below navbar it's `top : -1 * ($navbar-height + 1px)`;
	
	
	        var observedChild = document.createElement(this._element.tagName === 'UL' ? 'LI' : 'DIV');
	        observedChild.classList.add('sticky-trigger');
	
	        this._element.insertBefore(observedChild, this._element.firstChild);
	
	        Sticky._observer.observe(observedChild);
	
	        setTimeout(function () {
	          if (observedChild.getBoundingClientRect().bottom < 0) {
	            var isSticky = true;
	
	            if (isSticky && !_this._element.classList.contains('sticky-nav')) {
	              var pos = window.getComputedStyle(_this._element).position;
	              if (!(pos === 'sticky' || pos === '-webkit-sticky')) isSticky = false;
	            }
	
	            var evt = new window.CustomEvent('sticky-change', {
	              detail: {
	                isSticky: isSticky,
	                initialCheck: true
	              }
	            });
	
	            _this._element.dispatchEvent(evt);
	          }
	        }, 200);
	      } /// /
	      // we use it when a sticky element becomes stuck on top and 1 pixel of it goes out of view (because of top: -1px)
	      // so IntersectionObserver is triggered with intersectionRatio < 1 and y < 0
	      // then we trigger an event for it, so later we may for example change its classList to update styling
	
	    }, {
	      key: "_initObserver",
	      value: function _initObserver() {
	        if (Sticky._observer !== null) return;
	        Sticky._observer = new window.IntersectionObserver(function (_ref) {
	          var _ref2 = _slicedToArray(_ref, 1),
	              entry = _ref2[0];
	
	          var isSticky = entry.intersectionRatio < 1 && entry.boundingClientRect.bottom < 0; // isSticky=true means we are at sticky position
	          // so if our sticky element is for example 'sticky-nav-md' and we are at sticky position
	          // but our window size is above 'md' and therefore CSS rule 'position: sticky' is not applied at all
	          // so we check if we are really sticky or not
	
	          var stickyNav = entry.target.parentElement; // entry.target is the `.sticky-trigger` and parentElement is the `.sticky-nav` element
	          // check if `position` is actually `sticky` ... for example if we have `.sticky-nav-md`, it will be sticky only on small (md) devices
	
	          if (isSticky && !stickyNav.classList.contains('sticky-nav')) {
	            // don't check `.sticky-nav` element because it's sticky regardless of window size
	            var pos = window.getComputedStyle(stickyNav).position;
	            if (!(pos === 'sticky' || pos === '-webkit-sticky')) isSticky = false;
	          }
	
	          var evt = new window.CustomEvent('sticky-change', {
	            detail: {
	              isSticky: isSticky
	            }
	          });
	          stickyNav.dispatchEvent(evt);
	        }, {
	          threshold: [1.0],
	          delay: 100
	        });
	      } // Static methods
	
	    }], [{
	      key: "_jQueryInterface",
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          var $this = $__default['default'](this);
	          var data = $this.data(DATA_KEY$a);
	
	          if (!data) {
	            data = new Sticky(this);
	            $this.data(DATA_KEY$a, data);
	          }
	
	          if (typeof config === 'string') {
	            if (typeof data[config] === 'undefined') {
	              throw new TypeError("No method named \"".concat(config, "\""));
	            }
	
	            data[config]();
	          }
	        });
	      }
	    }, {
	      key: "VERSION",
	      get: function get() {
	        return VERSION$a;
	      }
	    }]);
	
	    return Sticky;
	  }();
	
	  Sticky._observer = null; // static property
	
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	  */
	
	  $__default['default'](window).on(Event$9.LOAD_DATA_API, function () {
	    var stickyEl = document.querySelectorAll(Selector$6.STICKY);
	
	    for (var i = 0; i < stickyEl.length; i++) {
	      var $stickyEl = $__default['default'](stickyEl[i]);
	
	      Sticky._jQueryInterface.call($stickyEl);
	    }
	  });
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	  */
	
	  if (typeof $__default['default'] !== 'undefined') {
	    var JQUERY_NO_CONFLICT1$2 = $__default['default'].fn[NAME$9];
	    $__default['default'].fn[NAME$9] = Sticky._jQueryInterface;
	    $__default['default'].fn[NAME$9].Constructor = Sticky;
	
	    $__default['default'].fn[NAME$9].noConflict = function () {
	      $__default['default'].fn[NAME$9] = JQUERY_NO_CONFLICT1$2;
	      return Sticky._jQueryInterface;
	    };
	  }
	
	  /**
	   * --------------------------------------------------------------------------
	   * Ace (v3.1.1): index.js
	   * --------------------------------------------------------------------------
	   */
	  var index_umd = {
	    Util: Util,
	    Basic: Basic,
	    Scrollbar: Scrollbar,
	    Sidebar: Sidebar,
	    Aside: Aside,
	    Toaster: Toaster,
	    Widget: Widget,
	    FileInput: FileInput,
	    Wysiwyg: Wysiwyg,
	    NavTabScroller: NavTabScroller,
	    NavLinkScroller: NavLinkScroller,
	    TabSwipe: TabSwipe,
	    ScrollTop: ScrollTop,
	    Sticky: Sticky
	  };
	
	  return index_umd;
	
	})));
	//# sourceMappingURL=ace.js.map


/***/ },

/***/ 1121:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * mustache.js - Logic-less {{mustache}} templates with JavaScript
	 * http://github.com/janl/mustache.js
	 */
	
	/*global define: false*/
	
	var Mustache;
	
	(function (exports) {
	  if (typeof module !== "undefined" && module.exports) {
	    module.exports = exports; // CommonJS
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (exports), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // AMD
	  } else {
	    Mustache = exports; // <script>
	  }
	}((function () {
	
	  var exports = {};
	
	  exports.name = "mustache.js";
	  exports.version = "0.7.1";
	  exports.tags = ["{{", "}}"];
	
	  exports.Scanner = Scanner;
	  exports.Context = Context;
	  exports.Writer = Writer;
	
	  var whiteRe = /\s*/;
	  var spaceRe = /\s+/;
	  var nonSpaceRe = /\S/;
	  var eqRe = /\s*=/;
	  var curlyRe = /\s*\}/;
	  var tagRe = /#|\^|\/|>|\{|&|=|!/;
	
	  // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
	  // See https://github.com/janl/mustache.js/issues/189
	  function testRe(re, string) {
	    return RegExp.prototype.test.call(re, string);
	  }
	
	  function isWhitespace(string) {
	    return !testRe(nonSpaceRe, string);
	  }
	
	  var isArray = Array.isArray || function (obj) {
	    return Object.prototype.toString.call(obj) === "[object Array]";
	  };
	
	  function escapeRe(string) {
	    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
	  }
	
	  var entityMap = {
	    "&": "&amp;",
	    "<": "&lt;",
	    ">": "&gt;",
	    '"': '&quot;',
	    "'": '&#39;',
	    "/": '&#x2F;'
	  };
	
	  function escapeHtml(string) {
	    return String(string).replace(/[&<>"'\/]/g, function (s) {
	      return entityMap[s];
	    });
	  }
	
	  // Export the escaping function so that the user may override it.
	  // See https://github.com/janl/mustache.js/issues/244
	  exports.escape = escapeHtml;
	
	  function Scanner(string) {
	    this.string = string;
	    this.tail = string;
	    this.pos = 0;
	  }
	
	  /**
	   * Returns `true` if the tail is empty (end of string).
	   */
	  Scanner.prototype.eos = function () {
	    return this.tail === "";
	  };
	
	  /**
	   * Tries to match the given regular expression at the current position.
	   * Returns the matched text if it can match, the empty string otherwise.
	   */
	  Scanner.prototype.scan = function (re) {
	    var match = this.tail.match(re);
	
	    if (match && match.index === 0) {
	      this.tail = this.tail.substring(match[0].length);
	      this.pos += match[0].length;
	      return match[0];
	    }
	
	    return "";
	  };
	
	  /**
	   * Skips all text until the given regular expression can be matched. Returns
	   * the skipped string, which is the entire tail if no match can be made.
	   */
	  Scanner.prototype.scanUntil = function (re) {
	    var match, pos = this.tail.search(re);
	
	    switch (pos) {
	    case -1:
	      match = this.tail;
	      this.pos += this.tail.length;
	      this.tail = "";
	      break;
	    case 0:
	      match = "";
	      break;
	    default:
	      match = this.tail.substring(0, pos);
	      this.tail = this.tail.substring(pos);
	      this.pos += pos;
	    }
	
	    return match;
	  };
	
	  function Context(view, parent) {
	    this.view = view;
	    this.parent = parent;
	    this.clearCache();
	  }
	
	  Context.make = function (view) {
	    return (view instanceof Context) ? view : new Context(view);
	  };
	
	  Context.prototype.clearCache = function () {
	    this._cache = {};
	  };
	
	  Context.prototype.push = function (view) {
	    return new Context(view, this);
	  };
	
	  Context.prototype.lookup = function (name) {
	    var value = this._cache[name];
	
	    if (!value) {
	      if (name === ".") {
	        value = this.view;
	      } else {
	        var context = this;
	
	        while (context) {
	          if (name.indexOf(".") > 0) {
	            var names = name.split("."), i = 0;
	
	            value = context.view;
	
	            while (value && i < names.length) {
	              value = value[names[i++]];
	            }
	          } else {
	            value = context.view[name];
	          }
	
	          if (value != null) {
	            break;
	          }
	
	          context = context.parent;
	        }
	      }
	
	      this._cache[name] = value;
	    }
	
	    if (typeof value === "function") {
	      value = value.call(this.view);
	    }
	
	    return value;
	  };
	
	  function Writer() {
	    this.clearCache();
	  }
	
	  Writer.prototype.clearCache = function () {
	    this._cache = {};
	    this._partialCache = {};
	  };
	
	  Writer.prototype.compile = function (template, tags) {
	    var fn = this._cache[template];
	
	    if (!fn) {
	      var tokens = exports.parse(template, tags);
	      fn = this._cache[template] = this.compileTokens(tokens, template);
	    }
	
	    return fn;
	  };
	
	  Writer.prototype.compilePartial = function (name, template, tags) {
	    var fn = this.compile(template, tags);
	    this._partialCache[name] = fn;
	    return fn;
	  };
	
	  Writer.prototype.compileTokens = function (tokens, template) {
	    var fn = compileTokens(tokens);
	    var self = this;
	
	    return function (view, partials) {
	      if (partials) {
	        if (typeof partials === "function") {
	          self._loadPartial = partials;
	        } else {
	          for (var name in partials) {
	            self.compilePartial(name, partials[name]);
	          }
	        }
	      }
	
	      return fn(self, Context.make(view), template);
	    };
	  };
	
	  Writer.prototype.render = function (template, view, partials) {
	    return this.compile(template)(view, partials);
	  };
	
	  Writer.prototype._section = function (name, context, text, callback) {
	    var value = context.lookup(name);
	
	    switch (typeof value) {
	    case "object":
	      if (isArray(value)) {
	        var buffer = "";
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          buffer += callback(this, context.push(value[i]));
	        }
	
	        return buffer;
	      }
	
	      return value ? callback(this, context.push(value)) : "";
	    case "function":
	      var self = this;
	      var scopedRender = function (template) {
	        return self.render(template, context);
	      };
	
	      var result = value.call(context.view, text, scopedRender);
	      return result != null ? result : "";
	    default:
	      if (value) {
	        return callback(this, context);
	      }
	    }
	
	    return "";
	  };
	
	  Writer.prototype._inverted = function (name, context, callback) {
	    var value = context.lookup(name);
	
	    // Use JavaScript's definition of falsy. Include empty arrays.
	    // See https://github.com/janl/mustache.js/issues/186
	    if (!value || (isArray(value) && value.length === 0)) {
	      return callback(this, context);
	    }
	
	    return "";
	  };
	
	  Writer.prototype._partial = function (name, context) {
	    if (!(name in this._partialCache) && this._loadPartial) {
	      this.compilePartial(name, this._loadPartial(name));
	    }
	
	    var fn = this._partialCache[name];
	
	    return fn ? fn(context) : "";
	  };
	
	  Writer.prototype._name = function (name, context) {
	    var value = context.lookup(name);
	
	    if (typeof value === "function") {
	      value = value.call(context.view);
	    }
	
	    return (value == null) ? "" : String(value);
	  };
	
	  Writer.prototype._escaped = function (name, context) {
	    return exports.escape(this._name(name, context));
	  };
	
	  /**
	   * Calculates the bounds of the section represented by the given `token` in
	   * the original template by drilling down into nested sections to find the
	   * last token that is part of that section. Returns an array of [start, end].
	   */
	  function sectionBounds(token) {
	    var start = token[3];
	    var end = start;
	
	    var tokens;
	    while ((tokens = token[4]) && tokens.length) {
	      token = tokens[tokens.length - 1];
	      end = token[3];
	    }
	
	    return [start, end];
	  }
	
	  /**
	   * Low-level function that compiles the given `tokens` into a function
	   * that accepts three arguments: a Writer, a Context, and the template.
	   */
	  function compileTokens(tokens) {
	    var subRenders = {};
	
	    function subRender(i, tokens, template) {
	      if (!subRenders[i]) {
	        var fn = compileTokens(tokens);
	        subRenders[i] = function (writer, context) {
	          return fn(writer, context, template);
	        };
	      }
	
	      return subRenders[i];
	    }
	
	    return function (writer, context, template) {
	      var buffer = "";
	      var token, sectionText;
	
	      for (var i = 0, len = tokens.length; i < len; ++i) {
	        token = tokens[i];
	
	        switch (token[0]) {
	        case "#":
	          sectionText = template.slice.apply(template, sectionBounds(token));
	          buffer += writer._section(token[1], context, sectionText, subRender(i, token[4], template));
	          break;
	        case "^":
	          buffer += writer._inverted(token[1], context, subRender(i, token[4], template));
	          break;
	        case ">":
	          buffer += writer._partial(token[1], context);
	          break;
	        case "&":
	          buffer += writer._name(token[1], context);
	          break;
	        case "name":
	          buffer += writer._escaped(token[1], context);
	          break;
	        case "text":
	          buffer += token[1];
	          break;
	        }
	      }
	
	      return buffer;
	    };
	  }
	
	  /**
	   * Forms the given array of `tokens` into a nested tree structure where
	   * tokens that represent a section have a fifth item: an array that contains
	   * all tokens in that section.
	   */
	  function nestTokens(tokens) {
	    var tree = [];
	    var collector = tree;
	    var sections = [];
	    var token, section;
	
	    for (var i = 0; i < tokens.length; ++i) {
	      token = tokens[i];
	
	      switch (token[0]) {
	      case "#":
	      case "^":
	        token[4] = [];
	        sections.push(token);
	        collector.push(token);
	        collector = token[4];
	        break;
	      case "/":
	        if (sections.length === 0) {
	          throw new Error("Unopened section: " + token[1]);
	        }
	
	        section = sections.pop();
	
	        if (section[1] !== token[1]) {
	          throw new Error("Unclosed section: " + section[1]);
	        }
	
	        if (sections.length > 0) {
	          collector = sections[sections.length - 1][4];
	        } else {
	          collector = tree;
	        }
	        break;
	      default:
	        collector.push(token);
	      }
	    }
	
	    // Make sure there were no open sections when we're done.
	    section = sections.pop();
	
	    if (section) {
	      throw new Error("Unclosed section: " + section[1]);
	    }
	
	    return tree;
	  }
	
	  /**
	   * Combines the values of consecutive text tokens in the given `tokens` array
	   * to a single token.
	   */
	  function squashTokens(tokens) {
	    var token, lastToken, squashedTokens = [];
	
	    for (var i = 0; i < tokens.length; ++i) {
	      token = tokens[i];
	
	      if (lastToken && lastToken[0] === "text" && token[0] === "text") {
	        lastToken[1] += token[1];
	        lastToken[3] = token[3];
	      } else {
	        lastToken = token;
	        squashedTokens.push(token);
	      }
	    }
	
	    return squashedTokens;
	  }
	
	  function escapeTags(tags) {
	    if (tags.length !== 2) {
	      throw new Error("Invalid tags: " + tags.join(" "));
	    }
	
	    return [
	      new RegExp(escapeRe(tags[0]) + "\\s*"),
	      new RegExp("\\s*" + escapeRe(tags[1]))
	    ];
	  }
	
	  /**
	   * Breaks up the given `template` string into a tree of token objects. If
	   * `tags` is given here it must be an array with two string values: the
	   * opening and closing tags used in the template (e.g. ["<%", "%>"]). Of
	   * course, the default is to use mustaches (i.e. Mustache.tags).
	   */
	  exports.parse = function (template, tags) {
	    template = template || '';
	    tags = tags || exports.tags;
	
	    var tagRes = escapeTags(tags);
	    var scanner = new Scanner(template);
	
	    var tokens = [],      // Buffer to hold the tokens
	        spaces = [],      // Indices of whitespace tokens on the current line
	        hasTag = false,   // Is there a {{tag}} on the current line?
	        nonSpace = false; // Is there a non-space char on the current line?
	
	    // Strips all whitespace tokens array for the current line
	    // if there was a {{#tag}} on it and otherwise only space.
	    function stripSpace() {
	      if (hasTag && !nonSpace) {
	        while (spaces.length) {
	          tokens.splice(spaces.pop(), 1);
	        }
	      } else {
	        spaces = [];
	      }
	
	      hasTag = false;
	      nonSpace = false;
	    }
	
	    var start, type, value, chr;
	
	    while (!scanner.eos()) {
	      start = scanner.pos;
	      value = scanner.scanUntil(tagRes[0]);
	
	      if (value) {
	        for (var i = 0, len = value.length; i < len; ++i) {
	          chr = value.charAt(i);
	
	          if (isWhitespace(chr)) {
	            spaces.push(tokens.length);
	          } else {
	            nonSpace = true;
	          }
	
	          tokens.push(["text", chr, start, start + 1]);
	          start += 1;
	
	          if (chr === "\n") {
	            stripSpace(); // Check for whitespace on the current line.
	          }
	        }
	      }
	
	      start = scanner.pos;
	
	      // Match the opening tag.
	      if (!scanner.scan(tagRes[0])) {
	        break;
	      }
	
	      hasTag = true;
	      type = scanner.scan(tagRe) || "name";
	
	      // Skip any whitespace between tag and value.
	      scanner.scan(whiteRe);
	
	      // Extract the tag value.
	      if (type === "=") {
	        value = scanner.scanUntil(eqRe);
	        scanner.scan(eqRe);
	        scanner.scanUntil(tagRes[1]);
	      } else if (type === "{") {
	        var closeRe = new RegExp("\\s*" + escapeRe("}" + tags[1]));
	        value = scanner.scanUntil(closeRe);
	        scanner.scan(curlyRe);
	        scanner.scanUntil(tagRes[1]);
	        type = "&";
	      } else {
	        value = scanner.scanUntil(tagRes[1]);
	      }
	
	      // Match the closing tag.
	      if (!scanner.scan(tagRes[1])) {
	        throw new Error("Unclosed tag at " + scanner.pos);
	      }
	
	      tokens.push([type, value, start, scanner.pos]);
	
	      if (type === "name" || type === "{" || type === "&") {
	        nonSpace = true;
	      }
	
	      // Set the tags for the next time around.
	      if (type === "=") {
	        tags = value.split(spaceRe);
	        tagRes = escapeTags(tags);
	      }
	    }
	
	    tokens = squashTokens(tokens);
	
	    return nestTokens(tokens);
	  };
	
	  // The high-level clearCache, compile, compilePartial, and render functions
	  // use this default writer.
	  var _writer = new Writer();
	
	  /**
	   * Clears all cached templates and partials in the default writer.
	   */
	  exports.clearCache = function () {
	    return _writer.clearCache();
	  };
	
	  /**
	   * Compiles the given `template` to a reusable function using the default
	   * writer.
	   */
	  exports.compile = function (template, tags) {
	    return _writer.compile(template, tags);
	  };
	
	  /**
	   * Compiles the partial with the given `name` and `template` to a reusable
	   * function using the default writer.
	   */
	  exports.compilePartial = function (name, template, tags) {
	    return _writer.compilePartial(name, template, tags);
	  };
	
	  /**
	   * Compiles the given array of tokens (the output of a parse) to a reusable
	   * function using the default writer.
	   */
	  exports.compileTokens = function (tokens, template) {
	    return _writer.compileTokens(tokens, template);
	  };
	
	  /**
	   * Renders the `template` with the given `view` and `partials` using the
	   * default writer.
	   */
	  exports.render = function (template, view, partials) {
	    return _writer.render(template, view, partials);
	  };
	
	  // This is here for backwards compatibility with 0.4.x.
	  exports.to_html = function (template, view, partials, send) {
	    var result = exports.render(template, view, partials);
	
	    if (typeof send === "function") {
	      send(result);
	    } else {
	      return result;
	    }
	  };
	
	  return exports;
	
	}())));


/***/ }

/******/ });


// WEBPACK FOOTER //
// javascripts/user-common-js.js